var _regeneratorRuntime = require("/Users/saurabhtarge/Mastercard/dev/mastercard-srci-client-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/saurabhtarge/Mastercard/dev/mastercard-srci-client-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/saurabhtarge/Mastercard/dev/mastercard-srci-client-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/Users/saurabhtarge/Mastercard/dev/mastercard-srci-client-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/saurabhtarge/Mastercard/dev/mastercard-srci-client-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/saurabhtarge/Mastercard/dev/mastercard-srci-client-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/Users/saurabhtarge/Mastercard/dev/mastercard-srci-client-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(require("crypto"), require("zlib")) : "function" == typeof define && define.amd ? define(["crypto", "zlib"], e) : e((t = t || self).crypto$2, t.zlib);
}(this, function (t, e) {
  "use strict";

  t = t && t.hasOwnProperty("default") ? t.default : t, e = e && e.hasOwnProperty("default") ? e.default : e;
  var r = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function n(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
  }

  function i(t, e) {
    return t(e = {
      exports: {}
    }, e.exports), e.exports;
  }

  var a,
      o = i(function (t, e) {
    /*!
    	 * @overview es6-promise - a tiny implementation of Promises/A+.
    	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
    	 * @license   Licensed under MIT license
    	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
    	 * @version   v4.2.8+1e68dce6
    	 */
    t.exports = function () {
      function t(t) {
        return "function" == typeof t;
      }

      var e = Array.isArray ? Array.isArray : function (t) {
        return "[object Array]" === Object.prototype.toString.call(t);
      },
          n = 0,
          i = void 0,
          a = void 0,
          o = function o(t, e) {
        p[n] = t, p[n + 1] = e, 2 === (n += 2) && (a ? a(d) : E());
      },
          s = "undefined" != typeof window ? window : void 0,
          u = s || {},
          c = u.MutationObserver || u.WebKitMutationObserver,
          f = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
          l = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;

      function h() {
        var t = setTimeout;
        return function () {
          return t(d, 1);
        };
      }

      var p = new Array(1e3);

      function d() {
        for (var t = 0; t < n; t += 2) {
          (0, p[t])(p[t + 1]), p[t] = void 0, p[t + 1] = void 0;
        }

        n = 0;
      }

      var y,
          g,
          v,
          m,
          E = void 0;

      function C(t, e) {
        var r = this,
            n = new this.constructor(T);
        void 0 === n[b] && F(n);
        var i = r._state;

        if (i) {
          var a = arguments[i - 1];
          o(function () {
            return R(i, n, a, r._result);
          });
        } else k(r, n, t, e);

        return n;
      }

      function S(t) {
        if (t && "object" == typeof t && t.constructor === this) return t;
        var e = new this(T);
        return I(e, t), e;
      }

      f ? E = function E() {
        return process.nextTick(d);
      } : c ? (g = 0, v = new c(d), m = document.createTextNode(""), v.observe(m, {
        characterData: !0
      }), E = function E() {
        m.data = g = ++g % 2;
      }) : l ? ((y = new MessageChannel()).port1.onmessage = d, E = function E() {
        return y.port2.postMessage(0);
      }) : E = void 0 === s ? function () {
        try {
          var t = Function("return this")().require("vertx");

          return void 0 !== (i = t.runOnLoop || t.runOnContext) ? function () {
            i(d);
          } : h();
        } catch (t) {
          return h();
        }
      }() : h();
      var b = Math.random().toString(36).substring(2);

      function T() {}

      function A(e, r, n) {
        r.constructor === e.constructor && n === C && r.constructor.resolve === S ? function (t, e) {
          1 === e._state ? w(t, e._result) : 2 === e._state ? N(t, e._result) : k(e, void 0, function (e) {
            return I(t, e);
          }, function (e) {
            return N(t, e);
          });
        }(e, r) : void 0 === n ? w(e, r) : t(n) ? function (t, e, r) {
          o(function (t) {
            var n = !1,
                i = function (t, e, r, n) {
              try {
                t.call(e, r, n);
              } catch (t) {
                return t;
              }
            }(r, e, function (r) {
              n || (n = !0, e !== r ? I(t, r) : w(t, r));
            }, function (e) {
              n || (n = !0, N(t, e));
            }, t._label);

            !n && i && (n = !0, N(t, i));
          }, t);
        }(e, r, n) : w(e, r);
      }

      function I(t, e) {
        if (t === e) N(t, new TypeError("You cannot resolve a promise with itself"));else if (i = typeof (n = e), null === n || "object" !== i && "function" !== i) w(t, e);else {
          var r = void 0;

          try {
            r = e.then;
          } catch (e) {
            return void N(t, e);
          }

          A(t, e, r);
        }
        var n, i;
      }

      function B(t) {
        t._onerror && t._onerror(t._result), _(t);
      }

      function w(t, e) {
        void 0 === t._state && (t._result = e, t._state = 1, 0 !== t._subscribers.length && o(_, t));
      }

      function N(t, e) {
        void 0 === t._state && (t._state = 2, t._result = e, o(B, t));
      }

      function k(t, e, r, n) {
        var i = t._subscribers,
            a = i.length;
        t._onerror = null, i[a] = e, i[a + 1] = r, i[a + 2] = n, 0 === a && t._state && o(_, t);
      }

      function _(t) {
        var e = t._subscribers,
            r = t._state;

        if (0 !== e.length) {
          for (var n = void 0, i = void 0, a = t._result, o = 0; o < e.length; o += 3) {
            n = e[o], i = e[o + r], n ? R(r, n, i, a) : i(a);
          }

          t._subscribers.length = 0;
        }
      }

      function R(e, r, n, i) {
        var a = t(n),
            o = void 0,
            s = void 0,
            u = !0;

        if (a) {
          try {
            o = n(i);
          } catch (t) {
            u = !1, s = t;
          }

          if (r === o) return void N(r, new TypeError("A promises callback cannot return that same promise."));
        } else o = i;

        void 0 !== r._state || (a && u ? I(r, o) : !1 === u ? N(r, s) : 1 === e ? w(r, o) : 2 === e && N(r, o));
      }

      var P = 0;

      function F(t) {
        t[b] = P++, t._state = void 0, t._result = void 0, t._subscribers = [];
      }

      var L = function () {
        function t(t, r) {
          this._instanceConstructor = t, this.promise = new t(T), this.promise[b] || F(this.promise), e(r) ? (this.length = r.length, this._remaining = r.length, this._result = new Array(this.length), 0 === this.length ? w(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(r), 0 === this._remaining && w(this.promise, this._result))) : N(this.promise, new Error("Array Methods must be provided an Array"));
        }

        return t.prototype._enumerate = function (t) {
          for (var e = 0; void 0 === this._state && e < t.length; e++) {
            this._eachEntry(t[e], e);
          }
        }, t.prototype._eachEntry = function (t, e) {
          var r = this._instanceConstructor,
              n = r.resolve;

          if (n === S) {
            var i = void 0,
                a = void 0,
                o = !1;

            try {
              i = t.then;
            } catch (t) {
              o = !0, a = t;
            }

            if (i === C && void 0 !== t._state) this._settledAt(t._state, e, t._result);else if ("function" != typeof i) this._remaining--, this._result[e] = t;else if (r === U) {
              var s = new r(T);
              o ? N(s, a) : A(s, t, i), this._willSettleAt(s, e);
            } else this._willSettleAt(new r(function (e) {
              return e(t);
            }), e);
          } else this._willSettleAt(n(t), e);
        }, t.prototype._settledAt = function (t, e, r) {
          var n = this.promise;
          void 0 === n._state && (this._remaining--, 2 === t ? N(n, r) : this._result[e] = r), 0 === this._remaining && w(n, this._result);
        }, t.prototype._willSettleAt = function (t, e) {
          var r = this;
          k(t, void 0, function (t) {
            return r._settledAt(1, e, t);
          }, function (t) {
            return r._settledAt(2, e, t);
          });
        }, t;
      }(),
          U = function () {
        function e(t) {
          this[b] = P++, this._result = this._state = void 0, this._subscribers = [], T !== t && ("function" != typeof t && function () {
            throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
          }(), this instanceof e ? function (t, e) {
            try {
              e(function (e) {
                I(t, e);
              }, function (e) {
                N(t, e);
              });
            } catch (e) {
              N(t, e);
            }
          }(this, t) : function () {
            throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
          }());
        }

        return e.prototype.catch = function (t) {
          return this.then(null, t);
        }, e.prototype.finally = function (e) {
          var r = this.constructor;
          return t(e) ? this.then(function (t) {
            return r.resolve(e()).then(function () {
              return t;
            });
          }, function (t) {
            return r.resolve(e()).then(function () {
              throw t;
            });
          }) : this.then(e, e);
        }, e;
      }();

      return U.prototype.then = C, U.all = function (t) {
        return new L(this, t).promise;
      }, U.race = function (t) {
        var r = this;
        return e(t) ? new r(function (e, n) {
          for (var i = t.length, a = 0; a < i; a++) {
            r.resolve(t[a]).then(e, n);
          }
        }) : new r(function (t, e) {
          return e(new TypeError("You must pass an array to race."));
        });
      }, U.resolve = S, U.reject = function (t) {
        var e = new this(T);
        return N(e, t), e;
      }, U._setScheduler = function (t) {
        a = t;
      }, U._setAsap = function (t) {
        o = t;
      }, U._asap = o, U.polyfill = function () {
        var t = void 0;
        if (void 0 !== r) t = r;else if ("undefined" != typeof self) t = self;else try {
          t = Function("return this")();
        } catch (t) {
          throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var e = t.Promise;

        if (e) {
          var n = null;

          try {
            n = Object.prototype.toString.call(e.resolve());
          } catch (t) {}

          if ("[object Promise]" === n && !e.cast) return;
        }

        t.Promise = U;
      }, U.Promise = U, U;
    }();
  }),
      s = i(function (t, e) {
    (function () {
      var n = "Expected a function",
          i = "__lodash_placeholder__",
          a = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]],
          o = "[object Arguments]",
          s = "[object Array]",
          u = "[object Boolean]",
          c = "[object Date]",
          f = "[object Error]",
          l = "[object Function]",
          h = "[object GeneratorFunction]",
          p = "[object Map]",
          d = "[object Number]",
          y = "[object Object]",
          g = "[object RegExp]",
          v = "[object Set]",
          m = "[object String]",
          E = "[object Symbol]",
          C = "[object WeakMap]",
          S = "[object ArrayBuffer]",
          b = "[object DataView]",
          T = "[object Float32Array]",
          A = "[object Float64Array]",
          I = "[object Int8Array]",
          B = "[object Int16Array]",
          w = "[object Int32Array]",
          N = "[object Uint8Array]",
          k = "[object Uint16Array]",
          _ = "[object Uint32Array]",
          R = /\b__p \+= '';/g,
          P = /\b(__p \+=) '' \+/g,
          F = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
          L = /&(?:amp|lt|gt|quot|#39);/g,
          U = /[&<>"']/g,
          O = RegExp(L.source),
          D = RegExp(U.source),
          K = /<%-([\s\S]+?)%>/g,
          V = /<%([\s\S]+?)%>/g,
          x = /<%=([\s\S]+?)%>/g,
          j = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          M = /^\w*$/,
          H = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          z = /[\\^$.*+?()[\]{}|]/g,
          G = RegExp(z.source),
          q = /^\s+|\s+$/g,
          W = /^\s+/,
          Q = /\s+$/,
          X = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
          Y = /\{\n\/\* \[wrapped with (.+)\] \*/,
          Z = /,? & /,
          J = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
          $ = /\\(\\)?/g,
          tt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
          et = /\w*$/,
          rt = /^[-+]0x[0-9a-f]+$/i,
          nt = /^0b[01]+$/i,
          it = /^\[object .+?Constructor\]$/,
          at = /^0o[0-7]+$/i,
          ot = /^(?:0|[1-9]\d*)$/,
          st = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
          ut = /($^)/,
          ct = /['\n\r\u2028\u2029\\]/g,
          ft = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
          lt = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
          ht = "[\\ud800-\\udfff]",
          pt = "[" + lt + "]",
          dt = "[" + ft + "]",
          yt = "\\d+",
          gt = "[\\u2700-\\u27bf]",
          vt = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
          mt = "[^\\ud800-\\udfff" + lt + yt + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
          Et = "\\ud83c[\\udffb-\\udfff]",
          Ct = "[^\\ud800-\\udfff]",
          St = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          bt = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          Tt = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
          At = "(?:" + vt + "|" + mt + ")",
          It = "(?:" + Tt + "|" + mt + ")",
          Bt = "(?:" + dt + "|" + Et + ")" + "?",
          wt = "[\\ufe0e\\ufe0f]?" + Bt + ("(?:\\u200d(?:" + [Ct, St, bt].join("|") + ")[\\ufe0e\\ufe0f]?" + Bt + ")*"),
          Nt = "(?:" + [gt, St, bt].join("|") + ")" + wt,
          kt = "(?:" + [Ct + dt + "?", dt, St, bt, ht].join("|") + ")",
          _t = RegExp("['’]", "g"),
          Rt = RegExp(dt, "g"),
          Pt = RegExp(Et + "(?=" + Et + ")|" + kt + wt, "g"),
          Ft = RegExp([Tt + "?" + vt + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [pt, Tt, "$"].join("|") + ")", It + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [pt, Tt + At, "$"].join("|") + ")", Tt + "?" + At + "+(?:['’](?:d|ll|m|re|s|t|ve))?", Tt + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", yt, Nt].join("|"), "g"),
          Lt = RegExp("[\\u200d\\ud800-\\udfff" + ft + "\\ufe0e\\ufe0f]"),
          Ut = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
          Ot = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
          Dt = -1,
          Kt = {};

      Kt[T] = Kt[A] = Kt[I] = Kt[B] = Kt[w] = Kt[N] = Kt["[object Uint8ClampedArray]"] = Kt[k] = Kt[_] = !0, Kt[o] = Kt[s] = Kt[S] = Kt[u] = Kt[b] = Kt[c] = Kt[f] = Kt[l] = Kt[p] = Kt[d] = Kt[y] = Kt[g] = Kt[v] = Kt[m] = Kt[C] = !1;
      var Vt = {};
      Vt[o] = Vt[s] = Vt[S] = Vt[b] = Vt[u] = Vt[c] = Vt[T] = Vt[A] = Vt[I] = Vt[B] = Vt[w] = Vt[p] = Vt[d] = Vt[y] = Vt[g] = Vt[v] = Vt[m] = Vt[E] = Vt[N] = Vt["[object Uint8ClampedArray]"] = Vt[k] = Vt[_] = !0, Vt[f] = Vt[l] = Vt[C] = !1;

      var xt = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      },
          jt = parseFloat,
          Mt = parseInt,
          Ht = "object" == typeof r && r && r.Object === Object && r,
          zt = "object" == typeof self && self && self.Object === Object && self,
          Gt = Ht || zt || Function("return this")(),
          qt = e && !e.nodeType && e,
          Wt = qt && t && !t.nodeType && t,
          Qt = Wt && Wt.exports === qt,
          Xt = Qt && Ht.process,
          Yt = function () {
        try {
          var t = Wt && Wt.require && Wt.require("util").types;

          return t || Xt && Xt.binding && Xt.binding("util");
        } catch (t) {}
      }(),
          Zt = Yt && Yt.isArrayBuffer,
          Jt = Yt && Yt.isDate,
          $t = Yt && Yt.isMap,
          te = Yt && Yt.isRegExp,
          ee = Yt && Yt.isSet,
          re = Yt && Yt.isTypedArray;

      function ne(t, e, r) {
        switch (r.length) {
          case 0:
            return t.call(e);

          case 1:
            return t.call(e, r[0]);

          case 2:
            return t.call(e, r[0], r[1]);

          case 3:
            return t.call(e, r[0], r[1], r[2]);
        }

        return t.apply(e, r);
      }

      function ie(t, e, r, n) {
        for (var i = -1, a = null == t ? 0 : t.length; ++i < a;) {
          var o = t[i];
          e(n, o, r(o), t);
        }

        return n;
      }

      function ae(t, e) {
        for (var r = -1, n = null == t ? 0 : t.length; ++r < n && !1 !== e(t[r], r, t);) {
          ;
        }

        return t;
      }

      function oe(t, e) {
        for (var r = null == t ? 0 : t.length; r-- && !1 !== e(t[r], r, t);) {
          ;
        }

        return t;
      }

      function se(t, e) {
        for (var r = -1, n = null == t ? 0 : t.length; ++r < n;) {
          if (!e(t[r], r, t)) return !1;
        }

        return !0;
      }

      function ue(t, e) {
        for (var r = -1, n = null == t ? 0 : t.length, i = 0, a = []; ++r < n;) {
          var o = t[r];
          e(o, r, t) && (a[i++] = o);
        }

        return a;
      }

      function ce(t, e) {
        return !!(null == t ? 0 : t.length) && Ee(t, e, 0) > -1;
      }

      function fe(t, e, r) {
        for (var n = -1, i = null == t ? 0 : t.length; ++n < i;) {
          if (r(e, t[n])) return !0;
        }

        return !1;
      }

      function le(t, e) {
        for (var r = -1, n = null == t ? 0 : t.length, i = Array(n); ++r < n;) {
          i[r] = e(t[r], r, t);
        }

        return i;
      }

      function he(t, e) {
        for (var r = -1, n = e.length, i = t.length; ++r < n;) {
          t[i + r] = e[r];
        }

        return t;
      }

      function pe(t, e, r, n) {
        var i = -1,
            a = null == t ? 0 : t.length;

        for (n && a && (r = t[++i]); ++i < a;) {
          r = e(r, t[i], i, t);
        }

        return r;
      }

      function de(t, e, r, n) {
        var i = null == t ? 0 : t.length;

        for (n && i && (r = t[--i]); i--;) {
          r = e(r, t[i], i, t);
        }

        return r;
      }

      function ye(t, e) {
        for (var r = -1, n = null == t ? 0 : t.length; ++r < n;) {
          if (e(t[r], r, t)) return !0;
        }

        return !1;
      }

      var ge = Te("length");

      function ve(t, e, r) {
        var n;
        return r(t, function (t, r, i) {
          if (e(t, r, i)) return n = r, !1;
        }), n;
      }

      function me(t, e, r, n) {
        for (var i = t.length, a = r + (n ? 1 : -1); n ? a-- : ++a < i;) {
          if (e(t[a], a, t)) return a;
        }

        return -1;
      }

      function Ee(t, e, r) {
        return e == e ? function (t, e, r) {
          var n = r - 1,
              i = t.length;

          for (; ++n < i;) {
            if (t[n] === e) return n;
          }

          return -1;
        }(t, e, r) : me(t, Se, r);
      }

      function Ce(t, e, r, n) {
        for (var i = r - 1, a = t.length; ++i < a;) {
          if (n(t[i], e)) return i;
        }

        return -1;
      }

      function Se(t) {
        return t != t;
      }

      function be(t, e) {
        var r = null == t ? 0 : t.length;
        return r ? Be(t, e) / r : NaN;
      }

      function Te(t) {
        return function (e) {
          return null == e ? void 0 : e[t];
        };
      }

      function Ae(t) {
        return function (e) {
          return null == t ? void 0 : t[e];
        };
      }

      function Ie(t, e, r, n, i) {
        return i(t, function (t, i, a) {
          r = n ? (n = !1, t) : e(r, t, i, a);
        }), r;
      }

      function Be(t, e) {
        for (var r, n = -1, i = t.length; ++n < i;) {
          var a = e(t[n]);
          void 0 !== a && (r = void 0 === r ? a : r + a);
        }

        return r;
      }

      function we(t, e) {
        for (var r = -1, n = Array(t); ++r < t;) {
          n[r] = e(r);
        }

        return n;
      }

      function Ne(t) {
        return function (e) {
          return t(e);
        };
      }

      function ke(t, e) {
        return le(e, function (e) {
          return t[e];
        });
      }

      function _e(t, e) {
        return t.has(e);
      }

      function Re(t, e) {
        for (var r = -1, n = t.length; ++r < n && Ee(e, t[r], 0) > -1;) {
          ;
        }

        return r;
      }

      function Pe(t, e) {
        for (var r = t.length; r-- && Ee(e, t[r], 0) > -1;) {
          ;
        }

        return r;
      }

      function Fe(t, e) {
        for (var r = t.length, n = 0; r--;) {
          t[r] === e && ++n;
        }

        return n;
      }

      var Le = Ae({
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "Ç": "C",
        "ç": "c",
        "Ð": "D",
        "ð": "d",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "Ñ": "N",
        "ñ": "n",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ø": "O",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ø": "o",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "Ý": "Y",
        "ý": "y",
        "ÿ": "y",
        "Æ": "Ae",
        "æ": "ae",
        "Þ": "Th",
        "þ": "th",
        "ß": "ss",
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
      }),
          Ue = Ae({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      });

      function Oe(t) {
        return "\\" + xt[t];
      }

      function De(t) {
        return Lt.test(t);
      }

      function Ke(t) {
        var e = -1,
            r = Array(t.size);
        return t.forEach(function (t, n) {
          r[++e] = [n, t];
        }), r;
      }

      function Ve(t, e) {
        return function (r) {
          return t(e(r));
        };
      }

      function xe(t, e) {
        for (var r = -1, n = t.length, a = 0, o = []; ++r < n;) {
          var s = t[r];
          s !== e && s !== i || (t[r] = i, o[a++] = r);
        }

        return o;
      }

      function je(t) {
        var e = -1,
            r = Array(t.size);
        return t.forEach(function (t) {
          r[++e] = t;
        }), r;
      }

      function Me(t) {
        var e = -1,
            r = Array(t.size);
        return t.forEach(function (t) {
          r[++e] = [t, t];
        }), r;
      }

      function He(t) {
        return De(t) ? function (t) {
          var e = Pt.lastIndex = 0;

          for (; Pt.test(t);) {
            ++e;
          }

          return e;
        }(t) : ge(t);
      }

      function ze(t) {
        return De(t) ? function (t) {
          return t.match(Pt) || [];
        }(t) : function (t) {
          return t.split("");
        }(t);
      }

      var Ge = Ae({
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      });

      var qe = function t(e) {
        var r,
            ft = (e = null == e ? Gt : qe.defaults(Gt.Object(), e, qe.pick(Gt, Ot))).Array,
            lt = e.Date,
            ht = e.Error,
            pt = e.Function,
            dt = e.Math,
            yt = e.Object,
            gt = e.RegExp,
            vt = e.String,
            mt = e.TypeError,
            Et = ft.prototype,
            Ct = pt.prototype,
            St = yt.prototype,
            bt = e["__core-js_shared__"],
            Tt = Ct.toString,
            At = St.hasOwnProperty,
            It = 0,
            Bt = (r = /[^.]+$/.exec(bt && bt.keys && bt.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "",
            wt = St.toString,
            Nt = Tt.call(yt),
            kt = Gt._,
            Pt = gt("^" + Tt.call(At).replace(z, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
            Lt = Qt ? e.Buffer : void 0,
            xt = e.Symbol,
            Ht = e.Uint8Array,
            zt = Lt ? Lt.allocUnsafe : void 0,
            qt = Ve(yt.getPrototypeOf, yt),
            Wt = yt.create,
            Xt = St.propertyIsEnumerable,
            Yt = Et.splice,
            ge = xt ? xt.isConcatSpreadable : void 0,
            Ae = xt ? xt.iterator : void 0,
            We = xt ? xt.toStringTag : void 0,
            Qe = function () {
          try {
            var t = $i(yt, "defineProperty");
            return t({}, "", {}), t;
          } catch (t) {}
        }(),
            Xe = e.clearTimeout !== Gt.clearTimeout && e.clearTimeout,
            Ye = lt && lt.now !== Gt.Date.now && lt.now,
            Ze = e.setTimeout !== Gt.setTimeout && e.setTimeout,
            Je = dt.ceil,
            $e = dt.floor,
            tr = yt.getOwnPropertySymbols,
            er = Lt ? Lt.isBuffer : void 0,
            rr = e.isFinite,
            nr = Et.join,
            ir = Ve(yt.keys, yt),
            ar = dt.max,
            or = dt.min,
            sr = lt.now,
            ur = e.parseInt,
            cr = dt.random,
            fr = Et.reverse,
            lr = $i(e, "DataView"),
            hr = $i(e, "Map"),
            pr = $i(e, "Promise"),
            dr = $i(e, "Set"),
            yr = $i(e, "WeakMap"),
            gr = $i(yt, "create"),
            vr = yr && new yr(),
            mr = {},
            Er = Ba(lr),
            Cr = Ba(hr),
            Sr = Ba(pr),
            br = Ba(dr),
            Tr = Ba(yr),
            Ar = xt ? xt.prototype : void 0,
            Ir = Ar ? Ar.valueOf : void 0,
            Br = Ar ? Ar.toString : void 0;

        function wr(t) {
          if (zo(t) && !Fo(t) && !(t instanceof Rr)) {
            if (t instanceof _r) return t;
            if (At.call(t, "__wrapped__")) return wa(t);
          }

          return new _r(t);
        }

        var Nr = function () {
          function t() {}

          return function (e) {
            if (!Ho(e)) return {};
            if (Wt) return Wt(e);
            t.prototype = e;
            var r = new t();
            return t.prototype = void 0, r;
          };
        }();

        function kr() {}

        function _r(t, e) {
          this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = void 0;
        }

        function Rr(t) {
          this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
        }

        function Pr(t) {
          var e = -1,
              r = null == t ? 0 : t.length;

          for (this.clear(); ++e < r;) {
            var n = t[e];
            this.set(n[0], n[1]);
          }
        }

        function Fr(t) {
          var e = -1,
              r = null == t ? 0 : t.length;

          for (this.clear(); ++e < r;) {
            var n = t[e];
            this.set(n[0], n[1]);
          }
        }

        function Lr(t) {
          var e = -1,
              r = null == t ? 0 : t.length;

          for (this.clear(); ++e < r;) {
            var n = t[e];
            this.set(n[0], n[1]);
          }
        }

        function Ur(t) {
          var e = -1,
              r = null == t ? 0 : t.length;

          for (this.__data__ = new Lr(); ++e < r;) {
            this.add(t[e]);
          }
        }

        function Or(t) {
          var e = this.__data__ = new Fr(t);
          this.size = e.size;
        }

        function Dr(t, e) {
          var r = Fo(t),
              n = !r && Po(t),
              i = !r && !n && Do(t),
              a = !r && !n && !i && Jo(t),
              o = r || n || i || a,
              s = o ? we(t.length, vt) : [],
              u = s.length;

          for (var c in t) {
            !e && !At.call(t, c) || o && ("length" == c || i && ("offset" == c || "parent" == c) || a && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || oa(c, u)) || s.push(c);
          }

          return s;
        }

        function Kr(t) {
          var e = t.length;
          return e ? t[On(0, e - 1)] : void 0;
        }

        function Vr(t, e) {
          return Ta(vi(t), Qr(e, 0, t.length));
        }

        function xr(t) {
          return Ta(vi(t));
        }

        function jr(t, e, r) {
          (void 0 === r || ko(t[e], r)) && (void 0 !== r || e in t) || qr(t, e, r);
        }

        function Mr(t, e, r) {
          var n = t[e];
          At.call(t, e) && ko(n, r) && (void 0 !== r || e in t) || qr(t, e, r);
        }

        function Hr(t, e) {
          for (var r = t.length; r--;) {
            if (ko(t[r][0], e)) return r;
          }

          return -1;
        }

        function zr(t, e, r, n) {
          return $r(t, function (t, i, a) {
            e(n, t, r(t), a);
          }), n;
        }

        function Gr(t, e) {
          return t && mi(e, Cs(e), t);
        }

        function qr(t, e, r) {
          "__proto__" == e && Qe ? Qe(t, e, {
            configurable: !0,
            enumerable: !0,
            value: r,
            writable: !0
          }) : t[e] = r;
        }

        function Wr(t, e) {
          for (var r = -1, n = e.length, i = ft(n), a = null == t; ++r < n;) {
            i[r] = a ? void 0 : ys(t, e[r]);
          }

          return i;
        }

        function Qr(t, e, r) {
          return t == t && (void 0 !== r && (t = t <= r ? t : r), void 0 !== e && (t = t >= e ? t : e)), t;
        }

        function Xr(t, e, r, n, i, a) {
          var s,
              f = 1 & e,
              C = 2 & e,
              R = 4 & e;
          if (r && (s = i ? r(t, n, i, a) : r(t)), void 0 !== s) return s;
          if (!Ho(t)) return t;
          var P = Fo(t);

          if (P) {
            if (s = function (t) {
              var e = t.length,
                  r = new t.constructor(e);
              e && "string" == typeof t[0] && At.call(t, "index") && (r.index = t.index, r.input = t.input);
              return r;
            }(t), !f) return vi(t, s);
          } else {
            var F = ra(t),
                L = F == l || F == h;
            if (Do(t)) return li(t, f);

            if (F == y || F == o || L && !i) {
              if (s = C || L ? {} : ia(t), !f) return C ? function (t, e) {
                return mi(t, ea(t), e);
              }(t, function (t, e) {
                return t && mi(e, Ss(e), t);
              }(s, t)) : function (t, e) {
                return mi(t, ta(t), e);
              }(t, Gr(s, t));
            } else {
              if (!Vt[F]) return i ? t : {};

              s = function (t, e, r) {
                var n = t.constructor;

                switch (e) {
                  case S:
                    return hi(t);

                  case u:
                  case c:
                    return new n(+t);

                  case b:
                    return function (t, e) {
                      var r = e ? hi(t.buffer) : t.buffer;
                      return new t.constructor(r, t.byteOffset, t.byteLength);
                    }(t, r);

                  case T:
                  case A:
                  case I:
                  case B:
                  case w:
                  case N:
                  case "[object Uint8ClampedArray]":
                  case k:
                  case _:
                    return pi(t, r);

                  case p:
                    return new n();

                  case d:
                  case m:
                    return new n(t);

                  case g:
                    return function (t) {
                      var e = new t.constructor(t.source, et.exec(t));
                      return e.lastIndex = t.lastIndex, e;
                    }(t);

                  case v:
                    return new n();

                  case E:
                    return i = t, Ir ? yt(Ir.call(i)) : {};
                }

                var i;
              }(t, F, f);
            }
          }

          a || (a = new Or());
          var U = a.get(t);
          if (U) return U;
          a.set(t, s), Xo(t) ? t.forEach(function (n) {
            s.add(Xr(n, e, r, n, t, a));
          }) : Go(t) && t.forEach(function (n, i) {
            s.set(i, Xr(n, e, r, i, t, a));
          });
          var O = P ? void 0 : (R ? C ? qi : Gi : C ? Ss : Cs)(t);
          return ae(O || t, function (n, i) {
            O && (n = t[i = n]), Mr(s, i, Xr(n, e, r, i, t, a));
          }), s;
        }

        function Yr(t, e, r) {
          var n = r.length;
          if (null == t) return !n;

          for (t = yt(t); n--;) {
            var i = r[n],
                a = e[i],
                o = t[i];
            if (void 0 === o && !(i in t) || !a(o)) return !1;
          }

          return !0;
        }

        function Zr(t, e, r) {
          if ("function" != typeof t) throw new mt(n);
          return Ea(function () {
            t.apply(void 0, r);
          }, e);
        }

        function Jr(t, e, r, n) {
          var i = -1,
              a = ce,
              o = !0,
              s = t.length,
              u = [],
              c = e.length;
          if (!s) return u;
          r && (e = le(e, Ne(r))), n ? (a = fe, o = !1) : e.length >= 200 && (a = _e, o = !1, e = new Ur(e));

          t: for (; ++i < s;) {
            var f = t[i],
                l = null == r ? f : r(f);

            if (f = n || 0 !== f ? f : 0, o && l == l) {
              for (var h = c; h--;) {
                if (e[h] === l) continue t;
              }

              u.push(f);
            } else a(e, l, n) || u.push(f);
          }

          return u;
        }

        wr.templateSettings = {
          escape: K,
          evaluate: V,
          interpolate: x,
          variable: "",
          imports: {
            _: wr
          }
        }, wr.prototype = kr.prototype, wr.prototype.constructor = wr, _r.prototype = Nr(kr.prototype), _r.prototype.constructor = _r, Rr.prototype = Nr(kr.prototype), Rr.prototype.constructor = Rr, Pr.prototype.clear = function () {
          this.__data__ = gr ? gr(null) : {}, this.size = 0;
        }, Pr.prototype.delete = function (t) {
          var e = this.has(t) && delete this.__data__[t];
          return this.size -= e ? 1 : 0, e;
        }, Pr.prototype.get = function (t) {
          var e = this.__data__;

          if (gr) {
            var r = e[t];
            return "__lodash_hash_undefined__" === r ? void 0 : r;
          }

          return At.call(e, t) ? e[t] : void 0;
        }, Pr.prototype.has = function (t) {
          var e = this.__data__;
          return gr ? void 0 !== e[t] : At.call(e, t);
        }, Pr.prototype.set = function (t, e) {
          var r = this.__data__;
          return this.size += this.has(t) ? 0 : 1, r[t] = gr && void 0 === e ? "__lodash_hash_undefined__" : e, this;
        }, Fr.prototype.clear = function () {
          this.__data__ = [], this.size = 0;
        }, Fr.prototype.delete = function (t) {
          var e = this.__data__,
              r = Hr(e, t);
          return !(r < 0) && (r == e.length - 1 ? e.pop() : Yt.call(e, r, 1), --this.size, !0);
        }, Fr.prototype.get = function (t) {
          var e = this.__data__,
              r = Hr(e, t);
          return r < 0 ? void 0 : e[r][1];
        }, Fr.prototype.has = function (t) {
          return Hr(this.__data__, t) > -1;
        }, Fr.prototype.set = function (t, e) {
          var r = this.__data__,
              n = Hr(r, t);
          return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
        }, Lr.prototype.clear = function () {
          this.size = 0, this.__data__ = {
            hash: new Pr(),
            map: new (hr || Fr)(),
            string: new Pr()
          };
        }, Lr.prototype.delete = function (t) {
          var e = Zi(this, t).delete(t);
          return this.size -= e ? 1 : 0, e;
        }, Lr.prototype.get = function (t) {
          return Zi(this, t).get(t);
        }, Lr.prototype.has = function (t) {
          return Zi(this, t).has(t);
        }, Lr.prototype.set = function (t, e) {
          var r = Zi(this, t),
              n = r.size;
          return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
        }, Ur.prototype.add = Ur.prototype.push = function (t) {
          return this.__data__.set(t, "__lodash_hash_undefined__"), this;
        }, Ur.prototype.has = function (t) {
          return this.__data__.has(t);
        }, Or.prototype.clear = function () {
          this.__data__ = new Fr(), this.size = 0;
        }, Or.prototype.delete = function (t) {
          var e = this.__data__,
              r = e.delete(t);
          return this.size = e.size, r;
        }, Or.prototype.get = function (t) {
          return this.__data__.get(t);
        }, Or.prototype.has = function (t) {
          return this.__data__.has(t);
        }, Or.prototype.set = function (t, e) {
          var r = this.__data__;

          if (r instanceof Fr) {
            var n = r.__data__;
            if (!hr || n.length < 199) return n.push([t, e]), this.size = ++r.size, this;
            r = this.__data__ = new Lr(n);
          }

          return r.set(t, e), this.size = r.size, this;
        };
        var $r = Si(un),
            tn = Si(cn, !0);

        function en(t, e) {
          var r = !0;
          return $r(t, function (t, n, i) {
            return r = !!e(t, n, i);
          }), r;
        }

        function rn(t, e, r) {
          for (var n = -1, i = t.length; ++n < i;) {
            var a = t[n],
                o = e(a);
            if (null != o && (void 0 === s ? o == o && !Zo(o) : r(o, s))) var s = o,
                u = a;
          }

          return u;
        }

        function nn(t, e) {
          var r = [];
          return $r(t, function (t, n, i) {
            e(t, n, i) && r.push(t);
          }), r;
        }

        function an(t, e, r, n, i) {
          var a = -1,
              o = t.length;

          for (r || (r = aa), i || (i = []); ++a < o;) {
            var s = t[a];
            e > 0 && r(s) ? e > 1 ? an(s, e - 1, r, n, i) : he(i, s) : n || (i[i.length] = s);
          }

          return i;
        }

        var on = bi(),
            sn = bi(!0);

        function un(t, e) {
          return t && on(t, e, Cs);
        }

        function cn(t, e) {
          return t && sn(t, e, Cs);
        }

        function fn(t, e) {
          return ue(e, function (e) {
            return xo(t[e]);
          });
        }

        function ln(t, e) {
          for (var r = 0, n = (e = si(e, t)).length; null != t && r < n;) {
            t = t[Ia(e[r++])];
          }

          return r && r == n ? t : void 0;
        }

        function hn(t, e, r) {
          var n = e(t);
          return Fo(t) ? n : he(n, r(t));
        }

        function pn(t) {
          return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : We && We in yt(t) ? function (t) {
            var e = At.call(t, We),
                r = t[We];

            try {
              t[We] = void 0;
              var n = !0;
            } catch (t) {}

            var i = wt.call(t);
            n && (e ? t[We] = r : delete t[We]);
            return i;
          }(t) : function (t) {
            return wt.call(t);
          }(t);
        }

        function dn(t, e) {
          return t > e;
        }

        function yn(t, e) {
          return null != t && At.call(t, e);
        }

        function gn(t, e) {
          return null != t && e in yt(t);
        }

        function vn(t, e, r) {
          for (var n = r ? fe : ce, i = t[0].length, a = t.length, o = a, s = ft(a), u = 1 / 0, c = []; o--;) {
            var f = t[o];
            o && e && (f = le(f, Ne(e))), u = or(f.length, u), s[o] = !r && (e || i >= 120 && f.length >= 120) ? new Ur(o && f) : void 0;
          }

          f = t[0];
          var l = -1,
              h = s[0];

          t: for (; ++l < i && c.length < u;) {
            var p = f[l],
                d = e ? e(p) : p;

            if (p = r || 0 !== p ? p : 0, !(h ? _e(h, d) : n(c, d, r))) {
              for (o = a; --o;) {
                var y = s[o];
                if (!(y ? _e(y, d) : n(t[o], d, r))) continue t;
              }

              h && h.push(d), c.push(p);
            }
          }

          return c;
        }

        function mn(t, e, r) {
          var n = null == (t = ya(t, e = si(e, t))) ? t : t[Ia(Ka(e))];
          return null == n ? void 0 : ne(n, t, r);
        }

        function En(t) {
          return zo(t) && pn(t) == o;
        }

        function Cn(t, e, r, n, i) {
          return t === e || (null == t || null == e || !zo(t) && !zo(e) ? t != t && e != e : function (t, e, r, n, i, a) {
            var l = Fo(t),
                h = Fo(e),
                C = l ? s : ra(t),
                T = h ? s : ra(e),
                A = (C = C == o ? y : C) == y,
                I = (T = T == o ? y : T) == y,
                B = C == T;

            if (B && Do(t)) {
              if (!Do(e)) return !1;
              l = !0, A = !1;
            }

            if (B && !A) return a || (a = new Or()), l || Jo(t) ? Hi(t, e, r, n, i, a) : function (t, e, r, n, i, a, o) {
              switch (r) {
                case b:
                  if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                  t = t.buffer, e = e.buffer;

                case S:
                  return !(t.byteLength != e.byteLength || !a(new Ht(t), new Ht(e)));

                case u:
                case c:
                case d:
                  return ko(+t, +e);

                case f:
                  return t.name == e.name && t.message == e.message;

                case g:
                case m:
                  return t == e + "";

                case p:
                  var s = Ke;

                case v:
                  var l = 1 & n;
                  if (s || (s = je), t.size != e.size && !l) return !1;
                  var h = o.get(t);
                  if (h) return h == e;
                  n |= 2, o.set(t, e);
                  var y = Hi(s(t), s(e), n, i, a, o);
                  return o.delete(t), y;

                case E:
                  if (Ir) return Ir.call(t) == Ir.call(e);
              }

              return !1;
            }(t, e, C, r, n, i, a);

            if (!(1 & r)) {
              var w = A && At.call(t, "__wrapped__"),
                  N = I && At.call(e, "__wrapped__");

              if (w || N) {
                var k = w ? t.value() : t,
                    _ = N ? e.value() : e;

                return a || (a = new Or()), i(k, _, r, n, a);
              }
            }

            if (!B) return !1;
            return a || (a = new Or()), function (t, e, r, n, i, a) {
              var o = 1 & r,
                  s = Gi(t),
                  u = s.length,
                  c = Gi(e).length;
              if (u != c && !o) return !1;
              var f = u;

              for (; f--;) {
                var l = s[f];
                if (!(o ? l in e : At.call(e, l))) return !1;
              }

              var h = a.get(t);
              if (h && a.get(e)) return h == e;
              var p = !0;
              a.set(t, e), a.set(e, t);
              var d = o;

              for (; ++f < u;) {
                l = s[f];
                var y = t[l],
                    g = e[l];
                if (n) var v = o ? n(g, y, l, e, t, a) : n(y, g, l, t, e, a);

                if (!(void 0 === v ? y === g || i(y, g, r, n, a) : v)) {
                  p = !1;
                  break;
                }

                d || (d = "constructor" == l);
              }

              if (p && !d) {
                var m = t.constructor,
                    E = e.constructor;
                m != E && "constructor" in t && "constructor" in e && !("function" == typeof m && m instanceof m && "function" == typeof E && E instanceof E) && (p = !1);
              }

              return a.delete(t), a.delete(e), p;
            }(t, e, r, n, i, a);
          }(t, e, r, n, Cn, i));
        }

        function Sn(t, e, r, n) {
          var i = r.length,
              a = i,
              o = !n;
          if (null == t) return !a;

          for (t = yt(t); i--;) {
            var s = r[i];
            if (o && s[2] ? s[1] !== t[s[0]] : !(s[0] in t)) return !1;
          }

          for (; ++i < a;) {
            var u = (s = r[i])[0],
                c = t[u],
                f = s[1];

            if (o && s[2]) {
              if (void 0 === c && !(u in t)) return !1;
            } else {
              var l = new Or();
              if (n) var h = n(c, f, u, t, e, l);
              if (!(void 0 === h ? Cn(f, c, 3, n, l) : h)) return !1;
            }
          }

          return !0;
        }

        function bn(t) {
          return !(!Ho(t) || (e = t, Bt && Bt in e)) && (xo(t) ? Pt : it).test(Ba(t));
          var e;
        }

        function Tn(t) {
          return "function" == typeof t ? t : null == t ? qs : "object" == typeof t ? Fo(t) ? kn(t[0], t[1]) : Nn(t) : eu(t);
        }

        function An(t) {
          if (!la(t)) return ir(t);
          var e = [];

          for (var r in yt(t)) {
            At.call(t, r) && "constructor" != r && e.push(r);
          }

          return e;
        }

        function In(t) {
          if (!Ho(t)) return function (t) {
            var e = [];
            if (null != t) for (var r in yt(t)) {
              e.push(r);
            }
            return e;
          }(t);
          var e = la(t),
              r = [];

          for (var n in t) {
            ("constructor" != n || !e && At.call(t, n)) && r.push(n);
          }

          return r;
        }

        function Bn(t, e) {
          return t < e;
        }

        function wn(t, e) {
          var r = -1,
              n = Uo(t) ? ft(t.length) : [];
          return $r(t, function (t, i, a) {
            n[++r] = e(t, i, a);
          }), n;
        }

        function Nn(t) {
          var e = Ji(t);
          return 1 == e.length && e[0][2] ? pa(e[0][0], e[0][1]) : function (r) {
            return r === t || Sn(r, t, e);
          };
        }

        function kn(t, e) {
          return ua(t) && ha(e) ? pa(Ia(t), e) : function (r) {
            var n = ys(r, t);
            return void 0 === n && n === e ? gs(r, t) : Cn(e, n, 3);
          };
        }

        function _n(t, e, r, n, i) {
          t !== e && on(e, function (a, o) {
            if (i || (i = new Or()), Ho(a)) !function (t, e, r, n, i, a, o) {
              var s = va(t, r),
                  u = va(e, r),
                  c = o.get(u);
              if (c) return void jr(t, r, c);
              var f = a ? a(s, u, r + "", t, e, o) : void 0,
                  l = void 0 === f;

              if (l) {
                var h = Fo(u),
                    p = !h && Do(u),
                    d = !h && !p && Jo(u);
                f = u, h || p || d ? Fo(s) ? f = s : Oo(s) ? f = vi(s) : p ? (l = !1, f = li(u, !0)) : d ? (l = !1, f = pi(u, !0)) : f = [] : Wo(u) || Po(u) ? (f = s, Po(s) ? f = os(s) : Ho(s) && !xo(s) || (f = ia(u))) : l = !1;
              }

              l && (o.set(u, f), i(f, u, n, a, o), o.delete(u));
              jr(t, r, f);
            }(t, e, o, r, _n, n, i);else {
              var s = n ? n(va(t, o), a, o + "", t, e, i) : void 0;
              void 0 === s && (s = a), jr(t, o, s);
            }
          }, Ss);
        }

        function Rn(t, e) {
          var r = t.length;
          if (r) return oa(e += e < 0 ? r : 0, r) ? t[e] : void 0;
        }

        function Pn(t, e, r) {
          var n = -1;
          return e = le(e.length ? e : [qs], Ne(Yi())), function (t, e) {
            var r = t.length;

            for (t.sort(e); r--;) {
              t[r] = t[r].value;
            }

            return t;
          }(wn(t, function (t, r, i) {
            return {
              criteria: le(e, function (e) {
                return e(t);
              }),
              index: ++n,
              value: t
            };
          }), function (t, e) {
            return function (t, e, r) {
              var n = -1,
                  i = t.criteria,
                  a = e.criteria,
                  o = i.length,
                  s = r.length;

              for (; ++n < o;) {
                var u = di(i[n], a[n]);

                if (u) {
                  if (n >= s) return u;
                  var c = r[n];
                  return u * ("desc" == c ? -1 : 1);
                }
              }

              return t.index - e.index;
            }(t, e, r);
          });
        }

        function Fn(t, e, r) {
          for (var n = -1, i = e.length, a = {}; ++n < i;) {
            var o = e[n],
                s = ln(t, o);
            r(s, o) && jn(a, si(o, t), s);
          }

          return a;
        }

        function Ln(t, e, r, n) {
          var i = n ? Ce : Ee,
              a = -1,
              o = e.length,
              s = t;

          for (t === e && (e = vi(e)), r && (s = le(t, Ne(r))); ++a < o;) {
            for (var u = 0, c = e[a], f = r ? r(c) : c; (u = i(s, f, u, n)) > -1;) {
              s !== t && Yt.call(s, u, 1), Yt.call(t, u, 1);
            }
          }

          return t;
        }

        function Un(t, e) {
          for (var r = t ? e.length : 0, n = r - 1; r--;) {
            var i = e[r];

            if (r == n || i !== a) {
              var a = i;
              oa(i) ? Yt.call(t, i, 1) : $n(t, i);
            }
          }

          return t;
        }

        function On(t, e) {
          return t + $e(cr() * (e - t + 1));
        }

        function Dn(t, e) {
          var r = "";
          if (!t || e < 1 || e > 9007199254740991) return r;

          do {
            e % 2 && (r += t), (e = $e(e / 2)) && (t += t);
          } while (e);

          return r;
        }

        function Kn(t, e) {
          return Ca(da(t, e, qs), t + "");
        }

        function Vn(t) {
          return Kr(ks(t));
        }

        function xn(t, e) {
          var r = ks(t);
          return Ta(r, Qr(e, 0, r.length));
        }

        function jn(t, e, r, n) {
          if (!Ho(t)) return t;

          for (var i = -1, a = (e = si(e, t)).length, o = a - 1, s = t; null != s && ++i < a;) {
            var u = Ia(e[i]),
                c = r;

            if (i != o) {
              var f = s[u];
              void 0 === (c = n ? n(f, u, s) : void 0) && (c = Ho(f) ? f : oa(e[i + 1]) ? [] : {});
            }

            Mr(s, u, c), s = s[u];
          }

          return t;
        }

        var Mn = vr ? function (t, e) {
          return vr.set(t, e), t;
        } : qs,
            Hn = Qe ? function (t, e) {
          return Qe(t, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Hs(e),
            writable: !0
          });
        } : qs;

        function zn(t) {
          return Ta(ks(t));
        }

        function Gn(t, e, r) {
          var n = -1,
              i = t.length;
          e < 0 && (e = -e > i ? 0 : i + e), (r = r > i ? i : r) < 0 && (r += i), i = e > r ? 0 : r - e >>> 0, e >>>= 0;

          for (var a = ft(i); ++n < i;) {
            a[n] = t[n + e];
          }

          return a;
        }

        function qn(t, e) {
          var r;
          return $r(t, function (t, n, i) {
            return !(r = e(t, n, i));
          }), !!r;
        }

        function Wn(t, e, r) {
          var n = 0,
              i = null == t ? n : t.length;

          if ("number" == typeof e && e == e && i <= 2147483647) {
            for (; n < i;) {
              var a = n + i >>> 1,
                  o = t[a];
              null !== o && !Zo(o) && (r ? o <= e : o < e) ? n = a + 1 : i = a;
            }

            return i;
          }

          return Qn(t, e, qs, r);
        }

        function Qn(t, e, r, n) {
          e = r(e);

          for (var i = 0, a = null == t ? 0 : t.length, o = e != e, s = null === e, u = Zo(e), c = void 0 === e; i < a;) {
            var f = $e((i + a) / 2),
                l = r(t[f]),
                h = void 0 !== l,
                p = null === l,
                d = l == l,
                y = Zo(l);
            if (o) var g = n || d;else g = c ? d && (n || h) : s ? d && h && (n || !p) : u ? d && h && !p && (n || !y) : !p && !y && (n ? l <= e : l < e);
            g ? i = f + 1 : a = f;
          }

          return or(a, 4294967294);
        }

        function Xn(t, e) {
          for (var r = -1, n = t.length, i = 0, a = []; ++r < n;) {
            var o = t[r],
                s = e ? e(o) : o;

            if (!r || !ko(s, u)) {
              var u = s;
              a[i++] = 0 === o ? 0 : o;
            }
          }

          return a;
        }

        function Yn(t) {
          return "number" == typeof t ? t : Zo(t) ? NaN : +t;
        }

        function Zn(t) {
          if ("string" == typeof t) return t;
          if (Fo(t)) return le(t, Zn) + "";
          if (Zo(t)) return Br ? Br.call(t) : "";
          var e = t + "";
          return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
        }

        function Jn(t, e, r) {
          var n = -1,
              i = ce,
              a = t.length,
              o = !0,
              s = [],
              u = s;
          if (r) o = !1, i = fe;else if (a >= 200) {
            var c = e ? null : Di(t);
            if (c) return je(c);
            o = !1, i = _e, u = new Ur();
          } else u = e ? [] : s;

          t: for (; ++n < a;) {
            var f = t[n],
                l = e ? e(f) : f;

            if (f = r || 0 !== f ? f : 0, o && l == l) {
              for (var h = u.length; h--;) {
                if (u[h] === l) continue t;
              }

              e && u.push(l), s.push(f);
            } else i(u, l, r) || (u !== s && u.push(l), s.push(f));
          }

          return s;
        }

        function $n(t, e) {
          return null == (t = ya(t, e = si(e, t))) || delete t[Ia(Ka(e))];
        }

        function ti(t, e, r, n) {
          return jn(t, e, r(ln(t, e)), n);
        }

        function ei(t, e, r, n) {
          for (var i = t.length, a = n ? i : -1; (n ? a-- : ++a < i) && e(t[a], a, t);) {
            ;
          }

          return r ? Gn(t, n ? 0 : a, n ? a + 1 : i) : Gn(t, n ? a + 1 : 0, n ? i : a);
        }

        function ri(t, e) {
          var r = t;
          return r instanceof Rr && (r = r.value()), pe(e, function (t, e) {
            return e.func.apply(e.thisArg, he([t], e.args));
          }, r);
        }

        function ni(t, e, r) {
          var n = t.length;
          if (n < 2) return n ? Jn(t[0]) : [];

          for (var i = -1, a = ft(n); ++i < n;) {
            for (var o = t[i], s = -1; ++s < n;) {
              s != i && (a[i] = Jr(a[i] || o, t[s], e, r));
            }
          }

          return Jn(an(a, 1), e, r);
        }

        function ii(t, e, r) {
          for (var n = -1, i = t.length, a = e.length, o = {}; ++n < i;) {
            var s = n < a ? e[n] : void 0;
            r(o, t[n], s);
          }

          return o;
        }

        function ai(t) {
          return Oo(t) ? t : [];
        }

        function oi(t) {
          return "function" == typeof t ? t : qs;
        }

        function si(t, e) {
          return Fo(t) ? t : ua(t, e) ? [t] : Aa(ss(t));
        }

        var ui = Kn;

        function ci(t, e, r) {
          var n = t.length;
          return r = void 0 === r ? n : r, !e && r >= n ? t : Gn(t, e, r);
        }

        var fi = Xe || function (t) {
          return Gt.clearTimeout(t);
        };

        function li(t, e) {
          if (e) return t.slice();
          var r = t.length,
              n = zt ? zt(r) : new t.constructor(r);
          return t.copy(n), n;
        }

        function hi(t) {
          var e = new t.constructor(t.byteLength);
          return new Ht(e).set(new Ht(t)), e;
        }

        function pi(t, e) {
          var r = e ? hi(t.buffer) : t.buffer;
          return new t.constructor(r, t.byteOffset, t.length);
        }

        function di(t, e) {
          if (t !== e) {
            var r = void 0 !== t,
                n = null === t,
                i = t == t,
                a = Zo(t),
                o = void 0 !== e,
                s = null === e,
                u = e == e,
                c = Zo(e);
            if (!s && !c && !a && t > e || a && o && u && !s && !c || n && o && u || !r && u || !i) return 1;
            if (!n && !a && !c && t < e || c && r && i && !n && !a || s && r && i || !o && i || !u) return -1;
          }

          return 0;
        }

        function yi(t, e, r, n) {
          for (var i = -1, a = t.length, o = r.length, s = -1, u = e.length, c = ar(a - o, 0), f = ft(u + c), l = !n; ++s < u;) {
            f[s] = e[s];
          }

          for (; ++i < o;) {
            (l || i < a) && (f[r[i]] = t[i]);
          }

          for (; c--;) {
            f[s++] = t[i++];
          }

          return f;
        }

        function gi(t, e, r, n) {
          for (var i = -1, a = t.length, o = -1, s = r.length, u = -1, c = e.length, f = ar(a - s, 0), l = ft(f + c), h = !n; ++i < f;) {
            l[i] = t[i];
          }

          for (var p = i; ++u < c;) {
            l[p + u] = e[u];
          }

          for (; ++o < s;) {
            (h || i < a) && (l[p + r[o]] = t[i++]);
          }

          return l;
        }

        function vi(t, e) {
          var r = -1,
              n = t.length;

          for (e || (e = ft(n)); ++r < n;) {
            e[r] = t[r];
          }

          return e;
        }

        function mi(t, e, r, n) {
          var i = !r;
          r || (r = {});

          for (var a = -1, o = e.length; ++a < o;) {
            var s = e[a],
                u = n ? n(r[s], t[s], s, r, t) : void 0;
            void 0 === u && (u = t[s]), i ? qr(r, s, u) : Mr(r, s, u);
          }

          return r;
        }

        function Ei(t, e) {
          return function (r, n) {
            var i = Fo(r) ? ie : zr,
                a = e ? e() : {};
            return i(r, t, Yi(n, 2), a);
          };
        }

        function Ci(t) {
          return Kn(function (e, r) {
            var n = -1,
                i = r.length,
                a = i > 1 ? r[i - 1] : void 0,
                o = i > 2 ? r[2] : void 0;

            for (a = t.length > 3 && "function" == typeof a ? (i--, a) : void 0, o && sa(r[0], r[1], o) && (a = i < 3 ? void 0 : a, i = 1), e = yt(e); ++n < i;) {
              var s = r[n];
              s && t(e, s, n, a);
            }

            return e;
          });
        }

        function Si(t, e) {
          return function (r, n) {
            if (null == r) return r;
            if (!Uo(r)) return t(r, n);

            for (var i = r.length, a = e ? i : -1, o = yt(r); (e ? a-- : ++a < i) && !1 !== n(o[a], a, o);) {
              ;
            }

            return r;
          };
        }

        function bi(t) {
          return function (e, r, n) {
            for (var i = -1, a = yt(e), o = n(e), s = o.length; s--;) {
              var u = o[t ? s : ++i];
              if (!1 === r(a[u], u, a)) break;
            }

            return e;
          };
        }

        function Ti(t) {
          return function (e) {
            var r = De(e = ss(e)) ? ze(e) : void 0,
                n = r ? r[0] : e.charAt(0),
                i = r ? ci(r, 1).join("") : e.slice(1);
            return n[t]() + i;
          };
        }

        function Ai(t) {
          return function (e) {
            return pe(xs(Ps(e).replace(_t, "")), t, "");
          };
        }

        function Ii(t) {
          return function () {
            var e = arguments;

            switch (e.length) {
              case 0:
                return new t();

              case 1:
                return new t(e[0]);

              case 2:
                return new t(e[0], e[1]);

              case 3:
                return new t(e[0], e[1], e[2]);

              case 4:
                return new t(e[0], e[1], e[2], e[3]);

              case 5:
                return new t(e[0], e[1], e[2], e[3], e[4]);

              case 6:
                return new t(e[0], e[1], e[2], e[3], e[4], e[5]);

              case 7:
                return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
            }

            var r = Nr(t.prototype),
                n = t.apply(r, e);
            return Ho(n) ? n : r;
          };
        }

        function Bi(t) {
          return function (e, r, n) {
            var i = yt(e);

            if (!Uo(e)) {
              var a = Yi(r, 3);
              e = Cs(e), r = function r(t) {
                return a(i[t], t, i);
              };
            }

            var o = t(e, r, n);
            return o > -1 ? i[a ? e[o] : o] : void 0;
          };
        }

        function wi(t) {
          return zi(function (e) {
            var r = e.length,
                i = r,
                a = _r.prototype.thru;

            for (t && e.reverse(); i--;) {
              var o = e[i];
              if ("function" != typeof o) throw new mt(n);
              if (a && !s && "wrapper" == Qi(o)) var s = new _r([], !0);
            }

            for (i = s ? i : r; ++i < r;) {
              var u = Qi(o = e[i]),
                  c = "wrapper" == u ? Wi(o) : void 0;
              s = c && ca(c[0]) && 424 == c[1] && !c[4].length && 1 == c[9] ? s[Qi(c[0])].apply(s, c[3]) : 1 == o.length && ca(o) ? s[u]() : s.thru(o);
            }

            return function () {
              var t = arguments,
                  n = t[0];
              if (s && 1 == t.length && Fo(n)) return s.plant(n).value();

              for (var i = 0, a = r ? e[i].apply(this, t) : n; ++i < r;) {
                a = e[i].call(this, a);
              }

              return a;
            };
          });
        }

        function Ni(t, e, r, n, i, a, o, s, u, c) {
          var f = 128 & e,
              l = 1 & e,
              h = 2 & e,
              p = 24 & e,
              d = 512 & e,
              y = h ? void 0 : Ii(t);
          return function g() {
            for (var v = arguments.length, m = ft(v), E = v; E--;) {
              m[E] = arguments[E];
            }

            if (p) var C = Xi(g),
                S = Fe(m, C);

            if (n && (m = yi(m, n, i, p)), a && (m = gi(m, a, o, p)), v -= S, p && v < c) {
              var b = xe(m, C);
              return Ui(t, e, Ni, g.placeholder, r, m, b, s, u, c - v);
            }

            var T = l ? r : this,
                A = h ? T[t] : t;
            return v = m.length, s ? m = ga(m, s) : d && v > 1 && m.reverse(), f && u < v && (m.length = u), this && this !== Gt && this instanceof g && (A = y || Ii(A)), A.apply(T, m);
          };
        }

        function ki(t, e) {
          return function (r, n) {
            return function (t, e, r, n) {
              return un(t, function (t, i, a) {
                e(n, r(t), i, a);
              }), n;
            }(r, t, e(n), {});
          };
        }

        function _i(t, e) {
          return function (r, n) {
            var i;
            if (void 0 === r && void 0 === n) return e;

            if (void 0 !== r && (i = r), void 0 !== n) {
              if (void 0 === i) return n;
              "string" == typeof r || "string" == typeof n ? (r = Zn(r), n = Zn(n)) : (r = Yn(r), n = Yn(n)), i = t(r, n);
            }

            return i;
          };
        }

        function Ri(t) {
          return zi(function (e) {
            return e = le(e, Ne(Yi())), Kn(function (r) {
              var n = this;
              return t(e, function (t) {
                return ne(t, n, r);
              });
            });
          });
        }

        function Pi(t, e) {
          var r = (e = void 0 === e ? " " : Zn(e)).length;
          if (r < 2) return r ? Dn(e, t) : e;
          var n = Dn(e, Je(t / He(e)));
          return De(e) ? ci(ze(n), 0, t).join("") : n.slice(0, t);
        }

        function Fi(t) {
          return function (e, r, n) {
            return n && "number" != typeof n && sa(e, r, n) && (r = n = void 0), e = rs(e), void 0 === r ? (r = e, e = 0) : r = rs(r), function (t, e, r, n) {
              for (var i = -1, a = ar(Je((e - t) / (r || 1)), 0), o = ft(a); a--;) {
                o[n ? a : ++i] = t, t += r;
              }

              return o;
            }(e, r, n = void 0 === n ? e < r ? 1 : -1 : rs(n), t);
          };
        }

        function Li(t) {
          return function (e, r) {
            return "string" == typeof e && "string" == typeof r || (e = as(e), r = as(r)), t(e, r);
          };
        }

        function Ui(t, e, r, n, i, a, o, s, u, c) {
          var f = 8 & e;
          e |= f ? 32 : 64, 4 & (e &= ~(f ? 64 : 32)) || (e &= -4);
          var l = [t, e, i, f ? a : void 0, f ? o : void 0, f ? void 0 : a, f ? void 0 : o, s, u, c],
              h = r.apply(void 0, l);
          return ca(t) && ma(h, l), h.placeholder = n, Sa(h, t, e);
        }

        function Oi(t) {
          var e = dt[t];
          return function (t, r) {
            if (t = as(t), (r = null == r ? 0 : or(ns(r), 292)) && rr(t)) {
              var n = (ss(t) + "e").split("e");
              return +((n = (ss(e(n[0] + "e" + (+n[1] + r))) + "e").split("e"))[0] + "e" + (+n[1] - r));
            }

            return e(t);
          };
        }

        var Di = dr && 1 / je(new dr([, -0]))[1] == 1 / 0 ? function (t) {
          return new dr(t);
        } : Zs;

        function Ki(t) {
          return function (e) {
            var r = ra(e);
            return r == p ? Ke(e) : r == v ? Me(e) : function (t, e) {
              return le(e, function (e) {
                return [e, t[e]];
              });
            }(e, t(e));
          };
        }

        function Vi(t, e, r, a, o, s, u, c) {
          var f = 2 & e;
          if (!f && "function" != typeof t) throw new mt(n);
          var l = a ? a.length : 0;

          if (l || (e &= -97, a = o = void 0), u = void 0 === u ? u : ar(ns(u), 0), c = void 0 === c ? c : ns(c), l -= o ? o.length : 0, 64 & e) {
            var h = a,
                p = o;
            a = o = void 0;
          }

          var d = f ? void 0 : Wi(t),
              y = [t, e, r, a, o, h, p, s, u, c];
          if (d && function (t, e) {
            var r = t[1],
                n = e[1],
                a = r | n,
                o = a < 131,
                s = 128 == n && 8 == r || 128 == n && 256 == r && t[7].length <= e[8] || 384 == n && e[7].length <= e[8] && 8 == r;
            if (!o && !s) return t;
            1 & n && (t[2] = e[2], a |= 1 & r ? 0 : 4);
            var u = e[3];

            if (u) {
              var c = t[3];
              t[3] = c ? yi(c, u, e[4]) : u, t[4] = c ? xe(t[3], i) : e[4];
            }

            (u = e[5]) && (c = t[5], t[5] = c ? gi(c, u, e[6]) : u, t[6] = c ? xe(t[5], i) : e[6]);
            (u = e[7]) && (t[7] = u);
            128 & n && (t[8] = null == t[8] ? e[8] : or(t[8], e[8]));
            null == t[9] && (t[9] = e[9]);
            t[0] = e[0], t[1] = a;
          }(y, d), t = y[0], e = y[1], r = y[2], a = y[3], o = y[4], !(c = y[9] = void 0 === y[9] ? f ? 0 : t.length : ar(y[9] - l, 0)) && 24 & e && (e &= -25), e && 1 != e) g = 8 == e || 16 == e ? function (t, e, r) {
            var n = Ii(t);
            return function i() {
              for (var a = arguments.length, o = ft(a), s = a, u = Xi(i); s--;) {
                o[s] = arguments[s];
              }

              var c = a < 3 && o[0] !== u && o[a - 1] !== u ? [] : xe(o, u);
              if ((a -= c.length) < r) return Ui(t, e, Ni, i.placeholder, void 0, o, c, void 0, void 0, r - a);
              var f = this && this !== Gt && this instanceof i ? n : t;
              return ne(f, this, o);
            };
          }(t, e, c) : 32 != e && 33 != e || o.length ? Ni.apply(void 0, y) : function (t, e, r, n) {
            var i = 1 & e,
                a = Ii(t);
            return function e() {
              for (var o = -1, s = arguments.length, u = -1, c = n.length, f = ft(c + s), l = this && this !== Gt && this instanceof e ? a : t; ++u < c;) {
                f[u] = n[u];
              }

              for (; s--;) {
                f[u++] = arguments[++o];
              }

              return ne(l, i ? r : this, f);
            };
          }(t, e, r, a);else var g = function (t, e, r) {
            var n = 1 & e,
                i = Ii(t);
            return function e() {
              var a = this && this !== Gt && this instanceof e ? i : t;
              return a.apply(n ? r : this, arguments);
            };
          }(t, e, r);
          return Sa((d ? Mn : ma)(g, y), t, e);
        }

        function xi(t, e, r, n) {
          return void 0 === t || ko(t, St[r]) && !At.call(n, r) ? e : t;
        }

        function ji(t, e, r, n, i, a) {
          return Ho(t) && Ho(e) && (a.set(e, t), _n(t, e, void 0, ji, a), a.delete(e)), t;
        }

        function Mi(t) {
          return Wo(t) ? void 0 : t;
        }

        function Hi(t, e, r, n, i, a) {
          var o = 1 & r,
              s = t.length,
              u = e.length;
          if (s != u && !(o && u > s)) return !1;
          var c = a.get(t);
          if (c && a.get(e)) return c == e;
          var f = -1,
              l = !0,
              h = 2 & r ? new Ur() : void 0;

          for (a.set(t, e), a.set(e, t); ++f < s;) {
            var p = t[f],
                d = e[f];
            if (n) var y = o ? n(d, p, f, e, t, a) : n(p, d, f, t, e, a);

            if (void 0 !== y) {
              if (y) continue;
              l = !1;
              break;
            }

            if (h) {
              if (!ye(e, function (t, e) {
                if (!_e(h, e) && (p === t || i(p, t, r, n, a))) return h.push(e);
              })) {
                l = !1;
                break;
              }
            } else if (p !== d && !i(p, d, r, n, a)) {
              l = !1;
              break;
            }
          }

          return a.delete(t), a.delete(e), l;
        }

        function zi(t) {
          return Ca(da(t, void 0, Fa), t + "");
        }

        function Gi(t) {
          return hn(t, Cs, ta);
        }

        function qi(t) {
          return hn(t, Ss, ea);
        }

        var Wi = vr ? function (t) {
          return vr.get(t);
        } : Zs;

        function Qi(t) {
          for (var e = t.name + "", r = mr[e], n = At.call(mr, e) ? r.length : 0; n--;) {
            var i = r[n],
                a = i.func;
            if (null == a || a == t) return i.name;
          }

          return e;
        }

        function Xi(t) {
          return (At.call(wr, "placeholder") ? wr : t).placeholder;
        }

        function Yi() {
          var t = wr.iteratee || Ws;
          return t = t === Ws ? Tn : t, arguments.length ? t(arguments[0], arguments[1]) : t;
        }

        function Zi(t, e) {
          var r,
              n,
              i = t.__data__;
          return ("string" == (n = typeof (r = e)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof e ? "string" : "hash"] : i.map;
        }

        function Ji(t) {
          for (var e = Cs(t), r = e.length; r--;) {
            var n = e[r],
                i = t[n];
            e[r] = [n, i, ha(i)];
          }

          return e;
        }

        function $i(t, e) {
          var r = function (t, e) {
            return null == t ? void 0 : t[e];
          }(t, e);

          return bn(r) ? r : void 0;
        }

        var ta = tr ? function (t) {
          return null == t ? [] : (t = yt(t), ue(tr(t), function (e) {
            return Xt.call(t, e);
          }));
        } : iu,
            ea = tr ? function (t) {
          for (var e = []; t;) {
            he(e, ta(t)), t = qt(t);
          }

          return e;
        } : iu,
            ra = pn;

        function na(t, e, r) {
          for (var n = -1, i = (e = si(e, t)).length, a = !1; ++n < i;) {
            var o = Ia(e[n]);
            if (!(a = null != t && r(t, o))) break;
            t = t[o];
          }

          return a || ++n != i ? a : !!(i = null == t ? 0 : t.length) && Mo(i) && oa(o, i) && (Fo(t) || Po(t));
        }

        function ia(t) {
          return "function" != typeof t.constructor || la(t) ? {} : Nr(qt(t));
        }

        function aa(t) {
          return Fo(t) || Po(t) || !!(ge && t && t[ge]);
        }

        function oa(t, e) {
          var r = typeof t;
          return !!(e = null == e ? 9007199254740991 : e) && ("number" == r || "symbol" != r && ot.test(t)) && t > -1 && t % 1 == 0 && t < e;
        }

        function sa(t, e, r) {
          if (!Ho(r)) return !1;
          var n = typeof e;
          return !!("number" == n ? Uo(r) && oa(e, r.length) : "string" == n && e in r) && ko(r[e], t);
        }

        function ua(t, e) {
          if (Fo(t)) return !1;
          var r = typeof t;
          return !("number" != r && "symbol" != r && "boolean" != r && null != t && !Zo(t)) || M.test(t) || !j.test(t) || null != e && t in yt(e);
        }

        function ca(t) {
          var e = Qi(t),
              r = wr[e];
          if ("function" != typeof r || !(e in Rr.prototype)) return !1;
          if (t === r) return !0;
          var n = Wi(r);
          return !!n && t === n[0];
        }

        (lr && ra(new lr(new ArrayBuffer(1))) != b || hr && ra(new hr()) != p || pr && "[object Promise]" != ra(pr.resolve()) || dr && ra(new dr()) != v || yr && ra(new yr()) != C) && (ra = function ra(t) {
          var e = pn(t),
              r = e == y ? t.constructor : void 0,
              n = r ? Ba(r) : "";
          if (n) switch (n) {
            case Er:
              return b;

            case Cr:
              return p;

            case Sr:
              return "[object Promise]";

            case br:
              return v;

            case Tr:
              return C;
          }
          return e;
        });
        var fa = bt ? xo : au;

        function la(t) {
          var e = t && t.constructor;
          return t === ("function" == typeof e && e.prototype || St);
        }

        function ha(t) {
          return t == t && !Ho(t);
        }

        function pa(t, e) {
          return function (r) {
            return null != r && r[t] === e && (void 0 !== e || t in yt(r));
          };
        }

        function da(t, e, r) {
          return e = ar(void 0 === e ? t.length - 1 : e, 0), function () {
            for (var n = arguments, i = -1, a = ar(n.length - e, 0), o = ft(a); ++i < a;) {
              o[i] = n[e + i];
            }

            i = -1;

            for (var s = ft(e + 1); ++i < e;) {
              s[i] = n[i];
            }

            return s[e] = r(o), ne(t, this, s);
          };
        }

        function ya(t, e) {
          return e.length < 2 ? t : ln(t, Gn(e, 0, -1));
        }

        function ga(t, e) {
          for (var r = t.length, n = or(e.length, r), i = vi(t); n--;) {
            var a = e[n];
            t[n] = oa(a, r) ? i[a] : void 0;
          }

          return t;
        }

        function va(t, e) {
          if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
        }

        var ma = ba(Mn),
            Ea = Ze || function (t, e) {
          return Gt.setTimeout(t, e);
        },
            Ca = ba(Hn);

        function Sa(t, e, r) {
          var n = e + "";
          return Ca(t, function (t, e) {
            var r = e.length;
            if (!r) return t;
            var n = r - 1;
            return e[n] = (r > 1 ? "& " : "") + e[n], e = e.join(r > 2 ? ", " : " "), t.replace(X, "{\n/* [wrapped with " + e + "] */\n");
          }(n, function (t, e) {
            return ae(a, function (r) {
              var n = "_." + r[0];
              e & r[1] && !ce(t, n) && t.push(n);
            }), t.sort();
          }(function (t) {
            var e = t.match(Y);
            return e ? e[1].split(Z) : [];
          }(n), r)));
        }

        function ba(t) {
          var e = 0,
              r = 0;
          return function () {
            var n = sr(),
                i = 16 - (n - r);

            if (r = n, i > 0) {
              if (++e >= 800) return arguments[0];
            } else e = 0;

            return t.apply(void 0, arguments);
          };
        }

        function Ta(t, e) {
          var r = -1,
              n = t.length,
              i = n - 1;

          for (e = void 0 === e ? n : e; ++r < e;) {
            var a = On(r, i),
                o = t[a];
            t[a] = t[r], t[r] = o;
          }

          return t.length = e, t;
        }

        var Aa = function (t) {
          var e = To(t, function (t) {
            return 500 === r.size && r.clear(), t;
          }),
              r = e.cache;
          return e;
        }(function (t) {
          var e = [];
          return 46 === t.charCodeAt(0) && e.push(""), t.replace(H, function (t, r, n, i) {
            e.push(n ? i.replace($, "$1") : r || t);
          }), e;
        });

        function Ia(t) {
          if ("string" == typeof t || Zo(t)) return t;
          var e = t + "";
          return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
        }

        function Ba(t) {
          if (null != t) {
            try {
              return Tt.call(t);
            } catch (t) {}

            try {
              return t + "";
            } catch (t) {}
          }

          return "";
        }

        function wa(t) {
          if (t instanceof Rr) return t.clone();
          var e = new _r(t.__wrapped__, t.__chain__);
          return e.__actions__ = vi(t.__actions__), e.__index__ = t.__index__, e.__values__ = t.__values__, e;
        }

        var Na = Kn(function (t, e) {
          return Oo(t) ? Jr(t, an(e, 1, Oo, !0)) : [];
        }),
            ka = Kn(function (t, e) {
          var r = Ka(e);
          return Oo(r) && (r = void 0), Oo(t) ? Jr(t, an(e, 1, Oo, !0), Yi(r, 2)) : [];
        }),
            _a = Kn(function (t, e) {
          var r = Ka(e);
          return Oo(r) && (r = void 0), Oo(t) ? Jr(t, an(e, 1, Oo, !0), void 0, r) : [];
        });

        function Ra(t, e, r) {
          var n = null == t ? 0 : t.length;
          if (!n) return -1;
          var i = null == r ? 0 : ns(r);
          return i < 0 && (i = ar(n + i, 0)), me(t, Yi(e, 3), i);
        }

        function Pa(t, e, r) {
          var n = null == t ? 0 : t.length;
          if (!n) return -1;
          var i = n - 1;
          return void 0 !== r && (i = ns(r), i = r < 0 ? ar(n + i, 0) : or(i, n - 1)), me(t, Yi(e, 3), i, !0);
        }

        function Fa(t) {
          return (null == t ? 0 : t.length) ? an(t, 1) : [];
        }

        function La(t) {
          return t && t.length ? t[0] : void 0;
        }

        var Ua = Kn(function (t) {
          var e = le(t, ai);
          return e.length && e[0] === t[0] ? vn(e) : [];
        }),
            Oa = Kn(function (t) {
          var e = Ka(t),
              r = le(t, ai);
          return e === Ka(r) ? e = void 0 : r.pop(), r.length && r[0] === t[0] ? vn(r, Yi(e, 2)) : [];
        }),
            Da = Kn(function (t) {
          var e = Ka(t),
              r = le(t, ai);
          return (e = "function" == typeof e ? e : void 0) && r.pop(), r.length && r[0] === t[0] ? vn(r, void 0, e) : [];
        });

        function Ka(t) {
          var e = null == t ? 0 : t.length;
          return e ? t[e - 1] : void 0;
        }

        var Va = Kn(xa);

        function xa(t, e) {
          return t && t.length && e && e.length ? Ln(t, e) : t;
        }

        var ja = zi(function (t, e) {
          var r = null == t ? 0 : t.length,
              n = Wr(t, e);
          return Un(t, le(e, function (t) {
            return oa(t, r) ? +t : t;
          }).sort(di)), n;
        });

        function Ma(t) {
          return null == t ? t : fr.call(t);
        }

        var Ha = Kn(function (t) {
          return Jn(an(t, 1, Oo, !0));
        }),
            za = Kn(function (t) {
          var e = Ka(t);
          return Oo(e) && (e = void 0), Jn(an(t, 1, Oo, !0), Yi(e, 2));
        }),
            Ga = Kn(function (t) {
          var e = Ka(t);
          return e = "function" == typeof e ? e : void 0, Jn(an(t, 1, Oo, !0), void 0, e);
        });

        function qa(t) {
          if (!t || !t.length) return [];
          var e = 0;
          return t = ue(t, function (t) {
            if (Oo(t)) return e = ar(t.length, e), !0;
          }), we(e, function (e) {
            return le(t, Te(e));
          });
        }

        function Wa(t, e) {
          if (!t || !t.length) return [];
          var r = qa(t);
          return null == e ? r : le(r, function (t) {
            return ne(e, void 0, t);
          });
        }

        var Qa = Kn(function (t, e) {
          return Oo(t) ? Jr(t, e) : [];
        }),
            Xa = Kn(function (t) {
          return ni(ue(t, Oo));
        }),
            Ya = Kn(function (t) {
          var e = Ka(t);
          return Oo(e) && (e = void 0), ni(ue(t, Oo), Yi(e, 2));
        }),
            Za = Kn(function (t) {
          var e = Ka(t);
          return e = "function" == typeof e ? e : void 0, ni(ue(t, Oo), void 0, e);
        }),
            Ja = Kn(qa);
        var $a = Kn(function (t) {
          var e = t.length,
              r = e > 1 ? t[e - 1] : void 0;
          return r = "function" == typeof r ? (t.pop(), r) : void 0, Wa(t, r);
        });

        function to(t) {
          var e = wr(t);
          return e.__chain__ = !0, e;
        }

        function eo(t, e) {
          return e(t);
        }

        var ro = zi(function (t) {
          var e = t.length,
              r = e ? t[0] : 0,
              n = this.__wrapped__,
              i = function i(e) {
            return Wr(e, t);
          };

          return !(e > 1 || this.__actions__.length) && n instanceof Rr && oa(r) ? ((n = n.slice(r, +r + (e ? 1 : 0))).__actions__.push({
            func: eo,
            args: [i],
            thisArg: void 0
          }), new _r(n, this.__chain__).thru(function (t) {
            return e && !t.length && t.push(void 0), t;
          })) : this.thru(i);
        });
        var no = Ei(function (t, e, r) {
          At.call(t, r) ? ++t[r] : qr(t, r, 1);
        });
        var io = Bi(Ra),
            ao = Bi(Pa);

        function oo(t, e) {
          return (Fo(t) ? ae : $r)(t, Yi(e, 3));
        }

        function so(t, e) {
          return (Fo(t) ? oe : tn)(t, Yi(e, 3));
        }

        var uo = Ei(function (t, e, r) {
          At.call(t, r) ? t[r].push(e) : qr(t, r, [e]);
        });
        var co = Kn(function (t, e, r) {
          var n = -1,
              i = "function" == typeof e,
              a = Uo(t) ? ft(t.length) : [];
          return $r(t, function (t) {
            a[++n] = i ? ne(e, t, r) : mn(t, e, r);
          }), a;
        }),
            fo = Ei(function (t, e, r) {
          qr(t, r, e);
        });

        function lo(t, e) {
          return (Fo(t) ? le : wn)(t, Yi(e, 3));
        }

        var ho = Ei(function (t, e, r) {
          t[r ? 0 : 1].push(e);
        }, function () {
          return [[], []];
        });

        var po = Kn(function (t, e) {
          if (null == t) return [];
          var r = e.length;
          return r > 1 && sa(t, e[0], e[1]) ? e = [] : r > 2 && sa(e[0], e[1], e[2]) && (e = [e[0]]), Pn(t, an(e, 1), []);
        }),
            yo = Ye || function () {
          return Gt.Date.now();
        };

        function go(t, e, r) {
          return e = r ? void 0 : e, Vi(t, 128, void 0, void 0, void 0, void 0, e = t && null == e ? t.length : e);
        }

        function vo(t, e) {
          var r;
          if ("function" != typeof e) throw new mt(n);
          return t = ns(t), function () {
            return --t > 0 && (r = e.apply(this, arguments)), t <= 1 && (e = void 0), r;
          };
        }

        var mo = Kn(function (t, e, r) {
          var n = 1;

          if (r.length) {
            var i = xe(r, Xi(mo));
            n |= 32;
          }

          return Vi(t, n, e, r, i);
        }),
            Eo = Kn(function (t, e, r) {
          var n = 3;

          if (r.length) {
            var i = xe(r, Xi(Eo));
            n |= 32;
          }

          return Vi(e, n, t, r, i);
        });

        function Co(t, e, r) {
          var i,
              a,
              o,
              s,
              u,
              c,
              f = 0,
              l = !1,
              h = !1,
              p = !0;
          if ("function" != typeof t) throw new mt(n);

          function d(e) {
            var r = i,
                n = a;
            return i = a = void 0, f = e, s = t.apply(n, r);
          }

          function y(t) {
            return f = t, u = Ea(v, e), l ? d(t) : s;
          }

          function g(t) {
            var r = t - c;
            return void 0 === c || r >= e || r < 0 || h && t - f >= o;
          }

          function v() {
            var t = yo();
            if (g(t)) return m(t);
            u = Ea(v, function (t) {
              var r = e - (t - c);
              return h ? or(r, o - (t - f)) : r;
            }(t));
          }

          function m(t) {
            return u = void 0, p && i ? d(t) : (i = a = void 0, s);
          }

          function E() {
            var t = yo(),
                r = g(t);

            if (i = arguments, a = this, c = t, r) {
              if (void 0 === u) return y(c);
              if (h) return fi(u), u = Ea(v, e), d(c);
            }

            return void 0 === u && (u = Ea(v, e)), s;
          }

          return e = as(e) || 0, Ho(r) && (l = !!r.leading, o = (h = "maxWait" in r) ? ar(as(r.maxWait) || 0, e) : o, p = "trailing" in r ? !!r.trailing : p), E.cancel = function () {
            void 0 !== u && fi(u), f = 0, i = c = a = u = void 0;
          }, E.flush = function () {
            return void 0 === u ? s : m(yo());
          }, E;
        }

        var So = Kn(function (t, e) {
          return Zr(t, 1, e);
        }),
            bo = Kn(function (t, e, r) {
          return Zr(t, as(e) || 0, r);
        });

        function To(t, e) {
          if ("function" != typeof t || null != e && "function" != typeof e) throw new mt(n);

          var r = function r() {
            var n = arguments,
                i = e ? e.apply(this, n) : n[0],
                a = r.cache;
            if (a.has(i)) return a.get(i);
            var o = t.apply(this, n);
            return r.cache = a.set(i, o) || a, o;
          };

          return r.cache = new (To.Cache || Lr)(), r;
        }

        function Ao(t) {
          if ("function" != typeof t) throw new mt(n);
          return function () {
            var e = arguments;

            switch (e.length) {
              case 0:
                return !t.call(this);

              case 1:
                return !t.call(this, e[0]);

              case 2:
                return !t.call(this, e[0], e[1]);

              case 3:
                return !t.call(this, e[0], e[1], e[2]);
            }

            return !t.apply(this, e);
          };
        }

        To.Cache = Lr;
        var Io = ui(function (t, e) {
          var r = (e = 1 == e.length && Fo(e[0]) ? le(e[0], Ne(Yi())) : le(an(e, 1), Ne(Yi()))).length;
          return Kn(function (n) {
            for (var i = -1, a = or(n.length, r); ++i < a;) {
              n[i] = e[i].call(this, n[i]);
            }

            return ne(t, this, n);
          });
        }),
            Bo = Kn(function (t, e) {
          return Vi(t, 32, void 0, e, xe(e, Xi(Bo)));
        }),
            wo = Kn(function (t, e) {
          return Vi(t, 64, void 0, e, xe(e, Xi(wo)));
        }),
            No = zi(function (t, e) {
          return Vi(t, 256, void 0, void 0, void 0, e);
        });

        function ko(t, e) {
          return t === e || t != t && e != e;
        }

        var _o = Li(dn),
            Ro = Li(function (t, e) {
          return t >= e;
        }),
            Po = En(function () {
          return arguments;
        }()) ? En : function (t) {
          return zo(t) && At.call(t, "callee") && !Xt.call(t, "callee");
        },
            Fo = ft.isArray,
            Lo = Zt ? Ne(Zt) : function (t) {
          return zo(t) && pn(t) == S;
        };

        function Uo(t) {
          return null != t && Mo(t.length) && !xo(t);
        }

        function Oo(t) {
          return zo(t) && Uo(t);
        }

        var Do = er || au,
            Ko = Jt ? Ne(Jt) : function (t) {
          return zo(t) && pn(t) == c;
        };

        function Vo(t) {
          if (!zo(t)) return !1;
          var e = pn(t);
          return e == f || "[object DOMException]" == e || "string" == typeof t.message && "string" == typeof t.name && !Wo(t);
        }

        function xo(t) {
          if (!Ho(t)) return !1;
          var e = pn(t);
          return e == l || e == h || "[object AsyncFunction]" == e || "[object Proxy]" == e;
        }

        function jo(t) {
          return "number" == typeof t && t == ns(t);
        }

        function Mo(t) {
          return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
        }

        function Ho(t) {
          var e = typeof t;
          return null != t && ("object" == e || "function" == e);
        }

        function zo(t) {
          return null != t && "object" == typeof t;
        }

        var Go = $t ? Ne($t) : function (t) {
          return zo(t) && ra(t) == p;
        };

        function qo(t) {
          return "number" == typeof t || zo(t) && pn(t) == d;
        }

        function Wo(t) {
          if (!zo(t) || pn(t) != y) return !1;
          var e = qt(t);
          if (null === e) return !0;
          var r = At.call(e, "constructor") && e.constructor;
          return "function" == typeof r && r instanceof r && Tt.call(r) == Nt;
        }

        var Qo = te ? Ne(te) : function (t) {
          return zo(t) && pn(t) == g;
        };
        var Xo = ee ? Ne(ee) : function (t) {
          return zo(t) && ra(t) == v;
        };

        function Yo(t) {
          return "string" == typeof t || !Fo(t) && zo(t) && pn(t) == m;
        }

        function Zo(t) {
          return "symbol" == typeof t || zo(t) && pn(t) == E;
        }

        var Jo = re ? Ne(re) : function (t) {
          return zo(t) && Mo(t.length) && !!Kt[pn(t)];
        };
        var $o = Li(Bn),
            ts = Li(function (t, e) {
          return t <= e;
        });

        function es(t) {
          if (!t) return [];
          if (Uo(t)) return Yo(t) ? ze(t) : vi(t);
          if (Ae && t[Ae]) return function (t) {
            for (var e, r = []; !(e = t.next()).done;) {
              r.push(e.value);
            }

            return r;
          }(t[Ae]());
          var e = ra(t);
          return (e == p ? Ke : e == v ? je : ks)(t);
        }

        function rs(t) {
          return t ? (t = as(t)) === 1 / 0 || t === -1 / 0 ? 17976931348623157e292 * (t < 0 ? -1 : 1) : t == t ? t : 0 : 0 === t ? t : 0;
        }

        function ns(t) {
          var e = rs(t),
              r = e % 1;
          return e == e ? r ? e - r : e : 0;
        }

        function is(t) {
          return t ? Qr(ns(t), 0, 4294967295) : 0;
        }

        function as(t) {
          if ("number" == typeof t) return t;
          if (Zo(t)) return NaN;

          if (Ho(t)) {
            var e = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = Ho(e) ? e + "" : e;
          }

          if ("string" != typeof t) return 0 === t ? t : +t;
          t = t.replace(q, "");
          var r = nt.test(t);
          return r || at.test(t) ? Mt(t.slice(2), r ? 2 : 8) : rt.test(t) ? NaN : +t;
        }

        function os(t) {
          return mi(t, Ss(t));
        }

        function ss(t) {
          return null == t ? "" : Zn(t);
        }

        var us = Ci(function (t, e) {
          if (la(e) || Uo(e)) mi(e, Cs(e), t);else for (var r in e) {
            At.call(e, r) && Mr(t, r, e[r]);
          }
        }),
            cs = Ci(function (t, e) {
          mi(e, Ss(e), t);
        }),
            fs = Ci(function (t, e, r, n) {
          mi(e, Ss(e), t, n);
        }),
            ls = Ci(function (t, e, r, n) {
          mi(e, Cs(e), t, n);
        }),
            hs = zi(Wr);
        var ps = Kn(function (t, e) {
          t = yt(t);
          var r = -1,
              n = e.length,
              i = n > 2 ? e[2] : void 0;

          for (i && sa(e[0], e[1], i) && (n = 1); ++r < n;) {
            for (var a = e[r], o = Ss(a), s = -1, u = o.length; ++s < u;) {
              var c = o[s],
                  f = t[c];
              (void 0 === f || ko(f, St[c]) && !At.call(t, c)) && (t[c] = a[c]);
            }
          }

          return t;
        }),
            ds = Kn(function (t) {
          return t.push(void 0, ji), ne(Ts, void 0, t);
        });

        function ys(t, e, r) {
          var n = null == t ? void 0 : ln(t, e);
          return void 0 === n ? r : n;
        }

        function gs(t, e) {
          return null != t && na(t, e, gn);
        }

        var vs = ki(function (t, e, r) {
          null != e && "function" != typeof e.toString && (e = wt.call(e)), t[e] = r;
        }, Hs(qs)),
            ms = ki(function (t, e, r) {
          null != e && "function" != typeof e.toString && (e = wt.call(e)), At.call(t, e) ? t[e].push(r) : t[e] = [r];
        }, Yi),
            Es = Kn(mn);

        function Cs(t) {
          return Uo(t) ? Dr(t) : An(t);
        }

        function Ss(t) {
          return Uo(t) ? Dr(t, !0) : In(t);
        }

        var bs = Ci(function (t, e, r) {
          _n(t, e, r);
        }),
            Ts = Ci(function (t, e, r, n) {
          _n(t, e, r, n);
        }),
            As = zi(function (t, e) {
          var r = {};
          if (null == t) return r;
          var n = !1;
          e = le(e, function (e) {
            return e = si(e, t), n || (n = e.length > 1), e;
          }), mi(t, qi(t), r), n && (r = Xr(r, 7, Mi));

          for (var i = e.length; i--;) {
            $n(r, e[i]);
          }

          return r;
        });
        var Is = zi(function (t, e) {
          return null == t ? {} : function (t, e) {
            return Fn(t, e, function (e, r) {
              return gs(t, r);
            });
          }(t, e);
        });

        function Bs(t, e) {
          if (null == t) return {};
          var r = le(qi(t), function (t) {
            return [t];
          });
          return e = Yi(e), Fn(t, r, function (t, r) {
            return e(t, r[0]);
          });
        }

        var ws = Ki(Cs),
            Ns = Ki(Ss);

        function ks(t) {
          return null == t ? [] : ke(t, Cs(t));
        }

        var _s = Ai(function (t, e, r) {
          return e = e.toLowerCase(), t + (r ? Rs(e) : e);
        });

        function Rs(t) {
          return Vs(ss(t).toLowerCase());
        }

        function Ps(t) {
          return (t = ss(t)) && t.replace(st, Le).replace(Rt, "");
        }

        var Fs = Ai(function (t, e, r) {
          return t + (r ? "-" : "") + e.toLowerCase();
        }),
            Ls = Ai(function (t, e, r) {
          return t + (r ? " " : "") + e.toLowerCase();
        }),
            Us = Ti("toLowerCase");
        var Os = Ai(function (t, e, r) {
          return t + (r ? "_" : "") + e.toLowerCase();
        });
        var Ds = Ai(function (t, e, r) {
          return t + (r ? " " : "") + Vs(e);
        });
        var Ks = Ai(function (t, e, r) {
          return t + (r ? " " : "") + e.toUpperCase();
        }),
            Vs = Ti("toUpperCase");

        function xs(t, e, r) {
          return t = ss(t), void 0 === (e = r ? void 0 : e) ? function (t) {
            return Ut.test(t);
          }(t) ? function (t) {
            return t.match(Ft) || [];
          }(t) : function (t) {
            return t.match(J) || [];
          }(t) : t.match(e) || [];
        }

        var js = Kn(function (t, e) {
          try {
            return ne(t, void 0, e);
          } catch (t) {
            return Vo(t) ? t : new ht(t);
          }
        }),
            Ms = zi(function (t, e) {
          return ae(e, function (e) {
            e = Ia(e), qr(t, e, mo(t[e], t));
          }), t;
        });

        function Hs(t) {
          return function () {
            return t;
          };
        }

        var zs = wi(),
            Gs = wi(!0);

        function qs(t) {
          return t;
        }

        function Ws(t) {
          return Tn("function" == typeof t ? t : Xr(t, 1));
        }

        var Qs = Kn(function (t, e) {
          return function (r) {
            return mn(r, t, e);
          };
        }),
            Xs = Kn(function (t, e) {
          return function (r) {
            return mn(t, r, e);
          };
        });

        function Ys(t, e, r) {
          var n = Cs(e),
              i = fn(e, n);
          null != r || Ho(e) && (i.length || !n.length) || (r = e, e = t, t = this, i = fn(e, Cs(e)));
          var a = !(Ho(r) && "chain" in r && !r.chain),
              o = xo(t);
          return ae(i, function (r) {
            var n = e[r];
            t[r] = n, o && (t.prototype[r] = function () {
              var e = this.__chain__;

              if (a || e) {
                var r = t(this.__wrapped__),
                    i = r.__actions__ = vi(this.__actions__);
                return i.push({
                  func: n,
                  args: arguments,
                  thisArg: t
                }), r.__chain__ = e, r;
              }

              return n.apply(t, he([this.value()], arguments));
            });
          }), t;
        }

        function Zs() {}

        var Js = Ri(le),
            $s = Ri(se),
            tu = Ri(ye);

        function eu(t) {
          return ua(t) ? Te(Ia(t)) : function (t) {
            return function (e) {
              return ln(e, t);
            };
          }(t);
        }

        var ru = Fi(),
            nu = Fi(!0);

        function iu() {
          return [];
        }

        function au() {
          return !1;
        }

        var ou = _i(function (t, e) {
          return t + e;
        }, 0),
            su = Oi("ceil"),
            uu = _i(function (t, e) {
          return t / e;
        }, 1),
            cu = Oi("floor");

        var fu,
            lu = _i(function (t, e) {
          return t * e;
        }, 1),
            hu = Oi("round"),
            pu = _i(function (t, e) {
          return t - e;
        }, 0);

        return wr.after = function (t, e) {
          if ("function" != typeof e) throw new mt(n);
          return t = ns(t), function () {
            if (--t < 1) return e.apply(this, arguments);
          };
        }, wr.ary = go, wr.assign = us, wr.assignIn = cs, wr.assignInWith = fs, wr.assignWith = ls, wr.at = hs, wr.before = vo, wr.bind = mo, wr.bindAll = Ms, wr.bindKey = Eo, wr.castArray = function () {
          if (!arguments.length) return [];
          var t = arguments[0];
          return Fo(t) ? t : [t];
        }, wr.chain = to, wr.chunk = function (t, e, r) {
          e = (r ? sa(t, e, r) : void 0 === e) ? 1 : ar(ns(e), 0);
          var n = null == t ? 0 : t.length;
          if (!n || e < 1) return [];

          for (var i = 0, a = 0, o = ft(Je(n / e)); i < n;) {
            o[a++] = Gn(t, i, i += e);
          }

          return o;
        }, wr.compact = function (t) {
          for (var e = -1, r = null == t ? 0 : t.length, n = 0, i = []; ++e < r;) {
            var a = t[e];
            a && (i[n++] = a);
          }

          return i;
        }, wr.concat = function () {
          var t = arguments.length;
          if (!t) return [];

          for (var e = ft(t - 1), r = arguments[0], n = t; n--;) {
            e[n - 1] = arguments[n];
          }

          return he(Fo(r) ? vi(r) : [r], an(e, 1));
        }, wr.cond = function (t) {
          var e = null == t ? 0 : t.length,
              r = Yi();
          return t = e ? le(t, function (t) {
            if ("function" != typeof t[1]) throw new mt(n);
            return [r(t[0]), t[1]];
          }) : [], Kn(function (r) {
            for (var n = -1; ++n < e;) {
              var i = t[n];
              if (ne(i[0], this, r)) return ne(i[1], this, r);
            }
          });
        }, wr.conforms = function (t) {
          return function (t) {
            var e = Cs(t);
            return function (r) {
              return Yr(r, t, e);
            };
          }(Xr(t, 1));
        }, wr.constant = Hs, wr.countBy = no, wr.create = function (t, e) {
          var r = Nr(t);
          return null == e ? r : Gr(r, e);
        }, wr.curry = function t(e, r, n) {
          var i = Vi(e, 8, void 0, void 0, void 0, void 0, void 0, r = n ? void 0 : r);
          return i.placeholder = t.placeholder, i;
        }, wr.curryRight = function t(e, r, n) {
          var i = Vi(e, 16, void 0, void 0, void 0, void 0, void 0, r = n ? void 0 : r);
          return i.placeholder = t.placeholder, i;
        }, wr.debounce = Co, wr.defaults = ps, wr.defaultsDeep = ds, wr.defer = So, wr.delay = bo, wr.difference = Na, wr.differenceBy = ka, wr.differenceWith = _a, wr.drop = function (t, e, r) {
          var n = null == t ? 0 : t.length;
          return n ? Gn(t, (e = r || void 0 === e ? 1 : ns(e)) < 0 ? 0 : e, n) : [];
        }, wr.dropRight = function (t, e, r) {
          var n = null == t ? 0 : t.length;
          return n ? Gn(t, 0, (e = n - (e = r || void 0 === e ? 1 : ns(e))) < 0 ? 0 : e) : [];
        }, wr.dropRightWhile = function (t, e) {
          return t && t.length ? ei(t, Yi(e, 3), !0, !0) : [];
        }, wr.dropWhile = function (t, e) {
          return t && t.length ? ei(t, Yi(e, 3), !0) : [];
        }, wr.fill = function (t, e, r, n) {
          var i = null == t ? 0 : t.length;
          return i ? (r && "number" != typeof r && sa(t, e, r) && (r = 0, n = i), function (t, e, r, n) {
            var i = t.length;

            for ((r = ns(r)) < 0 && (r = -r > i ? 0 : i + r), (n = void 0 === n || n > i ? i : ns(n)) < 0 && (n += i), n = r > n ? 0 : is(n); r < n;) {
              t[r++] = e;
            }

            return t;
          }(t, e, r, n)) : [];
        }, wr.filter = function (t, e) {
          return (Fo(t) ? ue : nn)(t, Yi(e, 3));
        }, wr.flatMap = function (t, e) {
          return an(lo(t, e), 1);
        }, wr.flatMapDeep = function (t, e) {
          return an(lo(t, e), 1 / 0);
        }, wr.flatMapDepth = function (t, e, r) {
          return r = void 0 === r ? 1 : ns(r), an(lo(t, e), r);
        }, wr.flatten = Fa, wr.flattenDeep = function (t) {
          return (null == t ? 0 : t.length) ? an(t, 1 / 0) : [];
        }, wr.flattenDepth = function (t, e) {
          return (null == t ? 0 : t.length) ? an(t, e = void 0 === e ? 1 : ns(e)) : [];
        }, wr.flip = function (t) {
          return Vi(t, 512);
        }, wr.flow = zs, wr.flowRight = Gs, wr.fromPairs = function (t) {
          for (var e = -1, r = null == t ? 0 : t.length, n = {}; ++e < r;) {
            var i = t[e];
            n[i[0]] = i[1];
          }

          return n;
        }, wr.functions = function (t) {
          return null == t ? [] : fn(t, Cs(t));
        }, wr.functionsIn = function (t) {
          return null == t ? [] : fn(t, Ss(t));
        }, wr.groupBy = uo, wr.initial = function (t) {
          return (null == t ? 0 : t.length) ? Gn(t, 0, -1) : [];
        }, wr.intersection = Ua, wr.intersectionBy = Oa, wr.intersectionWith = Da, wr.invert = vs, wr.invertBy = ms, wr.invokeMap = co, wr.iteratee = Ws, wr.keyBy = fo, wr.keys = Cs, wr.keysIn = Ss, wr.map = lo, wr.mapKeys = function (t, e) {
          var r = {};
          return e = Yi(e, 3), un(t, function (t, n, i) {
            qr(r, e(t, n, i), t);
          }), r;
        }, wr.mapValues = function (t, e) {
          var r = {};
          return e = Yi(e, 3), un(t, function (t, n, i) {
            qr(r, n, e(t, n, i));
          }), r;
        }, wr.matches = function (t) {
          return Nn(Xr(t, 1));
        }, wr.matchesProperty = function (t, e) {
          return kn(t, Xr(e, 1));
        }, wr.memoize = To, wr.merge = bs, wr.mergeWith = Ts, wr.method = Qs, wr.methodOf = Xs, wr.mixin = Ys, wr.negate = Ao, wr.nthArg = function (t) {
          return t = ns(t), Kn(function (e) {
            return Rn(e, t);
          });
        }, wr.omit = As, wr.omitBy = function (t, e) {
          return Bs(t, Ao(Yi(e)));
        }, wr.once = function (t) {
          return vo(2, t);
        }, wr.orderBy = function (t, e, r, n) {
          return null == t ? [] : (Fo(e) || (e = null == e ? [] : [e]), Fo(r = n ? void 0 : r) || (r = null == r ? [] : [r]), Pn(t, e, r));
        }, wr.over = Js, wr.overArgs = Io, wr.overEvery = $s, wr.overSome = tu, wr.partial = Bo, wr.partialRight = wo, wr.partition = ho, wr.pick = Is, wr.pickBy = Bs, wr.property = eu, wr.propertyOf = function (t) {
          return function (e) {
            return null == t ? void 0 : ln(t, e);
          };
        }, wr.pull = Va, wr.pullAll = xa, wr.pullAllBy = function (t, e, r) {
          return t && t.length && e && e.length ? Ln(t, e, Yi(r, 2)) : t;
        }, wr.pullAllWith = function (t, e, r) {
          return t && t.length && e && e.length ? Ln(t, e, void 0, r) : t;
        }, wr.pullAt = ja, wr.range = ru, wr.rangeRight = nu, wr.rearg = No, wr.reject = function (t, e) {
          return (Fo(t) ? ue : nn)(t, Ao(Yi(e, 3)));
        }, wr.remove = function (t, e) {
          var r = [];
          if (!t || !t.length) return r;
          var n = -1,
              i = [],
              a = t.length;

          for (e = Yi(e, 3); ++n < a;) {
            var o = t[n];
            e(o, n, t) && (r.push(o), i.push(n));
          }

          return Un(t, i), r;
        }, wr.rest = function (t, e) {
          if ("function" != typeof t) throw new mt(n);
          return Kn(t, e = void 0 === e ? e : ns(e));
        }, wr.reverse = Ma, wr.sampleSize = function (t, e, r) {
          return e = (r ? sa(t, e, r) : void 0 === e) ? 1 : ns(e), (Fo(t) ? Vr : xn)(t, e);
        }, wr.set = function (t, e, r) {
          return null == t ? t : jn(t, e, r);
        }, wr.setWith = function (t, e, r, n) {
          return n = "function" == typeof n ? n : void 0, null == t ? t : jn(t, e, r, n);
        }, wr.shuffle = function (t) {
          return (Fo(t) ? xr : zn)(t);
        }, wr.slice = function (t, e, r) {
          var n = null == t ? 0 : t.length;
          return n ? (r && "number" != typeof r && sa(t, e, r) ? (e = 0, r = n) : (e = null == e ? 0 : ns(e), r = void 0 === r ? n : ns(r)), Gn(t, e, r)) : [];
        }, wr.sortBy = po, wr.sortedUniq = function (t) {
          return t && t.length ? Xn(t) : [];
        }, wr.sortedUniqBy = function (t, e) {
          return t && t.length ? Xn(t, Yi(e, 2)) : [];
        }, wr.split = function (t, e, r) {
          return r && "number" != typeof r && sa(t, e, r) && (e = r = void 0), (r = void 0 === r ? 4294967295 : r >>> 0) ? (t = ss(t)) && ("string" == typeof e || null != e && !Qo(e)) && !(e = Zn(e)) && De(t) ? ci(ze(t), 0, r) : t.split(e, r) : [];
        }, wr.spread = function (t, e) {
          if ("function" != typeof t) throw new mt(n);
          return e = null == e ? 0 : ar(ns(e), 0), Kn(function (r) {
            var n = r[e],
                i = ci(r, 0, e);
            return n && he(i, n), ne(t, this, i);
          });
        }, wr.tail = function (t) {
          var e = null == t ? 0 : t.length;
          return e ? Gn(t, 1, e) : [];
        }, wr.take = function (t, e, r) {
          return t && t.length ? Gn(t, 0, (e = r || void 0 === e ? 1 : ns(e)) < 0 ? 0 : e) : [];
        }, wr.takeRight = function (t, e, r) {
          var n = null == t ? 0 : t.length;
          return n ? Gn(t, (e = n - (e = r || void 0 === e ? 1 : ns(e))) < 0 ? 0 : e, n) : [];
        }, wr.takeRightWhile = function (t, e) {
          return t && t.length ? ei(t, Yi(e, 3), !1, !0) : [];
        }, wr.takeWhile = function (t, e) {
          return t && t.length ? ei(t, Yi(e, 3)) : [];
        }, wr.tap = function (t, e) {
          return e(t), t;
        }, wr.throttle = function (t, e, r) {
          var i = !0,
              a = !0;
          if ("function" != typeof t) throw new mt(n);
          return Ho(r) && (i = "leading" in r ? !!r.leading : i, a = "trailing" in r ? !!r.trailing : a), Co(t, e, {
            leading: i,
            maxWait: e,
            trailing: a
          });
        }, wr.thru = eo, wr.toArray = es, wr.toPairs = ws, wr.toPairsIn = Ns, wr.toPath = function (t) {
          return Fo(t) ? le(t, Ia) : Zo(t) ? [t] : vi(Aa(ss(t)));
        }, wr.toPlainObject = os, wr.transform = function (t, e, r) {
          var n = Fo(t),
              i = n || Do(t) || Jo(t);

          if (e = Yi(e, 4), null == r) {
            var a = t && t.constructor;
            r = i ? n ? new a() : [] : Ho(t) && xo(a) ? Nr(qt(t)) : {};
          }

          return (i ? ae : un)(t, function (t, n, i) {
            return e(r, t, n, i);
          }), r;
        }, wr.unary = function (t) {
          return go(t, 1);
        }, wr.union = Ha, wr.unionBy = za, wr.unionWith = Ga, wr.uniq = function (t) {
          return t && t.length ? Jn(t) : [];
        }, wr.uniqBy = function (t, e) {
          return t && t.length ? Jn(t, Yi(e, 2)) : [];
        }, wr.uniqWith = function (t, e) {
          return e = "function" == typeof e ? e : void 0, t && t.length ? Jn(t, void 0, e) : [];
        }, wr.unset = function (t, e) {
          return null == t || $n(t, e);
        }, wr.unzip = qa, wr.unzipWith = Wa, wr.update = function (t, e, r) {
          return null == t ? t : ti(t, e, oi(r));
        }, wr.updateWith = function (t, e, r, n) {
          return n = "function" == typeof n ? n : void 0, null == t ? t : ti(t, e, oi(r), n);
        }, wr.values = ks, wr.valuesIn = function (t) {
          return null == t ? [] : ke(t, Ss(t));
        }, wr.without = Qa, wr.words = xs, wr.wrap = function (t, e) {
          return Bo(oi(e), t);
        }, wr.xor = Xa, wr.xorBy = Ya, wr.xorWith = Za, wr.zip = Ja, wr.zipObject = function (t, e) {
          return ii(t || [], e || [], Mr);
        }, wr.zipObjectDeep = function (t, e) {
          return ii(t || [], e || [], jn);
        }, wr.zipWith = $a, wr.entries = ws, wr.entriesIn = Ns, wr.extend = cs, wr.extendWith = fs, Ys(wr, wr), wr.add = ou, wr.attempt = js, wr.camelCase = _s, wr.capitalize = Rs, wr.ceil = su, wr.clamp = function (t, e, r) {
          return void 0 === r && (r = e, e = void 0), void 0 !== r && (r = (r = as(r)) == r ? r : 0), void 0 !== e && (e = (e = as(e)) == e ? e : 0), Qr(as(t), e, r);
        }, wr.clone = function (t) {
          return Xr(t, 4);
        }, wr.cloneDeep = function (t) {
          return Xr(t, 5);
        }, wr.cloneDeepWith = function (t, e) {
          return Xr(t, 5, e = "function" == typeof e ? e : void 0);
        }, wr.cloneWith = function (t, e) {
          return Xr(t, 4, e = "function" == typeof e ? e : void 0);
        }, wr.conformsTo = function (t, e) {
          return null == e || Yr(t, e, Cs(e));
        }, wr.deburr = Ps, wr.defaultTo = function (t, e) {
          return null == t || t != t ? e : t;
        }, wr.divide = uu, wr.endsWith = function (t, e, r) {
          t = ss(t), e = Zn(e);
          var n = t.length,
              i = r = void 0 === r ? n : Qr(ns(r), 0, n);
          return (r -= e.length) >= 0 && t.slice(r, i) == e;
        }, wr.eq = ko, wr.escape = function (t) {
          return (t = ss(t)) && D.test(t) ? t.replace(U, Ue) : t;
        }, wr.escapeRegExp = function (t) {
          return (t = ss(t)) && G.test(t) ? t.replace(z, "\\$&") : t;
        }, wr.every = function (t, e, r) {
          var n = Fo(t) ? se : en;
          return r && sa(t, e, r) && (e = void 0), n(t, Yi(e, 3));
        }, wr.find = io, wr.findIndex = Ra, wr.findKey = function (t, e) {
          return ve(t, Yi(e, 3), un);
        }, wr.findLast = ao, wr.findLastIndex = Pa, wr.findLastKey = function (t, e) {
          return ve(t, Yi(e, 3), cn);
        }, wr.floor = cu, wr.forEach = oo, wr.forEachRight = so, wr.forIn = function (t, e) {
          return null == t ? t : on(t, Yi(e, 3), Ss);
        }, wr.forInRight = function (t, e) {
          return null == t ? t : sn(t, Yi(e, 3), Ss);
        }, wr.forOwn = function (t, e) {
          return t && un(t, Yi(e, 3));
        }, wr.forOwnRight = function (t, e) {
          return t && cn(t, Yi(e, 3));
        }, wr.get = ys, wr.gt = _o, wr.gte = Ro, wr.has = function (t, e) {
          return null != t && na(t, e, yn);
        }, wr.hasIn = gs, wr.head = La, wr.identity = qs, wr.includes = function (t, e, r, n) {
          t = Uo(t) ? t : ks(t), r = r && !n ? ns(r) : 0;
          var i = t.length;
          return r < 0 && (r = ar(i + r, 0)), Yo(t) ? r <= i && t.indexOf(e, r) > -1 : !!i && Ee(t, e, r) > -1;
        }, wr.indexOf = function (t, e, r) {
          var n = null == t ? 0 : t.length;
          if (!n) return -1;
          var i = null == r ? 0 : ns(r);
          return i < 0 && (i = ar(n + i, 0)), Ee(t, e, i);
        }, wr.inRange = function (t, e, r) {
          return e = rs(e), void 0 === r ? (r = e, e = 0) : r = rs(r), function (t, e, r) {
            return t >= or(e, r) && t < ar(e, r);
          }(t = as(t), e, r);
        }, wr.invoke = Es, wr.isArguments = Po, wr.isArray = Fo, wr.isArrayBuffer = Lo, wr.isArrayLike = Uo, wr.isArrayLikeObject = Oo, wr.isBoolean = function (t) {
          return !0 === t || !1 === t || zo(t) && pn(t) == u;
        }, wr.isBuffer = Do, wr.isDate = Ko, wr.isElement = function (t) {
          return zo(t) && 1 === t.nodeType && !Wo(t);
        }, wr.isEmpty = function (t) {
          if (null == t) return !0;
          if (Uo(t) && (Fo(t) || "string" == typeof t || "function" == typeof t.splice || Do(t) || Jo(t) || Po(t))) return !t.length;
          var e = ra(t);
          if (e == p || e == v) return !t.size;
          if (la(t)) return !An(t).length;

          for (var r in t) {
            if (At.call(t, r)) return !1;
          }

          return !0;
        }, wr.isEqual = function (t, e) {
          return Cn(t, e);
        }, wr.isEqualWith = function (t, e, r) {
          var n = (r = "function" == typeof r ? r : void 0) ? r(t, e) : void 0;
          return void 0 === n ? Cn(t, e, void 0, r) : !!n;
        }, wr.isError = Vo, wr.isFinite = function (t) {
          return "number" == typeof t && rr(t);
        }, wr.isFunction = xo, wr.isInteger = jo, wr.isLength = Mo, wr.isMap = Go, wr.isMatch = function (t, e) {
          return t === e || Sn(t, e, Ji(e));
        }, wr.isMatchWith = function (t, e, r) {
          return r = "function" == typeof r ? r : void 0, Sn(t, e, Ji(e), r);
        }, wr.isNaN = function (t) {
          return qo(t) && t != +t;
        }, wr.isNative = function (t) {
          if (fa(t)) throw new ht("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
          return bn(t);
        }, wr.isNil = function (t) {
          return null == t;
        }, wr.isNull = function (t) {
          return null === t;
        }, wr.isNumber = qo, wr.isObject = Ho, wr.isObjectLike = zo, wr.isPlainObject = Wo, wr.isRegExp = Qo, wr.isSafeInteger = function (t) {
          return jo(t) && t >= -9007199254740991 && t <= 9007199254740991;
        }, wr.isSet = Xo, wr.isString = Yo, wr.isSymbol = Zo, wr.isTypedArray = Jo, wr.isUndefined = function (t) {
          return void 0 === t;
        }, wr.isWeakMap = function (t) {
          return zo(t) && ra(t) == C;
        }, wr.isWeakSet = function (t) {
          return zo(t) && "[object WeakSet]" == pn(t);
        }, wr.join = function (t, e) {
          return null == t ? "" : nr.call(t, e);
        }, wr.kebabCase = Fs, wr.last = Ka, wr.lastIndexOf = function (t, e, r) {
          var n = null == t ? 0 : t.length;
          if (!n) return -1;
          var i = n;
          return void 0 !== r && (i = (i = ns(r)) < 0 ? ar(n + i, 0) : or(i, n - 1)), e == e ? function (t, e, r) {
            for (var n = r + 1; n--;) {
              if (t[n] === e) return n;
            }

            return n;
          }(t, e, i) : me(t, Se, i, !0);
        }, wr.lowerCase = Ls, wr.lowerFirst = Us, wr.lt = $o, wr.lte = ts, wr.max = function (t) {
          return t && t.length ? rn(t, qs, dn) : void 0;
        }, wr.maxBy = function (t, e) {
          return t && t.length ? rn(t, Yi(e, 2), dn) : void 0;
        }, wr.mean = function (t) {
          return be(t, qs);
        }, wr.meanBy = function (t, e) {
          return be(t, Yi(e, 2));
        }, wr.min = function (t) {
          return t && t.length ? rn(t, qs, Bn) : void 0;
        }, wr.minBy = function (t, e) {
          return t && t.length ? rn(t, Yi(e, 2), Bn) : void 0;
        }, wr.stubArray = iu, wr.stubFalse = au, wr.stubObject = function () {
          return {};
        }, wr.stubString = function () {
          return "";
        }, wr.stubTrue = function () {
          return !0;
        }, wr.multiply = lu, wr.nth = function (t, e) {
          return t && t.length ? Rn(t, ns(e)) : void 0;
        }, wr.noConflict = function () {
          return Gt._ === this && (Gt._ = kt), this;
        }, wr.noop = Zs, wr.now = yo, wr.pad = function (t, e, r) {
          t = ss(t);
          var n = (e = ns(e)) ? He(t) : 0;
          if (!e || n >= e) return t;
          var i = (e - n) / 2;
          return Pi($e(i), r) + t + Pi(Je(i), r);
        }, wr.padEnd = function (t, e, r) {
          t = ss(t);
          var n = (e = ns(e)) ? He(t) : 0;
          return e && n < e ? t + Pi(e - n, r) : t;
        }, wr.padStart = function (t, e, r) {
          t = ss(t);
          var n = (e = ns(e)) ? He(t) : 0;
          return e && n < e ? Pi(e - n, r) + t : t;
        }, wr.parseInt = function (t, e, r) {
          return r || null == e ? e = 0 : e && (e = +e), ur(ss(t).replace(W, ""), e || 0);
        }, wr.random = function (t, e, r) {
          if (r && "boolean" != typeof r && sa(t, e, r) && (e = r = void 0), void 0 === r && ("boolean" == typeof e ? (r = e, e = void 0) : "boolean" == typeof t && (r = t, t = void 0)), void 0 === t && void 0 === e ? (t = 0, e = 1) : (t = rs(t), void 0 === e ? (e = t, t = 0) : e = rs(e)), t > e) {
            var n = t;
            t = e, e = n;
          }

          if (r || t % 1 || e % 1) {
            var i = cr();
            return or(t + i * (e - t + jt("1e-" + ((i + "").length - 1))), e);
          }

          return On(t, e);
        }, wr.reduce = function (t, e, r) {
          var n = Fo(t) ? pe : Ie,
              i = arguments.length < 3;
          return n(t, Yi(e, 4), r, i, $r);
        }, wr.reduceRight = function (t, e, r) {
          var n = Fo(t) ? de : Ie,
              i = arguments.length < 3;
          return n(t, Yi(e, 4), r, i, tn);
        }, wr.repeat = function (t, e, r) {
          return e = (r ? sa(t, e, r) : void 0 === e) ? 1 : ns(e), Dn(ss(t), e);
        }, wr.replace = function () {
          var t = arguments,
              e = ss(t[0]);
          return t.length < 3 ? e : e.replace(t[1], t[2]);
        }, wr.result = function (t, e, r) {
          var n = -1,
              i = (e = si(e, t)).length;

          for (i || (i = 1, t = void 0); ++n < i;) {
            var a = null == t ? void 0 : t[Ia(e[n])];
            void 0 === a && (n = i, a = r), t = xo(a) ? a.call(t) : a;
          }

          return t;
        }, wr.round = hu, wr.runInContext = t, wr.sample = function (t) {
          return (Fo(t) ? Kr : Vn)(t);
        }, wr.size = function (t) {
          if (null == t) return 0;
          if (Uo(t)) return Yo(t) ? He(t) : t.length;
          var e = ra(t);
          return e == p || e == v ? t.size : An(t).length;
        }, wr.snakeCase = Os, wr.some = function (t, e, r) {
          var n = Fo(t) ? ye : qn;
          return r && sa(t, e, r) && (e = void 0), n(t, Yi(e, 3));
        }, wr.sortedIndex = function (t, e) {
          return Wn(t, e);
        }, wr.sortedIndexBy = function (t, e, r) {
          return Qn(t, e, Yi(r, 2));
        }, wr.sortedIndexOf = function (t, e) {
          var r = null == t ? 0 : t.length;

          if (r) {
            var n = Wn(t, e);
            if (n < r && ko(t[n], e)) return n;
          }

          return -1;
        }, wr.sortedLastIndex = function (t, e) {
          return Wn(t, e, !0);
        }, wr.sortedLastIndexBy = function (t, e, r) {
          return Qn(t, e, Yi(r, 2), !0);
        }, wr.sortedLastIndexOf = function (t, e) {
          if (null == t ? 0 : t.length) {
            var r = Wn(t, e, !0) - 1;
            if (ko(t[r], e)) return r;
          }

          return -1;
        }, wr.startCase = Ds, wr.startsWith = function (t, e, r) {
          return t = ss(t), r = null == r ? 0 : Qr(ns(r), 0, t.length), e = Zn(e), t.slice(r, r + e.length) == e;
        }, wr.subtract = pu, wr.sum = function (t) {
          return t && t.length ? Be(t, qs) : 0;
        }, wr.sumBy = function (t, e) {
          return t && t.length ? Be(t, Yi(e, 2)) : 0;
        }, wr.template = function (t, e, r) {
          var n = wr.templateSettings;
          r && sa(t, e, r) && (e = void 0), t = ss(t), e = fs({}, e, n, xi);
          var i,
              a,
              o = fs({}, e.imports, n.imports, xi),
              s = Cs(o),
              u = ke(o, s),
              c = 0,
              f = e.interpolate || ut,
              l = "__p += '",
              h = gt((e.escape || ut).source + "|" + f.source + "|" + (f === x ? tt : ut).source + "|" + (e.evaluate || ut).source + "|$", "g"),
              p = "//# sourceURL=" + (At.call(e, "sourceURL") ? (e.sourceURL + "").replace(/[\r\n]/g, " ") : "lodash.templateSources[" + ++Dt + "]") + "\n";
          t.replace(h, function (e, r, n, o, s, u) {
            return n || (n = o), l += t.slice(c, u).replace(ct, Oe), r && (i = !0, l += "' +\n__e(" + r + ") +\n'"), s && (a = !0, l += "';\n" + s + ";\n__p += '"), n && (l += "' +\n((__t = (" + n + ")) == null ? '' : __t) +\n'"), c = u + e.length, e;
          }), l += "';\n";
          var d = At.call(e, "variable") && e.variable;
          d || (l = "with (obj) {\n" + l + "\n}\n"), l = (a ? l.replace(R, "") : l).replace(P, "$1").replace(F, "$1;"), l = "function(" + (d || "obj") + ") {\n" + (d ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (i ? ", __e = _.escape" : "") + (a ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + l + "return __p\n}";
          var y = js(function () {
            return pt(s, p + "return " + l).apply(void 0, u);
          });
          if (y.source = l, Vo(y)) throw y;
          return y;
        }, wr.times = function (t, e) {
          if ((t = ns(t)) < 1 || t > 9007199254740991) return [];
          var r = 4294967295,
              n = or(t, 4294967295);
          t -= 4294967295;

          for (var i = we(n, e = Yi(e)); ++r < t;) {
            e(r);
          }

          return i;
        }, wr.toFinite = rs, wr.toInteger = ns, wr.toLength = is, wr.toLower = function (t) {
          return ss(t).toLowerCase();
        }, wr.toNumber = as, wr.toSafeInteger = function (t) {
          return t ? Qr(ns(t), -9007199254740991, 9007199254740991) : 0 === t ? t : 0;
        }, wr.toString = ss, wr.toUpper = function (t) {
          return ss(t).toUpperCase();
        }, wr.trim = function (t, e, r) {
          if ((t = ss(t)) && (r || void 0 === e)) return t.replace(q, "");
          if (!t || !(e = Zn(e))) return t;
          var n = ze(t),
              i = ze(e);
          return ci(n, Re(n, i), Pe(n, i) + 1).join("");
        }, wr.trimEnd = function (t, e, r) {
          if ((t = ss(t)) && (r || void 0 === e)) return t.replace(Q, "");
          if (!t || !(e = Zn(e))) return t;
          var n = ze(t);
          return ci(n, 0, Pe(n, ze(e)) + 1).join("");
        }, wr.trimStart = function (t, e, r) {
          if ((t = ss(t)) && (r || void 0 === e)) return t.replace(W, "");
          if (!t || !(e = Zn(e))) return t;
          var n = ze(t);
          return ci(n, Re(n, ze(e))).join("");
        }, wr.truncate = function (t, e) {
          var r = 30,
              n = "...";

          if (Ho(e)) {
            var i = "separator" in e ? e.separator : i;
            r = "length" in e ? ns(e.length) : r, n = "omission" in e ? Zn(e.omission) : n;
          }

          var a = (t = ss(t)).length;

          if (De(t)) {
            var o = ze(t);
            a = o.length;
          }

          if (r >= a) return t;
          var s = r - He(n);
          if (s < 1) return n;
          var u = o ? ci(o, 0, s).join("") : t.slice(0, s);
          if (void 0 === i) return u + n;

          if (o && (s += u.length - s), Qo(i)) {
            if (t.slice(s).search(i)) {
              var c,
                  f = u;

              for (i.global || (i = gt(i.source, ss(et.exec(i)) + "g")), i.lastIndex = 0; c = i.exec(f);) {
                var l = c.index;
              }

              u = u.slice(0, void 0 === l ? s : l);
            }
          } else if (t.indexOf(Zn(i), s) != s) {
            var h = u.lastIndexOf(i);
            h > -1 && (u = u.slice(0, h));
          }

          return u + n;
        }, wr.unescape = function (t) {
          return (t = ss(t)) && O.test(t) ? t.replace(L, Ge) : t;
        }, wr.uniqueId = function (t) {
          var e = ++It;
          return ss(t) + e;
        }, wr.upperCase = Ks, wr.upperFirst = Vs, wr.each = oo, wr.eachRight = so, wr.first = La, Ys(wr, (fu = {}, un(wr, function (t, e) {
          At.call(wr.prototype, e) || (fu[e] = t);
        }), fu), {
          chain: !1
        }), wr.VERSION = "4.17.15", ae(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (t) {
          wr[t].placeholder = wr;
        }), ae(["drop", "take"], function (t, e) {
          Rr.prototype[t] = function (r) {
            r = void 0 === r ? 1 : ar(ns(r), 0);
            var n = this.__filtered__ && !e ? new Rr(this) : this.clone();
            return n.__filtered__ ? n.__takeCount__ = or(r, n.__takeCount__) : n.__views__.push({
              size: or(r, 4294967295),
              type: t + (n.__dir__ < 0 ? "Right" : "")
            }), n;
          }, Rr.prototype[t + "Right"] = function (e) {
            return this.reverse()[t](e).reverse();
          };
        }), ae(["filter", "map", "takeWhile"], function (t, e) {
          var r = e + 1,
              n = 1 == r || 3 == r;

          Rr.prototype[t] = function (t) {
            var e = this.clone();
            return e.__iteratees__.push({
              iteratee: Yi(t, 3),
              type: r
            }), e.__filtered__ = e.__filtered__ || n, e;
          };
        }), ae(["head", "last"], function (t, e) {
          var r = "take" + (e ? "Right" : "");

          Rr.prototype[t] = function () {
            return this[r](1).value()[0];
          };
        }), ae(["initial", "tail"], function (t, e) {
          var r = "drop" + (e ? "" : "Right");

          Rr.prototype[t] = function () {
            return this.__filtered__ ? new Rr(this) : this[r](1);
          };
        }), Rr.prototype.compact = function () {
          return this.filter(qs);
        }, Rr.prototype.find = function (t) {
          return this.filter(t).head();
        }, Rr.prototype.findLast = function (t) {
          return this.reverse().find(t);
        }, Rr.prototype.invokeMap = Kn(function (t, e) {
          return "function" == typeof t ? new Rr(this) : this.map(function (r) {
            return mn(r, t, e);
          });
        }), Rr.prototype.reject = function (t) {
          return this.filter(Ao(Yi(t)));
        }, Rr.prototype.slice = function (t, e) {
          t = ns(t);
          var r = this;
          return r.__filtered__ && (t > 0 || e < 0) ? new Rr(r) : (t < 0 ? r = r.takeRight(-t) : t && (r = r.drop(t)), void 0 !== e && (r = (e = ns(e)) < 0 ? r.dropRight(-e) : r.take(e - t)), r);
        }, Rr.prototype.takeRightWhile = function (t) {
          return this.reverse().takeWhile(t).reverse();
        }, Rr.prototype.toArray = function () {
          return this.take(4294967295);
        }, un(Rr.prototype, function (t, e) {
          var r = /^(?:filter|find|map|reject)|While$/.test(e),
              n = /^(?:head|last)$/.test(e),
              i = wr[n ? "take" + ("last" == e ? "Right" : "") : e],
              a = n || /^find/.test(e);
          i && (wr.prototype[e] = function () {
            var e = this.__wrapped__,
                o = n ? [1] : arguments,
                s = e instanceof Rr,
                u = o[0],
                c = s || Fo(e),
                f = function f(t) {
              var e = i.apply(wr, he([t], o));
              return n && l ? e[0] : e;
            };

            c && r && "function" == typeof u && 1 != u.length && (s = c = !1);
            var l = this.__chain__,
                h = !!this.__actions__.length,
                p = a && !l,
                d = s && !h;

            if (!a && c) {
              e = d ? e : new Rr(this);
              var y = t.apply(e, o);
              return y.__actions__.push({
                func: eo,
                args: [f],
                thisArg: void 0
              }), new _r(y, l);
            }

            return p && d ? t.apply(this, o) : (y = this.thru(f), p ? n ? y.value()[0] : y.value() : y);
          });
        }), ae(["pop", "push", "shift", "sort", "splice", "unshift"], function (t) {
          var e = Et[t],
              r = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru",
              n = /^(?:pop|shift)$/.test(t);

          wr.prototype[t] = function () {
            var t = arguments;

            if (n && !this.__chain__) {
              var i = this.value();
              return e.apply(Fo(i) ? i : [], t);
            }

            return this[r](function (r) {
              return e.apply(Fo(r) ? r : [], t);
            });
          };
        }), un(Rr.prototype, function (t, e) {
          var r = wr[e];

          if (r) {
            var n = r.name + "";
            At.call(mr, n) || (mr[n] = []), mr[n].push({
              name: e,
              func: r
            });
          }
        }), mr[Ni(void 0, 2).name] = [{
          name: "wrapper",
          func: void 0
        }], Rr.prototype.clone = function () {
          var t = new Rr(this.__wrapped__);
          return t.__actions__ = vi(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = vi(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = vi(this.__views__), t;
        }, Rr.prototype.reverse = function () {
          if (this.__filtered__) {
            var t = new Rr(this);
            t.__dir__ = -1, t.__filtered__ = !0;
          } else (t = this.clone()).__dir__ *= -1;

          return t;
        }, Rr.prototype.value = function () {
          var t = this.__wrapped__.value(),
              e = this.__dir__,
              r = Fo(t),
              n = e < 0,
              i = r ? t.length : 0,
              a = function (t, e, r) {
            var n = -1,
                i = r.length;

            for (; ++n < i;) {
              var a = r[n],
                  o = a.size;

              switch (a.type) {
                case "drop":
                  t += o;
                  break;

                case "dropRight":
                  e -= o;
                  break;

                case "take":
                  e = or(e, t + o);
                  break;

                case "takeRight":
                  t = ar(t, e - o);
              }
            }

            return {
              start: t,
              end: e
            };
          }(0, i, this.__views__),
              o = a.start,
              s = a.end,
              u = s - o,
              c = n ? s : o - 1,
              f = this.__iteratees__,
              l = f.length,
              h = 0,
              p = or(u, this.__takeCount__);

          if (!r || !n && i == u && p == u) return ri(t, this.__actions__);
          var d = [];

          t: for (; u-- && h < p;) {
            for (var y = -1, g = t[c += e]; ++y < l;) {
              var v = f[y],
                  m = v.iteratee,
                  E = v.type,
                  C = m(g);
              if (2 == E) g = C;else if (!C) {
                if (1 == E) continue t;
                break t;
              }
            }

            d[h++] = g;
          }

          return d;
        }, wr.prototype.at = ro, wr.prototype.chain = function () {
          return to(this);
        }, wr.prototype.commit = function () {
          return new _r(this.value(), this.__chain__);
        }, wr.prototype.next = function () {
          void 0 === this.__values__ && (this.__values__ = es(this.value()));
          var t = this.__index__ >= this.__values__.length;
          return {
            done: t,
            value: t ? void 0 : this.__values__[this.__index__++]
          };
        }, wr.prototype.plant = function (t) {
          for (var e, r = this; r instanceof kr;) {
            var n = wa(r);
            n.__index__ = 0, n.__values__ = void 0, e ? i.__wrapped__ = n : e = n;
            var i = n;
            r = r.__wrapped__;
          }

          return i.__wrapped__ = t, e;
        }, wr.prototype.reverse = function () {
          var t = this.__wrapped__;

          if (t instanceof Rr) {
            var e = t;
            return this.__actions__.length && (e = new Rr(this)), (e = e.reverse()).__actions__.push({
              func: eo,
              args: [Ma],
              thisArg: void 0
            }), new _r(e, this.__chain__);
          }

          return this.thru(Ma);
        }, wr.prototype.toJSON = wr.prototype.valueOf = wr.prototype.value = function () {
          return ri(this.__wrapped__, this.__actions__);
        }, wr.prototype.first = wr.prototype.head, Ae && (wr.prototype[Ae] = function () {
          return this;
        }), wr;
      }();

      Wt ? ((Wt.exports = qe)._ = qe, qt._ = qe) : Gt._ = qe;
    }).call(r);
  }),
      u = s.partialRight,
      c = s.merge,
      f = (a = [], "undefined" != typeof Uint8ClampedArray && a.push(Uint8ClampedArray), "undefined" != typeof Uint8Array && a.push(Uint8Array), "undefined" != typeof Uint16Array && a.push(Uint16Array), "undefined" != typeof Uint32Array && a.push(Uint32Array), "undefined" != typeof Float32Array && a.push(Float32Array), "undefined" != typeof Float64Array && a.push(Float64Array), a);
  var l = u(c, function (t, e) {
    if (Buffer.isBuffer(e)) e = Buffer.from(e);else {
      var r = function (t) {
        for (var e, r = 0; !e && f.length > r; r++) {
          t instanceof f[r] && (e = f[r]);
        }

        return e;
      }(e);

      e = r ? new r(e, e.byteOffset, e.byteLength) : void 0;
    }
    return e;
  }),
      h = {
    options: {
      usePureJavaScript: !1
    }
  },
      p = {},
      d = p,
      y = {};
  p.encode = function (t, e, r) {
    if ("string" != typeof e) throw new TypeError('"alphabet" must be a string.');
    if (void 0 !== r && "number" != typeof r) throw new TypeError('"maxline" must be a number.');
    var n = "";

    if (t instanceof Uint8Array) {
      var i = 0,
          a = e.length,
          o = e.charAt(0),
          s = [0];

      for (i = 0; i < t.length; ++i) {
        for (var u = 0, c = t[i]; u < s.length; ++u) {
          c += s[u] << 8, s[u] = c % a, c = c / a | 0;
        }

        for (; c > 0;) {
          s.push(c % a), c = c / a | 0;
        }
      }

      for (i = 0; 0 === t[i] && i < t.length - 1; ++i) {
        n += o;
      }

      for (i = s.length - 1; i >= 0; --i) {
        n += e[s[i]];
      }
    } else n = function (t, e) {
      var r = 0,
          n = e.length,
          i = e.charAt(0),
          a = [0];

      for (r = 0; r < t.length(); ++r) {
        for (var o = 0, s = t.at(r); o < a.length; ++o) {
          s += a[o] << 8, a[o] = s % n, s = s / n | 0;
        }

        for (; s > 0;) {
          a.push(s % n), s = s / n | 0;
        }
      }

      var u = "";

      for (r = 0; 0 === t.at(r) && r < t.length() - 1; ++r) {
        u += i;
      }

      for (r = a.length - 1; r >= 0; --r) {
        u += e[a[r]];
      }

      return u;
    }(t, e);

    if (r) {
      var f = new RegExp(".{1," + r + "}", "g");
      n = n.match(f).join("\r\n");
    }

    return n;
  }, p.decode = function (t, e) {
    if ("string" != typeof t) throw new TypeError('"input" must be a string.');
    if ("string" != typeof e) throw new TypeError('"alphabet" must be a string.');
    var r = y[e];

    if (!r) {
      r = y[e] = [];

      for (var n = 0; n < e.length; ++n) {
        r[e.charCodeAt(n)] = n;
      }
    }

    t = t.replace(/\s/g, "");
    var i = e.length,
        a = e.charAt(0),
        o = [0];

    for (n = 0; n < t.length; n++) {
      var s = r[t.charCodeAt(n)];
      if (void 0 === s) return;

      for (var u = 0, c = s; u < o.length; ++u) {
        c += o[u] * i, o[u] = 255 & c, c >>= 8;
      }

      for (; c > 0;) {
        o.push(255 & c), c >>= 8;
      }
    }

    for (var f = 0; t[f] === a && f < t.length - 1; ++f) {
      o.push(0);
    }

    return "undefined" != typeof Buffer ? Buffer.from(o.reverse()) : new Uint8Array(o.reverse());
  };
  i(function (t) {
    var e = t.exports = h.util = h.util || {};

    function n(t) {
      if (8 !== t && 16 !== t && 24 !== t && 32 !== t) throw new Error("Only 8, 16, 24, or 32 bits supported: " + t);
    }

    function i(t) {
      if (this.data = "", this.read = 0, "string" == typeof t) this.data = t;else if (e.isArrayBuffer(t) || e.isArrayBufferView(t)) {
        if ("undefined" != typeof Buffer && t instanceof Buffer) this.data = t.toString("binary");else {
          var r = new Uint8Array(t);

          try {
            this.data = String.fromCharCode.apply(null, r);
          } catch (t) {
            for (var n = 0; n < r.length; ++n) {
              this.putByte(r[n]);
            }
          }
        }
      } else (t instanceof i || "object" == typeof t && "string" == typeof t.data && "number" == typeof t.read) && (this.data = t.data, this.read = t.read);
      this._constructedStringLength = 0;
    }

    !function () {
      if ("undefined" != typeof process && process.nextTick && !process.browser) return e.nextTick = process.nextTick, void ("function" == typeof setImmediate ? e.setImmediate = setImmediate : e.setImmediate = e.nextTick);
      if ("function" == typeof setImmediate) return e.setImmediate = function () {
        return setImmediate.apply(void 0, arguments);
      }, void (e.nextTick = function (t) {
        return setImmediate(t);
      });

      if (e.setImmediate = function (t) {
        setTimeout(t, 0);
      }, "undefined" != typeof window && "function" == typeof window.postMessage) {
        var t = "forge.setImmediate",
            r = [];
        e.setImmediate = function (e) {
          r.push(e), 1 === r.length && window.postMessage(t, "*");
        }, window.addEventListener("message", function (e) {
          if (e.source === window && e.data === t) {
            e.stopPropagation();
            var n = r.slice();
            r.length = 0, n.forEach(function (t) {
              t();
            });
          }
        }, !0);
      }

      if ("undefined" != typeof MutationObserver) {
        var n = Date.now(),
            i = !0,
            a = document.createElement("div");
        r = [];
        new MutationObserver(function () {
          var t = r.slice();
          r.length = 0, t.forEach(function (t) {
            t();
          });
        }).observe(a, {
          attributes: !0
        });
        var o = e.setImmediate;

        e.setImmediate = function (t) {
          Date.now() - n > 15 ? (n = Date.now(), o(t)) : (r.push(t), 1 === r.length && a.setAttribute("a", i = !i));
        };
      }

      e.nextTick = e.setImmediate;
    }(), e.isNodejs = "undefined" != typeof process && process.versions && process.versions.node, e.globalScope = e.isNodejs ? r : "undefined" == typeof self ? window : self, e.isArray = Array.isArray || function (t) {
      return "[object Array]" === Object.prototype.toString.call(t);
    }, e.isArrayBuffer = function (t) {
      return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer;
    }, e.isArrayBufferView = function (t) {
      return t && e.isArrayBuffer(t.buffer) && void 0 !== t.byteLength;
    }, e.ByteBuffer = i, e.ByteStringBuffer = i;
    e.ByteStringBuffer.prototype._optimizeConstructedString = function (t) {
      this._constructedStringLength += t, this._constructedStringLength > 4096 && (this.data.substr(0, 1), this._constructedStringLength = 0);
    }, e.ByteStringBuffer.prototype.length = function () {
      return this.data.length - this.read;
    }, e.ByteStringBuffer.prototype.isEmpty = function () {
      return this.length() <= 0;
    }, e.ByteStringBuffer.prototype.putByte = function (t) {
      return this.putBytes(String.fromCharCode(t));
    }, e.ByteStringBuffer.prototype.fillWithByte = function (t, e) {
      t = String.fromCharCode(t);

      for (var r = this.data; e > 0;) {
        1 & e && (r += t), (e >>>= 1) > 0 && (t += t);
      }

      return this.data = r, this._optimizeConstructedString(e), this;
    }, e.ByteStringBuffer.prototype.putBytes = function (t) {
      return this.data += t, this._optimizeConstructedString(t.length), this;
    }, e.ByteStringBuffer.prototype.putString = function (t) {
      return this.putBytes(e.encodeUtf8(t));
    }, e.ByteStringBuffer.prototype.putInt16 = function (t) {
      return this.putBytes(String.fromCharCode(t >> 8 & 255) + String.fromCharCode(255 & t));
    }, e.ByteStringBuffer.prototype.putInt24 = function (t) {
      return this.putBytes(String.fromCharCode(t >> 16 & 255) + String.fromCharCode(t >> 8 & 255) + String.fromCharCode(255 & t));
    }, e.ByteStringBuffer.prototype.putInt32 = function (t) {
      return this.putBytes(String.fromCharCode(t >> 24 & 255) + String.fromCharCode(t >> 16 & 255) + String.fromCharCode(t >> 8 & 255) + String.fromCharCode(255 & t));
    }, e.ByteStringBuffer.prototype.putInt16Le = function (t) {
      return this.putBytes(String.fromCharCode(255 & t) + String.fromCharCode(t >> 8 & 255));
    }, e.ByteStringBuffer.prototype.putInt24Le = function (t) {
      return this.putBytes(String.fromCharCode(255 & t) + String.fromCharCode(t >> 8 & 255) + String.fromCharCode(t >> 16 & 255));
    }, e.ByteStringBuffer.prototype.putInt32Le = function (t) {
      return this.putBytes(String.fromCharCode(255 & t) + String.fromCharCode(t >> 8 & 255) + String.fromCharCode(t >> 16 & 255) + String.fromCharCode(t >> 24 & 255));
    }, e.ByteStringBuffer.prototype.putInt = function (t, e) {
      n(e);
      var r = "";

      do {
        e -= 8, r += String.fromCharCode(t >> e & 255);
      } while (e > 0);

      return this.putBytes(r);
    }, e.ByteStringBuffer.prototype.putSignedInt = function (t, e) {
      return t < 0 && (t += 2 << e - 1), this.putInt(t, e);
    }, e.ByteStringBuffer.prototype.putBuffer = function (t) {
      return this.putBytes(t.getBytes());
    }, e.ByteStringBuffer.prototype.getByte = function () {
      return this.data.charCodeAt(this.read++);
    }, e.ByteStringBuffer.prototype.getInt16 = function () {
      var t = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
      return this.read += 2, t;
    }, e.ByteStringBuffer.prototype.getInt24 = function () {
      var t = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
      return this.read += 3, t;
    }, e.ByteStringBuffer.prototype.getInt32 = function () {
      var t = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
      return this.read += 4, t;
    }, e.ByteStringBuffer.prototype.getInt16Le = function () {
      var t = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
      return this.read += 2, t;
    }, e.ByteStringBuffer.prototype.getInt24Le = function () {
      var t = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
      return this.read += 3, t;
    }, e.ByteStringBuffer.prototype.getInt32Le = function () {
      var t = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
      return this.read += 4, t;
    }, e.ByteStringBuffer.prototype.getInt = function (t) {
      n(t);
      var e = 0;

      do {
        e = (e << 8) + this.data.charCodeAt(this.read++), t -= 8;
      } while (t > 0);

      return e;
    }, e.ByteStringBuffer.prototype.getSignedInt = function (t) {
      var e = this.getInt(t),
          r = 2 << t - 2;
      return e >= r && (e -= r << 1), e;
    }, e.ByteStringBuffer.prototype.getBytes = function (t) {
      var e;
      return t ? (t = Math.min(this.length(), t), e = this.data.slice(this.read, this.read + t), this.read += t) : 0 === t ? e = "" : (e = 0 === this.read ? this.data : this.data.slice(this.read), this.clear()), e;
    }, e.ByteStringBuffer.prototype.bytes = function (t) {
      return void 0 === t ? this.data.slice(this.read) : this.data.slice(this.read, this.read + t);
    }, e.ByteStringBuffer.prototype.at = function (t) {
      return this.data.charCodeAt(this.read + t);
    }, e.ByteStringBuffer.prototype.setAt = function (t, e) {
      return this.data = this.data.substr(0, this.read + t) + String.fromCharCode(e) + this.data.substr(this.read + t + 1), this;
    }, e.ByteStringBuffer.prototype.last = function () {
      return this.data.charCodeAt(this.data.length - 1);
    }, e.ByteStringBuffer.prototype.copy = function () {
      var t = e.createBuffer(this.data);
      return t.read = this.read, t;
    }, e.ByteStringBuffer.prototype.compact = function () {
      return this.read > 0 && (this.data = this.data.slice(this.read), this.read = 0), this;
    }, e.ByteStringBuffer.prototype.clear = function () {
      return this.data = "", this.read = 0, this;
    }, e.ByteStringBuffer.prototype.truncate = function (t) {
      var e = Math.max(0, this.length() - t);
      return this.data = this.data.substr(this.read, e), this.read = 0, this;
    }, e.ByteStringBuffer.prototype.toHex = function () {
      for (var t = "", e = this.read; e < this.data.length; ++e) {
        var r = this.data.charCodeAt(e);
        r < 16 && (t += "0"), t += r.toString(16);
      }

      return t;
    }, e.ByteStringBuffer.prototype.toString = function () {
      return e.decodeUtf8(this.bytes());
    }, e.DataBuffer = function (t, r) {
      r = r || {}, this.read = r.readOffset || 0, this.growSize = r.growSize || 1024;
      var n = e.isArrayBuffer(t),
          i = e.isArrayBufferView(t);
      if (n || i) return this.data = n ? new DataView(t) : new DataView(t.buffer, t.byteOffset, t.byteLength), void (this.write = "writeOffset" in r ? r.writeOffset : this.data.byteLength);
      this.data = new DataView(new ArrayBuffer(0)), this.write = 0, null != t && this.putBytes(t), "writeOffset" in r && (this.write = r.writeOffset);
    }, e.DataBuffer.prototype.length = function () {
      return this.write - this.read;
    }, e.DataBuffer.prototype.isEmpty = function () {
      return this.length() <= 0;
    }, e.DataBuffer.prototype.accommodate = function (t, e) {
      if (this.length() >= t) return this;
      e = Math.max(e || this.growSize, t);
      var r = new Uint8Array(this.data.buffer, this.data.byteOffset, this.data.byteLength),
          n = new Uint8Array(this.length() + e);
      return n.set(r), this.data = new DataView(n.buffer), this;
    }, e.DataBuffer.prototype.putByte = function (t) {
      return this.accommodate(1), this.data.setUint8(this.write++, t), this;
    }, e.DataBuffer.prototype.fillWithByte = function (t, e) {
      this.accommodate(e);

      for (var r = 0; r < e; ++r) {
        this.data.setUint8(t);
      }

      return this;
    }, e.DataBuffer.prototype.putBytes = function (t, r) {
      if (e.isArrayBufferView(t)) {
        var n = (i = new Uint8Array(t.buffer, t.byteOffset, t.byteLength)).byteLength - i.byteOffset;
        return this.accommodate(n), new Uint8Array(this.data.buffer, this.write).set(i), this.write += n, this;
      }

      if (e.isArrayBuffer(t)) {
        var i = new Uint8Array(t);
        return this.accommodate(i.byteLength), new Uint8Array(this.data.buffer).set(i, this.write), this.write += i.byteLength, this;
      }

      if (t instanceof e.DataBuffer || "object" == typeof t && "number" == typeof t.read && "number" == typeof t.write && e.isArrayBufferView(t.data)) {
        i = new Uint8Array(t.data.byteLength, t.read, t.length());
        return this.accommodate(i.byteLength), new Uint8Array(t.data.byteLength, this.write).set(i), this.write += i.byteLength, this;
      }

      if (t instanceof e.ByteStringBuffer && (t = t.data, r = "binary"), r = r || "binary", "string" == typeof t) {
        var a;
        if ("hex" === r) return this.accommodate(Math.ceil(t.length / 2)), a = new Uint8Array(this.data.buffer, this.write), this.write += e.binary.hex.decode(t, a, this.write), this;
        if ("base64" === r) return this.accommodate(3 * Math.ceil(t.length / 4)), a = new Uint8Array(this.data.buffer, this.write), this.write += e.binary.base64.decode(t, a, this.write), this;
        if ("utf8" === r && (t = e.encodeUtf8(t), r = "binary"), "binary" === r || "raw" === r) return this.accommodate(t.length), a = new Uint8Array(this.data.buffer, this.write), this.write += e.binary.raw.decode(a), this;
        if ("utf16" === r) return this.accommodate(2 * t.length), a = new Uint16Array(this.data.buffer, this.write), this.write += e.text.utf16.encode(a), this;
        throw new Error("Invalid encoding: " + r);
      }

      throw Error("Invalid parameter: " + t);
    }, e.DataBuffer.prototype.putBuffer = function (t) {
      return this.putBytes(t), t.clear(), this;
    }, e.DataBuffer.prototype.putString = function (t) {
      return this.putBytes(t, "utf16");
    }, e.DataBuffer.prototype.putInt16 = function (t) {
      return this.accommodate(2), this.data.setInt16(this.write, t), this.write += 2, this;
    }, e.DataBuffer.prototype.putInt24 = function (t) {
      return this.accommodate(3), this.data.setInt16(this.write, t >> 8 & 65535), this.data.setInt8(this.write, t >> 16 & 255), this.write += 3, this;
    }, e.DataBuffer.prototype.putInt32 = function (t) {
      return this.accommodate(4), this.data.setInt32(this.write, t), this.write += 4, this;
    }, e.DataBuffer.prototype.putInt16Le = function (t) {
      return this.accommodate(2), this.data.setInt16(this.write, t, !0), this.write += 2, this;
    }, e.DataBuffer.prototype.putInt24Le = function (t) {
      return this.accommodate(3), this.data.setInt8(this.write, t >> 16 & 255), this.data.setInt16(this.write, t >> 8 & 65535, !0), this.write += 3, this;
    }, e.DataBuffer.prototype.putInt32Le = function (t) {
      return this.accommodate(4), this.data.setInt32(this.write, t, !0), this.write += 4, this;
    }, e.DataBuffer.prototype.putInt = function (t, e) {
      n(e), this.accommodate(e / 8);

      do {
        e -= 8, this.data.setInt8(this.write++, t >> e & 255);
      } while (e > 0);

      return this;
    }, e.DataBuffer.prototype.putSignedInt = function (t, e) {
      return n(e), this.accommodate(e / 8), t < 0 && (t += 2 << e - 1), this.putInt(t, e);
    }, e.DataBuffer.prototype.getByte = function () {
      return this.data.getInt8(this.read++);
    }, e.DataBuffer.prototype.getInt16 = function () {
      var t = this.data.getInt16(this.read);
      return this.read += 2, t;
    }, e.DataBuffer.prototype.getInt24 = function () {
      var t = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
      return this.read += 3, t;
    }, e.DataBuffer.prototype.getInt32 = function () {
      var t = this.data.getInt32(this.read);
      return this.read += 4, t;
    }, e.DataBuffer.prototype.getInt16Le = function () {
      var t = this.data.getInt16(this.read, !0);
      return this.read += 2, t;
    }, e.DataBuffer.prototype.getInt24Le = function () {
      var t = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, !0) << 8;
      return this.read += 3, t;
    }, e.DataBuffer.prototype.getInt32Le = function () {
      var t = this.data.getInt32(this.read, !0);
      return this.read += 4, t;
    }, e.DataBuffer.prototype.getInt = function (t) {
      n(t);
      var e = 0;

      do {
        e = (e << 8) + this.data.getInt8(this.read++), t -= 8;
      } while (t > 0);

      return e;
    }, e.DataBuffer.prototype.getSignedInt = function (t) {
      var e = this.getInt(t),
          r = 2 << t - 2;
      return e >= r && (e -= r << 1), e;
    }, e.DataBuffer.prototype.getBytes = function (t) {
      var e;
      return t ? (t = Math.min(this.length(), t), e = this.data.slice(this.read, this.read + t), this.read += t) : 0 === t ? e = "" : (e = 0 === this.read ? this.data : this.data.slice(this.read), this.clear()), e;
    }, e.DataBuffer.prototype.bytes = function (t) {
      return void 0 === t ? this.data.slice(this.read) : this.data.slice(this.read, this.read + t);
    }, e.DataBuffer.prototype.at = function (t) {
      return this.data.getUint8(this.read + t);
    }, e.DataBuffer.prototype.setAt = function (t, e) {
      return this.data.setUint8(t, e), this;
    }, e.DataBuffer.prototype.last = function () {
      return this.data.getUint8(this.write - 1);
    }, e.DataBuffer.prototype.copy = function () {
      return new e.DataBuffer(this);
    }, e.DataBuffer.prototype.compact = function () {
      if (this.read > 0) {
        var t = new Uint8Array(this.data.buffer, this.read),
            e = new Uint8Array(t.byteLength);
        e.set(t), this.data = new DataView(e), this.write -= this.read, this.read = 0;
      }

      return this;
    }, e.DataBuffer.prototype.clear = function () {
      return this.data = new DataView(new ArrayBuffer(0)), this.read = this.write = 0, this;
    }, e.DataBuffer.prototype.truncate = function (t) {
      return this.write = Math.max(0, this.length() - t), this.read = Math.min(this.read, this.write), this;
    }, e.DataBuffer.prototype.toHex = function () {
      for (var t = "", e = this.read; e < this.data.byteLength; ++e) {
        var r = this.data.getUint8(e);
        r < 16 && (t += "0"), t += r.toString(16);
      }

      return t;
    }, e.DataBuffer.prototype.toString = function (t) {
      var r = new Uint8Array(this.data, this.read, this.length());
      if ("binary" === (t = t || "utf8") || "raw" === t) return e.binary.raw.encode(r);
      if ("hex" === t) return e.binary.hex.encode(r);
      if ("base64" === t) return e.binary.base64.encode(r);
      if ("utf8" === t) return e.text.utf8.decode(r);
      if ("utf16" === t) return e.text.utf16.decode(r);
      throw new Error("Invalid encoding: " + t);
    }, e.createBuffer = function (t, r) {
      return r = r || "raw", void 0 !== t && "utf8" === r && (t = e.encodeUtf8(t)), new e.ByteBuffer(t);
    }, e.fillString = function (t, e) {
      for (var r = ""; e > 0;) {
        1 & e && (r += t), (e >>>= 1) > 0 && (t += t);
      }

      return r;
    }, e.xorBytes = function (t, e, r) {
      for (var n = "", i = "", a = "", o = 0, s = 0; r > 0; --r, ++o) {
        i = t.charCodeAt(o) ^ e.charCodeAt(o), s >= 10 && (n += a, a = "", s = 0), a += String.fromCharCode(i), ++s;
      }

      return n += a;
    }, e.hexToBytes = function (t) {
      var e = "",
          r = 0;

      for (!0 & t.length && (r = 1, e += String.fromCharCode(parseInt(t[0], 16))); r < t.length; r += 2) {
        e += String.fromCharCode(parseInt(t.substr(r, 2), 16));
      }

      return e;
    }, e.bytesToHex = function (t) {
      return e.createBuffer(t).toHex();
    }, e.int32ToBytes = function (t) {
      return String.fromCharCode(t >> 24 & 255) + String.fromCharCode(t >> 16 & 255) + String.fromCharCode(t >> 8 & 255) + String.fromCharCode(255 & t);
    };
    var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        o = [62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, 64, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51],
        s = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
    e.encode64 = function (t, e) {
      for (var r, n, i, o = "", s = "", u = 0; u < t.length;) {
        r = t.charCodeAt(u++), n = t.charCodeAt(u++), i = t.charCodeAt(u++), o += a.charAt(r >> 2), o += a.charAt((3 & r) << 4 | n >> 4), isNaN(n) ? o += "==" : (o += a.charAt((15 & n) << 2 | i >> 6), o += isNaN(i) ? "=" : a.charAt(63 & i)), e && o.length > e && (s += o.substr(0, e) + "\r\n", o = o.substr(e));
      }

      return s += o;
    }, e.decode64 = function (t) {
      t = t.replace(/[^A-Za-z0-9\+\/\=]/g, "");

      for (var e, r, n, i, a = "", s = 0; s < t.length;) {
        e = o[t.charCodeAt(s++) - 43], r = o[t.charCodeAt(s++) - 43], n = o[t.charCodeAt(s++) - 43], i = o[t.charCodeAt(s++) - 43], a += String.fromCharCode(e << 2 | r >> 4), 64 !== n && (a += String.fromCharCode((15 & r) << 4 | n >> 2), 64 !== i && (a += String.fromCharCode((3 & n) << 6 | i)));
      }

      return a;
    }, e.encodeUtf8 = function (t) {
      return unescape(encodeURIComponent(t));
    }, e.decodeUtf8 = function (t) {
      return decodeURIComponent(escape(t));
    }, e.binary = {
      raw: {},
      hex: {},
      base64: {},
      base58: {},
      baseN: {
        encode: d.encode,
        decode: d.decode
      }
    }, e.binary.raw.encode = function (t) {
      return String.fromCharCode.apply(null, t);
    }, e.binary.raw.decode = function (t, e, r) {
      var n = e;
      n || (n = new Uint8Array(t.length));

      for (var i = r = r || 0, a = 0; a < t.length; ++a) {
        n[i++] = t.charCodeAt(a);
      }

      return e ? i - r : n;
    }, e.binary.hex.encode = e.bytesToHex, e.binary.hex.decode = function (t, e, r) {
      var n = e;
      n || (n = new Uint8Array(Math.ceil(t.length / 2)));
      var i = 0,
          a = r = r || 0;

      for (1 & t.length && (i = 1, n[a++] = parseInt(t[0], 16)); i < t.length; i += 2) {
        n[a++] = parseInt(t.substr(i, 2), 16);
      }

      return e ? a - r : n;
    }, e.binary.base64.encode = function (t, e) {
      for (var r, n, i, o = "", s = "", u = 0; u < t.byteLength;) {
        r = t[u++], n = t[u++], i = t[u++], o += a.charAt(r >> 2), o += a.charAt((3 & r) << 4 | n >> 4), isNaN(n) ? o += "==" : (o += a.charAt((15 & n) << 2 | i >> 6), o += isNaN(i) ? "=" : a.charAt(63 & i)), e && o.length > e && (s += o.substr(0, e) + "\r\n", o = o.substr(e));
      }

      return s += o;
    }, e.binary.base64.decode = function (t, e, r) {
      var n,
          i,
          a,
          s,
          u = e;
      u || (u = new Uint8Array(3 * Math.ceil(t.length / 4))), t = t.replace(/[^A-Za-z0-9\+\/\=]/g, "");

      for (var c = 0, f = r = r || 0; c < t.length;) {
        n = o[t.charCodeAt(c++) - 43], i = o[t.charCodeAt(c++) - 43], a = o[t.charCodeAt(c++) - 43], s = o[t.charCodeAt(c++) - 43], u[f++] = n << 2 | i >> 4, 64 !== a && (u[f++] = (15 & i) << 4 | a >> 2, 64 !== s && (u[f++] = (3 & a) << 6 | s));
      }

      return e ? f - r : u.subarray(0, f);
    }, e.binary.base58.encode = function (t, r) {
      return e.binary.baseN.encode(t, s, r);
    }, e.binary.base58.decode = function (t, r) {
      return e.binary.baseN.decode(t, s, r);
    }, e.text = {
      utf8: {},
      utf16: {}
    }, e.text.utf8.encode = function (t, r, n) {
      t = e.encodeUtf8(t);
      var i = r;
      i || (i = new Uint8Array(t.length));

      for (var a = n = n || 0, o = 0; o < t.length; ++o) {
        i[a++] = t.charCodeAt(o);
      }

      return r ? a - n : i;
    }, e.text.utf8.decode = function (t) {
      return e.decodeUtf8(String.fromCharCode.apply(null, t));
    }, e.text.utf16.encode = function (t, e, r) {
      var n = e;
      n || (n = new Uint8Array(2 * t.length));

      for (var i = new Uint16Array(n.buffer), a = r = r || 0, o = r, s = 0; s < t.length; ++s) {
        i[o++] = t.charCodeAt(s), a += 2;
      }

      return e ? a - r : n;
    }, e.text.utf16.decode = function (t) {
      return String.fromCharCode.apply(null, new Uint16Array(t.buffer));
    }, e.deflate = function (t, r, n) {
      if (r = e.decode64(t.deflate(e.encode64(r)).rval), n) {
        var i = 2;
        32 & r.charCodeAt(1) && (i = 6), r = r.substring(i, r.length - 4);
      }

      return r;
    }, e.inflate = function (t, r, n) {
      var i = t.inflate(e.encode64(r)).rval;
      return null === i ? null : e.decode64(i);
    };

    var u = function u(t, r, n) {
      if (!t) throw new Error("WebStorage not available.");
      var i;

      if (null === n ? i = t.removeItem(r) : (n = e.encode64(JSON.stringify(n)), i = t.setItem(r, n)), void 0 !== i && !0 !== i.rval) {
        var a = new Error(i.error.message);
        throw a.id = i.error.id, a.name = i.error.name, a;
      }
    },
        c = function c(t, r) {
      if (!t) throw new Error("WebStorage not available.");
      var n = t.getItem(r);
      if (t.init) if (null === n.rval) {
        if (n.error) {
          var i = new Error(n.error.message);
          throw i.id = n.error.id, i.name = n.error.name, i;
        }

        n = null;
      } else n = n.rval;
      return null !== n && (n = JSON.parse(e.decode64(n))), n;
    },
        f = function f(t, e, r, n) {
      var i = c(t, e);
      null === i && (i = {}), i[r] = n, u(t, e, i);
    },
        l = function l(t, e, r) {
      var n = c(t, e);
      return null !== n && (n = r in n ? n[r] : null), n;
    },
        p = function p(t, e, r) {
      var n = c(t, e);

      if (null !== n && r in n) {
        delete n[r];
        var i = !0;

        for (var a in n) {
          i = !1;
          break;
        }

        i && (n = null), u(t, e, n);
      }
    },
        y = function y(t, e) {
      u(t, e, null);
    },
        g = function g(t, e, r) {
      var n,
          i = null;
      void 0 === r && (r = ["web", "flash"]);
      var a = !1,
          o = null;

      for (var s in r) {
        n = r[s];

        try {
          if ("flash" === n || "both" === n) {
            if (null === e[0]) throw new Error("Flash local storage not available.");
            i = t.apply(this, e), a = "flash" === n;
          }

          "web" !== n && "both" !== n || (e[0] = localStorage, i = t.apply(this, e), a = !0);
        } catch (t) {
          o = t;
        }

        if (a) break;
      }

      if (!a) throw o;
      return i;
    };

    e.setItem = function (t, e, r, n, i) {
      g(f, arguments, i);
    }, e.getItem = function (t, e, r, n) {
      return g(l, arguments, n);
    }, e.removeItem = function (t, e, r, n) {
      g(p, arguments, n);
    }, e.clearItems = function (t, e, r) {
      g(y, arguments, r);
    }, e.parseUrl = function (t) {
      var e = /^(https?):\/\/([^:&^\/]*):?(\d*)(.*)$/g;
      e.lastIndex = 0;
      var r = e.exec(t),
          n = null === r ? null : {
        full: t,
        scheme: r[1],
        host: r[2],
        port: r[3],
        path: r[4]
      };
      return n && (n.fullHost = n.host, n.port ? 80 !== n.port && "http" === n.scheme ? n.fullHost += ":" + n.port : 443 !== n.port && "https" === n.scheme && (n.fullHost += ":" + n.port) : "http" === n.scheme ? n.port = 80 : "https" === n.scheme && (n.port = 443), n.full = n.scheme + "://" + n.fullHost), n;
    };
    var v = null;
    e.getQueryVariables = function (t) {
      var e,
          r = function r(t) {
        for (var e = {}, r = t.split("&"), n = 0; n < r.length; n++) {
          var i,
              a,
              o = r[n].indexOf("=");
          o > 0 ? (i = r[n].substring(0, o), a = r[n].substring(o + 1)) : (i = r[n], a = null), i in e || (e[i] = []), i in Object.prototype || null === a || e[i].push(unescape(a));
        }

        return e;
      };

      return void 0 === t ? (null === v && (v = "undefined" != typeof window && window.location && window.location.search ? r(window.location.search.substring(1)) : {}), e = v) : e = r(t), e;
    }, e.parseFragment = function (t) {
      var r = t,
          n = "",
          i = t.indexOf("?");
      i > 0 && (r = t.substring(0, i), n = t.substring(i + 1));
      var a = r.split("/");
      return a.length > 0 && "" === a[0] && a.shift(), {
        pathString: r,
        queryString: n,
        path: a,
        query: "" === n ? {} : e.getQueryVariables(n)
      };
    }, e.makeRequest = function (t) {
      var r = e.parseFragment(t),
          n = {
        path: r.pathString,
        query: r.queryString,
        getPath: function getPath(t) {
          return void 0 === t ? r.path : r.path[t];
        },
        getQuery: function getQuery(t, e) {
          var n;
          return void 0 === t ? n = r.query : (n = r.query[t]) && void 0 !== e && (n = n[e]), n;
        },
        getQueryLast: function getQueryLast(t, e) {
          var r = n.getQuery(t);
          return r ? r[r.length - 1] : e;
        }
      };
      return n;
    }, e.makeLink = function (t, e, r) {
      t = jQuery.isArray(t) ? t.join("/") : t;
      var n = jQuery.param(e || {});
      return r = r || "", t + (n.length > 0 ? "?" + n : "") + (r.length > 0 ? "#" + r : "");
    }, e.setPath = function (t, e, r) {
      if ("object" == typeof t && null !== t) for (var n = 0, i = e.length; n < i;) {
        var a = e[n++];
        if (n == i) t[a] = r;else {
          var o = (a in t);
          (!o || o && "object" != typeof t[a] || o && null === t[a]) && (t[a] = {}), t = t[a];
        }
      }
    }, e.getPath = function (t, e, r) {
      for (var n = 0, i = e.length, a = !0; a && n < i && "object" == typeof t && null !== t;) {
        var o = e[n++];
        (a = o in t) && (t = t[o]);
      }

      return a ? t : r;
    }, e.deletePath = function (t, e) {
      if ("object" == typeof t && null !== t) for (var r = 0, n = e.length; r < n;) {
        var i = e[r++];
        if (r == n) delete t[i];else {
          if (!(i in t) || "object" != typeof t[i] || null === t[i]) break;
          t = t[i];
        }
      }
    }, e.isEmpty = function (t) {
      for (var e in t) {
        if (t.hasOwnProperty(e)) return !1;
      }

      return !0;
    }, e.format = function (t) {
      for (var e, r, n = /%./g, i = 0, a = [], o = 0; e = n.exec(t);) {
        (r = t.substring(o, n.lastIndex - 2)).length > 0 && a.push(r), o = n.lastIndex;
        var s = e[0][1];

        switch (s) {
          case "s":
          case "o":
            i < arguments.length ? a.push(arguments[1 + i++]) : a.push("<?>");
            break;

          case "%":
            a.push("%");
            break;

          default:
            a.push("<%" + s + "?>");
        }
      }

      return a.push(t.substring(o)), a.join("");
    }, e.formatNumber = function (t, e, r, n) {
      var i = t,
          a = isNaN(e = Math.abs(e)) ? 2 : e,
          o = void 0 === r ? "," : r,
          s = void 0 === n ? "." : n,
          u = i < 0 ? "-" : "",
          c = parseInt(i = Math.abs(+i || 0).toFixed(a), 10) + "",
          f = c.length > 3 ? c.length % 3 : 0;
      return u + (f ? c.substr(0, f) + s : "") + c.substr(f).replace(/(\d{3})(?=\d)/g, "$1" + s) + (a ? o + Math.abs(i - c).toFixed(a).slice(2) : "");
    }, e.formatSize = function (t) {
      return t = t >= 1073741824 ? e.formatNumber(t / 1073741824, 2, ".", "") + " GiB" : t >= 1048576 ? e.formatNumber(t / 1048576, 2, ".", "") + " MiB" : t >= 1024 ? e.formatNumber(t / 1024, 0) + " KiB" : e.formatNumber(t, 0) + " bytes";
    }, e.bytesFromIP = function (t) {
      return -1 !== t.indexOf(".") ? e.bytesFromIPv4(t) : -1 !== t.indexOf(":") ? e.bytesFromIPv6(t) : null;
    }, e.bytesFromIPv4 = function (t) {
      if (4 !== (t = t.split(".")).length) return null;

      for (var r = e.createBuffer(), n = 0; n < t.length; ++n) {
        var i = parseInt(t[n], 10);
        if (isNaN(i)) return null;
        r.putByte(i);
      }

      return r.getBytes();
    }, e.bytesFromIPv6 = function (t) {
      for (var r = 0, n = 2 * (8 - (t = t.split(":").filter(function (t) {
        return 0 === t.length && ++r, !0;
      })).length + r), i = e.createBuffer(), a = 0; a < 8; ++a) {
        if (t[a] && 0 !== t[a].length) {
          var o = e.hexToBytes(t[a]);
          o.length < 2 && i.putByte(0), i.putBytes(o);
        } else i.fillWithByte(0, n), n = 0;
      }

      return i.getBytes();
    }, e.bytesToIP = function (t) {
      return 4 === t.length ? e.bytesToIPv4(t) : 16 === t.length ? e.bytesToIPv6(t) : null;
    }, e.bytesToIPv4 = function (t) {
      if (4 !== t.length) return null;

      for (var e = [], r = 0; r < t.length; ++r) {
        e.push(t.charCodeAt(r));
      }

      return e.join(".");
    }, e.bytesToIPv6 = function (t) {
      if (16 !== t.length) return null;

      for (var r = [], n = [], i = 0, a = 0; a < t.length; a += 2) {
        for (var o = e.bytesToHex(t[a] + t[a + 1]); "0" === o[0] && "0" !== o;) {
          o = o.substr(1);
        }

        if ("0" === o) {
          var s = n[n.length - 1],
              u = r.length;
          s && u === s.end + 1 ? (s.end = u, s.end - s.start > n[i].end - n[i].start && (i = n.length - 1)) : n.push({
            start: u,
            end: u
          });
        }

        r.push(o);
      }

      if (n.length > 0) {
        var c = n[i];
        c.end - c.start > 0 && (r.splice(c.start, c.end - c.start + 1, ""), 0 === c.start && r.unshift(""), 7 === c.end && r.push(""));
      }

      return r.join(":");
    }, e.estimateCores = function (t, r) {
      if ("function" == typeof t && (r = t, t = {}), t = t || {}, "cores" in e && !t.update) return r(null, e.cores);
      if ("undefined" != typeof navigator && "hardwareConcurrency" in navigator && navigator.hardwareConcurrency > 0) return e.cores = navigator.hardwareConcurrency, r(null, e.cores);
      if ("undefined" == typeof Worker) return e.cores = 1, r(null, e.cores);
      if ("undefined" == typeof Blob) return e.cores = 2, r(null, e.cores);
      var n = URL.createObjectURL(new Blob(["(", function () {
        self.addEventListener("message", function (t) {
          var e = Date.now(),
              r = e + 4;
          self.postMessage({
            st: e,
            et: r
          });
        });
      }.toString(), ")()"], {
        type: "application/javascript"
      }));
      !function t(i, a, o) {
        if (0 === a) {
          var s = Math.floor(i.reduce(function (t, e) {
            return t + e;
          }, 0) / i.length);
          return e.cores = Math.max(1, s), URL.revokeObjectURL(n), r(null, e.cores);
        }

        !function (t, e) {
          for (var r = [], i = [], a = 0; a < t; ++a) {
            var o = new Worker(n);
            o.addEventListener("message", function (n) {
              if (i.push(n.data), i.length === t) {
                for (var a = 0; a < t; ++a) {
                  r[a].terminate();
                }

                e(null, i);
              }
            }), r.push(o);
          }

          for (a = 0; a < t; ++a) {
            r[a].postMessage(a);
          }
        }(o, function (e, r) {
          i.push(function (t, e) {
            for (var r = [], n = 0; n < t; ++n) {
              for (var i = e[n], a = r[n] = [], o = 0; o < t; ++o) {
                if (n !== o) {
                  var s = e[o];
                  (i.st > s.st && i.st < s.et || s.st > i.st && s.st < i.et) && a.push(o);
                }
              }
            }

            return r.reduce(function (t, e) {
              return Math.max(t, e.length);
            }, 0);
          }(o, r)), t(i, a - 1, o);
        });
      }([], 5, 16);
    };
  }), h.cipher = h.cipher || {};
  h.cipher.algorithms = h.cipher.algorithms || {}, h.cipher.createCipher = function (t, e) {
    var r = t;
    if ("string" == typeof r && (r = h.cipher.getAlgorithm(r)) && (r = r()), !r) throw new Error("Unsupported algorithm: " + t);
    return new h.cipher.BlockCipher({
      algorithm: r,
      key: e,
      decrypt: !1
    });
  }, h.cipher.createDecipher = function (t, e) {
    var r = t;
    if ("string" == typeof r && (r = h.cipher.getAlgorithm(r)) && (r = r()), !r) throw new Error("Unsupported algorithm: " + t);
    return new h.cipher.BlockCipher({
      algorithm: r,
      key: e,
      decrypt: !0
    });
  }, h.cipher.registerAlgorithm = function (t, e) {
    t = t.toUpperCase(), h.cipher.algorithms[t] = e;
  }, h.cipher.getAlgorithm = function (t) {
    return (t = t.toUpperCase()) in h.cipher.algorithms ? h.cipher.algorithms[t] : null;
  };

  var g = h.cipher.BlockCipher = function (t) {
    this.algorithm = t.algorithm, this.mode = this.algorithm.mode, this.blockSize = this.mode.blockSize, this._finish = !1, this._input = null, this.output = null, this._op = t.decrypt ? this.mode.decrypt : this.mode.encrypt, this._decrypt = t.decrypt, this.algorithm.initialize(t);
  };

  g.prototype.start = function (t) {
    t = t || {};
    var e = {};

    for (var r in t) {
      e[r] = t[r];
    }

    e.decrypt = this._decrypt, this._finish = !1, this._input = h.util.createBuffer(), this.output = t.output || h.util.createBuffer(), this.mode.start(e);
  }, g.prototype.update = function (t) {
    for (t && this._input.putBuffer(t); !this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish;) {
      ;
    }

    this._input.compact();
  }, g.prototype.finish = function (t) {
    !t || "ECB" !== this.mode.name && "CBC" !== this.mode.name || (this.mode.pad = function (e) {
      return t(this.blockSize, e, !1);
    }, this.mode.unpad = function (e) {
      return t(this.blockSize, e, !0);
    });
    var e = {};
    return e.decrypt = this._decrypt, e.overflow = this._input.length() % this.blockSize, !(!this._decrypt && this.mode.pad && !this.mode.pad(this._input, e)) && (this._finish = !0, this.update(), !(this._decrypt && this.mode.unpad && !this.mode.unpad(this.output, e)) && !(this.mode.afterFinish && !this.mode.afterFinish(this.output, e)));
  };
  i(function (t) {
    h.cipher = h.cipher || {};
    var e = t.exports = h.cipher.modes = h.cipher.modes || {};

    function r(t) {
      if ("string" == typeof t && (t = h.util.createBuffer(t)), h.util.isArray(t) && t.length > 4) {
        var e = t;
        t = h.util.createBuffer();

        for (var r = 0; r < e.length; ++r) {
          t.putByte(e[r]);
        }
      }

      return h.util.isArray(t) || (t = [t.getInt32(), t.getInt32(), t.getInt32(), t.getInt32()]), t;
    }

    function n(t) {
      t[t.length - 1] = t[t.length - 1] + 1 & 4294967295;
    }

    function i(t) {
      return [t / 4294967296 | 0, 4294967295 & t];
    }

    e.ecb = function (t) {
      t = t || {}, this.name = "ECB", this.cipher = t.cipher, this.blockSize = t.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
    }, e.ecb.prototype.start = function (t) {}, e.ecb.prototype.encrypt = function (t, e, r) {
      if (t.length() < this.blockSize && !(r && t.length() > 0)) return !0;

      for (var n = 0; n < this._ints; ++n) {
        this._inBlock[n] = t.getInt32();
      }

      this.cipher.encrypt(this._inBlock, this._outBlock);

      for (n = 0; n < this._ints; ++n) {
        e.putInt32(this._outBlock[n]);
      }
    }, e.ecb.prototype.decrypt = function (t, e, r) {
      if (t.length() < this.blockSize && !(r && t.length() > 0)) return !0;

      for (var n = 0; n < this._ints; ++n) {
        this._inBlock[n] = t.getInt32();
      }

      this.cipher.decrypt(this._inBlock, this._outBlock);

      for (n = 0; n < this._ints; ++n) {
        e.putInt32(this._outBlock[n]);
      }
    }, e.ecb.prototype.pad = function (t, e) {
      var r = t.length() === this.blockSize ? this.blockSize : this.blockSize - t.length();
      return t.fillWithByte(r, r), !0;
    }, e.ecb.prototype.unpad = function (t, e) {
      if (e.overflow > 0) return !1;
      var r = t.length(),
          n = t.at(r - 1);
      return !(n > this.blockSize << 2) && (t.truncate(n), !0);
    }, e.cbc = function (t) {
      t = t || {}, this.name = "CBC", this.cipher = t.cipher, this.blockSize = t.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
    }, e.cbc.prototype.start = function (t) {
      if (null === t.iv) {
        if (!this._prev) throw new Error("Invalid IV parameter.");
        this._iv = this._prev.slice(0);
      } else {
        if (!("iv" in t)) throw new Error("Invalid IV parameter.");
        this._iv = r(t.iv), this._prev = this._iv.slice(0);
      }
    }, e.cbc.prototype.encrypt = function (t, e, r) {
      if (t.length() < this.blockSize && !(r && t.length() > 0)) return !0;

      for (var n = 0; n < this._ints; ++n) {
        this._inBlock[n] = this._prev[n] ^ t.getInt32();
      }

      this.cipher.encrypt(this._inBlock, this._outBlock);

      for (n = 0; n < this._ints; ++n) {
        e.putInt32(this._outBlock[n]);
      }

      this._prev = this._outBlock;
    }, e.cbc.prototype.decrypt = function (t, e, r) {
      if (t.length() < this.blockSize && !(r && t.length() > 0)) return !0;

      for (var n = 0; n < this._ints; ++n) {
        this._inBlock[n] = t.getInt32();
      }

      this.cipher.decrypt(this._inBlock, this._outBlock);

      for (n = 0; n < this._ints; ++n) {
        e.putInt32(this._prev[n] ^ this._outBlock[n]);
      }

      this._prev = this._inBlock.slice(0);
    }, e.cbc.prototype.pad = function (t, e) {
      var r = t.length() === this.blockSize ? this.blockSize : this.blockSize - t.length();
      return t.fillWithByte(r, r), !0;
    }, e.cbc.prototype.unpad = function (t, e) {
      if (e.overflow > 0) return !1;
      var r = t.length(),
          n = t.at(r - 1);
      return !(n > this.blockSize << 2) && (t.truncate(n), !0);
    }, e.cfb = function (t) {
      t = t || {}, this.name = "CFB", this.cipher = t.cipher, this.blockSize = t.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialBlock = new Array(this._ints), this._partialOutput = h.util.createBuffer(), this._partialBytes = 0;
    }, e.cfb.prototype.start = function (t) {
      if (!("iv" in t)) throw new Error("Invalid IV parameter.");
      this._iv = r(t.iv), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
    }, e.cfb.prototype.encrypt = function (t, e, r) {
      var n = t.length();
      if (0 === n) return !0;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), 0 === this._partialBytes && n >= this.blockSize) for (var i = 0; i < this._ints; ++i) {
        this._inBlock[i] = t.getInt32() ^ this._outBlock[i], e.putInt32(this._inBlock[i]);
      } else {
        var a = (this.blockSize - n) % this.blockSize;
        a > 0 && (a = this.blockSize - a), this._partialOutput.clear();

        for (i = 0; i < this._ints; ++i) {
          this._partialBlock[i] = t.getInt32() ^ this._outBlock[i], this._partialOutput.putInt32(this._partialBlock[i]);
        }

        if (a > 0) t.read -= this.blockSize;else for (i = 0; i < this._ints; ++i) {
          this._inBlock[i] = this._partialBlock[i];
        }
        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a > 0 && !r) return e.putBytes(this._partialOutput.getBytes(a - this._partialBytes)), this._partialBytes = a, !0;
        e.putBytes(this._partialOutput.getBytes(n - this._partialBytes)), this._partialBytes = 0;
      }
    }, e.cfb.prototype.decrypt = function (t, e, r) {
      var n = t.length();
      if (0 === n) return !0;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), 0 === this._partialBytes && n >= this.blockSize) for (var i = 0; i < this._ints; ++i) {
        this._inBlock[i] = t.getInt32(), e.putInt32(this._inBlock[i] ^ this._outBlock[i]);
      } else {
        var a = (this.blockSize - n) % this.blockSize;
        a > 0 && (a = this.blockSize - a), this._partialOutput.clear();

        for (i = 0; i < this._ints; ++i) {
          this._partialBlock[i] = t.getInt32(), this._partialOutput.putInt32(this._partialBlock[i] ^ this._outBlock[i]);
        }

        if (a > 0) t.read -= this.blockSize;else for (i = 0; i < this._ints; ++i) {
          this._inBlock[i] = this._partialBlock[i];
        }
        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a > 0 && !r) return e.putBytes(this._partialOutput.getBytes(a - this._partialBytes)), this._partialBytes = a, !0;
        e.putBytes(this._partialOutput.getBytes(n - this._partialBytes)), this._partialBytes = 0;
      }
    }, e.ofb = function (t) {
      t = t || {}, this.name = "OFB", this.cipher = t.cipher, this.blockSize = t.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = h.util.createBuffer(), this._partialBytes = 0;
    }, e.ofb.prototype.start = function (t) {
      if (!("iv" in t)) throw new Error("Invalid IV parameter.");
      this._iv = r(t.iv), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
    }, e.ofb.prototype.encrypt = function (t, e, r) {
      var n = t.length();
      if (0 === t.length()) return !0;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), 0 === this._partialBytes && n >= this.blockSize) for (var i = 0; i < this._ints; ++i) {
        e.putInt32(t.getInt32() ^ this._outBlock[i]), this._inBlock[i] = this._outBlock[i];
      } else {
        var a = (this.blockSize - n) % this.blockSize;
        a > 0 && (a = this.blockSize - a), this._partialOutput.clear();

        for (i = 0; i < this._ints; ++i) {
          this._partialOutput.putInt32(t.getInt32() ^ this._outBlock[i]);
        }

        if (a > 0) t.read -= this.blockSize;else for (i = 0; i < this._ints; ++i) {
          this._inBlock[i] = this._outBlock[i];
        }
        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), a > 0 && !r) return e.putBytes(this._partialOutput.getBytes(a - this._partialBytes)), this._partialBytes = a, !0;
        e.putBytes(this._partialOutput.getBytes(n - this._partialBytes)), this._partialBytes = 0;
      }
    }, e.ofb.prototype.decrypt = e.ofb.prototype.encrypt, e.ctr = function (t) {
      t = t || {}, this.name = "CTR", this.cipher = t.cipher, this.blockSize = t.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = h.util.createBuffer(), this._partialBytes = 0;
    }, e.ctr.prototype.start = function (t) {
      if (!("iv" in t)) throw new Error("Invalid IV parameter.");
      this._iv = r(t.iv), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
    }, e.ctr.prototype.encrypt = function (t, e, r) {
      var i = t.length();
      if (0 === i) return !0;
      if (this.cipher.encrypt(this._inBlock, this._outBlock), 0 === this._partialBytes && i >= this.blockSize) for (var a = 0; a < this._ints; ++a) {
        e.putInt32(t.getInt32() ^ this._outBlock[a]);
      } else {
        var o = (this.blockSize - i) % this.blockSize;
        o > 0 && (o = this.blockSize - o), this._partialOutput.clear();

        for (a = 0; a < this._ints; ++a) {
          this._partialOutput.putInt32(t.getInt32() ^ this._outBlock[a]);
        }

        if (o > 0 && (t.read -= this.blockSize), this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), o > 0 && !r) return e.putBytes(this._partialOutput.getBytes(o - this._partialBytes)), this._partialBytes = o, !0;
        e.putBytes(this._partialOutput.getBytes(i - this._partialBytes)), this._partialBytes = 0;
      }
      n(this._inBlock);
    }, e.ctr.prototype.decrypt = e.ctr.prototype.encrypt, e.gcm = function (t) {
      t = t || {}, this.name = "GCM", this.cipher = t.cipher, this.blockSize = t.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints), this._partialOutput = h.util.createBuffer(), this._partialBytes = 0, this._R = 3774873600;
    }, e.gcm.prototype.start = function (t) {
      if (!("iv" in t)) throw new Error("Invalid IV parameter.");
      var e,
          r = h.util.createBuffer(t.iv);
      if (this._cipherLength = 0, e = "additionalData" in t ? h.util.createBuffer(t.additionalData) : h.util.createBuffer(), this._tagLength = "tagLength" in t ? t.tagLength : 128, this._tag = null, t.decrypt && (this._tag = h.util.createBuffer(t.tag).getBytes(), this._tag.length !== this._tagLength / 8)) throw new Error("Authentication tag does not match tag length.");
      this._hashBlock = new Array(this._ints), this.tag = null, this._hashSubkey = new Array(this._ints), this.cipher.encrypt([0, 0, 0, 0], this._hashSubkey), this.componentBits = 4, this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
      var a = r.length();
      if (12 === a) this._j0 = [r.getInt32(), r.getInt32(), r.getInt32(), 1];else {
        for (this._j0 = [0, 0, 0, 0]; r.length() > 0;) {
          this._j0 = this.ghash(this._hashSubkey, this._j0, [r.getInt32(), r.getInt32(), r.getInt32(), r.getInt32()]);
        }

        this._j0 = this.ghash(this._hashSubkey, this._j0, [0, 0].concat(i(8 * a)));
      }
      this._inBlock = this._j0.slice(0), n(this._inBlock), this._partialBytes = 0, e = h.util.createBuffer(e), this._aDataLength = i(8 * e.length());
      var o = e.length() % this.blockSize;

      for (o && e.fillWithByte(0, this.blockSize - o), this._s = [0, 0, 0, 0]; e.length() > 0;) {
        this._s = this.ghash(this._hashSubkey, this._s, [e.getInt32(), e.getInt32(), e.getInt32(), e.getInt32()]);
      }
    }, e.gcm.prototype.encrypt = function (t, e, r) {
      var i = t.length();
      if (0 === i) return !0;

      if (this.cipher.encrypt(this._inBlock, this._outBlock), 0 === this._partialBytes && i >= this.blockSize) {
        for (var a = 0; a < this._ints; ++a) {
          e.putInt32(this._outBlock[a] ^= t.getInt32());
        }

        this._cipherLength += this.blockSize;
      } else {
        var o = (this.blockSize - i) % this.blockSize;
        o > 0 && (o = this.blockSize - o), this._partialOutput.clear();

        for (a = 0; a < this._ints; ++a) {
          this._partialOutput.putInt32(t.getInt32() ^ this._outBlock[a]);
        }

        if (o <= 0 || r) {
          if (r) {
            var s = i % this.blockSize;
            this._cipherLength += s, this._partialOutput.truncate(this.blockSize - s);
          } else this._cipherLength += this.blockSize;

          for (a = 0; a < this._ints; ++a) {
            this._outBlock[a] = this._partialOutput.getInt32();
          }

          this._partialOutput.read -= this.blockSize;
        }

        if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), o > 0 && !r) return t.read -= this.blockSize, e.putBytes(this._partialOutput.getBytes(o - this._partialBytes)), this._partialBytes = o, !0;
        e.putBytes(this._partialOutput.getBytes(i - this._partialBytes)), this._partialBytes = 0;
      }

      this._s = this.ghash(this._hashSubkey, this._s, this._outBlock), n(this._inBlock);
    }, e.gcm.prototype.decrypt = function (t, e, r) {
      var i = t.length();
      if (i < this.blockSize && !(r && i > 0)) return !0;
      this.cipher.encrypt(this._inBlock, this._outBlock), n(this._inBlock), this._hashBlock[0] = t.getInt32(), this._hashBlock[1] = t.getInt32(), this._hashBlock[2] = t.getInt32(), this._hashBlock[3] = t.getInt32(), this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);

      for (var a = 0; a < this._ints; ++a) {
        e.putInt32(this._outBlock[a] ^ this._hashBlock[a]);
      }

      i < this.blockSize ? this._cipherLength += i % this.blockSize : this._cipherLength += this.blockSize;
    }, e.gcm.prototype.afterFinish = function (t, e) {
      var r = !0;
      e.decrypt && e.overflow && t.truncate(this.blockSize - e.overflow), this.tag = h.util.createBuffer();

      var n = this._aDataLength.concat(i(8 * this._cipherLength));

      this._s = this.ghash(this._hashSubkey, this._s, n);
      var a = [];
      this.cipher.encrypt(this._j0, a);

      for (var o = 0; o < this._ints; ++o) {
        this.tag.putInt32(this._s[o] ^ a[o]);
      }

      return this.tag.truncate(this.tag.length() % (this._tagLength / 8)), e.decrypt && this.tag.bytes() !== this._tag && (r = !1), r;
    }, e.gcm.prototype.multiply = function (t, e) {
      for (var r = [0, 0, 0, 0], n = e.slice(0), i = 0; i < 128; ++i) {
        t[i / 32 | 0] & 1 << 31 - i % 32 && (r[0] ^= n[0], r[1] ^= n[1], r[2] ^= n[2], r[3] ^= n[3]), this.pow(n, n);
      }

      return r;
    }, e.gcm.prototype.pow = function (t, e) {
      for (var r = 1 & t[3], n = 3; n > 0; --n) {
        e[n] = t[n] >>> 1 | (1 & t[n - 1]) << 31;
      }

      e[0] = t[0] >>> 1, r && (e[0] ^= this._R);
    }, e.gcm.prototype.tableMultiply = function (t) {
      for (var e = [0, 0, 0, 0], r = 0; r < 32; ++r) {
        var n = t[r / 8 | 0] >>> 4 * (7 - r % 8) & 15,
            i = this._m[r][n];
        e[0] ^= i[0], e[1] ^= i[1], e[2] ^= i[2], e[3] ^= i[3];
      }

      return e;
    }, e.gcm.prototype.ghash = function (t, e, r) {
      return e[0] ^= r[0], e[1] ^= r[1], e[2] ^= r[2], e[3] ^= r[3], this.tableMultiply(e);
    }, e.gcm.prototype.generateHashTable = function (t, e) {
      for (var r = 8 / e, n = 4 * r, i = 16 * r, a = new Array(i), o = 0; o < i; ++o) {
        var s = [0, 0, 0, 0],
            u = (n - 1 - o % n) * e;
        s[o / n | 0] = 1 << e - 1 << u, a[o] = this.generateSubHashTable(this.multiply(s, t), e);
      }

      return a;
    }, e.gcm.prototype.generateSubHashTable = function (t, e) {
      var r = 1 << e,
          n = r >>> 1,
          i = new Array(r);
      i[n] = t.slice(0);

      for (var a = n >>> 1; a > 0;) {
        this.pow(i[2 * a], i[a] = []), a >>= 1;
      }

      for (a = 2; a < n;) {
        for (var o = 1; o < a; ++o) {
          var s = i[a],
              u = i[o];
          i[a + o] = [s[0] ^ u[0], s[1] ^ u[1], s[2] ^ u[2], s[3] ^ u[3]];
        }

        a *= 2;
      }

      for (i[0] = [0, 0, 0, 0], a = n + 1; a < r; ++a) {
        var c = i[a ^ n];
        i[a] = [t[0] ^ c[0], t[1] ^ c[1], t[2] ^ c[2], t[3] ^ c[3]];
      }

      return i;
    };
  }), h.aes = h.aes || {};

  function v(t, e) {
    h.cipher.registerAlgorithm(t, function () {
      return new h.aes.Algorithm(t, e);
    });
  }

  h.aes.startEncrypting = function (t, e, r, n) {
    var i = w({
      key: t,
      output: r,
      decrypt: !1,
      mode: n
    });
    return i.start(e), i;
  }, h.aes.createEncryptionCipher = function (t, e) {
    return w({
      key: t,
      output: null,
      decrypt: !1,
      mode: e
    });
  }, h.aes.startDecrypting = function (t, e, r, n) {
    var i = w({
      key: t,
      output: r,
      decrypt: !0,
      mode: n
    });
    return i.start(e), i;
  }, h.aes.createDecryptionCipher = function (t, e) {
    return w({
      key: t,
      output: null,
      decrypt: !0,
      mode: e
    });
  }, h.aes.Algorithm = function (t, e) {
    T || A();
    var r = this;
    r.name = t, r.mode = new e({
      blockSize: 16,
      cipher: {
        encrypt: function encrypt(t, e) {
          return B(r._w, t, e, !1);
        },
        decrypt: function decrypt(t, e) {
          return B(r._w, t, e, !0);
        }
      }
    }), r._init = !1;
  }, h.aes.Algorithm.prototype.initialize = function (t) {
    if (!this._init) {
      var e,
          r = t.key;

      if ("string" != typeof r || 16 !== r.length && 24 !== r.length && 32 !== r.length) {
        if (h.util.isArray(r) && (16 === r.length || 24 === r.length || 32 === r.length)) {
          e = r, r = h.util.createBuffer();

          for (var n = 0; n < e.length; ++n) {
            r.putByte(e[n]);
          }
        }
      } else r = h.util.createBuffer(r);

      if (!h.util.isArray(r)) {
        e = r, r = [];
        var i = e.length();

        if (16 === i || 24 === i || 32 === i) {
          i >>>= 2;

          for (n = 0; n < i; ++n) {
            r.push(e.getInt32());
          }
        }
      }

      if (!h.util.isArray(r) || 4 !== r.length && 6 !== r.length && 8 !== r.length) throw new Error("Invalid key parameter.");
      var a = this.mode.name,
          o = -1 !== ["CFB", "OFB", "CTR", "GCM"].indexOf(a);
      this._w = I(r, t.decrypt && !o), this._init = !0;
    }
  }, h.aes._expandKey = function (t, e) {
    return T || A(), I(t, e);
  }, h.aes._updateBlock = B, v("AES-ECB", h.cipher.modes.ecb), v("AES-CBC", h.cipher.modes.cbc), v("AES-CFB", h.cipher.modes.cfb), v("AES-OFB", h.cipher.modes.ofb), v("AES-CTR", h.cipher.modes.ctr), v("AES-GCM", h.cipher.modes.gcm);
  var m,
      E,
      C,
      S,
      b,
      T = !1;

  function A() {
    T = !0, C = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];

    for (var t = new Array(256), e = 0; e < 128; ++e) {
      t[e] = e << 1, t[e + 128] = e + 128 << 1 ^ 283;
    }

    m = new Array(256), E = new Array(256), S = new Array(4), b = new Array(4);

    for (e = 0; e < 4; ++e) {
      S[e] = new Array(256), b[e] = new Array(256);
    }

    var r,
        n,
        i,
        a,
        o,
        s,
        u,
        c = 0,
        f = 0;

    for (e = 0; e < 256; ++e) {
      a = (a = f ^ f << 1 ^ f << 2 ^ f << 3 ^ f << 4) >> 8 ^ 255 & a ^ 99, m[c] = a, E[a] = c, s = (o = t[a]) << 24 ^ a << 16 ^ a << 8 ^ a ^ o, u = ((r = t[c]) ^ (n = t[r]) ^ (i = t[n])) << 24 ^ (c ^ i) << 16 ^ (c ^ n ^ i) << 8 ^ c ^ r ^ i;

      for (var l = 0; l < 4; ++l) {
        S[l][c] = s, b[l][a] = u, s = s << 24 | s >>> 8, u = u << 24 | u >>> 8;
      }

      0 === c ? c = f = 1 : (c = r ^ t[t[t[r ^ i]]], f ^= t[t[f]]);
    }
  }

  function I(t, e) {
    for (var r, n = t.slice(0), i = 1, a = n.length, o = 4 * (a + 6 + 1), s = a; s < o; ++s) {
      r = n[s - 1], s % a == 0 ? (r = m[r >>> 16 & 255] << 24 ^ m[r >>> 8 & 255] << 16 ^ m[255 & r] << 8 ^ m[r >>> 24] ^ C[i] << 24, i++) : a > 6 && s % a == 4 && (r = m[r >>> 24] << 24 ^ m[r >>> 16 & 255] << 16 ^ m[r >>> 8 & 255] << 8 ^ m[255 & r]), n[s] = n[s - a] ^ r;
    }

    if (e) {
      for (var u, c = b[0], f = b[1], l = b[2], h = b[3], p = n.slice(0), d = (s = 0, (o = n.length) - 4); s < o; s += 4, d -= 4) {
        if (0 === s || s === o - 4) p[s] = n[d], p[s + 1] = n[d + 3], p[s + 2] = n[d + 2], p[s + 3] = n[d + 1];else for (var y = 0; y < 4; ++y) {
          u = n[d + y], p[s + (3 & -y)] = c[m[u >>> 24]] ^ f[m[u >>> 16 & 255]] ^ l[m[u >>> 8 & 255]] ^ h[m[255 & u]];
        }
      }

      n = p;
    }

    return n;
  }

  function B(t, e, r, n) {
    var i,
        a,
        o,
        s,
        u,
        c,
        f,
        l,
        h,
        p,
        d,
        y,
        g = t.length / 4 - 1;
    n ? (i = b[0], a = b[1], o = b[2], s = b[3], u = E) : (i = S[0], a = S[1], o = S[2], s = S[3], u = m), c = e[0] ^ t[0], f = e[n ? 3 : 1] ^ t[1], l = e[2] ^ t[2], h = e[n ? 1 : 3] ^ t[3];

    for (var v = 3, C = 1; C < g; ++C) {
      p = i[c >>> 24] ^ a[f >>> 16 & 255] ^ o[l >>> 8 & 255] ^ s[255 & h] ^ t[++v], d = i[f >>> 24] ^ a[l >>> 16 & 255] ^ o[h >>> 8 & 255] ^ s[255 & c] ^ t[++v], y = i[l >>> 24] ^ a[h >>> 16 & 255] ^ o[c >>> 8 & 255] ^ s[255 & f] ^ t[++v], h = i[h >>> 24] ^ a[c >>> 16 & 255] ^ o[f >>> 8 & 255] ^ s[255 & l] ^ t[++v], c = p, f = d, l = y;
    }

    r[0] = u[c >>> 24] << 24 ^ u[f >>> 16 & 255] << 16 ^ u[l >>> 8 & 255] << 8 ^ u[255 & h] ^ t[++v], r[n ? 3 : 1] = u[f >>> 24] << 24 ^ u[l >>> 16 & 255] << 16 ^ u[h >>> 8 & 255] << 8 ^ u[255 & c] ^ t[++v], r[2] = u[l >>> 24] << 24 ^ u[h >>> 16 & 255] << 16 ^ u[c >>> 8 & 255] << 8 ^ u[255 & f] ^ t[++v], r[n ? 1 : 3] = u[h >>> 24] << 24 ^ u[c >>> 16 & 255] << 16 ^ u[f >>> 8 & 255] << 8 ^ u[255 & l] ^ t[++v];
  }

  function w(t) {
    var e,
        r = "AES-" + ((t = t || {}).mode || "CBC").toUpperCase(),
        n = (e = t.decrypt ? h.cipher.createDecipher(r, t.key) : h.cipher.createCipher(r, t.key)).start;
    return e.start = function (t, r) {
      var i = null;
      r instanceof h.util.ByteBuffer && (i = r, r = {}), (r = r || {}).output = i, r.iv = t, n.call(e, r);
    }, e;
  }

  i(function (t) {
    h.pki = h.pki || {};
    var e = t.exports = h.pki.oids = h.oids = h.oids || {};

    function r(t, r) {
      e[t] = r, e[r] = t;
    }

    function n(t, r) {
      e[t] = r;
    }

    r("1.2.840.113549.1.1.1", "rsaEncryption"), r("1.2.840.113549.1.1.4", "md5WithRSAEncryption"), r("1.2.840.113549.1.1.5", "sha1WithRSAEncryption"), r("1.2.840.113549.1.1.7", "RSAES-OAEP"), r("1.2.840.113549.1.1.8", "mgf1"), r("1.2.840.113549.1.1.9", "pSpecified"), r("1.2.840.113549.1.1.10", "RSASSA-PSS"), r("1.2.840.113549.1.1.11", "sha256WithRSAEncryption"), r("1.2.840.113549.1.1.12", "sha384WithRSAEncryption"), r("1.2.840.113549.1.1.13", "sha512WithRSAEncryption"), r("1.2.840.10040.4.3", "dsa-with-sha1"), r("1.3.14.3.2.7", "desCBC"), r("1.3.14.3.2.26", "sha1"), r("2.16.840.1.101.3.4.2.1", "sha256"), r("2.16.840.1.101.3.4.2.2", "sha384"), r("2.16.840.1.101.3.4.2.3", "sha512"), r("1.2.840.113549.2.5", "md5"), r("1.2.840.113549.1.7.1", "data"), r("1.2.840.113549.1.7.2", "signedData"), r("1.2.840.113549.1.7.3", "envelopedData"), r("1.2.840.113549.1.7.4", "signedAndEnvelopedData"), r("1.2.840.113549.1.7.5", "digestedData"), r("1.2.840.113549.1.7.6", "encryptedData"), r("1.2.840.113549.1.9.1", "emailAddress"), r("1.2.840.113549.1.9.2", "unstructuredName"), r("1.2.840.113549.1.9.3", "contentType"), r("1.2.840.113549.1.9.4", "messageDigest"), r("1.2.840.113549.1.9.5", "signingTime"), r("1.2.840.113549.1.9.6", "counterSignature"), r("1.2.840.113549.1.9.7", "challengePassword"), r("1.2.840.113549.1.9.8", "unstructuredAddress"), r("1.2.840.113549.1.9.14", "extensionRequest"), r("1.2.840.113549.1.9.20", "friendlyName"), r("1.2.840.113549.1.9.21", "localKeyId"), r("1.2.840.113549.1.9.22.1", "x509Certificate"), r("1.2.840.113549.1.12.10.1.1", "keyBag"), r("1.2.840.113549.1.12.10.1.2", "pkcs8ShroudedKeyBag"), r("1.2.840.113549.1.12.10.1.3", "certBag"), r("1.2.840.113549.1.12.10.1.4", "crlBag"), r("1.2.840.113549.1.12.10.1.5", "secretBag"), r("1.2.840.113549.1.12.10.1.6", "safeContentsBag"), r("1.2.840.113549.1.5.13", "pkcs5PBES2"), r("1.2.840.113549.1.5.12", "pkcs5PBKDF2"), r("1.2.840.113549.1.12.1.1", "pbeWithSHAAnd128BitRC4"), r("1.2.840.113549.1.12.1.2", "pbeWithSHAAnd40BitRC4"), r("1.2.840.113549.1.12.1.3", "pbeWithSHAAnd3-KeyTripleDES-CBC"), r("1.2.840.113549.1.12.1.4", "pbeWithSHAAnd2-KeyTripleDES-CBC"), r("1.2.840.113549.1.12.1.5", "pbeWithSHAAnd128BitRC2-CBC"), r("1.2.840.113549.1.12.1.6", "pbewithSHAAnd40BitRC2-CBC"), r("1.2.840.113549.2.7", "hmacWithSHA1"), r("1.2.840.113549.2.8", "hmacWithSHA224"), r("1.2.840.113549.2.9", "hmacWithSHA256"), r("1.2.840.113549.2.10", "hmacWithSHA384"), r("1.2.840.113549.2.11", "hmacWithSHA512"), r("1.2.840.113549.3.7", "des-EDE3-CBC"), r("2.16.840.1.101.3.4.1.2", "aes128-CBC"), r("2.16.840.1.101.3.4.1.22", "aes192-CBC"), r("2.16.840.1.101.3.4.1.42", "aes256-CBC"), r("2.5.4.3", "commonName"), r("2.5.4.5", "serialName"), r("2.5.4.6", "countryName"), r("2.5.4.7", "localityName"), r("2.5.4.8", "stateOrProvinceName"), r("2.5.4.10", "organizationName"), r("2.5.4.11", "organizationalUnitName"), r("2.5.4.13", "description"), r("2.16.840.1.113730.1.1", "nsCertType"), r("2.16.840.1.113730.1.13", "nsComment"), n("2.5.29.1", "authorityKeyIdentifier"), n("2.5.29.2", "keyAttributes"), n("2.5.29.3", "certificatePolicies"), n("2.5.29.4", "keyUsageRestriction"), n("2.5.29.5", "policyMapping"), n("2.5.29.6", "subtreesConstraint"), n("2.5.29.7", "subjectAltName"), n("2.5.29.8", "issuerAltName"), n("2.5.29.9", "subjectDirectoryAttributes"), n("2.5.29.10", "basicConstraints"), n("2.5.29.11", "nameConstraints"), n("2.5.29.12", "policyConstraints"), n("2.5.29.13", "basicConstraints"), r("2.5.29.14", "subjectKeyIdentifier"), r("2.5.29.15", "keyUsage"), n("2.5.29.16", "privateKeyUsagePeriod"), r("2.5.29.17", "subjectAltName"), r("2.5.29.18", "issuerAltName"), r("2.5.29.19", "basicConstraints"), n("2.5.29.20", "cRLNumber"), n("2.5.29.21", "cRLReason"), n("2.5.29.22", "expirationDate"), n("2.5.29.23", "instructionCode"), n("2.5.29.24", "invalidityDate"), n("2.5.29.25", "cRLDistributionPoints"), n("2.5.29.26", "issuingDistributionPoint"), n("2.5.29.27", "deltaCRLIndicator"), n("2.5.29.28", "issuingDistributionPoint"), n("2.5.29.29", "certificateIssuer"), n("2.5.29.30", "nameConstraints"), r("2.5.29.31", "cRLDistributionPoints"), r("2.5.29.32", "certificatePolicies"), n("2.5.29.33", "policyMappings"), n("2.5.29.34", "policyConstraints"), r("2.5.29.35", "authorityKeyIdentifier"), n("2.5.29.36", "policyConstraints"), r("2.5.29.37", "extKeyUsage"), n("2.5.29.46", "freshestCRL"), n("2.5.29.54", "inhibitAnyPolicy"), r("1.3.6.1.4.1.11129.2.4.2", "timestampList"), r("1.3.6.1.5.5.7.1.1", "authorityInfoAccess"), r("1.3.6.1.5.5.7.3.1", "serverAuth"), r("1.3.6.1.5.5.7.3.2", "clientAuth"), r("1.3.6.1.5.5.7.3.3", "codeSigning"), r("1.3.6.1.5.5.7.3.4", "emailProtection"), r("1.3.6.1.5.5.7.3.8", "timeStamping");
  }), i(function (t) {
    var e = t.exports = h.asn1 = h.asn1 || {};

    function r(t, e, r) {
      if (r > e) {
        var n = new Error("Too few bytes to parse DER.");
        throw n.available = t.length(), n.remaining = e, n.requested = r, n;
      }
    }

    e.Class = {
      UNIVERSAL: 0,
      APPLICATION: 64,
      CONTEXT_SPECIFIC: 128,
      PRIVATE: 192
    }, e.Type = {
      NONE: 0,
      BOOLEAN: 1,
      INTEGER: 2,
      BITSTRING: 3,
      OCTETSTRING: 4,
      NULL: 5,
      OID: 6,
      ODESC: 7,
      EXTERNAL: 8,
      REAL: 9,
      ENUMERATED: 10,
      EMBEDDED: 11,
      UTF8: 12,
      ROID: 13,
      SEQUENCE: 16,
      SET: 17,
      PRINTABLESTRING: 19,
      IA5STRING: 22,
      UTCTIME: 23,
      GENERALIZEDTIME: 24,
      BMPSTRING: 30
    }, e.create = function (t, r, n, i, a) {
      if (h.util.isArray(i)) {
        for (var o = [], s = 0; s < i.length; ++s) {
          void 0 !== i[s] && o.push(i[s]);
        }

        i = o;
      }

      var u = {
        tagClass: t,
        type: r,
        constructed: n,
        composed: n || h.util.isArray(i),
        value: i
      };
      return a && "bitStringContents" in a && (u.bitStringContents = a.bitStringContents, u.original = e.copy(u)), u;
    }, e.copy = function (t, r) {
      var n;

      if (h.util.isArray(t)) {
        n = [];

        for (var i = 0; i < t.length; ++i) {
          n.push(e.copy(t[i], r));
        }

        return n;
      }

      return "string" == typeof t ? t : (n = {
        tagClass: t.tagClass,
        type: t.type,
        constructed: t.constructed,
        composed: t.composed,
        value: e.copy(t.value, r)
      }, r && !r.excludeBitStringContents && (n.bitStringContents = t.bitStringContents), n);
    }, e.equals = function (t, r, n) {
      if (h.util.isArray(t)) {
        if (!h.util.isArray(r)) return !1;
        if (t.length !== r.length) return !1;

        for (var i = 0; i < t.length; ++i) {
          if (!e.equals(t[i], r[i])) return !1;
        }

        return !0;
      }

      if (typeof t != typeof r) return !1;
      if ("string" == typeof t) return t === r;
      var a = t.tagClass === r.tagClass && t.type === r.type && t.constructed === r.constructed && t.composed === r.composed && e.equals(t.value, r.value);
      return n && n.includeBitStringContents && (a = a && t.bitStringContents === r.bitStringContents), a;
    }, e.getBerValueLength = function (t) {
      var e = t.getByte();
      if (128 !== e) return 128 & e ? t.getInt((127 & e) << 3) : e;
    };
    e.fromDer = function (t, n) {
      return void 0 === n && (n = {
        strict: !0,
        decodeBitStrings: !0
      }), "boolean" == typeof n && (n = {
        strict: n,
        decodeBitStrings: !0
      }), "strict" in n || (n.strict = !0), "decodeBitStrings" in n || (n.decodeBitStrings = !0), "string" == typeof t && (t = h.util.createBuffer(t)), function t(n, i, a, o) {
        var s;
        r(n, i, 2);
        var u = n.getByte();
        i--;
        var c = 192 & u,
            f = 31 & u;
        s = n.length();

        var l,
            h,
            p = function (t, e) {
          var n = t.getByte();

          if (e--, 128 !== n) {
            var i;

            if (128 & n) {
              var a = 127 & n;
              r(t, e, a), i = t.getInt(a << 3);
            } else i = n;

            if (i < 0) throw new Error("Negative length: " + i);
            return i;
          }
        }(n, i);

        if (i -= s - n.length(), void 0 !== p && p > i) {
          if (o.strict) {
            var d = new Error("Too few bytes to read ASN.1 value.");
            throw d.available = n.length(), d.remaining = i, d.requested = p, d;
          }

          p = i;
        }

        var y = 32 == (32 & u);
        if (y) if (l = [], void 0 === p) for (;;) {
          if (r(n, i, 2), n.bytes(2) === String.fromCharCode(0, 0)) {
            n.getBytes(2), i -= 2;
            break;
          }

          s = n.length(), l.push(t(n, i, a + 1, o)), i -= s - n.length();
        } else for (; p > 0;) {
          s = n.length(), l.push(t(n, p, a + 1, o)), i -= s - n.length(), p -= s - n.length();
        }
        void 0 === l && c === e.Class.UNIVERSAL && f === e.Type.BITSTRING && (h = n.bytes(p));

        if (void 0 === l && o.decodeBitStrings && c === e.Class.UNIVERSAL && f === e.Type.BITSTRING && p > 1) {
          var g = n.read,
              v = i,
              m = 0;
          if (f === e.Type.BITSTRING && (r(n, i, 1), m = n.getByte(), i--), 0 === m) try {
            s = n.length();
            var E = {
              verbose: o.verbose,
              strict: !0,
              decodeBitStrings: !0
            },
                C = t(n, i, a + 1, E),
                S = s - n.length();
            i -= S, f == e.Type.BITSTRING && S++;
            var b = C.tagClass;
            S !== p || b !== e.Class.UNIVERSAL && b !== e.Class.CONTEXT_SPECIFIC || (l = [C]);
          } catch (t) {}
          void 0 === l && (n.read = g, i = v);
        }

        if (void 0 === l) {
          if (void 0 === p) {
            if (o.strict) throw new Error("Non-constructed ASN.1 object of indefinite length.");
            p = i;
          }

          if (f === e.Type.BMPSTRING) for (l = ""; p > 0; p -= 2) {
            r(n, i, 2), l += String.fromCharCode(n.getInt16()), i -= 2;
          } else l = n.getBytes(p);
        }

        var T = void 0 === h ? null : {
          bitStringContents: h
        };
        return e.create(c, f, y, l, T);
      }(t, t.length(), 0, n);
    }, e.toDer = function (t) {
      var r = h.util.createBuffer(),
          n = t.tagClass | t.type,
          i = h.util.createBuffer(),
          a = !1;
      if ("bitStringContents" in t && (a = !0, t.original && (a = e.equals(t, t.original))), a) i.putBytes(t.bitStringContents);else if (t.composed) {
        t.constructed ? n |= 32 : i.putByte(0);

        for (var o = 0; o < t.value.length; ++o) {
          void 0 !== t.value[o] && i.putBuffer(e.toDer(t.value[o]));
        }
      } else if (t.type === e.Type.BMPSTRING) for (o = 0; o < t.value.length; ++o) {
        i.putInt16(t.value.charCodeAt(o));
      } else t.type === e.Type.INTEGER && t.value.length > 1 && (0 === t.value.charCodeAt(0) && 0 == (128 & t.value.charCodeAt(1)) || 255 === t.value.charCodeAt(0) && 128 == (128 & t.value.charCodeAt(1))) ? i.putBytes(t.value.substr(1)) : i.putBytes(t.value);
      if (r.putByte(n), i.length() <= 127) r.putByte(127 & i.length());else {
        var s = i.length(),
            u = "";

        do {
          u += String.fromCharCode(255 & s), s >>>= 8;
        } while (s > 0);

        r.putByte(128 | u.length);

        for (o = u.length - 1; o >= 0; --o) {
          r.putByte(u.charCodeAt(o));
        }
      }
      return r.putBuffer(i), r;
    }, e.oidToDer = function (t) {
      var e,
          r,
          n,
          i,
          a = t.split("."),
          o = h.util.createBuffer();
      o.putByte(40 * parseInt(a[0], 10) + parseInt(a[1], 10));

      for (var s = 2; s < a.length; ++s) {
        e = !0, r = [], n = parseInt(a[s], 10);

        do {
          i = 127 & n, n >>>= 7, e || (i |= 128), r.push(i), e = !1;
        } while (n > 0);

        for (var u = r.length - 1; u >= 0; --u) {
          o.putByte(r[u]);
        }
      }

      return o;
    }, e.derToOid = function (t) {
      var e;
      "string" == typeof t && (t = h.util.createBuffer(t));
      var r = t.getByte();
      e = Math.floor(r / 40) + "." + r % 40;

      for (var n = 0; t.length() > 0;) {
        n <<= 7, 128 & (r = t.getByte()) ? n += 127 & r : (e += "." + (n + r), n = 0);
      }

      return e;
    }, e.utcTimeToDate = function (t) {
      var e = new Date(),
          r = parseInt(t.substr(0, 2), 10);
      r = r >= 50 ? 1900 + r : 2e3 + r;
      var n = parseInt(t.substr(2, 2), 10) - 1,
          i = parseInt(t.substr(4, 2), 10),
          a = parseInt(t.substr(6, 2), 10),
          o = parseInt(t.substr(8, 2), 10),
          s = 0;

      if (t.length > 11) {
        var u = t.charAt(10),
            c = 10;
        "+" !== u && "-" !== u && (s = parseInt(t.substr(10, 2), 10), c += 2);
      }

      if (e.setUTCFullYear(r, n, i), e.setUTCHours(a, o, s, 0), c && ("+" === (u = t.charAt(c)) || "-" === u)) {
        var f = 60 * parseInt(t.substr(c + 1, 2), 10) + parseInt(t.substr(c + 4, 2), 10);
        f *= 6e4, "+" === u ? e.setTime(+e - f) : e.setTime(+e + f);
      }

      return e;
    }, e.generalizedTimeToDate = function (t) {
      var e = new Date(),
          r = parseInt(t.substr(0, 4), 10),
          n = parseInt(t.substr(4, 2), 10) - 1,
          i = parseInt(t.substr(6, 2), 10),
          a = parseInt(t.substr(8, 2), 10),
          o = parseInt(t.substr(10, 2), 10),
          s = parseInt(t.substr(12, 2), 10),
          u = 0,
          c = 0,
          f = !1;
      "Z" === t.charAt(t.length - 1) && (f = !0);
      var l = t.length - 5,
          h = t.charAt(l);
      "+" !== h && "-" !== h || (c = 60 * parseInt(t.substr(l + 1, 2), 10) + parseInt(t.substr(l + 4, 2), 10), c *= 6e4, "+" === h && (c *= -1), f = !0);
      return "." === t.charAt(14) && (u = 1e3 * parseFloat(t.substr(14), 10)), f ? (e.setUTCFullYear(r, n, i), e.setUTCHours(a, o, s, u), e.setTime(+e + c)) : (e.setFullYear(r, n, i), e.setHours(a, o, s, u)), e;
    }, e.dateToUtcTime = function (t) {
      if ("string" == typeof t) return t;
      var e = "",
          r = [];
      r.push(("" + t.getUTCFullYear()).substr(2)), r.push("" + (t.getUTCMonth() + 1)), r.push("" + t.getUTCDate()), r.push("" + t.getUTCHours()), r.push("" + t.getUTCMinutes()), r.push("" + t.getUTCSeconds());

      for (var n = 0; n < r.length; ++n) {
        r[n].length < 2 && (e += "0"), e += r[n];
      }

      return e += "Z";
    }, e.dateToGeneralizedTime = function (t) {
      if ("string" == typeof t) return t;
      var e = "",
          r = [];
      r.push("" + t.getUTCFullYear()), r.push("" + (t.getUTCMonth() + 1)), r.push("" + t.getUTCDate()), r.push("" + t.getUTCHours()), r.push("" + t.getUTCMinutes()), r.push("" + t.getUTCSeconds());

      for (var n = 0; n < r.length; ++n) {
        r[n].length < 2 && (e += "0"), e += r[n];
      }

      return e += "Z";
    }, e.integerToDer = function (t) {
      var e = h.util.createBuffer();
      if (t >= -128 && t < 128) return e.putSignedInt(t, 8);
      if (t >= -32768 && t < 32768) return e.putSignedInt(t, 16);
      if (t >= -8388608 && t < 8388608) return e.putSignedInt(t, 24);
      if (t >= -2147483648 && t < 2147483648) return e.putSignedInt(t, 32);
      var r = new Error("Integer too large; max is 32-bits.");
      throw r.integer = t, r;
    }, e.derToInteger = function (t) {
      "string" == typeof t && (t = h.util.createBuffer(t));
      var e = 8 * t.length();
      if (e > 32) throw new Error("Integer too large; max is 32-bits.");
      return t.getSignedInt(e);
    }, e.validate = function (t, r, n, i) {
      var a = !1;
      if (t.tagClass !== r.tagClass && void 0 !== r.tagClass || t.type !== r.type && void 0 !== r.type) i && (t.tagClass !== r.tagClass && i.push("[" + r.name + '] Expected tag class "' + r.tagClass + '", got "' + t.tagClass + '"'), t.type !== r.type && i.push("[" + r.name + '] Expected type "' + r.type + '", got "' + t.type + '"'));else if (t.constructed === r.constructed || void 0 === r.constructed) {
        if (a = !0, r.value && h.util.isArray(r.value)) for (var o = 0, s = 0; a && s < r.value.length; ++s) {
          a = r.value[s].optional || !1, t.value[o] && ((a = e.validate(t.value[o], r.value[s], n, i)) ? ++o : r.value[s].optional && (a = !0)), !a && i && i.push("[" + r.name + '] Tag class "' + r.tagClass + '", type "' + r.type + '" expected value length "' + r.value.length + '", got "' + t.value.length + '"');
        }
        if (a && n && (r.capture && (n[r.capture] = t.value), r.captureAsn1 && (n[r.captureAsn1] = t), r.captureBitStringContents && "bitStringContents" in t && (n[r.captureBitStringContents] = t.bitStringContents), r.captureBitStringValue && "bitStringContents" in t)) if (t.bitStringContents.length < 2) n[r.captureBitStringValue] = "";else {
          if (0 !== t.bitStringContents.charCodeAt(0)) throw new Error("captureBitStringValue only supported for zero unused bits");
          n[r.captureBitStringValue] = t.bitStringContents.slice(1);
        }
      } else i && i.push("[" + r.name + '] Expected constructed "' + r.constructed + '", got "' + t.constructed + '"');
      return a;
    };
    var n = /[^\\u0000-\\u00ff]/;

    e.prettyPrint = function (t, r, i) {
      var a = "";
      i = i || 2, (r = r || 0) > 0 && (a += "\n");

      for (var o = "", s = 0; s < r * i; ++s) {
        o += " ";
      }

      switch (a += o + "Tag: ", t.tagClass) {
        case e.Class.UNIVERSAL:
          a += "Universal:";
          break;

        case e.Class.APPLICATION:
          a += "Application:";
          break;

        case e.Class.CONTEXT_SPECIFIC:
          a += "Context-Specific:";
          break;

        case e.Class.PRIVATE:
          a += "Private:";
      }

      if (t.tagClass === e.Class.UNIVERSAL) switch (a += t.type, t.type) {
        case e.Type.NONE:
          a += " (None)";
          break;

        case e.Type.BOOLEAN:
          a += " (Boolean)";
          break;

        case e.Type.INTEGER:
          a += " (Integer)";
          break;

        case e.Type.BITSTRING:
          a += " (Bit string)";
          break;

        case e.Type.OCTETSTRING:
          a += " (Octet string)";
          break;

        case e.Type.NULL:
          a += " (Null)";
          break;

        case e.Type.OID:
          a += " (Object Identifier)";
          break;

        case e.Type.ODESC:
          a += " (Object Descriptor)";
          break;

        case e.Type.EXTERNAL:
          a += " (External or Instance of)";
          break;

        case e.Type.REAL:
          a += " (Real)";
          break;

        case e.Type.ENUMERATED:
          a += " (Enumerated)";
          break;

        case e.Type.EMBEDDED:
          a += " (Embedded PDV)";
          break;

        case e.Type.UTF8:
          a += " (UTF8)";
          break;

        case e.Type.ROID:
          a += " (Relative Object Identifier)";
          break;

        case e.Type.SEQUENCE:
          a += " (Sequence)";
          break;

        case e.Type.SET:
          a += " (Set)";
          break;

        case e.Type.PRINTABLESTRING:
          a += " (Printable String)";
          break;

        case e.Type.IA5String:
          a += " (IA5String (ASCII))";
          break;

        case e.Type.UTCTIME:
          a += " (UTC time)";
          break;

        case e.Type.GENERALIZEDTIME:
          a += " (Generalized time)";
          break;

        case e.Type.BMPSTRING:
          a += " (BMP String)";
      } else a += t.type;

      if (a += "\n", a += o + "Constructed: " + t.constructed + "\n", t.composed) {
        var u = 0,
            c = "";

        for (s = 0; s < t.value.length; ++s) {
          void 0 !== t.value[s] && (u += 1, c += e.prettyPrint(t.value[s], r + 1, i), s + 1 < t.value.length && (c += ","));
        }

        a += o + "Sub values: " + u + c;
      } else {
        if (a += o + "Value: ", t.type === e.Type.OID) {
          var f = e.derToOid(t.value);
          a += f, h.pki && h.pki.oids && f in h.pki.oids && (a += " (" + h.pki.oids[f] + ") ");
        }

        if (t.type === e.Type.INTEGER) try {
          a += e.derToInteger(t.value);
        } catch (e) {
          a += "0x" + h.util.bytesToHex(t.value);
        } else if (t.type === e.Type.BITSTRING) {
          if (t.value.length > 1 ? a += "0x" + h.util.bytesToHex(t.value.slice(1)) : a += "(none)", t.value.length > 0) {
            var l = t.value.charCodeAt(0);
            1 == l ? a += " (1 unused bit shown)" : l > 1 && (a += " (" + l + " unused bits shown)");
          }
        } else t.type === e.Type.OCTETSTRING ? (n.test(t.value) || (a += "(" + t.value + ") "), a += "0x" + h.util.bytesToHex(t.value)) : t.type === e.Type.UTF8 ? a += h.util.decodeUtf8(t.value) : t.type === e.Type.PRINTABLESTRING || t.type === e.Type.IA5String ? a += t.value : n.test(t.value) ? a += "0x" + h.util.bytesToHex(t.value) : 0 === t.value.length ? a += "[null]" : a += t.value;
      }

      return a;
    };
  }), h.md = h.md || {};
  h.md.algorithms = h.md.algorithms || {};
  i(function (t) {
    (t.exports = h.hmac = h.hmac || {}).create = function () {
      var t = null,
          e = null,
          r = null,
          n = null,
          i = {
        start: function start(i, a) {
          if (null !== i) if ("string" == typeof i) {
            if (!((i = i.toLowerCase()) in h.md.algorithms)) throw new Error('Unknown hash algorithm "' + i + '"');
            e = h.md.algorithms[i].create();
          } else e = i;
          if (null === a) a = t;else {
            if ("string" == typeof a) a = h.util.createBuffer(a);else if (h.util.isArray(a)) {
              var o = a;
              a = h.util.createBuffer();

              for (var s = 0; s < o.length; ++s) {
                a.putByte(o[s]);
              }
            }
            var u = a.length();
            u > e.blockLength && (e.start(), e.update(a.bytes()), a = e.digest()), r = h.util.createBuffer(), n = h.util.createBuffer(), u = a.length();

            for (s = 0; s < u; ++s) {
              o = a.at(s);
              r.putByte(54 ^ o), n.putByte(92 ^ o);
            }

            if (u < e.blockLength) for (o = e.blockLength - u, s = 0; s < o; ++s) {
              r.putByte(54), n.putByte(92);
            }
            t = a, r = r.bytes(), n = n.bytes();
          }
          e.start(), e.update(r);
        },
        update: function update(t) {
          e.update(t);
        },
        getMac: function getMac() {
          var t = e.digest().bytes();
          return e.start(), e.update(n), e.update(t), e.digest();
        }
      };
      return i.digest = i.getMac, i;
    };
  }), i(function (t) {
    h.mgf = h.mgf || {}, (t.exports = h.mgf.mgf1 = h.mgf1 = h.mgf1 || {}).create = function (t) {
      return {
        generate: function generate(e, r) {
          for (var n = new h.util.ByteBuffer(), i = Math.ceil(r / t.digestLength), a = 0; a < i; a++) {
            var o = new h.util.ByteBuffer();
            o.putInt32(a), t.start(), t.update(e + o.getBytes()), n.putBuffer(t.digest());
          }

          return n.truncate(n.length() - r), n.getBytes();
        }
      };
    };
  });
  var N,
      k = h.pkcs5 = h.pkcs5 || {};
  h.util.isNodejs && !h.options.usePureJavaScript && (N = t);
  h.pbkdf2 = k.pbkdf2 = function (t, e, r, n, i, a) {
    if ("function" == typeof i && (a = i, i = null), h.util.isNodejs && !h.options.usePureJavaScript && N.pbkdf2 && (null === i || "object" != typeof i) && (N.pbkdf2Sync.length > 4 || !i || "sha1" === i)) return "string" != typeof i && (i = "sha1"), t = Buffer.from(t, "binary"), e = Buffer.from(e, "binary"), a ? 4 === N.pbkdf2Sync.length ? N.pbkdf2(t, e, r, n, function (t, e) {
      if (t) return a(t);
      a(null, e.toString("binary"));
    }) : N.pbkdf2(t, e, r, n, i, function (t, e) {
      if (t) return a(t);
      a(null, e.toString("binary"));
    }) : 4 === N.pbkdf2Sync.length ? N.pbkdf2Sync(t, e, r, n).toString("binary") : N.pbkdf2Sync(t, e, r, n, i).toString("binary");

    if (null == i && (i = "sha1"), "string" == typeof i) {
      if (!(i in h.md.algorithms)) throw new Error("Unknown hash algorithm: " + i);
      i = h.md[i].create();
    }

    var o = i.digestLength;

    if (n > 4294967295 * o) {
      var s = new Error("Derived key is too long.");
      if (a) return a(s);
      throw s;
    }

    var u = Math.ceil(n / o),
        c = n - (u - 1) * o,
        f = h.hmac.create();
    f.start(i, t);
    var l,
        p,
        d,
        y = "";

    if (!a) {
      for (var g = 1; g <= u; ++g) {
        f.start(null, null), f.update(e), f.update(h.util.int32ToBytes(g)), l = d = f.digest().getBytes();

        for (var v = 2; v <= r; ++v) {
          f.start(null, null), f.update(d), p = f.digest().getBytes(), l = h.util.xorBytes(l, p, o), d = p;
        }

        y += g < u ? l : l.substr(0, c);
      }

      return y;
    }

    g = 1;

    function m() {
      if (g > u) return a(null, y);
      f.start(null, null), f.update(e), f.update(h.util.int32ToBytes(g)), l = d = f.digest().getBytes(), v = 2, E();
    }

    function E() {
      if (v <= r) return f.start(null, null), f.update(d), p = f.digest().getBytes(), l = h.util.xorBytes(l, p, o), d = p, ++v, h.util.setImmediate(E);
      y += g < u ? l : l.substr(0, c), ++g, m();
    }

    m();
  }, i(function (t) {
    var e = t.exports = h.pem = h.pem || {};

    function r(t) {
      for (var e = t.name + ": ", r = [], n = function n(t, e) {
        return " " + e;
      }, i = 0; i < t.values.length; ++i) {
        r.push(t.values[i].replace(/^(\S+\r\n)/, n));
      }

      e += r.join(",") + "\r\n";
      var a = 0,
          o = -1;

      for (i = 0; i < e.length; ++i, ++a) {
        if (a > 65 && -1 !== o) {
          var s = e[o];
          "," === s ? (++o, e = e.substr(0, o) + "\r\n " + e.substr(o)) : e = e.substr(0, o) + "\r\n" + s + e.substr(o + 1), a = i - o - 1, o = -1, ++i;
        } else " " !== e[i] && "\t" !== e[i] && "," !== e[i] || (o = i);
      }

      return e;
    }

    function n(t) {
      return t.replace(/^\s+/, "");
    }

    e.encode = function (t, e) {
      e = e || {};
      var n,
          i = "-----BEGIN " + t.type + "-----\r\n";
      if (t.procType && (i += r(n = {
        name: "Proc-Type",
        values: [String(t.procType.version), t.procType.type]
      })), t.contentDomain && (i += r(n = {
        name: "Content-Domain",
        values: [t.contentDomain]
      })), t.dekInfo && (n = {
        name: "DEK-Info",
        values: [t.dekInfo.algorithm]
      }, t.dekInfo.parameters && n.values.push(t.dekInfo.parameters), i += r(n)), t.headers) for (var a = 0; a < t.headers.length; ++a) {
        i += r(t.headers[a]);
      }
      return t.procType && (i += "\r\n"), i += h.util.encode64(t.body, e.maxline || 64) + "\r\n", i += "-----END " + t.type + "-----\r\n";
    }, e.decode = function (t) {
      for (var e, r = [], i = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g, a = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/, o = /\r?\n/; e = i.exec(t);) {
        var s = {
          type: e[1],
          procType: null,
          contentDomain: null,
          dekInfo: null,
          headers: [],
          body: h.util.decode64(e[3])
        };

        if (r.push(s), e[2]) {
          for (var u = e[2].split(o), c = 0; e && c < u.length;) {
            for (var f = u[c].replace(/\s+$/, ""), l = c + 1; l < u.length; ++l) {
              var p = u[l];
              if (!/\s/.test(p[0])) break;
              f += p, c = l;
            }

            if (e = f.match(a)) {
              for (var d = {
                name: e[1],
                values: []
              }, y = e[2].split(","), g = 0; g < y.length; ++g) {
                d.values.push(n(y[g]));
              }

              if (s.procType) {
                if (s.contentDomain || "Content-Domain" !== d.name) {
                  if (s.dekInfo || "DEK-Info" !== d.name) s.headers.push(d);else {
                    if (0 === d.values.length) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
                    s.dekInfo = {
                      algorithm: y[0],
                      parameters: y[1] || null
                    };
                  }
                } else s.contentDomain = y[0] || "";
              } else {
                if ("Proc-Type" !== d.name) throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
                if (2 !== d.values.length) throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
                s.procType = {
                  version: y[0],
                  type: y[1]
                };
              }
            }

            ++c;
          }

          if ("ENCRYPTED" === s.procType && !s.dekInfo) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
        }
      }

      if (0 === r.length) throw new Error("Invalid PEM formatted message.");
      return r;
    };
  }), i(function (t) {
    var e = t.exports = h.sha256 = h.sha256 || {};
    h.md.sha256 = h.md.algorithms.sha256 = e, e.create = function () {
      n || (r = String.fromCharCode(128), r += h.util.fillString(String.fromCharCode(0), 64), i = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], n = !0);
      var t = null,
          e = h.util.createBuffer(),
          o = new Array(64),
          s = {
        algorithm: "sha256",
        blockLength: 64,
        digestLength: 32,
        messageLength: 0,
        fullMessageLength: null,
        messageLengthSize: 8,
        start: function start() {
          s.messageLength = 0, s.fullMessageLength = s.messageLength64 = [];

          for (var r = s.messageLengthSize / 4, n = 0; n < r; ++n) {
            s.fullMessageLength.push(0);
          }

          return e = h.util.createBuffer(), t = {
            h0: 1779033703,
            h1: 3144134277,
            h2: 1013904242,
            h3: 2773480762,
            h4: 1359893119,
            h5: 2600822924,
            h6: 528734635,
            h7: 1541459225
          }, s;
        }
      };
      return s.start(), s.update = function (r, n) {
        "utf8" === n && (r = h.util.encodeUtf8(r));
        var i = r.length;
        s.messageLength += i, i = [i / 4294967296 >>> 0, i >>> 0];

        for (var u = s.fullMessageLength.length - 1; u >= 0; --u) {
          s.fullMessageLength[u] += i[1], i[1] = i[0] + (s.fullMessageLength[u] / 4294967296 >>> 0), s.fullMessageLength[u] = s.fullMessageLength[u] >>> 0, i[0] = i[1] / 4294967296 >>> 0;
        }

        return e.putBytes(r), a(t, o, e), (e.read > 2048 || 0 === e.length()) && e.compact(), s;
      }, s.digest = function () {
        var n = h.util.createBuffer();
        n.putBytes(e.bytes());
        var i,
            u = s.fullMessageLength[s.fullMessageLength.length - 1] + s.messageLengthSize & s.blockLength - 1;
        n.putBytes(r.substr(0, s.blockLength - u));

        for (var c = 8 * s.fullMessageLength[0], f = 0; f < s.fullMessageLength.length - 1; ++f) {
          c += (i = 8 * s.fullMessageLength[f + 1]) / 4294967296 >>> 0, n.putInt32(c >>> 0), c = i >>> 0;
        }

        n.putInt32(c);
        var l = {
          h0: t.h0,
          h1: t.h1,
          h2: t.h2,
          h3: t.h3,
          h4: t.h4,
          h5: t.h5,
          h6: t.h6,
          h7: t.h7
        };
        a(l, o, n);
        var p = h.util.createBuffer();
        return p.putInt32(l.h0), p.putInt32(l.h1), p.putInt32(l.h2), p.putInt32(l.h3), p.putInt32(l.h4), p.putInt32(l.h5), p.putInt32(l.h6), p.putInt32(l.h7), p;
      }, s;
    };
    var r = null,
        n = !1,
        i = null;

    function a(t, e, r) {
      for (var n, a, o, s, u, c, f, l, h, p, d, y, g, v = r.length(); v >= 64;) {
        for (u = 0; u < 16; ++u) {
          e[u] = r.getInt32();
        }

        for (; u < 64; ++u) {
          n = ((n = e[u - 2]) >>> 17 | n << 15) ^ (n >>> 19 | n << 13) ^ n >>> 10, a = ((a = e[u - 15]) >>> 7 | a << 25) ^ (a >>> 18 | a << 14) ^ a >>> 3, e[u] = n + e[u - 7] + a + e[u - 16] | 0;
        }

        for (c = t.h0, f = t.h1, l = t.h2, h = t.h3, p = t.h4, d = t.h5, y = t.h6, g = t.h7, u = 0; u < 64; ++u) {
          o = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10), s = c & f | l & (c ^ f), n = g + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + (y ^ p & (d ^ y)) + i[u] + e[u], g = y, y = d, d = p, p = h + n >>> 0, h = l, l = f, f = c, c = n + (a = o + s) >>> 0;
        }

        t.h0 = t.h0 + c | 0, t.h1 = t.h1 + f | 0, t.h2 = t.h2 + l | 0, t.h3 = t.h3 + h | 0, t.h4 = t.h4 + p | 0, t.h5 = t.h5 + d | 0, t.h6 = t.h6 + y | 0, t.h7 = t.h7 + g | 0, v -= 64;
      }
    }
  }), i(function (e) {
    var r = null;
    !h.util.isNodejs || h.options.usePureJavaScript || process.versions["node-webkit"] || (r = t), (e.exports = h.prng = h.prng || {}).create = function (t) {
      for (var e = {
        plugin: t,
        key: null,
        seed: null,
        time: null,
        reseeds: 0,
        generated: 0,
        keyBytes: ""
      }, n = t.md, i = new Array(32), a = 0; a < 32; ++a) {
        i[a] = n.create();
      }

      function o() {
        if (e.pools[0].messageLength >= 32) return s();
        var t = 32 - e.pools[0].messageLength << 5;
        e.collect(e.seedFileSync(t)), s();
      }

      function s() {
        e.reseeds = 4294967295 === e.reseeds ? 0 : e.reseeds + 1;
        var t = e.plugin.md.create();
        t.update(e.keyBytes);

        for (var r = 1, n = 0; n < 32; ++n) {
          e.reseeds % r == 0 && (t.update(e.pools[n].digest().getBytes()), e.pools[n].start()), r <<= 1;
        }

        e.keyBytes = t.digest().getBytes(), t.start(), t.update(e.keyBytes);
        var i = t.digest().getBytes();
        e.key = e.plugin.formatKey(e.keyBytes), e.seed = e.plugin.formatSeed(i), e.generated = 0;
      }

      function u(t) {
        var e = null,
            r = h.util.globalScope,
            n = r.crypto || r.msCrypto;
        n && n.getRandomValues && (e = function e(t) {
          return n.getRandomValues(t);
        });
        var i = h.util.createBuffer();
        if (e) for (; i.length() < t;) {
          var a = Math.max(1, Math.min(t - i.length(), 65536) / 4),
              o = new Uint32Array(Math.floor(a));

          try {
            e(o);

            for (var s = 0; s < o.length; ++s) {
              i.putInt32(o[s]);
            }
          } catch (t) {
            if (!("undefined" != typeof QuotaExceededError && t instanceof QuotaExceededError)) throw t;
          }
        }
        if (i.length() < t) for (var u, c, f, l = Math.floor(65536 * Math.random()); i.length() < t;) {
          c = 16807 * (65535 & l), c += (32767 & (u = 16807 * (l >> 16))) << 16, l = 4294967295 & (c = (2147483647 & (c += u >> 15)) + (c >> 31));

          for (s = 0; s < 3; ++s) {
            f = l >>> (s << 3), f ^= Math.floor(256 * Math.random()), i.putByte(String.fromCharCode(255 & f));
          }
        }
        return i.getBytes(t);
      }

      return e.pools = i, e.pool = 0, e.generate = function (t, r) {
        if (!r) return e.generateSync(t);
        var n = e.plugin.cipher,
            i = e.plugin.increment,
            a = e.plugin.formatKey,
            o = e.plugin.formatSeed,
            u = h.util.createBuffer();
        e.key = null, function c(f) {
          if (f) return r(f);
          if (u.length() >= t) return r(null, u.getBytes(t));
          e.generated > 1048575 && (e.key = null);
          if (null === e.key) return h.util.nextTick(function () {
            !function (t) {
              if (e.pools[0].messageLength >= 32) return s(), t();
              var r = 32 - e.pools[0].messageLength << 5;
              e.seedFile(r, function (r, n) {
                if (r) return t(r);
                e.collect(n), s(), t();
              });
            }(c);
          });
          var l = n(e.key, e.seed);
          e.generated += l.length, u.putBytes(l), e.key = a(n(e.key, i(e.seed))), e.seed = o(n(e.key, e.seed)), h.util.setImmediate(c);
        }();
      }, e.generateSync = function (t) {
        var r = e.plugin.cipher,
            n = e.plugin.increment,
            i = e.plugin.formatKey,
            a = e.plugin.formatSeed;
        e.key = null;

        for (var s = h.util.createBuffer(); s.length() < t;) {
          e.generated > 1048575 && (e.key = null), null === e.key && o();
          var u = r(e.key, e.seed);
          e.generated += u.length, s.putBytes(u), e.key = i(r(e.key, n(e.seed))), e.seed = a(r(e.key, e.seed));
        }

        return s.getBytes(t);
      }, r ? (e.seedFile = function (t, e) {
        r.randomBytes(t, function (t, r) {
          if (t) return e(t);
          e(null, r.toString());
        });
      }, e.seedFileSync = function (t) {
        return r.randomBytes(t).toString();
      }) : (e.seedFile = function (t, e) {
        try {
          e(null, u(t));
        } catch (t) {
          e(t);
        }
      }, e.seedFileSync = u), e.collect = function (t) {
        for (var r = t.length, n = 0; n < r; ++n) {
          e.pools[e.pool].update(t.substr(n, 1)), e.pool = 31 === e.pool ? 0 : e.pool + 1;
        }
      }, e.collectInt = function (t, r) {
        for (var n = "", i = 0; i < r; i += 8) {
          n += String.fromCharCode(t >> i & 255);
        }

        e.collect(n);
      }, e.registerWorker = function (t) {
        if (t === self) e.seedFile = function (t, e) {
          self.addEventListener("message", function t(r) {
            var n = r.data;
            n.forge && n.forge.prng && (self.removeEventListener("message", t), e(n.forge.prng.err, n.forge.prng.bytes));
          }), self.postMessage({
            forge: {
              prng: {
                needed: t
              }
            }
          });
        };else {
          t.addEventListener("message", function (r) {
            var n = r.data;
            n.forge && n.forge.prng && e.seedFile(n.forge.prng.needed, function (e, r) {
              t.postMessage({
                forge: {
                  prng: {
                    err: e,
                    bytes: r
                  }
                }
              });
            });
          });
        }
      }, e;
    };
  }), i(function (t) {
    h.random && h.random.getBytes ? t.exports = h.random : function (e) {
      var r = {},
          n = new Array(4),
          i = h.util.createBuffer();

      function a() {
        var t = h.prng.create(r);
        return t.getBytes = function (e, r) {
          return t.generate(e, r);
        }, t.getBytesSync = function (e) {
          return t.generate(e);
        }, t;
      }

      r.formatKey = function (t) {
        var e = h.util.createBuffer(t);
        return (t = new Array(4))[0] = e.getInt32(), t[1] = e.getInt32(), t[2] = e.getInt32(), t[3] = e.getInt32(), h.aes._expandKey(t, !1);
      }, r.formatSeed = function (t) {
        var e = h.util.createBuffer(t);
        return (t = new Array(4))[0] = e.getInt32(), t[1] = e.getInt32(), t[2] = e.getInt32(), t[3] = e.getInt32(), t;
      }, r.cipher = function (t, e) {
        return h.aes._updateBlock(t, e, n, !1), i.putInt32(n[0]), i.putInt32(n[1]), i.putInt32(n[2]), i.putInt32(n[3]), i.getBytes();
      }, r.increment = function (t) {
        return ++t[3], t;
      }, r.md = h.md.sha256;
      var o = a(),
          s = null,
          u = h.util.globalScope,
          c = u.crypto || u.msCrypto;

      if (c && c.getRandomValues && (s = function s(t) {
        return c.getRandomValues(t);
      }), !h.util.isNodejs && !s) {
        if (o.collectInt(+new Date(), 32), "undefined" != typeof navigator) {
          var f = "";

          for (var l in navigator) {
            try {
              "string" == typeof navigator[l] && (f += navigator[l]);
            } catch (t) {}
          }

          o.collect(f), f = null;
        }

        e && (e().mousemove(function (t) {
          o.collectInt(t.clientX, 16), o.collectInt(t.clientY, 16);
        }), e().keypress(function (t) {
          o.collectInt(t.charCode, 8);
        }));
      }

      if (h.random) for (var l in o) {
        h.random[l] = o[l];
      } else h.random = o;
      h.random.createInstance = a, t.exports = h.random;
    }("undefined" != typeof jQuery ? jQuery : null);
  }), i(function (t) {
    var e = t.exports = h.sha1 = h.sha1 || {};
    h.md.sha1 = h.md.algorithms.sha1 = e, e.create = function () {
      n || (r = String.fromCharCode(128), r += h.util.fillString(String.fromCharCode(0), 64), n = !0);
      var t = null,
          e = h.util.createBuffer(),
          a = new Array(80),
          o = {
        algorithm: "sha1",
        blockLength: 64,
        digestLength: 20,
        messageLength: 0,
        fullMessageLength: null,
        messageLengthSize: 8,
        start: function start() {
          o.messageLength = 0, o.fullMessageLength = o.messageLength64 = [];

          for (var r = o.messageLengthSize / 4, n = 0; n < r; ++n) {
            o.fullMessageLength.push(0);
          }

          return e = h.util.createBuffer(), t = {
            h0: 1732584193,
            h1: 4023233417,
            h2: 2562383102,
            h3: 271733878,
            h4: 3285377520
          }, o;
        }
      };
      return o.start(), o.update = function (r, n) {
        "utf8" === n && (r = h.util.encodeUtf8(r));
        var s = r.length;
        o.messageLength += s, s = [s / 4294967296 >>> 0, s >>> 0];

        for (var u = o.fullMessageLength.length - 1; u >= 0; --u) {
          o.fullMessageLength[u] += s[1], s[1] = s[0] + (o.fullMessageLength[u] / 4294967296 >>> 0), o.fullMessageLength[u] = o.fullMessageLength[u] >>> 0, s[0] = s[1] / 4294967296 >>> 0;
        }

        return e.putBytes(r), i(t, a, e), (e.read > 2048 || 0 === e.length()) && e.compact(), o;
      }, o.digest = function () {
        var n = h.util.createBuffer();
        n.putBytes(e.bytes());
        var s,
            u = o.fullMessageLength[o.fullMessageLength.length - 1] + o.messageLengthSize & o.blockLength - 1;
        n.putBytes(r.substr(0, o.blockLength - u));

        for (var c = 8 * o.fullMessageLength[0], f = 0; f < o.fullMessageLength.length - 1; ++f) {
          c += (s = 8 * o.fullMessageLength[f + 1]) / 4294967296 >>> 0, n.putInt32(c >>> 0), c = s >>> 0;
        }

        n.putInt32(c);
        var l = {
          h0: t.h0,
          h1: t.h1,
          h2: t.h2,
          h3: t.h3,
          h4: t.h4
        };
        i(l, a, n);
        var p = h.util.createBuffer();
        return p.putInt32(l.h0), p.putInt32(l.h1), p.putInt32(l.h2), p.putInt32(l.h3), p.putInt32(l.h4), p;
      }, o;
    };
    var r = null,
        n = !1;

    function i(t, e, r) {
      for (var n, i, a, o, s, u, c, f = r.length(); f >= 64;) {
        for (i = t.h0, a = t.h1, o = t.h2, s = t.h3, u = t.h4, c = 0; c < 16; ++c) {
          n = r.getInt32(), e[c] = n, n = (i << 5 | i >>> 27) + (s ^ a & (o ^ s)) + u + 1518500249 + n, u = s, s = o, o = (a << 30 | a >>> 2) >>> 0, a = i, i = n;
        }

        for (; c < 20; ++c) {
          n = (n = e[c - 3] ^ e[c - 8] ^ e[c - 14] ^ e[c - 16]) << 1 | n >>> 31, e[c] = n, n = (i << 5 | i >>> 27) + (s ^ a & (o ^ s)) + u + 1518500249 + n, u = s, s = o, o = (a << 30 | a >>> 2) >>> 0, a = i, i = n;
        }

        for (; c < 32; ++c) {
          n = (n = e[c - 3] ^ e[c - 8] ^ e[c - 14] ^ e[c - 16]) << 1 | n >>> 31, e[c] = n, n = (i << 5 | i >>> 27) + (a ^ o ^ s) + u + 1859775393 + n, u = s, s = o, o = (a << 30 | a >>> 2) >>> 0, a = i, i = n;
        }

        for (; c < 40; ++c) {
          n = (n = e[c - 6] ^ e[c - 16] ^ e[c - 28] ^ e[c - 32]) << 2 | n >>> 30, e[c] = n, n = (i << 5 | i >>> 27) + (a ^ o ^ s) + u + 1859775393 + n, u = s, s = o, o = (a << 30 | a >>> 2) >>> 0, a = i, i = n;
        }

        for (; c < 60; ++c) {
          n = (n = e[c - 6] ^ e[c - 16] ^ e[c - 28] ^ e[c - 32]) << 2 | n >>> 30, e[c] = n, n = (i << 5 | i >>> 27) + (a & o | s & (a ^ o)) + u + 2400959708 + n, u = s, s = o, o = (a << 30 | a >>> 2) >>> 0, a = i, i = n;
        }

        for (; c < 80; ++c) {
          n = (n = e[c - 6] ^ e[c - 16] ^ e[c - 28] ^ e[c - 32]) << 2 | n >>> 30, e[c] = n, n = (i << 5 | i >>> 27) + (a ^ o ^ s) + u + 3395469782 + n, u = s, s = o, o = (a << 30 | a >>> 2) >>> 0, a = i, i = n;
        }

        t.h0 = t.h0 + i | 0, t.h1 = t.h1 + a | 0, t.h2 = t.h2 + o | 0, t.h3 = t.h3 + s | 0, t.h4 = t.h4 + u | 0, f -= 64;
      }
    }
  }), i(function (t) {
    var e = t.exports = h.pkcs1 = h.pkcs1 || {};

    function r(t, e, r) {
      r || (r = h.md.sha1.create());

      for (var n = "", i = Math.ceil(e / r.digestLength), a = 0; a < i; ++a) {
        var o = String.fromCharCode(a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, 255 & a);
        r.start(), r.update(t + o), n += r.digest().getBytes();
      }

      return n.substring(0, e);
    }

    e.encode_rsa_oaep = function (t, e, n) {
      var i, a, o, s;
      "string" == typeof n ? (i = n, a = arguments[3] || void 0, o = arguments[4] || void 0) : n && (i = n.label || void 0, a = n.seed || void 0, o = n.md || void 0, n.mgf1 && n.mgf1.md && (s = n.mgf1.md)), o ? o.start() : o = h.md.sha1.create(), s || (s = o);
      var u = Math.ceil(t.n.bitLength() / 8),
          c = u - 2 * o.digestLength - 2;
      if (e.length > c) throw (g = new Error("RSAES-OAEP input message length is too long.")).length = e.length, g.maxLength = c, g;
      i || (i = ""), o.update(i, "raw");

      for (var f = o.digest(), l = "", p = c - e.length, d = 0; d < p; d++) {
        l += "\0";
      }

      var y = f.getBytes() + l + "" + e;

      if (a) {
        if (a.length !== o.digestLength) {
          var g;
          throw (g = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.")).seedLength = a.length, g.digestLength = o.digestLength, g;
        }
      } else a = h.random.getBytes(o.digestLength);

      var v = r(a, u - o.digestLength - 1, s),
          m = h.util.xorBytes(y, v, y.length),
          E = r(m, o.digestLength, s),
          C = h.util.xorBytes(a, E, a.length);
      return "\0" + C + m;
    }, e.decode_rsa_oaep = function (t, e, n) {
      var i, a, o;
      "string" == typeof n ? (i = n, a = arguments[3] || void 0) : n && (i = n.label || void 0, a = n.md || void 0, n.mgf1 && n.mgf1.md && (o = n.mgf1.md));
      var s = Math.ceil(t.n.bitLength() / 8);
      if (e.length !== s) throw (m = new Error("RSAES-OAEP encoded message length is invalid.")).length = e.length, m.expectedLength = s, m;
      if (void 0 === a ? a = h.md.sha1.create() : a.start(), o || (o = a), s < 2 * a.digestLength + 2) throw new Error("RSAES-OAEP key is too short for the hash function.");
      i || (i = ""), a.update(i, "raw");

      for (var u = a.digest().getBytes(), c = e.charAt(0), f = e.substring(1, a.digestLength + 1), l = e.substring(1 + a.digestLength), p = r(l, a.digestLength, o), d = h.util.xorBytes(f, p, f.length), y = r(d, s - a.digestLength - 1, o), g = h.util.xorBytes(l, y, l.length), v = g.substring(0, a.digestLength), m = "\0" !== c, E = 0; E < a.digestLength; ++E) {
        m |= u.charAt(E) !== v.charAt(E);
      }

      for (var C = 1, S = a.digestLength, b = a.digestLength; b < g.length; b++) {
        var T = g.charCodeAt(b),
            A = 1 & T ^ 1,
            I = C ? 65534 : 0;
        m |= T & I, S += C &= A;
      }

      if (m || 1 !== g.charCodeAt(S)) throw new Error("Invalid RSAES-OAEP padding.");
      return g.substring(S + 1);
    };
  }), h.des = h.des || {};

  function _(t, e) {
    h.cipher.registerAlgorithm(t, function () {
      return new h.des.Algorithm(t, e);
    });
  }

  h.des.startEncrypting = function (t, e, r, n) {
    var i = x({
      key: t,
      output: r,
      decrypt: !1,
      mode: n || (null === e ? "ECB" : "CBC")
    });
    return i.start(e), i;
  }, h.des.createEncryptionCipher = function (t, e) {
    return x({
      key: t,
      output: null,
      decrypt: !1,
      mode: e
    });
  }, h.des.startDecrypting = function (t, e, r, n) {
    var i = x({
      key: t,
      output: r,
      decrypt: !0,
      mode: n || (null === e ? "ECB" : "CBC")
    });
    return i.start(e), i;
  }, h.des.createDecryptionCipher = function (t, e) {
    return x({
      key: t,
      output: null,
      decrypt: !0,
      mode: e
    });
  }, h.des.Algorithm = function (t, e) {
    var r = this;
    r.name = t, r.mode = new e({
      blockSize: 8,
      cipher: {
        encrypt: function encrypt(t, e) {
          return V(r._keys, t, e, !1);
        },
        decrypt: function decrypt(t, e) {
          return V(r._keys, t, e, !0);
        }
      }
    }), r._init = !1;
  }, h.des.Algorithm.prototype.initialize = function (t) {
    if (!this._init) {
      var e = h.util.createBuffer(t.key);
      if (0 === this.name.indexOf("3DES") && 24 !== e.length()) throw new Error("Invalid Triple-DES key size: " + 8 * e.length());
      this._keys = function (t) {
        for (var e, r = [0, 4, 536870912, 536870916, 65536, 65540, 536936448, 536936452, 512, 516, 536871424, 536871428, 66048, 66052, 536936960, 536936964], n = [0, 1, 1048576, 1048577, 67108864, 67108865, 68157440, 68157441, 256, 257, 1048832, 1048833, 67109120, 67109121, 68157696, 68157697], i = [0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272, 0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272], a = [0, 2097152, 134217728, 136314880, 8192, 2105344, 134225920, 136323072, 131072, 2228224, 134348800, 136445952, 139264, 2236416, 134356992, 136454144], o = [0, 262144, 16, 262160, 0, 262144, 16, 262160, 4096, 266240, 4112, 266256, 4096, 266240, 4112, 266256], s = [0, 1024, 32, 1056, 0, 1024, 32, 1056, 33554432, 33555456, 33554464, 33555488, 33554432, 33555456, 33554464, 33555488], u = [0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746, 0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746], c = [0, 65536, 2048, 67584, 536870912, 536936448, 536872960, 536938496, 131072, 196608, 133120, 198656, 537001984, 537067520, 537004032, 537069568], f = [0, 262144, 0, 262144, 2, 262146, 2, 262146, 33554432, 33816576, 33554432, 33816576, 33554434, 33816578, 33554434, 33816578], l = [0, 268435456, 8, 268435464, 0, 268435456, 8, 268435464, 1024, 268436480, 1032, 268436488, 1024, 268436480, 1032, 268436488], h = [0, 32, 0, 32, 1048576, 1048608, 1048576, 1048608, 8192, 8224, 8192, 8224, 1056768, 1056800, 1056768, 1056800], p = [0, 16777216, 512, 16777728, 2097152, 18874368, 2097664, 18874880, 67108864, 83886080, 67109376, 83886592, 69206016, 85983232, 69206528, 85983744], d = [0, 4096, 134217728, 134221824, 524288, 528384, 134742016, 134746112, 16, 4112, 134217744, 134221840, 524304, 528400, 134742032, 134746128], y = [0, 4, 256, 260, 0, 4, 256, 260, 1, 5, 257, 261, 1, 5, 257, 261], g = t.length() > 8 ? 3 : 1, v = [], m = [0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0], E = 0, C = 0; C < g; C++) {
          var S = t.getInt32(),
              b = t.getInt32();
          S ^= (e = 252645135 & (S >>> 4 ^ b)) << 4, S ^= e = 65535 & ((b ^= e) >>> -16 ^ S), S ^= (e = 858993459 & (S >>> 2 ^ (b ^= e << -16))) << 2, S ^= e = 65535 & ((b ^= e) >>> -16 ^ S), S ^= (e = 1431655765 & (S >>> 1 ^ (b ^= e << -16))) << 1, S ^= e = 16711935 & ((b ^= e) >>> 8 ^ S), e = (S ^= (e = 1431655765 & (S >>> 1 ^ (b ^= e << 8))) << 1) << 8 | (b ^= e) >>> 20 & 240, S = b << 24 | b << 8 & 16711680 | b >>> 8 & 65280 | b >>> 24 & 240, b = e;

          for (var T = 0; T < m.length; ++T) {
            m[T] ? (S = S << 2 | S >>> 26, b = b << 2 | b >>> 26) : (S = S << 1 | S >>> 27, b = b << 1 | b >>> 27);
            var A = r[(S &= -15) >>> 28] | n[S >>> 24 & 15] | i[S >>> 20 & 15] | a[S >>> 16 & 15] | o[S >>> 12 & 15] | s[S >>> 8 & 15] | u[S >>> 4 & 15],
                I = c[(b &= -15) >>> 28] | f[b >>> 24 & 15] | l[b >>> 20 & 15] | h[b >>> 16 & 15] | p[b >>> 12 & 15] | d[b >>> 8 & 15] | y[b >>> 4 & 15];
            e = 65535 & (I >>> 16 ^ A), v[E++] = A ^ e, v[E++] = I ^ e << 16;
          }
        }

        return v;
      }(e), this._init = !0;
    }
  }, _("DES-ECB", h.cipher.modes.ecb), _("DES-CBC", h.cipher.modes.cbc), _("DES-CFB", h.cipher.modes.cfb), _("DES-OFB", h.cipher.modes.ofb), _("DES-CTR", h.cipher.modes.ctr), _("3DES-ECB", h.cipher.modes.ecb), _("3DES-CBC", h.cipher.modes.cbc), _("3DES-CFB", h.cipher.modes.cfb), _("3DES-OFB", h.cipher.modes.ofb), _("3DES-CTR", h.cipher.modes.ctr);
  var R = [16843776, 0, 65536, 16843780, 16842756, 66564, 4, 65536, 1024, 16843776, 16843780, 1024, 16778244, 16842756, 16777216, 4, 1028, 16778240, 16778240, 66560, 66560, 16842752, 16842752, 16778244, 65540, 16777220, 16777220, 65540, 0, 1028, 66564, 16777216, 65536, 16843780, 4, 16842752, 16843776, 16777216, 16777216, 1024, 16842756, 65536, 66560, 16777220, 1024, 4, 16778244, 66564, 16843780, 65540, 16842752, 16778244, 16777220, 1028, 66564, 16843776, 1028, 16778240, 16778240, 0, 65540, 66560, 0, 16842756],
      P = [-2146402272, -2147450880, 32768, 1081376, 1048576, 32, -2146435040, -2147450848, -2147483616, -2146402272, -2146402304, -2147483648, -2147450880, 1048576, 32, -2146435040, 1081344, 1048608, -2147450848, 0, -2147483648, 32768, 1081376, -2146435072, 1048608, -2147483616, 0, 1081344, 32800, -2146402304, -2146435072, 32800, 0, 1081376, -2146435040, 1048576, -2147450848, -2146435072, -2146402304, 32768, -2146435072, -2147450880, 32, -2146402272, 1081376, 32, 32768, -2147483648, 32800, -2146402304, 1048576, -2147483616, 1048608, -2147450848, -2147483616, 1048608, 1081344, 0, -2147450880, 32800, -2147483648, -2146435040, -2146402272, 1081344],
      F = [520, 134349312, 0, 134348808, 134218240, 0, 131592, 134218240, 131080, 134217736, 134217736, 131072, 134349320, 131080, 134348800, 520, 134217728, 8, 134349312, 512, 131584, 134348800, 134348808, 131592, 134218248, 131584, 131072, 134218248, 8, 134349320, 512, 134217728, 134349312, 134217728, 131080, 520, 131072, 134349312, 134218240, 0, 512, 131080, 134349320, 134218240, 134217736, 512, 0, 134348808, 134218248, 131072, 134217728, 134349320, 8, 131592, 131584, 134217736, 134348800, 134218248, 520, 134348800, 131592, 8, 134348808, 131584],
      L = [8396801, 8321, 8321, 128, 8396928, 8388737, 8388609, 8193, 0, 8396800, 8396800, 8396929, 129, 0, 8388736, 8388609, 1, 8192, 8388608, 8396801, 128, 8388608, 8193, 8320, 8388737, 1, 8320, 8388736, 8192, 8396928, 8396929, 129, 8388736, 8388609, 8396800, 8396929, 129, 0, 0, 8396800, 8320, 8388736, 8388737, 1, 8396801, 8321, 8321, 128, 8396929, 129, 1, 8192, 8388609, 8193, 8396928, 8388737, 8193, 8320, 8388608, 8396801, 128, 8388608, 8192, 8396928],
      U = [256, 34078976, 34078720, 1107296512, 524288, 256, 1073741824, 34078720, 1074266368, 524288, 33554688, 1074266368, 1107296512, 1107820544, 524544, 1073741824, 33554432, 1074266112, 1074266112, 0, 1073742080, 1107820800, 1107820800, 33554688, 1107820544, 1073742080, 0, 1107296256, 34078976, 33554432, 1107296256, 524544, 524288, 1107296512, 256, 33554432, 1073741824, 34078720, 1107296512, 1074266368, 33554688, 1073741824, 1107820544, 34078976, 1074266368, 256, 33554432, 1107820544, 1107820800, 524544, 1107296256, 1107820800, 34078720, 0, 1074266112, 1107296256, 524544, 33554688, 1073742080, 524288, 0, 1074266112, 34078976, 1073742080],
      O = [536870928, 541065216, 16384, 541081616, 541065216, 16, 541081616, 4194304, 536887296, 4210704, 4194304, 536870928, 4194320, 536887296, 536870912, 16400, 0, 4194320, 536887312, 16384, 4210688, 536887312, 16, 541065232, 541065232, 0, 4210704, 541081600, 16400, 4210688, 541081600, 536870912, 536887296, 16, 541065232, 4210688, 541081616, 4194304, 16400, 536870928, 4194304, 536887296, 536870912, 16400, 536870928, 541081616, 4210688, 541065216, 4210704, 541081600, 0, 541065232, 16, 16384, 541065216, 4210704, 16384, 4194320, 536887312, 0, 541081600, 536870912, 4194320, 536887312],
      D = [2097152, 69206018, 67110914, 0, 2048, 67110914, 2099202, 69208064, 69208066, 2097152, 0, 67108866, 2, 67108864, 69206018, 2050, 67110912, 2099202, 2097154, 67110912, 67108866, 69206016, 69208064, 2097154, 69206016, 2048, 2050, 69208066, 2099200, 2, 67108864, 2099200, 67108864, 2099200, 2097152, 67110914, 67110914, 69206018, 69206018, 2, 2097154, 67108864, 67110912, 2097152, 69208064, 2050, 2099202, 69208064, 2050, 67108866, 69208066, 69206016, 2099200, 0, 2, 69208066, 0, 2099202, 69206016, 2048, 67108866, 67110912, 2048, 2097154],
      K = [268439616, 4096, 262144, 268701760, 268435456, 268439616, 64, 268435456, 262208, 268697600, 268701760, 266240, 268701696, 266304, 4096, 64, 268697600, 268435520, 268439552, 4160, 266240, 262208, 268697664, 268701696, 4160, 0, 0, 268697664, 268435520, 268439552, 266304, 262144, 266304, 262144, 268701696, 4096, 64, 268697664, 4096, 266304, 268439552, 64, 268435520, 268697600, 268697664, 268435456, 262144, 268439616, 0, 268701760, 262208, 268435520, 268697600, 268439552, 268439616, 0, 268701760, 266240, 266240, 4160, 4160, 262208, 268435456, 268701696];

  function V(t, e, r, n) {
    var i,
        a,
        o = 32 === t.length ? 3 : 9;
    i = 3 === o ? n ? [30, -2, -2] : [0, 32, 2] : n ? [94, 62, -2, 32, 64, 2, 30, -2, -2] : [0, 32, 2, 62, 30, -2, 64, 96, 2];
    var s = e[0],
        u = e[1];
    s ^= (a = 252645135 & (s >>> 4 ^ u)) << 4, s ^= (a = 65535 & (s >>> 16 ^ (u ^= a))) << 16, s ^= a = 858993459 & ((u ^= a) >>> 2 ^ s), s ^= a = 16711935 & ((u ^= a << 2) >>> 8 ^ s), s = (s ^= (a = 1431655765 & (s >>> 1 ^ (u ^= a << 8))) << 1) << 1 | s >>> 31, u = (u ^= a) << 1 | u >>> 31;

    for (var c = 0; c < o; c += 3) {
      for (var f = i[c + 1], l = i[c + 2], h = i[c]; h != f; h += l) {
        var p = u ^ t[h],
            d = (u >>> 4 | u << 28) ^ t[h + 1];
        a = s, s = u, u = a ^ (P[p >>> 24 & 63] | L[p >>> 16 & 63] | O[p >>> 8 & 63] | K[63 & p] | R[d >>> 24 & 63] | F[d >>> 16 & 63] | U[d >>> 8 & 63] | D[63 & d]);
      }

      a = s, s = u, u = a;
    }

    u = u >>> 1 | u << 31, u ^= a = 1431655765 & ((s = s >>> 1 | s << 31) >>> 1 ^ u), u ^= (a = 16711935 & (u >>> 8 ^ (s ^= a << 1))) << 8, u ^= (a = 858993459 & (u >>> 2 ^ (s ^= a))) << 2, u ^= a = 65535 & ((s ^= a) >>> 16 ^ u), u ^= a = 252645135 & ((s ^= a << 16) >>> 4 ^ u), s ^= a << 4, r[0] = s, r[1] = u;
  }

  function x(t) {
    var e,
        r = "DES-" + ((t = t || {}).mode || "CBC").toUpperCase(),
        n = (e = t.decrypt ? h.cipher.createDecipher(r, t.key) : h.cipher.createCipher(r, t.key)).start;
    return e.start = function (t, r) {
      var i = null;
      r instanceof h.util.ByteBuffer && (i = r, r = {}), (r = r || {}).output = i, r.iv = t, n.call(e, r);
    }, e;
  }

  i(function (t) {
    var e = h.asn1,
        r = t.exports = h.pkcs7asn1 = h.pkcs7asn1 || {};
    h.pkcs7 = h.pkcs7 || {}, h.pkcs7.asn1 = r;
    var n = {
      name: "ContentInfo",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "ContentInfo.ContentType",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.OID,
        constructed: !1,
        capture: "contentType"
      }, {
        name: "ContentInfo.content",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        type: 0,
        constructed: !0,
        optional: !0,
        captureAsn1: "content"
      }]
    };
    r.contentInfoValidator = n;
    var i = {
      name: "EncryptedContentInfo",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "EncryptedContentInfo.contentType",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.OID,
        constructed: !1,
        capture: "contentType"
      }, {
        name: "EncryptedContentInfo.contentEncryptionAlgorithm",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "EncryptedContentInfo.contentEncryptionAlgorithm.algorithm",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.OID,
          constructed: !1,
          capture: "encAlgorithm"
        }, {
          name: "EncryptedContentInfo.contentEncryptionAlgorithm.parameter",
          tagClass: e.Class.UNIVERSAL,
          captureAsn1: "encParameter"
        }]
      }, {
        name: "EncryptedContentInfo.encryptedContent",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        type: 0,
        capture: "encryptedContent",
        captureAsn1: "encryptedContentAsn1"
      }]
    };
    r.envelopedDataValidator = {
      name: "EnvelopedData",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "EnvelopedData.Version",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.INTEGER,
        constructed: !1,
        capture: "version"
      }, {
        name: "EnvelopedData.RecipientInfos",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SET,
        constructed: !0,
        captureAsn1: "recipientInfos"
      }].concat(i)
    }, r.encryptedDataValidator = {
      name: "EncryptedData",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "EncryptedData.Version",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.INTEGER,
        constructed: !1,
        capture: "version"
      }].concat(i)
    };
    var a = {
      name: "SignerInfo",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "SignerInfo.version",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.INTEGER,
        constructed: !1
      }, {
        name: "SignerInfo.issuerAndSerialNumber",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "SignerInfo.issuerAndSerialNumber.issuer",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.SEQUENCE,
          constructed: !0,
          captureAsn1: "issuer"
        }, {
          name: "SignerInfo.issuerAndSerialNumber.serialNumber",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.INTEGER,
          constructed: !1,
          capture: "serial"
        }]
      }, {
        name: "SignerInfo.digestAlgorithm",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "SignerInfo.digestAlgorithm.algorithm",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.OID,
          constructed: !1,
          capture: "digestAlgorithm"
        }, {
          name: "SignerInfo.digestAlgorithm.parameter",
          tagClass: e.Class.UNIVERSAL,
          constructed: !1,
          captureAsn1: "digestParameter",
          optional: !0
        }]
      }, {
        name: "SignerInfo.authenticatedAttributes",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        type: 0,
        constructed: !0,
        optional: !0,
        capture: "authenticatedAttributes"
      }, {
        name: "SignerInfo.digestEncryptionAlgorithm",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SEQUENCE,
        constructed: !0,
        capture: "signatureAlgorithm"
      }, {
        name: "SignerInfo.encryptedDigest",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.OCTETSTRING,
        constructed: !1,
        capture: "signature"
      }, {
        name: "SignerInfo.unauthenticatedAttributes",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        type: 1,
        constructed: !0,
        optional: !0,
        capture: "unauthenticatedAttributes"
      }]
    };
    r.signedDataValidator = {
      name: "SignedData",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "SignedData.Version",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.INTEGER,
        constructed: !1,
        capture: "version"
      }, {
        name: "SignedData.DigestAlgorithms",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SET,
        constructed: !0,
        captureAsn1: "digestAlgorithms"
      }, n, {
        name: "SignedData.Certificates",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        type: 0,
        optional: !0,
        captureAsn1: "certificates"
      }, {
        name: "SignedData.CertificateRevocationLists",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        type: 1,
        optional: !0,
        captureAsn1: "crls"
      }, {
        name: "SignedData.SignerInfos",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SET,
        capture: "signerInfos",
        optional: !0,
        value: [a]
      }]
    }, r.recipientInfoValidator = {
      name: "RecipientInfo",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "RecipientInfo.version",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.INTEGER,
        constructed: !1,
        capture: "version"
      }, {
        name: "RecipientInfo.issuerAndSerial",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "RecipientInfo.issuerAndSerial.issuer",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.SEQUENCE,
          constructed: !0,
          captureAsn1: "issuer"
        }, {
          name: "RecipientInfo.issuerAndSerial.serialNumber",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.INTEGER,
          constructed: !1,
          capture: "serial"
        }]
      }, {
        name: "RecipientInfo.keyEncryptionAlgorithm",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "RecipientInfo.keyEncryptionAlgorithm.algorithm",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.OID,
          constructed: !1,
          capture: "encAlgorithm"
        }, {
          name: "RecipientInfo.keyEncryptionAlgorithm.parameter",
          tagClass: e.Class.UNIVERSAL,
          constructed: !1,
          captureAsn1: "encParameter"
        }]
      }, {
        name: "RecipientInfo.encryptedKey",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.OCTETSTRING,
        constructed: !1,
        capture: "encKey"
      }]
    };
  }), h.mgf = h.mgf || {};
  h.mgf.mgf1 = h.mgf1;
  var j;
  i(function (t) {
    (t.exports = h.pss = h.pss || {}).create = function (t) {
      3 === arguments.length && (t = {
        md: arguments[0],
        mgf: arguments[1],
        saltLength: arguments[2]
      });
      var e,
          r = t.md,
          n = t.mgf,
          i = r.digestLength,
          a = t.salt || null;
      if ("string" == typeof a && (a = h.util.createBuffer(a)), "saltLength" in t) e = t.saltLength;else {
        if (null === a) throw new Error("Salt length not specified or specific salt not given.");
        e = a.length();
      }
      if (null !== a && a.length() !== e) throw new Error("Given salt length does not match length of given salt.");
      var o = t.prng || h.random,
          s = {
        encode: function encode(t, s) {
          var u,
              c,
              f = s - 1,
              l = Math.ceil(f / 8),
              p = t.digest().getBytes();
          if (l < i + e + 2) throw new Error("Message is too long to encrypt.");
          c = null === a ? o.getBytesSync(e) : a.bytes();
          var d = new h.util.ByteBuffer();
          d.fillWithByte(0, 8), d.putBytes(p), d.putBytes(c), r.start(), r.update(d.getBytes());
          var y = r.digest().getBytes(),
              g = new h.util.ByteBuffer();
          g.fillWithByte(0, l - e - i - 2), g.putByte(1), g.putBytes(c);
          var v = g.getBytes(),
              m = l - i - 1,
              E = n.generate(y, m),
              C = "";

          for (u = 0; u < m; u++) {
            C += String.fromCharCode(v.charCodeAt(u) ^ E.charCodeAt(u));
          }

          var S = 65280 >> 8 * l - f & 255;
          return (C = String.fromCharCode(C.charCodeAt(0) & ~S) + C.substr(1)) + y + String.fromCharCode(188);
        },
        verify: function verify(t, a, o) {
          var s,
              u = o - 1,
              c = Math.ceil(u / 8);
          if (a = a.substr(-c), c < i + e + 2) throw new Error("Inconsistent parameters to PSS signature verification.");
          if (188 !== a.charCodeAt(c - 1)) throw new Error("Encoded message does not end in 0xBC.");
          var f = c - i - 1,
              l = a.substr(0, f),
              p = a.substr(f, i),
              d = 65280 >> 8 * c - u & 255;
          if (0 != (l.charCodeAt(0) & d)) throw new Error("Bits beyond keysize not zero as expected.");
          var y = n.generate(p, f),
              g = "";

          for (s = 0; s < f; s++) {
            g += String.fromCharCode(l.charCodeAt(s) ^ y.charCodeAt(s));
          }

          g = String.fromCharCode(g.charCodeAt(0) & ~d) + g.substr(1);
          var v = c - i - e - 2;

          for (s = 0; s < v; s++) {
            if (0 !== g.charCodeAt(s)) throw new Error("Leftmost octets not zero as expected");
          }

          if (1 !== g.charCodeAt(v)) throw new Error("Inconsistent PSS signature, 0x01 marker not found");
          var m = g.substr(-e),
              E = new h.util.ByteBuffer();
          return E.fillWithByte(0, 8), E.putBytes(t), E.putBytes(m), r.start(), r.update(E.getBytes()), p === r.digest().getBytes();
        }
      };
      return s;
    };
  }), h.jsbn = h.jsbn || {};

  function M(t, e, r) {
    this.data = [], null != t && ("number" == typeof t ? this.fromNumber(t, e, r) : null == e && "string" != typeof t ? this.fromString(t, 256) : this.fromString(t, e));
  }

  function H() {
    return new M(null);
  }

  function z(t, e, r, n, i, a) {
    for (var o = 16383 & e, s = e >> 14; --a >= 0;) {
      var u = 16383 & this.data[t],
          c = this.data[t++] >> 14,
          f = s * u + c * o;
      i = ((u = o * u + ((16383 & f) << 14) + r.data[n] + i) >> 28) + (f >> 14) + s * c, r.data[n++] = 268435455 & u;
    }

    return i;
  }

  h.jsbn.BigInteger = M, "undefined" == typeof navigator ? (M.prototype.am = z, j = 28) : "Microsoft Internet Explorer" == navigator.appName ? (M.prototype.am = function (t, e, r, n, i, a) {
    for (var o = 32767 & e, s = e >> 15; --a >= 0;) {
      var u = 32767 & this.data[t],
          c = this.data[t++] >> 15,
          f = s * u + c * o;
      i = ((u = o * u + ((32767 & f) << 15) + r.data[n] + (1073741823 & i)) >>> 30) + (f >>> 15) + s * c + (i >>> 30), r.data[n++] = 1073741823 & u;
    }

    return i;
  }, j = 30) : "Netscape" != navigator.appName ? (M.prototype.am = function (t, e, r, n, i, a) {
    for (; --a >= 0;) {
      var o = e * this.data[t++] + r.data[n] + i;
      i = Math.floor(o / 67108864), r.data[n++] = 67108863 & o;
    }

    return i;
  }, j = 26) : (M.prototype.am = z, j = 28), M.prototype.DB = j, M.prototype.DM = (1 << j) - 1, M.prototype.DV = 1 << j;
  M.prototype.FV = Math.pow(2, 52), M.prototype.F1 = 52 - j, M.prototype.F2 = 2 * j - 52;
  var G,
      q,
      W = new Array();

  for (G = "0".charCodeAt(0), q = 0; q <= 9; ++q) {
    W[G++] = q;
  }

  for (G = "a".charCodeAt(0), q = 10; q < 36; ++q) {
    W[G++] = q;
  }

  for (G = "A".charCodeAt(0), q = 10; q < 36; ++q) {
    W[G++] = q;
  }

  function Q(t) {
    return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(t);
  }

  function X(t, e) {
    var r = W[t.charCodeAt(e)];
    return null == r ? -1 : r;
  }

  function Y(t) {
    var e = H();
    return e.fromInt(t), e;
  }

  function Z(t) {
    var e,
        r = 1;
    return 0 != (e = t >>> 16) && (t = e, r += 16), 0 != (e = t >> 8) && (t = e, r += 8), 0 != (e = t >> 4) && (t = e, r += 4), 0 != (e = t >> 2) && (t = e, r += 2), 0 != (e = t >> 1) && (t = e, r += 1), r;
  }

  function J(t) {
    this.m = t;
  }

  function $(t) {
    this.m = t, this.mp = t.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << t.DB - 15) - 1, this.mt2 = 2 * t.t;
  }

  function tt(t, e) {
    return t & e;
  }

  function et(t, e) {
    return t | e;
  }

  function rt(t, e) {
    return t ^ e;
  }

  function nt(t, e) {
    return t & ~e;
  }

  function it(t) {
    if (0 == t) return -1;
    var e = 0;
    return 0 == (65535 & t) && (t >>= 16, e += 16), 0 == (255 & t) && (t >>= 8, e += 8), 0 == (15 & t) && (t >>= 4, e += 4), 0 == (3 & t) && (t >>= 2, e += 2), 0 == (1 & t) && ++e, e;
  }

  function at(t) {
    for (var e = 0; 0 != t;) {
      t &= t - 1, ++e;
    }

    return e;
  }

  function ot() {}

  function st(t) {
    return t;
  }

  function ut(t) {
    this.r2 = H(), this.q3 = H(), M.ONE.dlShiftTo(2 * t.t, this.r2), this.mu = this.r2.divide(t), this.m = t;
  }

  J.prototype.convert = function (t) {
    return t.s < 0 || t.compareTo(this.m) >= 0 ? t.mod(this.m) : t;
  }, J.prototype.revert = function (t) {
    return t;
  }, J.prototype.reduce = function (t) {
    t.divRemTo(this.m, null, t);
  }, J.prototype.mulTo = function (t, e, r) {
    t.multiplyTo(e, r), this.reduce(r);
  }, J.prototype.sqrTo = function (t, e) {
    t.squareTo(e), this.reduce(e);
  }, $.prototype.convert = function (t) {
    var e = H();
    return t.abs().dlShiftTo(this.m.t, e), e.divRemTo(this.m, null, e), t.s < 0 && e.compareTo(M.ZERO) > 0 && this.m.subTo(e, e), e;
  }, $.prototype.revert = function (t) {
    var e = H();
    return t.copyTo(e), this.reduce(e), e;
  }, $.prototype.reduce = function (t) {
    for (; t.t <= this.mt2;) {
      t.data[t.t++] = 0;
    }

    for (var e = 0; e < this.m.t; ++e) {
      var r = 32767 & t.data[e],
          n = r * this.mpl + ((r * this.mph + (t.data[e] >> 15) * this.mpl & this.um) << 15) & t.DM;

      for (r = e + this.m.t, t.data[r] += this.m.am(0, n, t, e, 0, this.m.t); t.data[r] >= t.DV;) {
        t.data[r] -= t.DV, t.data[++r]++;
      }
    }

    t.clamp(), t.drShiftTo(this.m.t, t), t.compareTo(this.m) >= 0 && t.subTo(this.m, t);
  }, $.prototype.mulTo = function (t, e, r) {
    t.multiplyTo(e, r), this.reduce(r);
  }, $.prototype.sqrTo = function (t, e) {
    t.squareTo(e), this.reduce(e);
  }, M.prototype.copyTo = function (t) {
    for (var e = this.t - 1; e >= 0; --e) {
      t.data[e] = this.data[e];
    }

    t.t = this.t, t.s = this.s;
  }, M.prototype.fromInt = function (t) {
    this.t = 1, this.s = t < 0 ? -1 : 0, t > 0 ? this.data[0] = t : t < -1 ? this.data[0] = t + this.DV : this.t = 0;
  }, M.prototype.fromString = function (t, e) {
    var r;
    if (16 == e) r = 4;else if (8 == e) r = 3;else if (256 == e) r = 8;else if (2 == e) r = 1;else if (32 == e) r = 5;else {
      if (4 != e) return void this.fromRadix(t, e);
      r = 2;
    }
    this.t = 0, this.s = 0;

    for (var n = t.length, i = !1, a = 0; --n >= 0;) {
      var o = 8 == r ? 255 & t[n] : X(t, n);
      o < 0 ? "-" == t.charAt(n) && (i = !0) : (i = !1, 0 == a ? this.data[this.t++] = o : a + r > this.DB ? (this.data[this.t - 1] |= (o & (1 << this.DB - a) - 1) << a, this.data[this.t++] = o >> this.DB - a) : this.data[this.t - 1] |= o << a, (a += r) >= this.DB && (a -= this.DB));
    }

    8 == r && 0 != (128 & t[0]) && (this.s = -1, a > 0 && (this.data[this.t - 1] |= (1 << this.DB - a) - 1 << a)), this.clamp(), i && M.ZERO.subTo(this, this);
  }, M.prototype.clamp = function () {
    for (var t = this.s & this.DM; this.t > 0 && this.data[this.t - 1] == t;) {
      --this.t;
    }
  }, M.prototype.dlShiftTo = function (t, e) {
    var r;

    for (r = this.t - 1; r >= 0; --r) {
      e.data[r + t] = this.data[r];
    }

    for (r = t - 1; r >= 0; --r) {
      e.data[r] = 0;
    }

    e.t = this.t + t, e.s = this.s;
  }, M.prototype.drShiftTo = function (t, e) {
    for (var r = t; r < this.t; ++r) {
      e.data[r - t] = this.data[r];
    }

    e.t = Math.max(this.t - t, 0), e.s = this.s;
  }, M.prototype.lShiftTo = function (t, e) {
    var r,
        n = t % this.DB,
        i = this.DB - n,
        a = (1 << i) - 1,
        o = Math.floor(t / this.DB),
        s = this.s << n & this.DM;

    for (r = this.t - 1; r >= 0; --r) {
      e.data[r + o + 1] = this.data[r] >> i | s, s = (this.data[r] & a) << n;
    }

    for (r = o - 1; r >= 0; --r) {
      e.data[r] = 0;
    }

    e.data[o] = s, e.t = this.t + o + 1, e.s = this.s, e.clamp();
  }, M.prototype.rShiftTo = function (t, e) {
    e.s = this.s;
    var r = Math.floor(t / this.DB);
    if (r >= this.t) e.t = 0;else {
      var n = t % this.DB,
          i = this.DB - n,
          a = (1 << n) - 1;
      e.data[0] = this.data[r] >> n;

      for (var o = r + 1; o < this.t; ++o) {
        e.data[o - r - 1] |= (this.data[o] & a) << i, e.data[o - r] = this.data[o] >> n;
      }

      n > 0 && (e.data[this.t - r - 1] |= (this.s & a) << i), e.t = this.t - r, e.clamp();
    }
  }, M.prototype.subTo = function (t, e) {
    for (var r = 0, n = 0, i = Math.min(t.t, this.t); r < i;) {
      n += this.data[r] - t.data[r], e.data[r++] = n & this.DM, n >>= this.DB;
    }

    if (t.t < this.t) {
      for (n -= t.s; r < this.t;) {
        n += this.data[r], e.data[r++] = n & this.DM, n >>= this.DB;
      }

      n += this.s;
    } else {
      for (n += this.s; r < t.t;) {
        n -= t.data[r], e.data[r++] = n & this.DM, n >>= this.DB;
      }

      n -= t.s;
    }

    e.s = n < 0 ? -1 : 0, n < -1 ? e.data[r++] = this.DV + n : n > 0 && (e.data[r++] = n), e.t = r, e.clamp();
  }, M.prototype.multiplyTo = function (t, e) {
    var r = this.abs(),
        n = t.abs(),
        i = r.t;

    for (e.t = i + n.t; --i >= 0;) {
      e.data[i] = 0;
    }

    for (i = 0; i < n.t; ++i) {
      e.data[i + r.t] = r.am(0, n.data[i], e, i, 0, r.t);
    }

    e.s = 0, e.clamp(), this.s != t.s && M.ZERO.subTo(e, e);
  }, M.prototype.squareTo = function (t) {
    for (var e = this.abs(), r = t.t = 2 * e.t; --r >= 0;) {
      t.data[r] = 0;
    }

    for (r = 0; r < e.t - 1; ++r) {
      var n = e.am(r, e.data[r], t, 2 * r, 0, 1);
      (t.data[r + e.t] += e.am(r + 1, 2 * e.data[r], t, 2 * r + 1, n, e.t - r - 1)) >= e.DV && (t.data[r + e.t] -= e.DV, t.data[r + e.t + 1] = 1);
    }

    t.t > 0 && (t.data[t.t - 1] += e.am(r, e.data[r], t, 2 * r, 0, 1)), t.s = 0, t.clamp();
  }, M.prototype.divRemTo = function (t, e, r) {
    var n = t.abs();

    if (!(n.t <= 0)) {
      var i = this.abs();
      if (i.t < n.t) return null != e && e.fromInt(0), void (null != r && this.copyTo(r));
      null == r && (r = H());
      var a = H(),
          o = this.s,
          s = t.s,
          u = this.DB - Z(n.data[n.t - 1]);
      u > 0 ? (n.lShiftTo(u, a), i.lShiftTo(u, r)) : (n.copyTo(a), i.copyTo(r));
      var c = a.t,
          f = a.data[c - 1];

      if (0 != f) {
        var l = f * (1 << this.F1) + (c > 1 ? a.data[c - 2] >> this.F2 : 0),
            h = this.FV / l,
            p = (1 << this.F1) / l,
            d = 1 << this.F2,
            y = r.t,
            g = y - c,
            v = null == e ? H() : e;

        for (a.dlShiftTo(g, v), r.compareTo(v) >= 0 && (r.data[r.t++] = 1, r.subTo(v, r)), M.ONE.dlShiftTo(c, v), v.subTo(a, a); a.t < c;) {
          a.data[a.t++] = 0;
        }

        for (; --g >= 0;) {
          var m = r.data[--y] == f ? this.DM : Math.floor(r.data[y] * h + (r.data[y - 1] + d) * p);
          if ((r.data[y] += a.am(0, m, r, g, 0, c)) < m) for (a.dlShiftTo(g, v), r.subTo(v, r); r.data[y] < --m;) {
            r.subTo(v, r);
          }
        }

        null != e && (r.drShiftTo(c, e), o != s && M.ZERO.subTo(e, e)), r.t = c, r.clamp(), u > 0 && r.rShiftTo(u, r), o < 0 && M.ZERO.subTo(r, r);
      }
    }
  }, M.prototype.invDigit = function () {
    if (this.t < 1) return 0;
    var t = this.data[0];
    if (0 == (1 & t)) return 0;
    var e = 3 & t;
    return (e = (e = (e = (e = e * (2 - (15 & t) * e) & 15) * (2 - (255 & t) * e) & 255) * (2 - ((65535 & t) * e & 65535)) & 65535) * (2 - t * e % this.DV) % this.DV) > 0 ? this.DV - e : -e;
  }, M.prototype.isEven = function () {
    return 0 == (this.t > 0 ? 1 & this.data[0] : this.s);
  }, M.prototype.exp = function (t, e) {
    if (t > 4294967295 || t < 1) return M.ONE;
    var r = H(),
        n = H(),
        i = e.convert(this),
        a = Z(t) - 1;

    for (i.copyTo(r); --a >= 0;) {
      if (e.sqrTo(r, n), (t & 1 << a) > 0) e.mulTo(n, i, r);else {
        var o = r;
        r = n, n = o;
      }
    }

    return e.revert(r);
  }, M.prototype.toString = function (t) {
    if (this.s < 0) return "-" + this.negate().toString(t);
    var e;
    if (16 == t) e = 4;else if (8 == t) e = 3;else if (2 == t) e = 1;else if (32 == t) e = 5;else {
      if (4 != t) return this.toRadix(t);
      e = 2;
    }
    var r,
        n = (1 << e) - 1,
        i = !1,
        a = "",
        o = this.t,
        s = this.DB - o * this.DB % e;
    if (o-- > 0) for (s < this.DB && (r = this.data[o] >> s) > 0 && (i = !0, a = Q(r)); o >= 0;) {
      s < e ? (r = (this.data[o] & (1 << s) - 1) << e - s, r |= this.data[--o] >> (s += this.DB - e)) : (r = this.data[o] >> (s -= e) & n, s <= 0 && (s += this.DB, --o)), r > 0 && (i = !0), i && (a += Q(r));
    }
    return i ? a : "0";
  }, M.prototype.negate = function () {
    var t = H();
    return M.ZERO.subTo(this, t), t;
  }, M.prototype.abs = function () {
    return this.s < 0 ? this.negate() : this;
  }, M.prototype.compareTo = function (t) {
    var e = this.s - t.s;
    if (0 != e) return e;
    var r = this.t;
    if (0 != (e = r - t.t)) return this.s < 0 ? -e : e;

    for (; --r >= 0;) {
      if (0 != (e = this.data[r] - t.data[r])) return e;
    }

    return 0;
  }, M.prototype.bitLength = function () {
    return this.t <= 0 ? 0 : this.DB * (this.t - 1) + Z(this.data[this.t - 1] ^ this.s & this.DM);
  }, M.prototype.mod = function (t) {
    var e = H();
    return this.abs().divRemTo(t, null, e), this.s < 0 && e.compareTo(M.ZERO) > 0 && t.subTo(e, e), e;
  }, M.prototype.modPowInt = function (t, e) {
    var r;
    return r = t < 256 || e.isEven() ? new J(e) : new $(e), this.exp(t, r);
  }, M.ZERO = Y(0), M.ONE = Y(1), ot.prototype.convert = st, ot.prototype.revert = st, ot.prototype.mulTo = function (t, e, r) {
    t.multiplyTo(e, r);
  }, ot.prototype.sqrTo = function (t, e) {
    t.squareTo(e);
  }, ut.prototype.convert = function (t) {
    if (t.s < 0 || t.t > 2 * this.m.t) return t.mod(this.m);
    if (t.compareTo(this.m) < 0) return t;
    var e = H();
    return t.copyTo(e), this.reduce(e), e;
  }, ut.prototype.revert = function (t) {
    return t;
  }, ut.prototype.reduce = function (t) {
    for (t.drShiftTo(this.m.t - 1, this.r2), t.t > this.m.t + 1 && (t.t = this.m.t + 1, t.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t.compareTo(this.r2) < 0;) {
      t.dAddOffset(1, this.m.t + 1);
    }

    for (t.subTo(this.r2, t); t.compareTo(this.m) >= 0;) {
      t.subTo(this.m, t);
    }
  }, ut.prototype.mulTo = function (t, e, r) {
    t.multiplyTo(e, r), this.reduce(r);
  }, ut.prototype.sqrTo = function (t, e) {
    t.squareTo(e), this.reduce(e);
  };
  var ct = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509],
      ft = (1 << 26) / ct[ct.length - 1];
  M.prototype.chunkSize = function (t) {
    return Math.floor(Math.LN2 * this.DB / Math.log(t));
  }, M.prototype.toRadix = function (t) {
    if (null == t && (t = 10), 0 == this.signum() || t < 2 || t > 36) return "0";
    var e = this.chunkSize(t),
        r = Math.pow(t, e),
        n = Y(r),
        i = H(),
        a = H(),
        o = "";

    for (this.divRemTo(n, i, a); i.signum() > 0;) {
      o = (r + a.intValue()).toString(t).substr(1) + o, i.divRemTo(n, i, a);
    }

    return a.intValue().toString(t) + o;
  }, M.prototype.fromRadix = function (t, e) {
    this.fromInt(0), null == e && (e = 10);

    for (var r = this.chunkSize(e), n = Math.pow(e, r), i = !1, a = 0, o = 0, s = 0; s < t.length; ++s) {
      var u = X(t, s);
      u < 0 ? "-" == t.charAt(s) && 0 == this.signum() && (i = !0) : (o = e * o + u, ++a >= r && (this.dMultiply(n), this.dAddOffset(o, 0), a = 0, o = 0));
    }

    a > 0 && (this.dMultiply(Math.pow(e, a)), this.dAddOffset(o, 0)), i && M.ZERO.subTo(this, this);
  }, M.prototype.fromNumber = function (t, e, r) {
    if ("number" == typeof e) {
      if (t < 2) this.fromInt(1);else for (this.fromNumber(t, r), this.testBit(t - 1) || this.bitwiseTo(M.ONE.shiftLeft(t - 1), et, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(e);) {
        this.dAddOffset(2, 0), this.bitLength() > t && this.subTo(M.ONE.shiftLeft(t - 1), this);
      }
    } else {
      var n = new Array(),
          i = 7 & t;
      n.length = 1 + (t >> 3), e.nextBytes(n), i > 0 ? n[0] &= (1 << i) - 1 : n[0] = 0, this.fromString(n, 256);
    }
  }, M.prototype.bitwiseTo = function (t, e, r) {
    var n,
        i,
        a = Math.min(t.t, this.t);

    for (n = 0; n < a; ++n) {
      r.data[n] = e(this.data[n], t.data[n]);
    }

    if (t.t < this.t) {
      for (i = t.s & this.DM, n = a; n < this.t; ++n) {
        r.data[n] = e(this.data[n], i);
      }

      r.t = this.t;
    } else {
      for (i = this.s & this.DM, n = a; n < t.t; ++n) {
        r.data[n] = e(i, t.data[n]);
      }

      r.t = t.t;
    }

    r.s = e(this.s, t.s), r.clamp();
  }, M.prototype.changeBit = function (t, e) {
    var r = M.ONE.shiftLeft(t);
    return this.bitwiseTo(r, e, r), r;
  }, M.prototype.addTo = function (t, e) {
    for (var r = 0, n = 0, i = Math.min(t.t, this.t); r < i;) {
      n += this.data[r] + t.data[r], e.data[r++] = n & this.DM, n >>= this.DB;
    }

    if (t.t < this.t) {
      for (n += t.s; r < this.t;) {
        n += this.data[r], e.data[r++] = n & this.DM, n >>= this.DB;
      }

      n += this.s;
    } else {
      for (n += this.s; r < t.t;) {
        n += t.data[r], e.data[r++] = n & this.DM, n >>= this.DB;
      }

      n += t.s;
    }

    e.s = n < 0 ? -1 : 0, n > 0 ? e.data[r++] = n : n < -1 && (e.data[r++] = this.DV + n), e.t = r, e.clamp();
  }, M.prototype.dMultiply = function (t) {
    this.data[this.t] = this.am(0, t - 1, this, 0, 0, this.t), ++this.t, this.clamp();
  }, M.prototype.dAddOffset = function (t, e) {
    if (0 != t) {
      for (; this.t <= e;) {
        this.data[this.t++] = 0;
      }

      for (this.data[e] += t; this.data[e] >= this.DV;) {
        this.data[e] -= this.DV, ++e >= this.t && (this.data[this.t++] = 0), ++this.data[e];
      }
    }
  }, M.prototype.multiplyLowerTo = function (t, e, r) {
    var n,
        i = Math.min(this.t + t.t, e);

    for (r.s = 0, r.t = i; i > 0;) {
      r.data[--i] = 0;
    }

    for (n = r.t - this.t; i < n; ++i) {
      r.data[i + this.t] = this.am(0, t.data[i], r, i, 0, this.t);
    }

    for (n = Math.min(t.t, e); i < n; ++i) {
      this.am(0, t.data[i], r, i, 0, e - i);
    }

    r.clamp();
  }, M.prototype.multiplyUpperTo = function (t, e, r) {
    --e;
    var n = r.t = this.t + t.t - e;

    for (r.s = 0; --n >= 0;) {
      r.data[n] = 0;
    }

    for (n = Math.max(e - this.t, 0); n < t.t; ++n) {
      r.data[this.t + n - e] = this.am(e - n, t.data[n], r, 0, 0, this.t + n - e);
    }

    r.clamp(), r.drShiftTo(1, r);
  }, M.prototype.modInt = function (t) {
    if (t <= 0) return 0;
    var e = this.DV % t,
        r = this.s < 0 ? t - 1 : 0;
    if (this.t > 0) if (0 == e) r = this.data[0] % t;else for (var n = this.t - 1; n >= 0; --n) {
      r = (e * r + this.data[n]) % t;
    }
    return r;
  }, M.prototype.millerRabin = function (t) {
    var e = this.subtract(M.ONE),
        r = e.getLowestSetBit();
    if (r <= 0) return !1;

    for (var n, i = e.shiftRight(r), a = {
      nextBytes: function nextBytes(t) {
        for (var e = 0; e < t.length; ++e) {
          t[e] = Math.floor(256 * Math.random());
        }
      }
    }, o = 0; o < t; ++o) {
      do {
        n = new M(this.bitLength(), a);
      } while (n.compareTo(M.ONE) <= 0 || n.compareTo(e) >= 0);

      var s = n.modPow(i, this);

      if (0 != s.compareTo(M.ONE) && 0 != s.compareTo(e)) {
        for (var u = 1; u++ < r && 0 != s.compareTo(e);) {
          if (0 == (s = s.modPowInt(2, this)).compareTo(M.ONE)) return !1;
        }

        if (0 != s.compareTo(e)) return !1;
      }
    }

    return !0;
  }, M.prototype.clone = function () {
    var t = H();
    return this.copyTo(t), t;
  }, M.prototype.intValue = function () {
    if (this.s < 0) {
      if (1 == this.t) return this.data[0] - this.DV;
      if (0 == this.t) return -1;
    } else {
      if (1 == this.t) return this.data[0];
      if (0 == this.t) return 0;
    }

    return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
  }, M.prototype.byteValue = function () {
    return 0 == this.t ? this.s : this.data[0] << 24 >> 24;
  }, M.prototype.shortValue = function () {
    return 0 == this.t ? this.s : this.data[0] << 16 >> 16;
  }, M.prototype.signum = function () {
    return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this.data[0] <= 0 ? 0 : 1;
  }, M.prototype.toByteArray = function () {
    var t = this.t,
        e = new Array();
    e[0] = this.s;
    var r,
        n = this.DB - t * this.DB % 8,
        i = 0;
    if (t-- > 0) for (n < this.DB && (r = this.data[t] >> n) != (this.s & this.DM) >> n && (e[i++] = r | this.s << this.DB - n); t >= 0;) {
      n < 8 ? (r = (this.data[t] & (1 << n) - 1) << 8 - n, r |= this.data[--t] >> (n += this.DB - 8)) : (r = this.data[t] >> (n -= 8) & 255, n <= 0 && (n += this.DB, --t)), 0 != (128 & r) && (r |= -256), 0 == i && (128 & this.s) != (128 & r) && ++i, (i > 0 || r != this.s) && (e[i++] = r);
    }
    return e;
  }, M.prototype.equals = function (t) {
    return 0 == this.compareTo(t);
  }, M.prototype.min = function (t) {
    return this.compareTo(t) < 0 ? this : t;
  }, M.prototype.max = function (t) {
    return this.compareTo(t) > 0 ? this : t;
  }, M.prototype.and = function (t) {
    var e = H();
    return this.bitwiseTo(t, tt, e), e;
  }, M.prototype.or = function (t) {
    var e = H();
    return this.bitwiseTo(t, et, e), e;
  }, M.prototype.xor = function (t) {
    var e = H();
    return this.bitwiseTo(t, rt, e), e;
  }, M.prototype.andNot = function (t) {
    var e = H();
    return this.bitwiseTo(t, nt, e), e;
  }, M.prototype.not = function () {
    for (var t = H(), e = 0; e < this.t; ++e) {
      t.data[e] = this.DM & ~this.data[e];
    }

    return t.t = this.t, t.s = ~this.s, t;
  }, M.prototype.shiftLeft = function (t) {
    var e = H();
    return t < 0 ? this.rShiftTo(-t, e) : this.lShiftTo(t, e), e;
  }, M.prototype.shiftRight = function (t) {
    var e = H();
    return t < 0 ? this.lShiftTo(-t, e) : this.rShiftTo(t, e), e;
  }, M.prototype.getLowestSetBit = function () {
    for (var t = 0; t < this.t; ++t) {
      if (0 != this.data[t]) return t * this.DB + it(this.data[t]);
    }

    return this.s < 0 ? this.t * this.DB : -1;
  }, M.prototype.bitCount = function () {
    for (var t = 0, e = this.s & this.DM, r = 0; r < this.t; ++r) {
      t += at(this.data[r] ^ e);
    }

    return t;
  }, M.prototype.testBit = function (t) {
    var e = Math.floor(t / this.DB);
    return e >= this.t ? 0 != this.s : 0 != (this.data[e] & 1 << t % this.DB);
  }, M.prototype.setBit = function (t) {
    return this.changeBit(t, et);
  }, M.prototype.clearBit = function (t) {
    return this.changeBit(t, nt);
  }, M.prototype.flipBit = function (t) {
    return this.changeBit(t, rt);
  }, M.prototype.add = function (t) {
    var e = H();
    return this.addTo(t, e), e;
  }, M.prototype.subtract = function (t) {
    var e = H();
    return this.subTo(t, e), e;
  }, M.prototype.multiply = function (t) {
    var e = H();
    return this.multiplyTo(t, e), e;
  }, M.prototype.divide = function (t) {
    var e = H();
    return this.divRemTo(t, e, null), e;
  }, M.prototype.remainder = function (t) {
    var e = H();
    return this.divRemTo(t, null, e), e;
  }, M.prototype.divideAndRemainder = function (t) {
    var e = H(),
        r = H();
    return this.divRemTo(t, e, r), new Array(e, r);
  }, M.prototype.modPow = function (t, e) {
    var r,
        n,
        i = t.bitLength(),
        a = Y(1);
    if (i <= 0) return a;
    r = i < 18 ? 1 : i < 48 ? 3 : i < 144 ? 4 : i < 768 ? 5 : 6, n = i < 8 ? new J(e) : e.isEven() ? new ut(e) : new $(e);
    var o = new Array(),
        s = 3,
        u = r - 1,
        c = (1 << r) - 1;

    if (o[1] = n.convert(this), r > 1) {
      var f = H();

      for (n.sqrTo(o[1], f); s <= c;) {
        o[s] = H(), n.mulTo(f, o[s - 2], o[s]), s += 2;
      }
    }

    var l,
        h,
        p = t.t - 1,
        d = !0,
        y = H();

    for (i = Z(t.data[p]) - 1; p >= 0;) {
      for (i >= u ? l = t.data[p] >> i - u & c : (l = (t.data[p] & (1 << i + 1) - 1) << u - i, p > 0 && (l |= t.data[p - 1] >> this.DB + i - u)), s = r; 0 == (1 & l);) {
        l >>= 1, --s;
      }

      if ((i -= s) < 0 && (i += this.DB, --p), d) o[l].copyTo(a), d = !1;else {
        for (; s > 1;) {
          n.sqrTo(a, y), n.sqrTo(y, a), s -= 2;
        }

        s > 0 ? n.sqrTo(a, y) : (h = a, a = y, y = h), n.mulTo(y, o[l], a);
      }

      for (; p >= 0 && 0 == (t.data[p] & 1 << i);) {
        n.sqrTo(a, y), h = a, a = y, y = h, --i < 0 && (i = this.DB - 1, --p);
      }
    }

    return n.revert(a);
  }, M.prototype.modInverse = function (t) {
    var e = t.isEven();
    if (this.isEven() && e || 0 == t.signum()) return M.ZERO;

    for (var r = t.clone(), n = this.clone(), i = Y(1), a = Y(0), o = Y(0), s = Y(1); 0 != r.signum();) {
      for (; r.isEven();) {
        r.rShiftTo(1, r), e ? (i.isEven() && a.isEven() || (i.addTo(this, i), a.subTo(t, a)), i.rShiftTo(1, i)) : a.isEven() || a.subTo(t, a), a.rShiftTo(1, a);
      }

      for (; n.isEven();) {
        n.rShiftTo(1, n), e ? (o.isEven() && s.isEven() || (o.addTo(this, o), s.subTo(t, s)), o.rShiftTo(1, o)) : s.isEven() || s.subTo(t, s), s.rShiftTo(1, s);
      }

      r.compareTo(n) >= 0 ? (r.subTo(n, r), e && i.subTo(o, i), a.subTo(s, a)) : (n.subTo(r, n), e && o.subTo(i, o), s.subTo(a, s));
    }

    return 0 != n.compareTo(M.ONE) ? M.ZERO : s.compareTo(t) >= 0 ? s.subtract(t) : s.signum() < 0 ? (s.addTo(t, s), s.signum() < 0 ? s.add(t) : s) : s;
  }, M.prototype.pow = function (t) {
    return this.exp(t, new ot());
  }, M.prototype.gcd = function (t) {
    var e = this.s < 0 ? this.negate() : this.clone(),
        r = t.s < 0 ? t.negate() : t.clone();

    if (e.compareTo(r) < 0) {
      var n = e;
      e = r, r = n;
    }

    var i = e.getLowestSetBit(),
        a = r.getLowestSetBit();
    if (a < 0) return e;

    for (i < a && (a = i), a > 0 && (e.rShiftTo(a, e), r.rShiftTo(a, r)); e.signum() > 0;) {
      (i = e.getLowestSetBit()) > 0 && e.rShiftTo(i, e), (i = r.getLowestSetBit()) > 0 && r.rShiftTo(i, r), e.compareTo(r) >= 0 ? (e.subTo(r, e), e.rShiftTo(1, e)) : (r.subTo(e, r), r.rShiftTo(1, r));
    }

    return a > 0 && r.lShiftTo(a, r), r;
  }, M.prototype.isProbablePrime = function (t) {
    var e,
        r = this.abs();

    if (1 == r.t && r.data[0] <= ct[ct.length - 1]) {
      for (e = 0; e < ct.length; ++e) {
        if (r.data[0] == ct[e]) return !0;
      }

      return !1;
    }

    if (r.isEven()) return !1;

    for (e = 1; e < ct.length;) {
      for (var n = ct[e], i = e + 1; i < ct.length && n < ft;) {
        n *= ct[i++];
      }

      for (n = r.modInt(n); e < i;) {
        if (n % ct[e++] == 0) return !1;
      }
    }

    return r.millerRabin(t);
  };
  i(function (t) {
    !function () {
      if (h.prime) t.exports = h.prime;else {
        var e = t.exports = h.prime = h.prime || {},
            r = h.jsbn.BigInteger,
            n = [6, 4, 2, 4, 2, 4, 6, 2],
            i = new r(null);
        i.fromInt(30);

        var a = function a(t, e) {
          return t | e;
        };

        e.generateProbablePrime = function (t, e, n) {
          "function" == typeof e && (n = e, e = {});
          var i = (e = e || {}).algorithm || "PRIMEINC";
          "string" == typeof i && (i = {
            name: i
          }), i.options = i.options || {};
          var a = e.prng || h.random,
              u = {
            nextBytes: function nextBytes(t) {
              for (var e = a.getBytesSync(t.length), r = 0; r < t.length; ++r) {
                t[r] = e.charCodeAt(r);
              }
            }
          };
          if ("PRIMEINC" === i.name) return function (t, e, n, i) {
            if ("workers" in n) return function (t, e, n, i) {
              if ("undefined" == typeof Worker) return o(t, e, n, i);
              var a = s(t, e),
                  u = n.workers,
                  c = n.workLoad || 100,
                  f = 30 * c / 8,
                  l = n.workerScript || "forge/prime.worker.js";
              if (-1 === u) return h.util.estimateCores(function (t, e) {
                t && (e = 2), u = e - 1, p();
              });

              function p() {
                u = Math.max(1, u);

                for (var n = [], o = 0; o < u; ++o) {
                  n[o] = new Worker(l);
                }

                for (o = 0; o < u; ++o) {
                  n[o].addEventListener("message", p);
                }

                var h = !1;

                function p(o) {
                  if (!h) {
                    var u = o.data;

                    if (u.found) {
                      for (var l = 0; l < n.length; ++l) {
                        n[l].terminate();
                      }

                      return h = !0, i(null, new r(u.prime, 16));
                    }

                    a.bitLength() > t && (a = s(t, e));
                    var p = a.toString(16);
                    o.target.postMessage({
                      hex: p,
                      workLoad: c
                    }), a.dAddOffset(f, 0);
                  }
                }
              }

              p();
            }(t, e, n, i);
            return o(t, e, n, i);
          }(t, u, i.options, n);
          throw new Error("Invalid prime generation algorithm: " + i.name);
        };
      }

      function o(t, e, r, i) {
        var a = s(t, e),
            o = function (t) {
          return t <= 100 ? 27 : t <= 150 ? 18 : t <= 200 ? 15 : t <= 250 ? 12 : t <= 300 ? 9 : t <= 350 ? 8 : t <= 400 ? 7 : t <= 500 ? 6 : t <= 600 ? 5 : t <= 800 ? 4 : t <= 1250 ? 3 : 2;
        }(a.bitLength());

        "millerRabinTests" in r && (o = r.millerRabinTests);
        var u = 10;
        "maxBlockTime" in r && (u = r.maxBlockTime), function t(e, r, i, a, o, u, c) {
          var f = +new Date();

          do {
            if (e.bitLength() > r && (e = s(r, i)), e.isProbablePrime(o)) return c(null, e);
            e.dAddOffset(n[a++ % 8], 0);
          } while (u < 0 || +new Date() - f < u);

          h.util.setImmediate(function () {
            t(e, r, i, a, o, u, c);
          });
        }(a, t, e, 0, o, u, i);
      }

      function s(t, e) {
        var n = new r(t, e),
            o = t - 1;
        return n.testBit(o) || n.bitwiseTo(r.ONE.shiftLeft(o), a, n), n.dAddOffset(31 - n.mod(i).byteValue(), 0), n;
      }
    }();
  });
  if (void 0 === lt) var lt = h.jsbn.BigInteger;
  var ht = h.util.isNodejs ? t : null,
      pt = h.asn1,
      dt = h.util;
  h.pki = h.pki || {};
  h.pki.rsa = h.rsa = h.rsa || {};

  var yt = h.pki,
      gt = [6, 4, 2, 4, 2, 4, 6, 2],
      vt = {
    name: "PrivateKeyInfo",
    tagClass: pt.Class.UNIVERSAL,
    type: pt.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "PrivateKeyInfo.version",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "privateKeyVersion"
    }, {
      name: "PrivateKeyInfo.privateKeyAlgorithm",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "AlgorithmIdentifier.algorithm",
        tagClass: pt.Class.UNIVERSAL,
        type: pt.Type.OID,
        constructed: !1,
        capture: "privateKeyOid"
      }]
    }, {
      name: "PrivateKeyInfo",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.OCTETSTRING,
      constructed: !1,
      capture: "privateKey"
    }]
  },
      mt = {
    name: "RSAPrivateKey",
    tagClass: pt.Class.UNIVERSAL,
    type: pt.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "RSAPrivateKey.version",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "privateKeyVersion"
    }, {
      name: "RSAPrivateKey.modulus",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "privateKeyModulus"
    }, {
      name: "RSAPrivateKey.publicExponent",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "privateKeyPublicExponent"
    }, {
      name: "RSAPrivateKey.privateExponent",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "privateKeyPrivateExponent"
    }, {
      name: "RSAPrivateKey.prime1",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "privateKeyPrime1"
    }, {
      name: "RSAPrivateKey.prime2",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "privateKeyPrime2"
    }, {
      name: "RSAPrivateKey.exponent1",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "privateKeyExponent1"
    }, {
      name: "RSAPrivateKey.exponent2",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "privateKeyExponent2"
    }, {
      name: "RSAPrivateKey.coefficient",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "privateKeyCoefficient"
    }]
  },
      Et = {
    name: "RSAPublicKey",
    tagClass: pt.Class.UNIVERSAL,
    type: pt.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "RSAPublicKey.modulus",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "publicKeyModulus"
    }, {
      name: "RSAPublicKey.exponent",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.INTEGER,
      constructed: !1,
      capture: "publicKeyExponent"
    }]
  },
      Ct = h.pki.rsa.publicKeyValidator = {
    name: "SubjectPublicKeyInfo",
    tagClass: pt.Class.UNIVERSAL,
    type: pt.Type.SEQUENCE,
    constructed: !0,
    captureAsn1: "subjectPublicKeyInfo",
    value: [{
      name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "AlgorithmIdentifier.algorithm",
        tagClass: pt.Class.UNIVERSAL,
        type: pt.Type.OID,
        constructed: !1,
        capture: "publicKeyOid"
      }]
    }, {
      name: "SubjectPublicKeyInfo.subjectPublicKey",
      tagClass: pt.Class.UNIVERSAL,
      type: pt.Type.BITSTRING,
      constructed: !1,
      value: [{
        name: "SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey",
        tagClass: pt.Class.UNIVERSAL,
        type: pt.Type.SEQUENCE,
        constructed: !0,
        optional: !0,
        captureAsn1: "rsaPublicKey"
      }]
    }]
  },
      St = function St(t) {
    var e;

    if (!(t.algorithm in yt.oids)) {
      var r = new Error("Unknown message digest algorithm.");
      throw r.algorithm = t.algorithm, r;
    }

    e = yt.oids[t.algorithm];
    var n = pt.oidToDer(e).getBytes(),
        i = pt.create(pt.Class.UNIVERSAL, pt.Type.SEQUENCE, !0, []),
        a = pt.create(pt.Class.UNIVERSAL, pt.Type.SEQUENCE, !0, []);
    a.value.push(pt.create(pt.Class.UNIVERSAL, pt.Type.OID, !1, n)), a.value.push(pt.create(pt.Class.UNIVERSAL, pt.Type.NULL, !1, ""));
    var o = pt.create(pt.Class.UNIVERSAL, pt.Type.OCTETSTRING, !1, t.digest().getBytes());
    return i.value.push(a), i.value.push(o), pt.toDer(i).getBytes();
  },
      bt = function bt(t, e, r) {
    if (r) return t.modPow(e.e, e.n);
    if (!e.p || !e.q) return t.modPow(e.d, e.n);
    var n;
    e.dP || (e.dP = e.d.mod(e.p.subtract(lt.ONE))), e.dQ || (e.dQ = e.d.mod(e.q.subtract(lt.ONE))), e.qInv || (e.qInv = e.q.modInverse(e.p));

    do {
      n = new lt(h.util.bytesToHex(h.random.getBytes(e.n.bitLength() / 8)), 16);
    } while (n.compareTo(e.n) >= 0 || !n.gcd(e.n).equals(lt.ONE));

    for (var i = (t = t.multiply(n.modPow(e.e, e.n)).mod(e.n)).mod(e.p).modPow(e.dP, e.p), a = t.mod(e.q).modPow(e.dQ, e.q); i.compareTo(a) < 0;) {
      i = i.add(e.p);
    }

    var o = i.subtract(a).multiply(e.qInv).mod(e.p).multiply(e.q).add(a);
    return o = o.multiply(n.modInverse(e.n)).mod(e.n);
  };

  function Tt(t, e, r) {
    var n = h.util.createBuffer(),
        i = Math.ceil(e.n.bitLength() / 8);

    if (t.length > i - 11) {
      var a = new Error("Message is too long for PKCS#1 v1.5 padding.");
      throw a.length = t.length, a.max = i - 11, a;
    }

    n.putByte(0), n.putByte(r);
    var o,
        s = i - 3 - t.length;

    if (0 === r || 1 === r) {
      o = 0 === r ? 0 : 255;

      for (var u = 0; u < s; ++u) {
        n.putByte(o);
      }
    } else for (; s > 0;) {
      var c = 0,
          f = h.random.getBytes(s);

      for (u = 0; u < s; ++u) {
        0 === (o = f.charCodeAt(u)) ? ++c : n.putByte(o);
      }

      s = c;
    }

    return n.putByte(0), n.putBytes(t), n;
  }

  function At(t, e, r, n) {
    var i = Math.ceil(e.n.bitLength() / 8),
        a = h.util.createBuffer(t),
        o = a.getByte(),
        s = a.getByte();
    if (0 !== o || r && 0 !== s && 1 !== s || !r && 2 != s || r && 0 === s && void 0 === n) throw new Error("Encryption block is invalid.");
    var u = 0;

    if (0 === s) {
      u = i - 3 - n;

      for (var c = 0; c < u; ++c) {
        if (0 !== a.getByte()) throw new Error("Encryption block is invalid.");
      }
    } else if (1 === s) for (u = 0; a.length() > 1;) {
      if (255 !== a.getByte()) {
        --a.read;
        break;
      }

      ++u;
    } else if (2 === s) for (u = 0; a.length() > 1;) {
      if (0 === a.getByte()) {
        --a.read;
        break;
      }

      ++u;
    }

    if (0 !== a.getByte() || u !== i - 3 - a.length()) throw new Error("Encryption block is invalid.");
    return a.getBytes();
  }

  function It(t, e, r) {
    "function" == typeof e && (r = e, e = {});
    var n = {
      algorithm: {
        name: (e = e || {}).algorithm || "PRIMEINC",
        options: {
          workers: e.workers || 2,
          workLoad: e.workLoad || 100,
          workerScript: e.workerScript
        }
      }
    };

    function i() {
      a(t.pBits, function (e, n) {
        return e ? r(e) : (t.p = n, null !== t.q ? o(e, t.q) : void a(t.qBits, o));
      });
    }

    function a(t, e) {
      h.prime.generateProbablePrime(t, n, e);
    }

    function o(e, n) {
      if (e) return r(e);

      if (t.q = n, t.p.compareTo(t.q) < 0) {
        var s = t.p;
        t.p = t.q, t.q = s;
      }

      if (0 !== t.p.subtract(lt.ONE).gcd(t.e).compareTo(lt.ONE)) return t.p = null, void i();
      if (0 !== t.q.subtract(lt.ONE).gcd(t.e).compareTo(lt.ONE)) return t.q = null, void a(t.qBits, o);
      if (t.p1 = t.p.subtract(lt.ONE), t.q1 = t.q.subtract(lt.ONE), t.phi = t.p1.multiply(t.q1), 0 !== t.phi.gcd(t.e).compareTo(lt.ONE)) return t.p = t.q = null, void i();
      if (t.n = t.p.multiply(t.q), t.n.bitLength() !== t.bits) return t.q = null, void a(t.qBits, o);
      var u = t.e.modInverse(t.phi);
      t.keys = {
        privateKey: yt.rsa.setPrivateKey(t.n, t.e, u, t.p, t.q, u.mod(t.p1), u.mod(t.q1), t.q.modInverse(t.p)),
        publicKey: yt.rsa.setPublicKey(t.n, t.e)
      }, r(null, t.keys);
    }

    "prng" in e && (n.prng = e.prng), i();
  }

  function Bt(t) {
    var e = t.toString(16);
    e[0] >= "8" && (e = "00" + e);
    var r = h.util.hexToBytes(e);
    return r.length > 1 && (0 === r.charCodeAt(0) && 0 == (128 & r.charCodeAt(1)) || 255 === r.charCodeAt(0) && 128 == (128 & r.charCodeAt(1))) ? r.substr(1) : r;
  }

  function wt(t) {
    return t <= 100 ? 27 : t <= 150 ? 18 : t <= 200 ? 15 : t <= 250 ? 12 : t <= 300 ? 9 : t <= 350 ? 8 : t <= 400 ? 7 : t <= 500 ? 6 : t <= 600 ? 5 : t <= 800 ? 4 : t <= 1250 ? 3 : 2;
  }

  function Nt(t) {
    return h.util.isNodejs && "function" == typeof ht[t];
  }

  function kt(t) {
    return void 0 !== dt.globalScope && "object" == typeof dt.globalScope.crypto && "object" == typeof dt.globalScope.crypto.subtle && "function" == typeof dt.globalScope.crypto.subtle[t];
  }

  function _t(t) {
    return void 0 !== dt.globalScope && "object" == typeof dt.globalScope.msCrypto && "object" == typeof dt.globalScope.msCrypto.subtle && "function" == typeof dt.globalScope.msCrypto.subtle[t];
  }

  function Rt(t) {
    for (var e = h.util.hexToBytes(t.toString(16)), r = new Uint8Array(e.length), n = 0; n < e.length; ++n) {
      r[n] = e.charCodeAt(n);
    }

    return r;
  }

  yt.rsa.encrypt = function (t, e, r) {
    var n,
        i = r,
        a = Math.ceil(e.n.bitLength() / 8);
    !1 !== r && !0 !== r ? (i = 2 === r, n = Tt(t, e, r)) : (n = h.util.createBuffer()).putBytes(t);

    for (var o = new lt(n.toHex(), 16), s = bt(o, e, i).toString(16), u = h.util.createBuffer(), c = a - Math.ceil(s.length / 2); c > 0;) {
      u.putByte(0), --c;
    }

    return u.putBytes(h.util.hexToBytes(s)), u.getBytes();
  }, yt.rsa.decrypt = function (t, e, r, n) {
    var i = Math.ceil(e.n.bitLength() / 8);

    if (t.length !== i) {
      var a = new Error("Encrypted message length is invalid.");
      throw a.length = t.length, a.expected = i, a;
    }

    var o = new lt(h.util.createBuffer(t).toHex(), 16);
    if (o.compareTo(e.n) >= 0) throw new Error("Encrypted message is invalid.");

    for (var s = bt(o, e, r).toString(16), u = h.util.createBuffer(), c = i - Math.ceil(s.length / 2); c > 0;) {
      u.putByte(0), --c;
    }

    return u.putBytes(h.util.hexToBytes(s)), !1 !== n ? At(u.getBytes(), e, r) : u.getBytes();
  }, yt.rsa.createKeyPairGenerationState = function (t, e, r) {
    "string" == typeof t && (t = parseInt(t, 10)), t = t || 2048;
    var n,
        i = (r = r || {}).prng || h.random,
        a = {
      nextBytes: function nextBytes(t) {
        for (var e = i.getBytesSync(t.length), r = 0; r < t.length; ++r) {
          t[r] = e.charCodeAt(r);
        }
      }
    },
        o = r.algorithm || "PRIMEINC";
    if ("PRIMEINC" !== o) throw new Error("Invalid key generation algorithm: " + o);
    return (n = {
      algorithm: o,
      state: 0,
      bits: t,
      rng: a,
      eInt: e || 65537,
      e: new lt(null),
      p: null,
      q: null,
      qBits: t >> 1,
      pBits: t - (t >> 1),
      pqState: 0,
      num: null,
      keys: null
    }).e.fromInt(n.eInt), n;
  }, yt.rsa.stepKeyPairGenerationState = function (t, e) {
    "algorithm" in t || (t.algorithm = "PRIMEINC");
    var r = new lt(null);
    r.fromInt(30);

    for (var n, i = 0, a = function a(t, e) {
      return t | e;
    }, o = +new Date(), s = 0; null === t.keys && (e <= 0 || s < e);) {
      if (0 === t.state) {
        var u = null === t.p ? t.pBits : t.qBits,
            c = u - 1;
        0 === t.pqState ? (t.num = new lt(u, t.rng), t.num.testBit(c) || t.num.bitwiseTo(lt.ONE.shiftLeft(c), a, t.num), t.num.dAddOffset(31 - t.num.mod(r).byteValue(), 0), i = 0, ++t.pqState) : 1 === t.pqState ? t.num.bitLength() > u ? t.pqState = 0 : t.num.isProbablePrime(wt(t.num.bitLength())) ? ++t.pqState : t.num.dAddOffset(gt[i++ % 8], 0) : 2 === t.pqState ? t.pqState = 0 === t.num.subtract(lt.ONE).gcd(t.e).compareTo(lt.ONE) ? 3 : 0 : 3 === t.pqState && (t.pqState = 0, null === t.p ? t.p = t.num : t.q = t.num, null !== t.p && null !== t.q && ++t.state, t.num = null);
      } else if (1 === t.state) t.p.compareTo(t.q) < 0 && (t.num = t.p, t.p = t.q, t.q = t.num), ++t.state;else if (2 === t.state) t.p1 = t.p.subtract(lt.ONE), t.q1 = t.q.subtract(lt.ONE), t.phi = t.p1.multiply(t.q1), ++t.state;else if (3 === t.state) 0 === t.phi.gcd(t.e).compareTo(lt.ONE) ? ++t.state : (t.p = null, t.q = null, t.state = 0);else if (4 === t.state) t.n = t.p.multiply(t.q), t.n.bitLength() === t.bits ? ++t.state : (t.q = null, t.state = 0);else if (5 === t.state) {
        var f = t.e.modInverse(t.phi);
        t.keys = {
          privateKey: yt.rsa.setPrivateKey(t.n, t.e, f, t.p, t.q, f.mod(t.p1), f.mod(t.q1), t.q.modInverse(t.p)),
          publicKey: yt.rsa.setPublicKey(t.n, t.e)
        };
      }

      s += (n = +new Date()) - o, o = n;
    }

    return null !== t.keys;
  }, yt.rsa.generateKeyPair = function (t, e, r, n) {
    if (1 === arguments.length ? "object" == typeof t ? (r = t, t = void 0) : "function" == typeof t && (n = t, t = void 0) : 2 === arguments.length ? "number" == typeof t ? "function" == typeof e ? (n = e, e = void 0) : "number" != typeof e && (r = e, e = void 0) : (r = t, n = e, t = void 0, e = void 0) : 3 === arguments.length && ("number" == typeof e ? "function" == typeof r && (n = r, r = void 0) : (n = r, r = e, e = void 0)), r = r || {}, void 0 === t && (t = r.bits || 2048), void 0 === e && (e = r.e || 65537), !r.prng && t >= 256 && t <= 16384 && (65537 === e || 3 === e)) if (n) {
      if (Nt("generateKeyPair")) return ht.generateKeyPair("rsa", {
        modulusLength: t,
        publicExponent: e,
        publicKeyEncoding: {
          type: "spki",
          format: "pem"
        },
        privateKeyEncoding: {
          type: "pkcs8",
          format: "pem"
        }
      }, function (t, e, r) {
        if (t) return n(t);
        n(null, {
          privateKey: yt.privateKeyFromPem(r),
          publicKey: yt.publicKeyFromPem(e)
        });
      });
      if (kt("generateKey") && kt("exportKey")) return dt.globalScope.crypto.subtle.generateKey({
        name: "RSASSA-PKCS1-v1_5",
        modulusLength: t,
        publicExponent: Rt(e),
        hash: {
          name: "SHA-256"
        }
      }, !0, ["sign", "verify"]).then(function (t) {
        return dt.globalScope.crypto.subtle.exportKey("pkcs8", t.privateKey);
      }).then(void 0, function (t) {
        n(t);
      }).then(function (t) {
        if (t) {
          var e = yt.privateKeyFromAsn1(pt.fromDer(h.util.createBuffer(t)));
          n(null, {
            privateKey: e,
            publicKey: yt.setRsaPublicKey(e.n, e.e)
          });
        }
      });

      if (_t("generateKey") && _t("exportKey")) {
        var i = dt.globalScope.msCrypto.subtle.generateKey({
          name: "RSASSA-PKCS1-v1_5",
          modulusLength: t,
          publicExponent: Rt(e),
          hash: {
            name: "SHA-256"
          }
        }, !0, ["sign", "verify"]);
        return i.oncomplete = function (t) {
          var e = t.target.result,
              r = dt.globalScope.msCrypto.subtle.exportKey("pkcs8", e.privateKey);
          r.oncomplete = function (t) {
            var e = t.target.result,
                r = yt.privateKeyFromAsn1(pt.fromDer(h.util.createBuffer(e)));
            n(null, {
              privateKey: r,
              publicKey: yt.setRsaPublicKey(r.n, r.e)
            });
          }, r.onerror = function (t) {
            n(t);
          };
        }, void (i.onerror = function (t) {
          n(t);
        });
      }
    } else if (Nt("generateKeyPairSync")) {
      var a = ht.generateKeyPairSync("rsa", {
        modulusLength: t,
        publicExponent: e,
        publicKeyEncoding: {
          type: "spki",
          format: "pem"
        },
        privateKeyEncoding: {
          type: "pkcs8",
          format: "pem"
        }
      });
      return {
        privateKey: yt.privateKeyFromPem(a.privateKey),
        publicKey: yt.publicKeyFromPem(a.publicKey)
      };
    }
    var o = yt.rsa.createKeyPairGenerationState(t, e, r);
    if (!n) return yt.rsa.stepKeyPairGenerationState(o, 0), o.keys;
    It(o, r, n);
  }, yt.setRsaPublicKey = yt.rsa.setPublicKey = function (t, e) {
    var r = {
      n: t,
      e: e,
      encrypt: function encrypt(t, e, n) {
        if ("string" == typeof e ? e = e.toUpperCase() : void 0 === e && (e = "RSAES-PKCS1-V1_5"), "RSAES-PKCS1-V1_5" === e) e = {
          encode: function encode(t, e, r) {
            return Tt(t, e, 2).getBytes();
          }
        };else if ("RSA-OAEP" === e || "RSAES-OAEP" === e) e = {
          encode: function encode(t, e) {
            return h.pkcs1.encode_rsa_oaep(e, t, n);
          }
        };else if (-1 !== ["RAW", "NONE", "NULL", null].indexOf(e)) e = {
          encode: function encode(t) {
            return t;
          }
        };else if ("string" == typeof e) throw new Error('Unsupported encryption scheme: "' + e + '".');
        var i = e.encode(t, r, !0);
        return yt.rsa.encrypt(i, r, !0);
      },
      verify: function verify(t, e, n) {
        "string" == typeof n ? n = n.toUpperCase() : void 0 === n && (n = "RSASSA-PKCS1-V1_5"), "RSASSA-PKCS1-V1_5" === n ? n = {
          verify: function verify(t, e) {
            return e = At(e, r, !0), t === pt.fromDer(e).value[1].value;
          }
        } : "NONE" !== n && "NULL" !== n && null !== n || (n = {
          verify: function verify(t, e) {
            return t === (e = At(e, r, !0));
          }
        });
        var i = yt.rsa.decrypt(e, r, !0, !1);
        return n.verify(t, i, r.n.bitLength());
      }
    };
    return r;
  }, yt.setRsaPrivateKey = yt.rsa.setPrivateKey = function (t, e, r, n, i, a, o, s) {
    var u = {
      n: t,
      e: e,
      d: r,
      p: n,
      q: i,
      dP: a,
      dQ: o,
      qInv: s,
      decrypt: function decrypt(t, e, r) {
        "string" == typeof e ? e = e.toUpperCase() : void 0 === e && (e = "RSAES-PKCS1-V1_5");
        var n = yt.rsa.decrypt(t, u, !1, !1);
        if ("RSAES-PKCS1-V1_5" === e) e = {
          decode: At
        };else if ("RSA-OAEP" === e || "RSAES-OAEP" === e) e = {
          decode: function decode(t, e) {
            return h.pkcs1.decode_rsa_oaep(e, t, r);
          }
        };else {
          if (-1 === ["RAW", "NONE", "NULL", null].indexOf(e)) throw new Error('Unsupported encryption scheme: "' + e + '".');
          e = {
            decode: function decode(t) {
              return t;
            }
          };
        }
        return e.decode(n, u, !1);
      },
      sign: function sign(t, e) {
        var r = !1;
        "string" == typeof e && (e = e.toUpperCase()), void 0 === e || "RSASSA-PKCS1-V1_5" === e ? (e = {
          encode: St
        }, r = 1) : "NONE" !== e && "NULL" !== e && null !== e || (e = {
          encode: function encode() {
            return t;
          }
        }, r = 1);
        var n = e.encode(t, u.n.bitLength());
        return yt.rsa.encrypt(n, u, r);
      }
    };
    return u;
  }, yt.wrapRsaPrivateKey = function (t) {
    return pt.create(pt.Class.UNIVERSAL, pt.Type.SEQUENCE, !0, [pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, pt.integerToDer(0).getBytes()), pt.create(pt.Class.UNIVERSAL, pt.Type.SEQUENCE, !0, [pt.create(pt.Class.UNIVERSAL, pt.Type.OID, !1, pt.oidToDer(yt.oids.rsaEncryption).getBytes()), pt.create(pt.Class.UNIVERSAL, pt.Type.NULL, !1, "")]), pt.create(pt.Class.UNIVERSAL, pt.Type.OCTETSTRING, !1, pt.toDer(t).getBytes())]);
  }, yt.privateKeyFromAsn1 = function (t) {
    var e,
        r,
        n,
        i,
        a,
        o,
        s,
        u,
        c = {},
        f = [];

    if (pt.validate(t, vt, c, f) && (t = pt.fromDer(h.util.createBuffer(c.privateKey))), c = {}, f = [], !pt.validate(t, mt, c, f)) {
      var l = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
      throw l.errors = f, l;
    }

    return e = h.util.createBuffer(c.privateKeyModulus).toHex(), r = h.util.createBuffer(c.privateKeyPublicExponent).toHex(), n = h.util.createBuffer(c.privateKeyPrivateExponent).toHex(), i = h.util.createBuffer(c.privateKeyPrime1).toHex(), a = h.util.createBuffer(c.privateKeyPrime2).toHex(), o = h.util.createBuffer(c.privateKeyExponent1).toHex(), s = h.util.createBuffer(c.privateKeyExponent2).toHex(), u = h.util.createBuffer(c.privateKeyCoefficient).toHex(), yt.setRsaPrivateKey(new lt(e, 16), new lt(r, 16), new lt(n, 16), new lt(i, 16), new lt(a, 16), new lt(o, 16), new lt(s, 16), new lt(u, 16));
  }, yt.privateKeyToAsn1 = yt.privateKeyToRSAPrivateKey = function (t) {
    return pt.create(pt.Class.UNIVERSAL, pt.Type.SEQUENCE, !0, [pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, pt.integerToDer(0).getBytes()), pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, Bt(t.n)), pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, Bt(t.e)), pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, Bt(t.d)), pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, Bt(t.p)), pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, Bt(t.q)), pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, Bt(t.dP)), pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, Bt(t.dQ)), pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, Bt(t.qInv))]);
  }, yt.publicKeyFromAsn1 = function (t) {
    var e = {},
        r = [];

    if (pt.validate(t, Ct, e, r)) {
      var n,
          i = pt.derToOid(e.publicKeyOid);
      if (i !== yt.oids.rsaEncryption) throw (n = new Error("Cannot read public key. Unknown OID.")).oid = i, n;
      t = e.rsaPublicKey;
    }

    if (r = [], !pt.validate(t, Et, e, r)) throw (n = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.")).errors = r, n;
    var a = h.util.createBuffer(e.publicKeyModulus).toHex(),
        o = h.util.createBuffer(e.publicKeyExponent).toHex();
    return yt.setRsaPublicKey(new lt(a, 16), new lt(o, 16));
  }, yt.publicKeyToAsn1 = yt.publicKeyToSubjectPublicKeyInfo = function (t) {
    return pt.create(pt.Class.UNIVERSAL, pt.Type.SEQUENCE, !0, [pt.create(pt.Class.UNIVERSAL, pt.Type.SEQUENCE, !0, [pt.create(pt.Class.UNIVERSAL, pt.Type.OID, !1, pt.oidToDer(yt.oids.rsaEncryption).getBytes()), pt.create(pt.Class.UNIVERSAL, pt.Type.NULL, !1, "")]), pt.create(pt.Class.UNIVERSAL, pt.Type.BITSTRING, !1, [yt.publicKeyToRSAPublicKey(t)])]);
  }, yt.publicKeyToRSAPublicKey = function (t) {
    return pt.create(pt.Class.UNIVERSAL, pt.Type.SEQUENCE, !0, [pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, Bt(t.n)), pt.create(pt.Class.UNIVERSAL, pt.Type.INTEGER, !1, Bt(t.e))]);
  };
  i(function (t) {
    var e = h.asn1,
        r = t.exports = h.pki = h.pki || {},
        n = r.oids,
        i = {};
    i.CN = n.commonName, i.commonName = "CN", i.C = n.countryName, i.countryName = "C", i.L = n.localityName, i.localityName = "L", i.ST = n.stateOrProvinceName, i.stateOrProvinceName = "ST", i.O = n.organizationName, i.organizationName = "O", i.OU = n.organizationalUnitName, i.organizationalUnitName = "OU", i.E = n.emailAddress, i.emailAddress = "E";
    var a = h.pki.rsa.publicKeyValidator,
        o = {
      name: "Certificate",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "Certificate.TBSCertificate",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SEQUENCE,
        constructed: !0,
        captureAsn1: "tbsCertificate",
        value: [{
          name: "Certificate.TBSCertificate.version",
          tagClass: e.Class.CONTEXT_SPECIFIC,
          type: 0,
          constructed: !0,
          optional: !0,
          value: [{
            name: "Certificate.TBSCertificate.version.integer",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.INTEGER,
            constructed: !1,
            capture: "certVersion"
          }]
        }, {
          name: "Certificate.TBSCertificate.serialNumber",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.INTEGER,
          constructed: !1,
          capture: "certSerialNumber"
        }, {
          name: "Certificate.TBSCertificate.signature",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.SEQUENCE,
          constructed: !0,
          value: [{
            name: "Certificate.TBSCertificate.signature.algorithm",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.OID,
            constructed: !1,
            capture: "certinfoSignatureOid"
          }, {
            name: "Certificate.TBSCertificate.signature.parameters",
            tagClass: e.Class.UNIVERSAL,
            optional: !0,
            captureAsn1: "certinfoSignatureParams"
          }]
        }, {
          name: "Certificate.TBSCertificate.issuer",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.SEQUENCE,
          constructed: !0,
          captureAsn1: "certIssuer"
        }, {
          name: "Certificate.TBSCertificate.validity",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.SEQUENCE,
          constructed: !0,
          value: [{
            name: "Certificate.TBSCertificate.validity.notBefore (utc)",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.UTCTIME,
            constructed: !1,
            optional: !0,
            capture: "certValidity1UTCTime"
          }, {
            name: "Certificate.TBSCertificate.validity.notBefore (generalized)",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.GENERALIZEDTIME,
            constructed: !1,
            optional: !0,
            capture: "certValidity2GeneralizedTime"
          }, {
            name: "Certificate.TBSCertificate.validity.notAfter (utc)",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.UTCTIME,
            constructed: !1,
            optional: !0,
            capture: "certValidity3UTCTime"
          }, {
            name: "Certificate.TBSCertificate.validity.notAfter (generalized)",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.GENERALIZEDTIME,
            constructed: !1,
            optional: !0,
            capture: "certValidity4GeneralizedTime"
          }]
        }, {
          name: "Certificate.TBSCertificate.subject",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.SEQUENCE,
          constructed: !0,
          captureAsn1: "certSubject"
        }, a, {
          name: "Certificate.TBSCertificate.issuerUniqueID",
          tagClass: e.Class.CONTEXT_SPECIFIC,
          type: 1,
          constructed: !0,
          optional: !0,
          value: [{
            name: "Certificate.TBSCertificate.issuerUniqueID.id",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.BITSTRING,
            constructed: !1,
            captureBitStringValue: "certIssuerUniqueId"
          }]
        }, {
          name: "Certificate.TBSCertificate.subjectUniqueID",
          tagClass: e.Class.CONTEXT_SPECIFIC,
          type: 2,
          constructed: !0,
          optional: !0,
          value: [{
            name: "Certificate.TBSCertificate.subjectUniqueID.id",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.BITSTRING,
            constructed: !1,
            captureBitStringValue: "certSubjectUniqueId"
          }]
        }, {
          name: "Certificate.TBSCertificate.extensions",
          tagClass: e.Class.CONTEXT_SPECIFIC,
          type: 3,
          constructed: !0,
          captureAsn1: "certExtensions",
          optional: !0
        }]
      }, {
        name: "Certificate.signatureAlgorithm",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "Certificate.signatureAlgorithm.algorithm",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.OID,
          constructed: !1,
          capture: "certSignatureOid"
        }, {
          name: "Certificate.TBSCertificate.signature.parameters",
          tagClass: e.Class.UNIVERSAL,
          optional: !0,
          captureAsn1: "certSignatureParams"
        }]
      }, {
        name: "Certificate.signatureValue",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.BITSTRING,
        constructed: !1,
        captureBitStringValue: "certSignature"
      }]
    },
        s = {
      name: "rsapss",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "rsapss.hashAlgorithm",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        type: 0,
        constructed: !0,
        value: [{
          name: "rsapss.hashAlgorithm.AlgorithmIdentifier",
          tagClass: e.Class.UNIVERSAL,
          type: e.Class.SEQUENCE,
          constructed: !0,
          optional: !0,
          value: [{
            name: "rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.OID,
            constructed: !1,
            capture: "hashOid"
          }]
        }]
      }, {
        name: "rsapss.maskGenAlgorithm",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        type: 1,
        constructed: !0,
        value: [{
          name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier",
          tagClass: e.Class.UNIVERSAL,
          type: e.Class.SEQUENCE,
          constructed: !0,
          optional: !0,
          value: [{
            name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.OID,
            constructed: !1,
            capture: "maskGenOid"
          }, {
            name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.SEQUENCE,
            constructed: !0,
            value: [{
              name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm",
              tagClass: e.Class.UNIVERSAL,
              type: e.Type.OID,
              constructed: !1,
              capture: "maskGenHashOid"
            }]
          }]
        }]
      }, {
        name: "rsapss.saltLength",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        type: 2,
        optional: !0,
        value: [{
          name: "rsapss.saltLength.saltLength",
          tagClass: e.Class.UNIVERSAL,
          type: e.Class.INTEGER,
          constructed: !1,
          capture: "saltLength"
        }]
      }, {
        name: "rsapss.trailerField",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        type: 3,
        optional: !0,
        value: [{
          name: "rsapss.trailer.trailer",
          tagClass: e.Class.UNIVERSAL,
          type: e.Class.INTEGER,
          constructed: !1,
          capture: "trailer"
        }]
      }]
    },
        u = {
      name: "CertificationRequestInfo",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "certificationRequestInfo",
      value: [{
        name: "CertificationRequestInfo.integer",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.INTEGER,
        constructed: !1,
        capture: "certificationRequestInfoVersion"
      }, {
        name: "CertificationRequestInfo.subject",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SEQUENCE,
        constructed: !0,
        captureAsn1: "certificationRequestInfoSubject"
      }, a, {
        name: "CertificationRequestInfo.attributes",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        type: 0,
        constructed: !0,
        optional: !0,
        capture: "certificationRequestInfoAttributes",
        value: [{
          name: "CertificationRequestInfo.attributes",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.SEQUENCE,
          constructed: !0,
          value: [{
            name: "CertificationRequestInfo.attributes.type",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.OID,
            constructed: !1
          }, {
            name: "CertificationRequestInfo.attributes.value",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.SET,
            constructed: !0
          }]
        }]
      }]
    },
        c = {
      name: "CertificationRequest",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "csr",
      value: [u, {
        name: "CertificationRequest.signatureAlgorithm",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "CertificationRequest.signatureAlgorithm.algorithm",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.OID,
          constructed: !1,
          capture: "csrSignatureOid"
        }, {
          name: "CertificationRequest.signatureAlgorithm.parameters",
          tagClass: e.Class.UNIVERSAL,
          optional: !0,
          captureAsn1: "csrSignatureParams"
        }]
      }, {
        name: "CertificationRequest.signature",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.BITSTRING,
        constructed: !1,
        captureBitStringValue: "csrSignature"
      }]
    };

    function f(t, e) {
      "string" == typeof e && (e = {
        shortName: e
      });

      for (var r, n = null, i = 0; null === n && i < t.attributes.length; ++i) {
        r = t.attributes[i], e.type && e.type === r.type ? n = r : e.name && e.name === r.name ? n = r : e.shortName && e.shortName === r.shortName && (n = r);
      }

      return n;
    }

    r.RDNAttributesAsArray = function (t, r) {
      for (var a, o, s, u = [], c = 0; c < t.value.length; ++c) {
        a = t.value[c];

        for (var f = 0; f < a.value.length; ++f) {
          s = {}, o = a.value[f], s.type = e.derToOid(o.value[0].value), s.value = o.value[1].value, s.valueTagClass = o.value[1].type, s.type in n && (s.name = n[s.type], s.name in i && (s.shortName = i[s.name])), r && (r.update(s.type), r.update(s.value)), u.push(s);
        }
      }

      return u;
    }, r.CRIAttributesAsArray = function (t) {
      for (var a = [], o = 0; o < t.length; ++o) {
        for (var s = t[o], u = e.derToOid(s.value[0].value), c = s.value[1].value, f = 0; f < c.length; ++f) {
          var l = {};

          if (l.type = u, l.value = c[f].value, l.valueTagClass = c[f].type, l.type in n && (l.name = n[l.type], l.name in i && (l.shortName = i[l.name])), l.type === n.extensionRequest) {
            l.extensions = [];

            for (var h = 0; h < l.value.length; ++h) {
              l.extensions.push(r.certificateExtensionFromAsn1(l.value[h]));
            }
          }

          a.push(l);
        }
      }

      return a;
    };

    var l = function l(t, r, i) {
      var a = {};
      if (t !== n["RSASSA-PSS"]) return a;
      i && (a = {
        hash: {
          algorithmOid: n.sha1
        },
        mgf: {
          algorithmOid: n.mgf1,
          hash: {
            algorithmOid: n.sha1
          }
        },
        saltLength: 20
      });
      var o = {},
          u = [];

      if (!e.validate(r, s, o, u)) {
        var c = new Error("Cannot read RSASSA-PSS parameter block.");
        throw c.errors = u, c;
      }

      return void 0 !== o.hashOid && (a.hash = a.hash || {}, a.hash.algorithmOid = e.derToOid(o.hashOid)), void 0 !== o.maskGenOid && (a.mgf = a.mgf || {}, a.mgf.algorithmOid = e.derToOid(o.maskGenOid), a.mgf.hash = a.mgf.hash || {}, a.mgf.hash.algorithmOid = e.derToOid(o.maskGenHashOid)), void 0 !== o.saltLength && (a.saltLength = o.saltLength.charCodeAt(0)), a;
    };

    function p(t) {
      for (var r, n, i = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, []), a = t.attributes, o = 0; o < a.length; ++o) {
        var s = (r = a[o]).value,
            u = e.Type.PRINTABLESTRING;
        "valueTagClass" in r && (u = r.valueTagClass) === e.Type.UTF8 && (s = h.util.encodeUtf8(s)), n = e.create(e.Class.UNIVERSAL, e.Type.SET, !0, [e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.type).getBytes()), e.create(e.Class.UNIVERSAL, u, !1, s)])]), i.value.push(n);
      }

      return i;
    }

    function d(t) {
      for (var a, o = 0; o < t.length; ++o) {
        if (void 0 === (a = t[o]).name && (a.type && a.type in r.oids ? a.name = r.oids[a.type] : a.shortName && a.shortName in i && (a.name = r.oids[i[a.shortName]])), void 0 === a.type) {
          if (!(a.name && a.name in r.oids)) throw (u = new Error("Attribute type not specified.")).attribute = a, u;
          a.type = r.oids[a.name];
        }

        if (void 0 === a.shortName && a.name && a.name in i && (a.shortName = i[a.name]), a.type === n.extensionRequest && (a.valueConstructed = !0, a.valueTagClass = e.Type.SEQUENCE, !a.value && a.extensions)) {
          a.value = [];

          for (var s = 0; s < a.extensions.length; ++s) {
            a.value.push(r.certificateExtensionToAsn1(y(a.extensions[s])));
          }
        }

        var u;
        if (void 0 === a.value) throw (u = new Error("Attribute value not specified.")).attribute = a, u;
      }
    }

    function y(t, i) {
      if (i = i || {}, void 0 === t.name && t.id && t.id in r.oids && (t.name = r.oids[t.id]), void 0 === t.id) {
        if (!(t.name && t.name in r.oids)) throw (S = new Error("Extension ID not specified.")).extension = t, S;
        t.id = r.oids[t.name];
      }

      if (void 0 !== t.value) return t;

      if ("keyUsage" === t.name) {
        var a = 0,
            o = 0,
            s = 0;
        t.digitalSignature && (o |= 128, a = 7), t.nonRepudiation && (o |= 64, a = 6), t.keyEncipherment && (o |= 32, a = 5), t.dataEncipherment && (o |= 16, a = 4), t.keyAgreement && (o |= 8, a = 3), t.keyCertSign && (o |= 4, a = 2), t.cRLSign && (o |= 2, a = 1), t.encipherOnly && (o |= 1, a = 0), t.decipherOnly && (s |= 128, a = 7);
        var u = String.fromCharCode(a);
        0 !== s ? u += String.fromCharCode(o) + String.fromCharCode(s) : 0 !== o && (u += String.fromCharCode(o)), t.value = e.create(e.Class.UNIVERSAL, e.Type.BITSTRING, !1, u);
      } else if ("basicConstraints" === t.name) t.value = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, []), t.cA && t.value.value.push(e.create(e.Class.UNIVERSAL, e.Type.BOOLEAN, !1, String.fromCharCode(255))), "pathLenConstraint" in t && t.value.value.push(e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, e.integerToDer(t.pathLenConstraint).getBytes()));else if ("extKeyUsage" === t.name) {
        t.value = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, []);
        var c = t.value.value;

        for (var f in t) {
          !0 === t[f] && (f in n ? c.push(e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(n[f]).getBytes())) : -1 !== f.indexOf(".") && c.push(e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(f).getBytes())));
        }
      } else if ("nsCertType" === t.name) {
        a = 0, o = 0;
        t.client && (o |= 128, a = 7), t.server && (o |= 64, a = 6), t.email && (o |= 32, a = 5), t.objsign && (o |= 16, a = 4), t.reserved && (o |= 8, a = 3), t.sslCA && (o |= 4, a = 2), t.emailCA && (o |= 2, a = 1), t.objCA && (o |= 1, a = 0);
        u = String.fromCharCode(a);
        0 !== o && (u += String.fromCharCode(o)), t.value = e.create(e.Class.UNIVERSAL, e.Type.BITSTRING, !1, u);
      } else if ("subjectAltName" === t.name || "issuerAltName" === t.name) {
        t.value = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, []);

        for (var l = 0; l < t.altNames.length; ++l) {
          u = (m = t.altNames[l]).value;

          if (7 === m.type && m.ip) {
            if (null === (u = h.util.bytesFromIP(m.ip))) throw (S = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.')).extension = t, S;
          } else 8 === m.type && (u = m.oid ? e.oidToDer(e.oidToDer(m.oid)) : e.oidToDer(u));

          t.value.value.push(e.create(e.Class.CONTEXT_SPECIFIC, m.type, !1, u));
        }
      } else if ("nsComment" === t.name && i.cert) {
        if (!/^[\x00-\x7F]*$/.test(t.comment) || t.comment.length < 1 || t.comment.length > 128) throw new Error('Invalid "nsComment" content.');
        t.value = e.create(e.Class.UNIVERSAL, e.Type.IA5STRING, !1, t.comment);
      } else if ("subjectKeyIdentifier" === t.name && i.cert) {
        var d = i.cert.generateSubjectKeyIdentifier();
        t.subjectKeyIdentifier = d.toHex(), t.value = e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, d.getBytes());
      } else if ("authorityKeyIdentifier" === t.name && i.cert) {
        t.value = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, []);
        c = t.value.value;

        if (t.keyIdentifier) {
          var y = !0 === t.keyIdentifier ? i.cert.generateSubjectKeyIdentifier().getBytes() : t.keyIdentifier;
          c.push(e.create(e.Class.CONTEXT_SPECIFIC, 0, !1, y));
        }

        if (t.authorityCertIssuer) {
          var g = [e.create(e.Class.CONTEXT_SPECIFIC, 4, !0, [p(!0 === t.authorityCertIssuer ? i.cert.issuer : t.authorityCertIssuer)])];
          c.push(e.create(e.Class.CONTEXT_SPECIFIC, 1, !0, g));
        }

        if (t.serialNumber) {
          var v = h.util.hexToBytes(!0 === t.serialNumber ? i.cert.serialNumber : t.serialNumber);
          c.push(e.create(e.Class.CONTEXT_SPECIFIC, 2, !1, v));
        }
      } else if ("cRLDistributionPoints" === t.name) {
        t.value = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, []);
        c = t.value.value;
        var m,
            E = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, []),
            C = e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, []);

        for (l = 0; l < t.altNames.length; ++l) {
          u = (m = t.altNames[l]).value;

          if (7 === m.type && m.ip) {
            if (null === (u = h.util.bytesFromIP(m.ip))) throw (S = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.')).extension = t, S;
          } else 8 === m.type && (u = m.oid ? e.oidToDer(e.oidToDer(m.oid)) : e.oidToDer(u));

          C.value.push(e.create(e.Class.CONTEXT_SPECIFIC, m.type, !1, u));
        }

        E.value.push(e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [C])), c.push(E);
      }

      var S;
      if (void 0 === t.value) throw (S = new Error("Extension value not specified.")).extension = t, S;
      return t;
    }

    function g(t, r) {
      switch (t) {
        case n["RSASSA-PSS"]:
          var i = [];
          return void 0 !== r.hash.algorithmOid && i.push(e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.hash.algorithmOid).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.NULL, !1, "")])])), void 0 !== r.mgf.algorithmOid && i.push(e.create(e.Class.CONTEXT_SPECIFIC, 1, !0, [e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.mgf.algorithmOid).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.mgf.hash.algorithmOid).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.NULL, !1, "")])])])), void 0 !== r.saltLength && i.push(e.create(e.Class.CONTEXT_SPECIFIC, 2, !0, [e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, e.integerToDer(r.saltLength).getBytes())])), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, i);

        default:
          return e.create(e.Class.UNIVERSAL, e.Type.NULL, !1, "");
      }
    }

    function v(t) {
      var r = e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, []);
      if (0 === t.attributes.length) return r;

      for (var n = t.attributes, i = 0; i < n.length; ++i) {
        var a = n[i],
            o = a.value,
            s = e.Type.UTF8;
        "valueTagClass" in a && (s = a.valueTagClass), s === e.Type.UTF8 && (o = h.util.encodeUtf8(o));
        var u = !1;
        "valueConstructed" in a && (u = a.valueConstructed);
        var c = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(a.type).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.SET, !0, [e.create(e.Class.UNIVERSAL, s, u, o)])]);
        r.value.push(c);
      }

      return r;
    }

    r.certificateFromPem = function (t, n, i) {
      var a = h.pem.decode(t)[0];

      if ("CERTIFICATE" !== a.type && "X509 CERTIFICATE" !== a.type && "TRUSTED CERTIFICATE" !== a.type) {
        var o = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
        throw o.headerType = a.type, o;
      }

      if (a.procType && "ENCRYPTED" === a.procType.type) throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
      var s = e.fromDer(a.body, i);
      return r.certificateFromAsn1(s, n);
    }, r.certificateToPem = function (t, n) {
      var i = {
        type: "CERTIFICATE",
        body: e.toDer(r.certificateToAsn1(t)).getBytes()
      };
      return h.pem.encode(i, {
        maxline: n
      });
    }, r.publicKeyFromPem = function (t) {
      var n = h.pem.decode(t)[0];

      if ("PUBLIC KEY" !== n.type && "RSA PUBLIC KEY" !== n.type) {
        var i = new Error('Could not convert public key from PEM; PEM header type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
        throw i.headerType = n.type, i;
      }

      if (n.procType && "ENCRYPTED" === n.procType.type) throw new Error("Could not convert public key from PEM; PEM is encrypted.");
      var a = e.fromDer(n.body);
      return r.publicKeyFromAsn1(a);
    }, r.publicKeyToPem = function (t, n) {
      var i = {
        type: "PUBLIC KEY",
        body: e.toDer(r.publicKeyToAsn1(t)).getBytes()
      };
      return h.pem.encode(i, {
        maxline: n
      });
    }, r.publicKeyToRSAPublicKeyPem = function (t, n) {
      var i = {
        type: "RSA PUBLIC KEY",
        body: e.toDer(r.publicKeyToRSAPublicKey(t)).getBytes()
      };
      return h.pem.encode(i, {
        maxline: n
      });
    }, r.getPublicKeyFingerprint = function (t, n) {
      var i,
          a = (n = n || {}).md || h.md.sha1.create();

      switch (n.type || "RSAPublicKey") {
        case "RSAPublicKey":
          i = e.toDer(r.publicKeyToRSAPublicKey(t)).getBytes();
          break;

        case "SubjectPublicKeyInfo":
          i = e.toDer(r.publicKeyToAsn1(t)).getBytes();
          break;

        default:
          throw new Error('Unknown fingerprint type "' + n.type + '".');
      }

      a.start(), a.update(i);
      var o = a.digest();

      if ("hex" === n.encoding) {
        var s = o.toHex();
        return n.delimiter ? s.match(/.{2}/g).join(n.delimiter) : s;
      }

      if ("binary" === n.encoding) return o.getBytes();
      if (n.encoding) throw new Error('Unknown encoding "' + n.encoding + '".');
      return o;
    }, r.certificationRequestFromPem = function (t, n, i) {
      var a = h.pem.decode(t)[0];

      if ("CERTIFICATE REQUEST" !== a.type) {
        var o = new Error('Could not convert certification request from PEM; PEM header type is not "CERTIFICATE REQUEST".');
        throw o.headerType = a.type, o;
      }

      if (a.procType && "ENCRYPTED" === a.procType.type) throw new Error("Could not convert certification request from PEM; PEM is encrypted.");
      var s = e.fromDer(a.body, i);
      return r.certificationRequestFromAsn1(s, n);
    }, r.certificationRequestToPem = function (t, n) {
      var i = {
        type: "CERTIFICATE REQUEST",
        body: e.toDer(r.certificationRequestToAsn1(t)).getBytes()
      };
      return h.pem.encode(i, {
        maxline: n
      });
    }, r.createCertificate = function () {
      var t = {
        version: 2,
        serialNumber: "00",
        signatureOid: null,
        signature: null,
        siginfo: {}
      };
      return t.siginfo.algorithmOid = null, t.validity = {}, t.validity.notBefore = new Date(), t.validity.notAfter = new Date(), t.issuer = {}, t.issuer.getField = function (e) {
        return f(t.issuer, e);
      }, t.issuer.addField = function (e) {
        d([e]), t.issuer.attributes.push(e);
      }, t.issuer.attributes = [], t.issuer.hash = null, t.subject = {}, t.subject.getField = function (e) {
        return f(t.subject, e);
      }, t.subject.addField = function (e) {
        d([e]), t.subject.attributes.push(e);
      }, t.subject.attributes = [], t.subject.hash = null, t.extensions = [], t.publicKey = null, t.md = null, t.setSubject = function (e, r) {
        d(e), t.subject.attributes = e, delete t.subject.uniqueId, r && (t.subject.uniqueId = r), t.subject.hash = null;
      }, t.setIssuer = function (e, r) {
        d(e), t.issuer.attributes = e, delete t.issuer.uniqueId, r && (t.issuer.uniqueId = r), t.issuer.hash = null;
      }, t.setExtensions = function (e) {
        for (var r = 0; r < e.length; ++r) {
          y(e[r], {
            cert: t
          });
        }

        t.extensions = e;
      }, t.getExtension = function (e) {
        "string" == typeof e && (e = {
          name: e
        });

        for (var r, n = null, i = 0; null === n && i < t.extensions.length; ++i) {
          r = t.extensions[i], e.id && r.id === e.id ? n = r : e.name && r.name === e.name && (n = r);
        }

        return n;
      }, t.sign = function (i, a) {
        t.md = a || h.md.sha1.create();
        var o = n[t.md.algorithm + "WithRSAEncryption"];

        if (!o) {
          var s = new Error("Could not compute certificate digest. Unknown message digest algorithm OID.");
          throw s.algorithm = t.md.algorithm, s;
        }

        t.signatureOid = t.siginfo.algorithmOid = o, t.tbsCertificate = r.getTBSCertificate(t);
        var u = e.toDer(t.tbsCertificate);
        t.md.update(u.getBytes()), t.signature = i.sign(t.md);
      }, t.verify = function (i) {
        var a = !1;

        if (!t.issued(i)) {
          var o = i.issuer,
              s = t.subject;
          throw (y = new Error("The parent certificate did not issue the given child certificate; the child certificate's issuer does not match the parent's subject.")).expectedIssuer = o.attributes, y.actualIssuer = s.attributes, y;
        }

        var u = i.md;

        if (null === u) {
          if (i.signatureOid in n) switch (n[i.signatureOid]) {
            case "sha1WithRSAEncryption":
              u = h.md.sha1.create();
              break;

            case "md5WithRSAEncryption":
              u = h.md.md5.create();
              break;

            case "sha256WithRSAEncryption":
              u = h.md.sha256.create();
              break;

            case "sha384WithRSAEncryption":
              u = h.md.sha384.create();
              break;

            case "sha512WithRSAEncryption":
              u = h.md.sha512.create();
              break;

            case "RSASSA-PSS":
              u = h.md.sha256.create();
          }
          if (null === u) throw (y = new Error("Could not compute certificate digest. Unknown signature OID.")).signatureOid = i.signatureOid, y;
          var c = i.tbsCertificate || r.getTBSCertificate(i),
              f = e.toDer(c);
          u.update(f.getBytes());
        }

        if (null !== u) {
          var l;

          switch (i.signatureOid) {
            case n.sha1WithRSAEncryption:
              l = void 0;
              break;

            case n["RSASSA-PSS"]:
              var p, d, y;
              if (void 0 === (p = n[i.signatureParameters.mgf.hash.algorithmOid]) || void 0 === h.md[p]) throw (y = new Error("Unsupported MGF hash function.")).oid = i.signatureParameters.mgf.hash.algorithmOid, y.name = p, y;
              if (void 0 === (d = n[i.signatureParameters.mgf.algorithmOid]) || void 0 === h.mgf[d]) throw (y = new Error("Unsupported MGF function.")).oid = i.signatureParameters.mgf.algorithmOid, y.name = d, y;
              if (d = h.mgf[d].create(h.md[p].create()), void 0 === (p = n[i.signatureParameters.hash.algorithmOid]) || void 0 === h.md[p]) throw {
                message: "Unsupported RSASSA-PSS hash function.",
                oid: i.signatureParameters.hash.algorithmOid,
                name: p
              };
              l = h.pss.create(h.md[p].create(), d, i.signatureParameters.saltLength);
          }

          a = t.publicKey.verify(u.digest().getBytes(), i.signature, l);
        }

        return a;
      }, t.isIssuer = function (e) {
        var r = !1,
            n = t.issuer,
            i = e.subject;
        if (n.hash && i.hash) r = n.hash === i.hash;else if (n.attributes.length === i.attributes.length) {
          var a, o;
          r = !0;

          for (var s = 0; r && s < n.attributes.length; ++s) {
            a = n.attributes[s], o = i.attributes[s], a.type === o.type && a.value === o.value || (r = !1);
          }
        }
        return r;
      }, t.issued = function (e) {
        return e.isIssuer(t);
      }, t.generateSubjectKeyIdentifier = function () {
        return r.getPublicKeyFingerprint(t.publicKey, {
          type: "RSAPublicKey"
        });
      }, t.verifySubjectKeyIdentifier = function () {
        for (var e = n.subjectKeyIdentifier, r = 0; r < t.extensions.length; ++r) {
          var i = t.extensions[r];

          if (i.id === e) {
            var a = t.generateSubjectKeyIdentifier().getBytes();
            return h.util.hexToBytes(i.subjectKeyIdentifier) === a;
          }
        }

        return !1;
      }, t;
    }, r.certificateFromAsn1 = function (t, i) {
      var a = {},
          s = [];
      if (!e.validate(t, o, a, s)) throw (y = new Error("Cannot read X.509 certificate. ASN.1 object is not an X509v3 Certificate.")).errors = s, y;
      if (e.derToOid(a.publicKeyOid) !== r.oids.rsaEncryption) throw new Error("Cannot read public key. OID is not RSA.");
      var u = r.createCertificate();
      u.version = a.certVersion ? a.certVersion.charCodeAt(0) : 0;
      var c = h.util.createBuffer(a.certSerialNumber);
      u.serialNumber = c.toHex(), u.signatureOid = h.asn1.derToOid(a.certSignatureOid), u.signatureParameters = l(u.signatureOid, a.certSignatureParams, !0), u.siginfo.algorithmOid = h.asn1.derToOid(a.certinfoSignatureOid), u.siginfo.parameters = l(u.siginfo.algorithmOid, a.certinfoSignatureParams, !1), u.signature = a.certSignature;
      var p = [];
      if (void 0 !== a.certValidity1UTCTime && p.push(e.utcTimeToDate(a.certValidity1UTCTime)), void 0 !== a.certValidity2GeneralizedTime && p.push(e.generalizedTimeToDate(a.certValidity2GeneralizedTime)), void 0 !== a.certValidity3UTCTime && p.push(e.utcTimeToDate(a.certValidity3UTCTime)), void 0 !== a.certValidity4GeneralizedTime && p.push(e.generalizedTimeToDate(a.certValidity4GeneralizedTime)), p.length > 2) throw new Error("Cannot read notBefore/notAfter validity times; more than two times were provided in the certificate.");
      if (p.length < 2) throw new Error("Cannot read notBefore/notAfter validity times; they were not provided as either UTCTime or GeneralizedTime.");

      if (u.validity.notBefore = p[0], u.validity.notAfter = p[1], u.tbsCertificate = a.tbsCertificate, i) {
        var y;
        if (u.md = null, u.signatureOid in n) switch (n[u.signatureOid]) {
          case "sha1WithRSAEncryption":
            u.md = h.md.sha1.create();
            break;

          case "md5WithRSAEncryption":
            u.md = h.md.md5.create();
            break;

          case "sha256WithRSAEncryption":
            u.md = h.md.sha256.create();
            break;

          case "sha384WithRSAEncryption":
            u.md = h.md.sha384.create();
            break;

          case "sha512WithRSAEncryption":
            u.md = h.md.sha512.create();
            break;

          case "RSASSA-PSS":
            u.md = h.md.sha256.create();
        }
        if (null === u.md) throw (y = new Error("Could not compute certificate digest. Unknown signature OID.")).signatureOid = u.signatureOid, y;
        var g = e.toDer(u.tbsCertificate);
        u.md.update(g.getBytes());
      }

      var v = h.md.sha1.create();
      u.issuer.getField = function (t) {
        return f(u.issuer, t);
      }, u.issuer.addField = function (t) {
        d([t]), u.issuer.attributes.push(t);
      }, u.issuer.attributes = r.RDNAttributesAsArray(a.certIssuer, v), a.certIssuerUniqueId && (u.issuer.uniqueId = a.certIssuerUniqueId), u.issuer.hash = v.digest().toHex();
      var m = h.md.sha1.create();
      return u.subject.getField = function (t) {
        return f(u.subject, t);
      }, u.subject.addField = function (t) {
        d([t]), u.subject.attributes.push(t);
      }, u.subject.attributes = r.RDNAttributesAsArray(a.certSubject, m), a.certSubjectUniqueId && (u.subject.uniqueId = a.certSubjectUniqueId), u.subject.hash = m.digest().toHex(), a.certExtensions ? u.extensions = r.certificateExtensionsFromAsn1(a.certExtensions) : u.extensions = [], u.publicKey = r.publicKeyFromAsn1(a.subjectPublicKeyInfo), u;
    }, r.certificateExtensionsFromAsn1 = function (t) {
      for (var e = [], n = 0; n < t.value.length; ++n) {
        for (var i = t.value[n], a = 0; a < i.value.length; ++a) {
          e.push(r.certificateExtensionFromAsn1(i.value[a]));
        }
      }

      return e;
    }, r.certificateExtensionFromAsn1 = function (t) {
      var r = {};
      if (r.id = e.derToOid(t.value[0].value), r.critical = !1, t.value[1].type === e.Type.BOOLEAN ? (r.critical = 0 !== t.value[1].value.charCodeAt(0), r.value = t.value[2].value) : r.value = t.value[1].value, r.id in n) if (r.name = n[r.id], "keyUsage" === r.name) {
        var i = 0,
            a = 0;
        (s = e.fromDer(r.value)).value.length > 1 && (i = s.value.charCodeAt(1), a = s.value.length > 2 ? s.value.charCodeAt(2) : 0), r.digitalSignature = 128 == (128 & i), r.nonRepudiation = 64 == (64 & i), r.keyEncipherment = 32 == (32 & i), r.dataEncipherment = 16 == (16 & i), r.keyAgreement = 8 == (8 & i), r.keyCertSign = 4 == (4 & i), r.cRLSign = 2 == (2 & i), r.encipherOnly = 1 == (1 & i), r.decipherOnly = 128 == (128 & a);
      } else if ("basicConstraints" === r.name) {
        (s = e.fromDer(r.value)).value.length > 0 && s.value[0].type === e.Type.BOOLEAN ? r.cA = 0 !== s.value[0].value.charCodeAt(0) : r.cA = !1;
        var o = null;
        s.value.length > 0 && s.value[0].type === e.Type.INTEGER ? o = s.value[0].value : s.value.length > 1 && (o = s.value[1].value), null !== o && (r.pathLenConstraint = e.derToInteger(o));
      } else if ("extKeyUsage" === r.name) for (var s = e.fromDer(r.value), u = 0; u < s.value.length; ++u) {
        var c = e.derToOid(s.value[u].value);
        c in n ? r[n[c]] = !0 : r[c] = !0;
      } else if ("nsCertType" === r.name) {
        i = 0;
        (s = e.fromDer(r.value)).value.length > 1 && (i = s.value.charCodeAt(1)), r.client = 128 == (128 & i), r.server = 64 == (64 & i), r.email = 32 == (32 & i), r.objsign = 16 == (16 & i), r.reserved = 8 == (8 & i), r.sslCA = 4 == (4 & i), r.emailCA = 2 == (2 & i), r.objCA = 1 == (1 & i);
      } else if ("subjectAltName" === r.name || "issuerAltName" === r.name) {
        var f;
        r.altNames = [];
        s = e.fromDer(r.value);

        for (var l = 0; l < s.value.length; ++l) {
          var p = {
            type: (f = s.value[l]).type,
            value: f.value
          };

          switch (r.altNames.push(p), f.type) {
            case 1:
            case 2:
            case 6:
              break;

            case 7:
              p.ip = h.util.bytesToIP(f.value);
              break;

            case 8:
              p.oid = e.derToOid(f.value);
          }
        }
      } else if ("subjectKeyIdentifier" === r.name) {
        s = e.fromDer(r.value);
        r.subjectKeyIdentifier = h.util.bytesToHex(s.value);
      }
      return r;
    }, r.certificationRequestFromAsn1 = function (t, i) {
      var a = {},
          o = [];
      if (!e.validate(t, c, a, o)) throw (u = new Error("Cannot read PKCS#10 certificate request. ASN.1 object is not a PKCS#10 CertificationRequest.")).errors = o, u;
      if (e.derToOid(a.publicKeyOid) !== r.oids.rsaEncryption) throw new Error("Cannot read public key. OID is not RSA.");
      var s = r.createCertificationRequest();

      if (s.version = a.csrVersion ? a.csrVersion.charCodeAt(0) : 0, s.signatureOid = h.asn1.derToOid(a.csrSignatureOid), s.signatureParameters = l(s.signatureOid, a.csrSignatureParams, !0), s.siginfo.algorithmOid = h.asn1.derToOid(a.csrSignatureOid), s.siginfo.parameters = l(s.siginfo.algorithmOid, a.csrSignatureParams, !1), s.signature = a.csrSignature, s.certificationRequestInfo = a.certificationRequestInfo, i) {
        var u;
        if (s.md = null, s.signatureOid in n) switch (n[s.signatureOid]) {
          case "sha1WithRSAEncryption":
            s.md = h.md.sha1.create();
            break;

          case "md5WithRSAEncryption":
            s.md = h.md.md5.create();
            break;

          case "sha256WithRSAEncryption":
            s.md = h.md.sha256.create();
            break;

          case "sha384WithRSAEncryption":
            s.md = h.md.sha384.create();
            break;

          case "sha512WithRSAEncryption":
            s.md = h.md.sha512.create();
            break;

          case "RSASSA-PSS":
            s.md = h.md.sha256.create();
        }
        if (null === s.md) throw (u = new Error("Could not compute certification request digest. Unknown signature OID.")).signatureOid = s.signatureOid, u;
        var p = e.toDer(s.certificationRequestInfo);
        s.md.update(p.getBytes());
      }

      var y = h.md.sha1.create();
      return s.subject.getField = function (t) {
        return f(s.subject, t);
      }, s.subject.addField = function (t) {
        d([t]), s.subject.attributes.push(t);
      }, s.subject.attributes = r.RDNAttributesAsArray(a.certificationRequestInfoSubject, y), s.subject.hash = y.digest().toHex(), s.publicKey = r.publicKeyFromAsn1(a.subjectPublicKeyInfo), s.getAttribute = function (t) {
        return f(s, t);
      }, s.addAttribute = function (t) {
        d([t]), s.attributes.push(t);
      }, s.attributes = r.CRIAttributesAsArray(a.certificationRequestInfoAttributes || []), s;
    }, r.createCertificationRequest = function () {
      var t = {
        version: 0,
        signatureOid: null,
        signature: null,
        siginfo: {}
      };
      return t.siginfo.algorithmOid = null, t.subject = {}, t.subject.getField = function (e) {
        return f(t.subject, e);
      }, t.subject.addField = function (e) {
        d([e]), t.subject.attributes.push(e);
      }, t.subject.attributes = [], t.subject.hash = null, t.publicKey = null, t.attributes = [], t.getAttribute = function (e) {
        return f(t, e);
      }, t.addAttribute = function (e) {
        d([e]), t.attributes.push(e);
      }, t.md = null, t.setSubject = function (e) {
        d(e), t.subject.attributes = e, t.subject.hash = null;
      }, t.setAttributes = function (e) {
        d(e), t.attributes = e;
      }, t.sign = function (i, a) {
        t.md = a || h.md.sha1.create();
        var o = n[t.md.algorithm + "WithRSAEncryption"];

        if (!o) {
          var s = new Error("Could not compute certification request digest. Unknown message digest algorithm OID.");
          throw s.algorithm = t.md.algorithm, s;
        }

        t.signatureOid = t.siginfo.algorithmOid = o, t.certificationRequestInfo = r.getCertificationRequestInfo(t);
        var u = e.toDer(t.certificationRequestInfo);
        t.md.update(u.getBytes()), t.signature = i.sign(t.md);
      }, t.verify = function () {
        var i = !1,
            a = t.md;

        if (null === a) {
          if (t.signatureOid in n) switch (n[t.signatureOid]) {
            case "sha1WithRSAEncryption":
              a = h.md.sha1.create();
              break;

            case "md5WithRSAEncryption":
              a = h.md.md5.create();
              break;

            case "sha256WithRSAEncryption":
              a = h.md.sha256.create();
              break;

            case "sha384WithRSAEncryption":
              a = h.md.sha384.create();
              break;

            case "sha512WithRSAEncryption":
              a = h.md.sha512.create();
              break;

            case "RSASSA-PSS":
              a = h.md.sha256.create();
          }
          if (null === a) throw (l = new Error("Could not compute certification request digest. Unknown signature OID.")).signatureOid = t.signatureOid, l;
          var o = t.certificationRequestInfo || r.getCertificationRequestInfo(t),
              s = e.toDer(o);
          a.update(s.getBytes());
        }

        if (null !== a) {
          var u;

          switch (t.signatureOid) {
            case n.sha1WithRSAEncryption:
              break;

            case n["RSASSA-PSS"]:
              var c, f, l;
              if (void 0 === (c = n[t.signatureParameters.mgf.hash.algorithmOid]) || void 0 === h.md[c]) throw (l = new Error("Unsupported MGF hash function.")).oid = t.signatureParameters.mgf.hash.algorithmOid, l.name = c, l;
              if (void 0 === (f = n[t.signatureParameters.mgf.algorithmOid]) || void 0 === h.mgf[f]) throw (l = new Error("Unsupported MGF function.")).oid = t.signatureParameters.mgf.algorithmOid, l.name = f, l;
              if (f = h.mgf[f].create(h.md[c].create()), void 0 === (c = n[t.signatureParameters.hash.algorithmOid]) || void 0 === h.md[c]) throw (l = new Error("Unsupported RSASSA-PSS hash function.")).oid = t.signatureParameters.hash.algorithmOid, l.name = c, l;
              u = h.pss.create(h.md[c].create(), f, t.signatureParameters.saltLength);
          }

          i = t.publicKey.verify(a.digest().getBytes(), t.signature, u);
        }

        return i;
      }, t;
    };
    var m = new Date("1950-01-01T00:00:00Z"),
        E = new Date("2050-01-01T00:00:00Z");

    function C(t) {
      return t >= m && t < E ? e.create(e.Class.UNIVERSAL, e.Type.UTCTIME, !1, e.dateToUtcTime(t)) : e.create(e.Class.UNIVERSAL, e.Type.GENERALIZEDTIME, !1, e.dateToGeneralizedTime(t));
    }

    r.getTBSCertificate = function (t) {
      var n = C(t.validity.notBefore),
          i = C(t.validity.notAfter),
          a = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, e.integerToDer(t.version).getBytes())]), e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, h.util.hexToBytes(t.serialNumber)), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(t.siginfo.algorithmOid).getBytes()), g(t.siginfo.algorithmOid, t.siginfo.parameters)]), p(t.issuer), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [n, i]), p(t.subject), r.publicKeyToAsn1(t.publicKey)]);
      return t.issuer.uniqueId && a.value.push(e.create(e.Class.CONTEXT_SPECIFIC, 1, !0, [e.create(e.Class.UNIVERSAL, e.Type.BITSTRING, !1, String.fromCharCode(0) + t.issuer.uniqueId)])), t.subject.uniqueId && a.value.push(e.create(e.Class.CONTEXT_SPECIFIC, 2, !0, [e.create(e.Class.UNIVERSAL, e.Type.BITSTRING, !1, String.fromCharCode(0) + t.subject.uniqueId)])), t.extensions.length > 0 && a.value.push(r.certificateExtensionsToAsn1(t.extensions)), a;
    }, r.getCertificationRequestInfo = function (t) {
      return e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, e.integerToDer(t.version).getBytes()), p(t.subject), r.publicKeyToAsn1(t.publicKey), v(t)]);
    }, r.distinguishedNameToAsn1 = function (t) {
      return p(t);
    }, r.certificateToAsn1 = function (t) {
      var n = t.tbsCertificate || r.getTBSCertificate(t);
      return e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [n, e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(t.signatureOid).getBytes()), g(t.signatureOid, t.signatureParameters)]), e.create(e.Class.UNIVERSAL, e.Type.BITSTRING, !1, String.fromCharCode(0) + t.signature)]);
    }, r.certificateExtensionsToAsn1 = function (t) {
      var n = e.create(e.Class.CONTEXT_SPECIFIC, 3, !0, []),
          i = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, []);
      n.value.push(i);

      for (var a = 0; a < t.length; ++a) {
        i.value.push(r.certificateExtensionToAsn1(t[a]));
      }

      return n;
    }, r.certificateExtensionToAsn1 = function (t) {
      var r = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, []);
      r.value.push(e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(t.id).getBytes())), t.critical && r.value.push(e.create(e.Class.UNIVERSAL, e.Type.BOOLEAN, !1, String.fromCharCode(255)));
      var n = t.value;
      return "string" != typeof t.value && (n = e.toDer(n).getBytes()), r.value.push(e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, n)), r;
    }, r.certificationRequestToAsn1 = function (t) {
      var n = t.certificationRequestInfo || r.getCertificationRequestInfo(t);
      return e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [n, e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(t.signatureOid).getBytes()), g(t.signatureOid, t.signatureParameters)]), e.create(e.Class.UNIVERSAL, e.Type.BITSTRING, !1, String.fromCharCode(0) + t.signature)]);
    }, r.createCaStore = function (t) {
      var n = {
        certs: {}
      };

      function i(t) {
        return a(t), n.certs[t.hash] || null;
      }

      function a(t) {
        if (!t.hash) {
          var e = h.md.sha1.create();
          t.attributes = r.RDNAttributesAsArray(p(t), e), t.hash = e.digest().toHex();
        }
      }

      if (n.getIssuer = function (t) {
        return i(t.issuer);
      }, n.addCertificate = function (t) {
        if ("string" == typeof t && (t = h.pki.certificateFromPem(t)), a(t.subject), !n.hasCertificate(t)) if (t.subject.hash in n.certs) {
          var e = n.certs[t.subject.hash];
          h.util.isArray(e) || (e = [e]), e.push(t), n.certs[t.subject.hash] = e;
        } else n.certs[t.subject.hash] = t;
      }, n.hasCertificate = function (t) {
        "string" == typeof t && (t = h.pki.certificateFromPem(t));
        var n = i(t.subject);
        if (!n) return !1;
        h.util.isArray(n) || (n = [n]);

        for (var a = e.toDer(r.certificateToAsn1(t)).getBytes(), o = 0; o < n.length; ++o) {
          if (a === e.toDer(r.certificateToAsn1(n[o])).getBytes()) return !0;
        }

        return !1;
      }, n.listAllCertificates = function () {
        var t = [];

        for (var e in n.certs) {
          if (n.certs.hasOwnProperty(e)) {
            var r = n.certs[e];
            if (h.util.isArray(r)) for (var i = 0; i < r.length; ++i) {
              t.push(r[i]);
            } else t.push(r);
          }
        }

        return t;
      }, n.removeCertificate = function (t) {
        var o;
        if ("string" == typeof t && (t = h.pki.certificateFromPem(t)), a(t.subject), !n.hasCertificate(t)) return null;
        var s = i(t.subject);
        if (!h.util.isArray(s)) return o = n.certs[t.subject.hash], delete n.certs[t.subject.hash], o;

        for (var u = e.toDer(r.certificateToAsn1(t)).getBytes(), c = 0; c < s.length; ++c) {
          u === e.toDer(r.certificateToAsn1(s[c])).getBytes() && (o = s[c], s.splice(c, 1));
        }

        return 0 === s.length && delete n.certs[t.subject.hash], o;
      }, t) for (var o = 0; o < t.length; ++o) {
        var s = t[o];
        n.addCertificate(s);
      }
      return n;
    }, r.certificateError = {
      bad_certificate: "forge.pki.BadCertificate",
      unsupported_certificate: "forge.pki.UnsupportedCertificate",
      certificate_revoked: "forge.pki.CertificateRevoked",
      certificate_expired: "forge.pki.CertificateExpired",
      certificate_unknown: "forge.pki.CertificateUnknown",
      unknown_ca: "forge.pki.UnknownCertificateAuthority"
    }, r.verifyCertificateChain = function (t, e, n) {
      "function" == typeof n && (n = {
        verify: n
      }), n = n || {};
      var i = (e = e.slice(0)).slice(0),
          a = n.validityCheckDate;
      void 0 === a && (a = new Date());
      var o = !0,
          s = null,
          u = 0;

      do {
        var c = e.shift(),
            f = null,
            l = !1;

        if (a && (a < c.validity.notBefore || a > c.validity.notAfter) && (s = {
          message: "Certificate is not valid yet or has expired.",
          error: r.certificateError.certificate_expired,
          notBefore: c.validity.notBefore,
          notAfter: c.validity.notAfter,
          now: a
        }), null === s) {
          if (null === (f = e[0] || t.getIssuer(c)) && c.isIssuer(c) && (l = !0, f = c), f) {
            var p = f;
            h.util.isArray(p) || (p = [p]);

            for (var d = !1; !d && p.length > 0;) {
              f = p.shift();

              try {
                d = f.verify(c);
              } catch (t) {}
            }

            d || (s = {
              message: "Certificate signature is invalid.",
              error: r.certificateError.bad_certificate
            });
          }

          null !== s || f && !l || t.hasCertificate(c) || (s = {
            message: "Certificate is not trusted.",
            error: r.certificateError.unknown_ca
          });
        }

        if (null === s && f && !c.isIssuer(f) && (s = {
          message: "Certificate issuer is invalid.",
          error: r.certificateError.bad_certificate
        }), null === s) for (var y = {
          keyUsage: !0,
          basicConstraints: !0
        }, g = 0; null === s && g < c.extensions.length; ++g) {
          var v = c.extensions[g];
          !v.critical || v.name in y || (s = {
            message: "Certificate has an unsupported critical extension.",
            error: r.certificateError.unsupported_certificate
          });
        }

        if (null === s && (!o || 0 === e.length && (!f || l))) {
          var m = c.getExtension("basicConstraints"),
              E = c.getExtension("keyUsage");
          if (null !== E && (E.keyCertSign && null !== m || (s = {
            message: "Certificate keyUsage or basicConstraints conflict or indicate that the certificate is not a CA. If the certificate is the only one in the chain or isn't the first then the certificate must be a valid CA.",
            error: r.certificateError.bad_certificate
          })), null !== s || null === m || m.cA || (s = {
            message: "Certificate basicConstraints indicates the certificate is not a CA.",
            error: r.certificateError.bad_certificate
          }), null === s && null !== E && "pathLenConstraint" in m) u - 1 > m.pathLenConstraint && (s = {
            message: "Certificate basicConstraints pathLenConstraint violated.",
            error: r.certificateError.bad_certificate
          });
        }

        var C = null === s || s.error,
            S = n.verify ? n.verify(C, u, i) : C;
        if (!0 !== S) throw !0 === C && (s = {
          message: "The application rejected the certificate.",
          error: r.certificateError.bad_certificate
        }), (S || 0 === S) && ("object" != typeof S || h.util.isArray(S) ? "string" == typeof S && (s.error = S) : (S.message && (s.message = S.message), S.error && (s.error = S.error))), s;
        s = null, o = !1, ++u;
      } while (e.length > 0);

      return !0;
    };
  }), i(function (t) {
    var e = h.asn1,
        r = t.exports = h.pkcs7 = h.pkcs7 || {};

    function n(t) {
      var n = {},
          i = [];

      if (!e.validate(t, r.asn1.recipientInfoValidator, n, i)) {
        var a = new Error("Cannot read PKCS#7 RecipientInfo. ASN.1 object is not an PKCS#7 RecipientInfo.");
        throw a.errors = i, a;
      }

      return {
        version: n.version.charCodeAt(0),
        issuer: h.pki.RDNAttributesAsArray(n.issuer),
        serialNumber: h.util.createBuffer(n.serial).toHex(),
        encryptedContent: {
          algorithm: e.derToOid(n.encAlgorithm),
          parameter: n.encParameter.value,
          content: n.encKey
        }
      };
    }

    function i(t) {
      for (var r, n = [], i = 0; i < t.length; ++i) {
        n.push((r = t[i], e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, e.integerToDer(r.version).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [h.pki.distinguishedNameToAsn1({
          attributes: r.issuer
        }), e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, h.util.hexToBytes(r.serialNumber))]), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.encryptedContent.algorithm).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.NULL, !1, "")]), e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, r.encryptedContent.content)])));
      }

      return n;
    }

    function a(t) {
      var r = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, e.integerToDer(t.version).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [h.pki.distinguishedNameToAsn1({
        attributes: t.issuer
      }), e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, h.util.hexToBytes(t.serialNumber))]), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(t.digestAlgorithm).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.NULL, !1, "")])]);

      if (t.authenticatedAttributesAsn1 && r.value.push(t.authenticatedAttributesAsn1), r.value.push(e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(t.signatureAlgorithm).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.NULL, !1, "")])), r.value.push(e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, t.signature)), t.unauthenticatedAttributes.length > 0) {
        for (var n = e.create(e.Class.CONTEXT_SPECIFIC, 1, !0, []), i = 0; i < t.unauthenticatedAttributes.length; ++i) {
          var a = t.unauthenticatedAttributes[i];
          n.values.push(o(a));
        }

        r.value.push(n);
      }

      return r;
    }

    function o(t) {
      var r;
      if (t.type === h.pki.oids.contentType) r = e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(t.value).getBytes());else if (t.type === h.pki.oids.messageDigest) r = e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, t.value.bytes());else if (t.type === h.pki.oids.signingTime) {
        var n = new Date("1950-01-01T00:00:00Z"),
            i = new Date("2050-01-01T00:00:00Z"),
            a = t.value;

        if ("string" == typeof a) {
          var o = Date.parse(a);
          a = isNaN(o) ? 13 === a.length ? e.utcTimeToDate(a) : e.generalizedTimeToDate(a) : new Date(o);
        }

        r = a >= n && a < i ? e.create(e.Class.UNIVERSAL, e.Type.UTCTIME, !1, e.dateToUtcTime(a)) : e.create(e.Class.UNIVERSAL, e.Type.GENERALIZEDTIME, !1, e.dateToGeneralizedTime(a));
      }
      return e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(t.type).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.SET, !0, [r])]);
    }

    function s(t, r, n) {
      var i = {};

      if (!e.validate(r, n, i, [])) {
        var a = new Error("Cannot read PKCS#7 message. ASN.1 object is not a supported PKCS#7 message.");
        throw a.errors = a, a;
      }

      if (e.derToOid(i.contentType) !== h.pki.oids.data) throw new Error("Unsupported PKCS#7 message. Only wrapped ContentType Data supported.");

      if (i.encryptedContent) {
        var o = "";
        if (h.util.isArray(i.encryptedContent)) for (var s = 0; s < i.encryptedContent.length; ++s) {
          if (i.encryptedContent[s].type !== e.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting encrypted content constructed of only OCTET STRING objects.");
          o += i.encryptedContent[s].value;
        } else o = i.encryptedContent;
        t.encryptedContent = {
          algorithm: e.derToOid(i.encAlgorithm),
          parameter: h.util.createBuffer(i.encParameter.value),
          content: h.util.createBuffer(o)
        };
      }

      if (i.content) {
        o = "";
        if (h.util.isArray(i.content)) for (s = 0; s < i.content.length; ++s) {
          if (i.content[s].type !== e.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting content constructed of only OCTET STRING objects.");
          o += i.content[s].value;
        } else o = i.content;
        t.content = h.util.createBuffer(o);
      }

      return t.version = i.version.charCodeAt(0), t.rawCapture = i, i;
    }

    function u(t) {
      if (void 0 === t.encryptedContent.key) throw new Error("Symmetric key not available.");

      if (void 0 === t.content) {
        var e;

        switch (t.encryptedContent.algorithm) {
          case h.pki.oids["aes128-CBC"]:
          case h.pki.oids["aes192-CBC"]:
          case h.pki.oids["aes256-CBC"]:
            e = h.aes.createDecryptionCipher(t.encryptedContent.key);
            break;

          case h.pki.oids.desCBC:
          case h.pki.oids["des-EDE3-CBC"]:
            e = h.des.createDecryptionCipher(t.encryptedContent.key);
            break;

          default:
            throw new Error("Unsupported symmetric cipher, OID " + t.encryptedContent.algorithm);
        }

        if (e.start(t.encryptedContent.parameter), e.update(t.encryptedContent.content), !e.finish()) throw new Error("Symmetric decryption failed.");
        t.content = e.output;
      }
    }

    r.messageFromPem = function (t) {
      var n = h.pem.decode(t)[0];

      if ("PKCS7" !== n.type) {
        var i = new Error('Could not convert PKCS#7 message from PEM; PEM header type is not "PKCS#7".');
        throw i.headerType = n.type, i;
      }

      if (n.procType && "ENCRYPTED" === n.procType.type) throw new Error("Could not convert PKCS#7 message from PEM; PEM is encrypted.");
      var a = e.fromDer(n.body);
      return r.messageFromAsn1(a);
    }, r.messageToPem = function (t, r) {
      var n = {
        type: "PKCS7",
        body: e.toDer(t.toAsn1()).getBytes()
      };
      return h.pem.encode(n, {
        maxline: r
      });
    }, r.messageFromAsn1 = function (t) {
      var n = {},
          i = [];

      if (!e.validate(t, r.asn1.contentInfoValidator, n, i)) {
        var a = new Error("Cannot read PKCS#7 message. ASN.1 object is not an PKCS#7 ContentInfo.");
        throw a.errors = i, a;
      }

      var o,
          s = e.derToOid(n.contentType);

      switch (s) {
        case h.pki.oids.envelopedData:
          o = r.createEnvelopedData();
          break;

        case h.pki.oids.encryptedData:
          o = r.createEncryptedData();
          break;

        case h.pki.oids.signedData:
          o = r.createSignedData();
          break;

        default:
          throw new Error("Cannot read PKCS#7 message. ContentType with OID " + s + " is not (yet) supported.");
      }

      return o.fromAsn1(n.content.value[0]), o;
    }, r.createSignedData = function () {
      var t = null;
      return t = {
        type: h.pki.oids.signedData,
        version: 1,
        certificates: [],
        crls: [],
        signers: [],
        digestAlgorithmIdentifiers: [],
        contentInfo: null,
        signerInfos: [],
        fromAsn1: function fromAsn1(e) {
          if (s(t, e, r.asn1.signedDataValidator), t.certificates = [], t.crls = [], t.digestAlgorithmIdentifiers = [], t.contentInfo = null, t.signerInfos = [], t.rawCapture.certificates) for (var n = t.rawCapture.certificates.value, i = 0; i < n.length; ++i) {
            t.certificates.push(h.pki.certificateFromAsn1(n[i]));
          }
        },
        toAsn1: function toAsn1() {
          t.contentInfo || t.sign();

          for (var r = [], n = 0; n < t.certificates.length; ++n) {
            r.push(h.pki.certificateToAsn1(t.certificates[n]));
          }

          var i = [],
              a = e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, e.integerToDer(t.version).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.SET, !0, t.digestAlgorithmIdentifiers), t.contentInfo])]);
          return r.length > 0 && a.value[0].value.push(e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, r)), i.length > 0 && a.value[0].value.push(e.create(e.Class.CONTEXT_SPECIFIC, 1, !0, i)), a.value[0].value.push(e.create(e.Class.UNIVERSAL, e.Type.SET, !0, t.signerInfos)), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(t.type).getBytes()), a]);
        },
        addSigner: function addSigner(e) {
          var r = e.issuer,
              n = e.serialNumber;

          if (e.certificate) {
            var i = e.certificate;
            "string" == typeof i && (i = h.pki.certificateFromPem(i)), r = i.issuer.attributes, n = i.serialNumber;
          }

          var a = e.key;
          if (!a) throw new Error("Could not add PKCS#7 signer; no private key specified.");
          "string" == typeof a && (a = h.pki.privateKeyFromPem(a));
          var o = e.digestAlgorithm || h.pki.oids.sha1;

          switch (o) {
            case h.pki.oids.sha1:
            case h.pki.oids.sha256:
            case h.pki.oids.sha384:
            case h.pki.oids.sha512:
            case h.pki.oids.md5:
              break;

            default:
              throw new Error("Could not add PKCS#7 signer; unknown message digest algorithm: " + o);
          }

          var s = e.authenticatedAttributes || [];

          if (s.length > 0) {
            for (var u = !1, c = !1, f = 0; f < s.length; ++f) {
              var l = s[f];

              if (u || l.type !== h.pki.oids.contentType) {
                if (c || l.type !== h.pki.oids.messageDigest) ;else if (c = !0, u) break;
              } else if (u = !0, c) break;
            }

            if (!u || !c) throw new Error("Invalid signer.authenticatedAttributes. If signer.authenticatedAttributes is specified, then it must contain at least two attributes, PKCS #9 content-type and PKCS #9 message-digest.");
          }

          t.signers.push({
            key: a,
            version: 1,
            issuer: r,
            serialNumber: n,
            digestAlgorithm: o,
            signatureAlgorithm: h.pki.oids.rsaEncryption,
            signature: null,
            authenticatedAttributes: s,
            unauthenticatedAttributes: []
          });
        },
        sign: function sign(r) {
          var n;
          (r = r || {}, "object" != typeof t.content || null === t.contentInfo) && (t.contentInfo = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(h.pki.oids.data).getBytes())]), "content" in t && (t.content instanceof h.util.ByteBuffer ? n = t.content.bytes() : "string" == typeof t.content && (n = h.util.encodeUtf8(t.content)), r.detached ? t.detachedContent = e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, n) : t.contentInfo.value.push(e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, n)]))));
          0 !== t.signers.length && function (r) {
            var n;
            n = t.detachedContent ? t.detachedContent : (n = t.contentInfo.value[1]).value[0];
            if (!n) throw new Error("Could not sign PKCS#7 message; there is no content to sign.");
            var i = e.derToOid(t.contentInfo.value[0].value),
                s = e.toDer(n);

            for (var u in s.getByte(), e.getBerValueLength(s), s = s.getBytes(), r) {
              r[u].start().update(s);
            }

            for (var c = new Date(), f = 0; f < t.signers.length; ++f) {
              var l = t.signers[f];

              if (0 === l.authenticatedAttributes.length) {
                if (i !== h.pki.oids.data) throw new Error("Invalid signer; authenticatedAttributes must be present when the ContentInfo content type is not PKCS#7 Data.");
              } else {
                l.authenticatedAttributesAsn1 = e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, []);

                for (var p = e.create(e.Class.UNIVERSAL, e.Type.SET, !0, []), d = 0; d < l.authenticatedAttributes.length; ++d) {
                  var y = l.authenticatedAttributes[d];
                  y.type === h.pki.oids.messageDigest ? y.value = r[l.digestAlgorithm].digest() : y.type === h.pki.oids.signingTime && (y.value || (y.value = c)), p.value.push(o(y)), l.authenticatedAttributesAsn1.value.push(o(y));
                }

                s = e.toDer(p).getBytes(), l.md.start().update(s);
              }

              l.signature = l.key.sign(l.md, "RSASSA-PKCS1-V1_5");
            }

            t.signerInfos = function (t) {
              for (var e = [], r = 0; r < t.length; ++r) {
                e.push(a(t[r]));
              }

              return e;
            }(t.signers);
          }(function () {
            for (var r = {}, n = 0; n < t.signers.length; ++n) {
              var i = t.signers[n];
              (a = i.digestAlgorithm) in r || (r[a] = h.md[h.pki.oids[a]].create()), 0 === i.authenticatedAttributes.length ? i.md = r[a] : i.md = h.md[h.pki.oids[a]].create();
            }

            for (var a in t.digestAlgorithmIdentifiers = [], r) {
              t.digestAlgorithmIdentifiers.push(e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(a).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.NULL, !1, "")]));
            }

            return r;
          }());
        },
        verify: function verify() {
          throw new Error("PKCS#7 signature verification not yet implemented.");
        },
        addCertificate: function addCertificate(e) {
          "string" == typeof e && (e = h.pki.certificateFromPem(e)), t.certificates.push(e);
        },
        addCertificateRevokationList: function addCertificateRevokationList(t) {
          throw new Error("PKCS#7 CRL support not yet implemented.");
        }
      };
    }, r.createEncryptedData = function () {
      var t = null;
      return t = {
        type: h.pki.oids.encryptedData,
        version: 0,
        encryptedContent: {
          algorithm: h.pki.oids["aes256-CBC"]
        },
        fromAsn1: function fromAsn1(e) {
          s(t, e, r.asn1.encryptedDataValidator);
        },
        decrypt: function decrypt(e) {
          void 0 !== e && (t.encryptedContent.key = e), u(t);
        }
      };
    }, r.createEnvelopedData = function () {
      var t = null;
      return t = {
        type: h.pki.oids.envelopedData,
        version: 0,
        recipients: [],
        encryptedContent: {
          algorithm: h.pki.oids["aes256-CBC"]
        },
        fromAsn1: function fromAsn1(e) {
          var i = s(t, e, r.asn1.envelopedDataValidator);

          t.recipients = function (t) {
            for (var e = [], r = 0; r < t.length; ++r) {
              e.push(n(t[r]));
            }

            return e;
          }(i.recipientInfos.value);
        },
        toAsn1: function toAsn1() {
          return e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(t.type).getBytes()), e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, e.integerToDer(t.version).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.SET, !0, i(t.recipients)), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, (r = t.encryptedContent, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(h.pki.oids.data).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.algorithm).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, r.parameter.getBytes())]), e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, r.content.getBytes())])]))])])]);
          var r;
        },
        findRecipient: function findRecipient(e) {
          for (var r = e.issuer.attributes, n = 0; n < t.recipients.length; ++n) {
            var i = t.recipients[n],
                a = i.issuer;

            if (i.serialNumber === e.serialNumber && a.length === r.length) {
              for (var o = !0, s = 0; s < r.length; ++s) {
                if (a[s].type !== r[s].type || a[s].value !== r[s].value) {
                  o = !1;
                  break;
                }
              }

              if (o) return i;
            }
          }

          return null;
        },
        decrypt: function decrypt(e, r) {
          if (void 0 === t.encryptedContent.key && void 0 !== e && void 0 !== r) switch (e.encryptedContent.algorithm) {
            case h.pki.oids.rsaEncryption:
            case h.pki.oids.desCBC:
              var n = r.decrypt(e.encryptedContent.content);
              t.encryptedContent.key = h.util.createBuffer(n);
              break;

            default:
              throw new Error("Unsupported asymmetric cipher, OID " + e.encryptedContent.algorithm);
          }
          u(t);
        },
        addRecipient: function addRecipient(e) {
          t.recipients.push({
            version: 0,
            issuer: e.issuer.attributes,
            serialNumber: e.serialNumber,
            encryptedContent: {
              algorithm: h.pki.oids.rsaEncryption,
              key: e.publicKey
            }
          });
        },
        encrypt: function encrypt(e, r) {
          if (void 0 === t.encryptedContent.content) {
            var n, i, a;

            switch (r = r || t.encryptedContent.algorithm, e = e || t.encryptedContent.key, r) {
              case h.pki.oids["aes128-CBC"]:
                n = 16, i = 16, a = h.aes.createEncryptionCipher;
                break;

              case h.pki.oids["aes192-CBC"]:
                n = 24, i = 16, a = h.aes.createEncryptionCipher;
                break;

              case h.pki.oids["aes256-CBC"]:
                n = 32, i = 16, a = h.aes.createEncryptionCipher;
                break;

              case h.pki.oids["des-EDE3-CBC"]:
                n = 24, i = 8, a = h.des.createEncryptionCipher;
                break;

              default:
                throw new Error("Unsupported symmetric cipher, OID " + r);
            }

            if (void 0 === e) e = h.util.createBuffer(h.random.getBytes(n));else if (e.length() != n) throw new Error("Symmetric key has wrong length; got " + e.length() + " bytes, expected " + n + ".");
            t.encryptedContent.algorithm = r, t.encryptedContent.key = e, t.encryptedContent.parameter = h.util.createBuffer(h.random.getBytes(i));
            var o = a(e);
            if (o.start(t.encryptedContent.parameter.copy()), o.update(t.content), !o.finish()) throw new Error("Symmetric encryption failed.");
            t.encryptedContent.content = o.output;
          }

          for (var s = 0; s < t.recipients.length; ++s) {
            var u = t.recipients[s];
            if (void 0 === u.encryptedContent.content) switch (u.encryptedContent.algorithm) {
              case h.pki.oids.rsaEncryption:
                u.encryptedContent.content = u.encryptedContent.key.encrypt(t.encryptedContent.key.data);
                break;

              default:
                throw new Error("Unsupported asymmetric cipher, OID " + u.encryptedContent.algorithm);
            }
          }
        }
      };
    };
  });

  var Pt = [217, 120, 249, 196, 25, 221, 181, 237, 40, 233, 253, 121, 74, 160, 216, 157, 198, 126, 55, 131, 43, 118, 83, 142, 98, 76, 100, 136, 68, 139, 251, 162, 23, 154, 89, 245, 135, 179, 79, 19, 97, 69, 109, 141, 9, 129, 125, 50, 189, 143, 64, 235, 134, 183, 123, 11, 240, 149, 33, 34, 92, 107, 78, 130, 84, 214, 101, 147, 206, 96, 178, 28, 115, 86, 192, 20, 167, 140, 241, 220, 18, 117, 202, 31, 59, 190, 228, 209, 66, 61, 212, 48, 163, 60, 182, 38, 111, 191, 14, 218, 70, 105, 7, 87, 39, 242, 29, 155, 188, 148, 67, 3, 248, 17, 199, 246, 144, 239, 62, 231, 6, 195, 213, 47, 200, 102, 30, 215, 8, 232, 234, 222, 128, 82, 238, 247, 132, 170, 114, 172, 53, 77, 106, 42, 150, 26, 210, 113, 90, 21, 73, 116, 75, 159, 208, 94, 4, 24, 164, 236, 194, 224, 65, 110, 15, 81, 203, 204, 36, 145, 175, 80, 161, 244, 112, 57, 153, 124, 58, 133, 35, 184, 180, 122, 252, 2, 54, 91, 37, 85, 151, 49, 45, 93, 250, 152, 227, 138, 146, 174, 5, 223, 41, 16, 103, 108, 186, 201, 211, 0, 230, 207, 225, 158, 168, 44, 99, 22, 1, 63, 88, 226, 137, 169, 13, 56, 52, 27, 171, 51, 255, 176, 187, 72, 12, 95, 185, 177, 205, 46, 197, 243, 219, 71, 229, 165, 156, 119, 10, 166, 32, 104, 254, 127, 193, 173],
      Ft = [1, 2, 3, 5],
      Lt = function Lt(t, e) {
    return t << e & 65535 | (65535 & t) >> 16 - e;
  },
      Ut = function Ut(t, e) {
    return (65535 & t) >> e | t << 16 - e & 65535;
  };

  h.rc2 = h.rc2 || {};

  h.rc2.expandKey = function (t, e) {
    "string" == typeof t && (t = h.util.createBuffer(t)), e = e || 128;
    var r,
        n = t,
        i = t.length(),
        a = e,
        o = Math.ceil(a / 8),
        s = 255 >> (7 & a);

    for (r = i; r < 128; r++) {
      n.putByte(Pt[n.at(r - 1) + n.at(r - i) & 255]);
    }

    for (n.setAt(128 - o, Pt[n.at(128 - o) & s]), r = 127 - o; r >= 0; r--) {
      n.setAt(r, Pt[n.at(r + 1) ^ n.at(r + o)]);
    }

    return n;
  };

  var Ot = function Ot(t, e, r) {
    var n,
        i,
        a,
        o,
        s = !1,
        u = null,
        c = null,
        f = null,
        l = [];

    for (t = h.rc2.expandKey(t, e), a = 0; a < 64; a++) {
      l.push(t.getInt16Le());
    }

    r ? (n = function n(t) {
      for (a = 0; a < 4; a++) {
        t[a] += l[o] + (t[(a + 3) % 4] & t[(a + 2) % 4]) + (~t[(a + 3) % 4] & t[(a + 1) % 4]), t[a] = Lt(t[a], Ft[a]), o++;
      }
    }, i = function i(t) {
      for (a = 0; a < 4; a++) {
        t[a] += l[63 & t[(a + 3) % 4]];
      }
    }) : (n = function n(t) {
      for (a = 3; a >= 0; a--) {
        t[a] = Ut(t[a], Ft[a]), t[a] -= l[o] + (t[(a + 3) % 4] & t[(a + 2) % 4]) + (~t[(a + 3) % 4] & t[(a + 1) % 4]), o--;
      }
    }, i = function i(t) {
      for (a = 3; a >= 0; a--) {
        t[a] -= l[63 & t[(a + 3) % 4]];
      }
    });

    var p = function p(t) {
      var e = [];

      for (a = 0; a < 4; a++) {
        var n = u.getInt16Le();
        null !== f && (r ? n ^= f.getInt16Le() : f.putInt16Le(n)), e.push(65535 & n);
      }

      o = r ? 0 : 63;

      for (var i = 0; i < t.length; i++) {
        for (var s = 0; s < t[i][0]; s++) {
          t[i][1](e);
        }
      }

      for (a = 0; a < 4; a++) {
        null !== f && (r ? f.putInt16Le(e[a]) : e[a] ^= f.getInt16Le()), c.putInt16Le(e[a]);
      }
    },
        d = null;

    return d = {
      start: function start(t, e) {
        t && "string" == typeof t && (t = h.util.createBuffer(t)), s = !1, u = h.util.createBuffer(), c = e || new h.util.createBuffer(), f = t, d.output = c;
      },
      update: function update(t) {
        for (s || u.putBuffer(t); u.length() >= 8;) {
          p([[5, n], [1, i], [6, n], [1, i], [5, n]]);
        }
      },
      finish: function finish(t) {
        var e = !0;
        if (r) if (t) e = t(8, u, !r);else {
          var n = 8 === u.length() ? 8 : 8 - u.length();
          u.fillWithByte(n, n);
        }
        if (e && (s = !0, d.update()), !r && (e = 0 === u.length())) if (t) e = t(8, c, !r);else {
          var i = c.length(),
              a = c.at(i - 1);
          a > i ? e = !1 : c.truncate(a);
        }
        return e;
      }
    };
  };

  if (h.rc2.startEncrypting = function (t, e, r) {
    var n = h.rc2.createEncryptionCipher(t, 128);
    return n.start(e, r), n;
  }, h.rc2.createEncryptionCipher = function (t, e) {
    return Ot(t, e, !0);
  }, h.rc2.startDecrypting = function (t, e, r) {
    var n = h.rc2.createDecryptionCipher(t, 128);
    return n.start(e, r), n;
  }, h.rc2.createDecryptionCipher = function (t, e) {
    return Ot(t, e, !1);
  }, void 0 === Dt) var Dt = h.jsbn.BigInteger;
  var Kt = h.asn1,
      Vt = h.pki = h.pki || {},
      xt = (Vt.pbe = h.pbe = h.pbe || {}, Vt.oids),
      jt = {
    name: "EncryptedPrivateKeyInfo",
    tagClass: Kt.Class.UNIVERSAL,
    type: Kt.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "EncryptedPrivateKeyInfo.encryptionAlgorithm",
      tagClass: Kt.Class.UNIVERSAL,
      type: Kt.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "AlgorithmIdentifier.algorithm",
        tagClass: Kt.Class.UNIVERSAL,
        type: Kt.Type.OID,
        constructed: !1,
        capture: "encryptionOid"
      }, {
        name: "AlgorithmIdentifier.parameters",
        tagClass: Kt.Class.UNIVERSAL,
        type: Kt.Type.SEQUENCE,
        constructed: !0,
        captureAsn1: "encryptionParams"
      }]
    }, {
      name: "EncryptedPrivateKeyInfo.encryptedData",
      tagClass: Kt.Class.UNIVERSAL,
      type: Kt.Type.OCTETSTRING,
      constructed: !1,
      capture: "encryptedData"
    }]
  },
      Mt = {
    name: "PBES2Algorithms",
    tagClass: Kt.Class.UNIVERSAL,
    type: Kt.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "PBES2Algorithms.keyDerivationFunc",
      tagClass: Kt.Class.UNIVERSAL,
      type: Kt.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "PBES2Algorithms.keyDerivationFunc.oid",
        tagClass: Kt.Class.UNIVERSAL,
        type: Kt.Type.OID,
        constructed: !1,
        capture: "kdfOid"
      }, {
        name: "PBES2Algorithms.params",
        tagClass: Kt.Class.UNIVERSAL,
        type: Kt.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "PBES2Algorithms.params.salt",
          tagClass: Kt.Class.UNIVERSAL,
          type: Kt.Type.OCTETSTRING,
          constructed: !1,
          capture: "kdfSalt"
        }, {
          name: "PBES2Algorithms.params.iterationCount",
          tagClass: Kt.Class.UNIVERSAL,
          type: Kt.Type.INTEGER,
          constructed: !1,
          capture: "kdfIterationCount"
        }, {
          name: "PBES2Algorithms.params.keyLength",
          tagClass: Kt.Class.UNIVERSAL,
          type: Kt.Type.INTEGER,
          constructed: !1,
          optional: !0,
          capture: "keyLength"
        }, {
          name: "PBES2Algorithms.params.prf",
          tagClass: Kt.Class.UNIVERSAL,
          type: Kt.Type.SEQUENCE,
          constructed: !0,
          optional: !0,
          value: [{
            name: "PBES2Algorithms.params.prf.algorithm",
            tagClass: Kt.Class.UNIVERSAL,
            type: Kt.Type.OID,
            constructed: !1,
            capture: "prfOid"
          }]
        }]
      }]
    }, {
      name: "PBES2Algorithms.encryptionScheme",
      tagClass: Kt.Class.UNIVERSAL,
      type: Kt.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "PBES2Algorithms.encryptionScheme.oid",
        tagClass: Kt.Class.UNIVERSAL,
        type: Kt.Type.OID,
        constructed: !1,
        capture: "encOid"
      }, {
        name: "PBES2Algorithms.encryptionScheme.iv",
        tagClass: Kt.Class.UNIVERSAL,
        type: Kt.Type.OCTETSTRING,
        constructed: !1,
        capture: "encIv"
      }]
    }]
  },
      Ht = {
    name: "pkcs-12PbeParams",
    tagClass: Kt.Class.UNIVERSAL,
    type: Kt.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "pkcs-12PbeParams.salt",
      tagClass: Kt.Class.UNIVERSAL,
      type: Kt.Type.OCTETSTRING,
      constructed: !1,
      capture: "salt"
    }, {
      name: "pkcs-12PbeParams.iterations",
      tagClass: Kt.Class.UNIVERSAL,
      type: Kt.Type.INTEGER,
      constructed: !1,
      capture: "iterations"
    }]
  };

  function zt(t, e) {
    return t.start().update(e).digest().getBytes();
  }

  function Gt(t) {
    var e;

    if (t) {
      if (!(e = Vt.oids[Kt.derToOid(t)])) {
        var r = new Error("Unsupported PRF OID.");
        throw r.oid = t, r.supported = ["hmacWithSHA1", "hmacWithSHA224", "hmacWithSHA256", "hmacWithSHA384", "hmacWithSHA512"], r;
      }
    } else e = "hmacWithSHA1";

    return qt(e);
  }

  function qt(t) {
    var e = h.md;

    switch (t) {
      case "hmacWithSHA224":
        e = h.md.sha512;

      case "hmacWithSHA1":
      case "hmacWithSHA256":
      case "hmacWithSHA384":
      case "hmacWithSHA512":
        t = t.substr(8).toLowerCase();
        break;

      default:
        var r = new Error("Unsupported PRF algorithm.");
        throw r.algorithm = t, r.supported = ["hmacWithSHA1", "hmacWithSHA224", "hmacWithSHA256", "hmacWithSHA384", "hmacWithSHA512"], r;
    }

    if (!(e && t in e)) throw new Error("Unknown hash algorithm: " + t);
    return e[t].create();
  }

  Vt.encryptPrivateKeyInfo = function (t, e, r) {
    (r = r || {}).saltSize = r.saltSize || 8, r.count = r.count || 2048, r.algorithm = r.algorithm || "aes128", r.prfAlgorithm = r.prfAlgorithm || "sha1";
    var n,
        i,
        a,
        o = h.random.getBytesSync(r.saltSize),
        s = r.count,
        u = Kt.integerToDer(s);

    if (0 === r.algorithm.indexOf("aes") || "des" === r.algorithm) {
      var c, f, l;

      switch (r.algorithm) {
        case "aes128":
          n = 16, c = 16, f = xt["aes128-CBC"], l = h.aes.createEncryptionCipher;
          break;

        case "aes192":
          n = 24, c = 16, f = xt["aes192-CBC"], l = h.aes.createEncryptionCipher;
          break;

        case "aes256":
          n = 32, c = 16, f = xt["aes256-CBC"], l = h.aes.createEncryptionCipher;
          break;

        case "des":
          n = 8, c = 8, f = xt.desCBC, l = h.des.createEncryptionCipher;
          break;

        default:
          throw (m = new Error("Cannot encrypt private key. Unknown encryption algorithm.")).algorithm = r.algorithm, m;
      }

      var p = "hmacWith" + r.prfAlgorithm.toUpperCase(),
          d = qt(p),
          y = h.pkcs5.pbkdf2(e, o, s, n, d),
          g = h.random.getBytesSync(c);
      (E = l(y)).start(g), E.update(Kt.toDer(t)), E.finish(), a = E.output.getBytes();

      var v = function (t, e, r, n) {
        var i = Kt.create(Kt.Class.UNIVERSAL, Kt.Type.SEQUENCE, !0, [Kt.create(Kt.Class.UNIVERSAL, Kt.Type.OCTETSTRING, !1, t), Kt.create(Kt.Class.UNIVERSAL, Kt.Type.INTEGER, !1, e.getBytes())]);
        "hmacWithSHA1" !== n && i.value.push(Kt.create(Kt.Class.UNIVERSAL, Kt.Type.INTEGER, !1, h.util.hexToBytes(r.toString(16))), Kt.create(Kt.Class.UNIVERSAL, Kt.Type.SEQUENCE, !0, [Kt.create(Kt.Class.UNIVERSAL, Kt.Type.OID, !1, Kt.oidToDer(Vt.oids[n]).getBytes()), Kt.create(Kt.Class.UNIVERSAL, Kt.Type.NULL, !1, "")]));
        return i;
      }(o, u, n, p);

      i = Kt.create(Kt.Class.UNIVERSAL, Kt.Type.SEQUENCE, !0, [Kt.create(Kt.Class.UNIVERSAL, Kt.Type.OID, !1, Kt.oidToDer(xt.pkcs5PBES2).getBytes()), Kt.create(Kt.Class.UNIVERSAL, Kt.Type.SEQUENCE, !0, [Kt.create(Kt.Class.UNIVERSAL, Kt.Type.SEQUENCE, !0, [Kt.create(Kt.Class.UNIVERSAL, Kt.Type.OID, !1, Kt.oidToDer(xt.pkcs5PBKDF2).getBytes()), v]), Kt.create(Kt.Class.UNIVERSAL, Kt.Type.SEQUENCE, !0, [Kt.create(Kt.Class.UNIVERSAL, Kt.Type.OID, !1, Kt.oidToDer(f).getBytes()), Kt.create(Kt.Class.UNIVERSAL, Kt.Type.OCTETSTRING, !1, g)])])]);
    } else {
      var m;
      if ("3des" !== r.algorithm) throw (m = new Error("Cannot encrypt private key. Unknown encryption algorithm.")).algorithm = r.algorithm, m;
      n = 24;
      var E,
          C = new h.util.ByteBuffer(o);
      y = Vt.pbe.generatePkcs12Key(e, C, 1, s, n), g = Vt.pbe.generatePkcs12Key(e, C, 2, s, n);
      (E = h.des.createEncryptionCipher(y)).start(g), E.update(Kt.toDer(t)), E.finish(), a = E.output.getBytes(), i = Kt.create(Kt.Class.UNIVERSAL, Kt.Type.SEQUENCE, !0, [Kt.create(Kt.Class.UNIVERSAL, Kt.Type.OID, !1, Kt.oidToDer(xt["pbeWithSHAAnd3-KeyTripleDES-CBC"]).getBytes()), Kt.create(Kt.Class.UNIVERSAL, Kt.Type.SEQUENCE, !0, [Kt.create(Kt.Class.UNIVERSAL, Kt.Type.OCTETSTRING, !1, o), Kt.create(Kt.Class.UNIVERSAL, Kt.Type.INTEGER, !1, u.getBytes())])]);
    }

    return Kt.create(Kt.Class.UNIVERSAL, Kt.Type.SEQUENCE, !0, [i, Kt.create(Kt.Class.UNIVERSAL, Kt.Type.OCTETSTRING, !1, a)]);
  }, Vt.decryptPrivateKeyInfo = function (t, e) {
    var r = null,
        n = {},
        i = [];

    if (!Kt.validate(t, jt, n, i)) {
      var a = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
      throw a.errors = i, a;
    }

    var o = Kt.derToOid(n.encryptionOid),
        s = Vt.pbe.getCipher(o, n.encryptionParams, e),
        u = h.util.createBuffer(n.encryptedData);
    return s.update(u), s.finish() && (r = Kt.fromDer(s.output)), r;
  }, Vt.encryptedPrivateKeyToPem = function (t, e) {
    var r = {
      type: "ENCRYPTED PRIVATE KEY",
      body: Kt.toDer(t).getBytes()
    };
    return h.pem.encode(r, {
      maxline: e
    });
  }, Vt.encryptedPrivateKeyFromPem = function (t) {
    var e = h.pem.decode(t)[0];

    if ("ENCRYPTED PRIVATE KEY" !== e.type) {
      var r = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
      throw r.headerType = e.type, r;
    }

    if (e.procType && "ENCRYPTED" === e.procType.type) throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
    return Kt.fromDer(e.body);
  }, Vt.encryptRsaPrivateKey = function (t, e, r) {
    if (!(r = r || {}).legacy) {
      var n = Vt.wrapRsaPrivateKey(Vt.privateKeyToAsn1(t));
      return n = Vt.encryptPrivateKeyInfo(n, e, r), Vt.encryptedPrivateKeyToPem(n);
    }

    var i, a, o, s;

    switch (r.algorithm) {
      case "aes128":
        i = "AES-128-CBC", o = 16, a = h.random.getBytesSync(16), s = h.aes.createEncryptionCipher;
        break;

      case "aes192":
        i = "AES-192-CBC", o = 24, a = h.random.getBytesSync(16), s = h.aes.createEncryptionCipher;
        break;

      case "aes256":
        i = "AES-256-CBC", o = 32, a = h.random.getBytesSync(16), s = h.aes.createEncryptionCipher;
        break;

      case "3des":
        i = "DES-EDE3-CBC", o = 24, a = h.random.getBytesSync(8), s = h.des.createEncryptionCipher;
        break;

      case "des":
        i = "DES-CBC", o = 8, a = h.random.getBytesSync(8), s = h.des.createEncryptionCipher;
        break;

      default:
        var u = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + r.algorithm + '".');
        throw u.algorithm = r.algorithm, u;
    }

    var c = s(h.pbe.opensslDeriveBytes(e, a.substr(0, 8), o));
    c.start(a), c.update(Kt.toDer(Vt.privateKeyToAsn1(t))), c.finish();
    var f = {
      type: "RSA PRIVATE KEY",
      procType: {
        version: "4",
        type: "ENCRYPTED"
      },
      dekInfo: {
        algorithm: i,
        parameters: h.util.bytesToHex(a).toUpperCase()
      },
      body: c.output.getBytes()
    };
    return h.pem.encode(f);
  }, Vt.decryptRsaPrivateKey = function (t, e) {
    var r = null,
        n = h.pem.decode(t)[0];
    if ("ENCRYPTED PRIVATE KEY" !== n.type && "PRIVATE KEY" !== n.type && "RSA PRIVATE KEY" !== n.type) throw (o = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".')).headerType = o, o;

    if (n.procType && "ENCRYPTED" === n.procType.type) {
      var i, a;

      switch (n.dekInfo.algorithm) {
        case "DES-CBC":
          i = 8, a = h.des.createDecryptionCipher;
          break;

        case "DES-EDE3-CBC":
          i = 24, a = h.des.createDecryptionCipher;
          break;

        case "AES-128-CBC":
          i = 16, a = h.aes.createDecryptionCipher;
          break;

        case "AES-192-CBC":
          i = 24, a = h.aes.createDecryptionCipher;
          break;

        case "AES-256-CBC":
          i = 32, a = h.aes.createDecryptionCipher;
          break;

        case "RC2-40-CBC":
          i = 5, a = function a(t) {
            return h.rc2.createDecryptionCipher(t, 40);
          };
          break;

        case "RC2-64-CBC":
          i = 8, a = function a(t) {
            return h.rc2.createDecryptionCipher(t, 64);
          };
          break;

        case "RC2-128-CBC":
          i = 16, a = function a(t) {
            return h.rc2.createDecryptionCipher(t, 128);
          };
          break;

        default:
          var o;
          throw (o = new Error('Could not decrypt private key; unsupported encryption algorithm "' + n.dekInfo.algorithm + '".')).algorithm = n.dekInfo.algorithm, o;
      }

      var s = h.util.hexToBytes(n.dekInfo.parameters),
          u = a(h.pbe.opensslDeriveBytes(e, s.substr(0, 8), i));
      if (u.start(s), u.update(h.util.createBuffer(n.body)), !u.finish()) return r;
      r = u.output.getBytes();
    } else r = n.body;

    return null !== (r = "ENCRYPTED PRIVATE KEY" === n.type ? Vt.decryptPrivateKeyInfo(Kt.fromDer(r), e) : Kt.fromDer(r)) && (r = Vt.privateKeyFromAsn1(r)), r;
  }, Vt.pbe.generatePkcs12Key = function (t, e, r, n, i, a) {
    var o, s;

    if (null == a) {
      if (!("sha1" in h.md)) throw new Error('"sha1" hash algorithm unavailable.');
      a = h.md.sha1.create();
    }

    var u = a.digestLength,
        c = a.blockLength,
        f = new h.util.ByteBuffer(),
        l = new h.util.ByteBuffer();

    if (null != t) {
      for (s = 0; s < t.length; s++) {
        l.putInt16(t.charCodeAt(s));
      }

      l.putInt16(0);
    }

    var p = l.length(),
        d = e.length(),
        y = new h.util.ByteBuffer();
    y.fillWithByte(r, c);
    var g = c * Math.ceil(d / c),
        v = new h.util.ByteBuffer();

    for (s = 0; s < g; s++) {
      v.putByte(e.at(s % d));
    }

    var m = c * Math.ceil(p / c),
        E = new h.util.ByteBuffer();

    for (s = 0; s < m; s++) {
      E.putByte(l.at(s % p));
    }

    var C = v;
    C.putBuffer(E);

    for (var S = Math.ceil(i / u), b = 1; b <= S; b++) {
      var T = new h.util.ByteBuffer();
      T.putBytes(y.bytes()), T.putBytes(C.bytes());

      for (var A = 0; A < n; A++) {
        a.start(), a.update(T.getBytes()), T = a.digest();
      }

      var I = new h.util.ByteBuffer();

      for (s = 0; s < c; s++) {
        I.putByte(T.at(s % u));
      }

      var B = Math.ceil(d / c) + Math.ceil(p / c),
          w = new h.util.ByteBuffer();

      for (o = 0; o < B; o++) {
        var N = new h.util.ByteBuffer(C.getBytes(c)),
            k = 511;

        for (s = I.length() - 1; s >= 0; s--) {
          k >>= 8, k += I.at(s) + N.at(s), N.setAt(s, 255 & k);
        }

        w.putBuffer(N);
      }

      C = w, f.putBuffer(T);
    }

    return f.truncate(f.length() - i), f;
  }, Vt.pbe.getCipher = function (t, e, r) {
    switch (t) {
      case Vt.oids.pkcs5PBES2:
        return Vt.pbe.getCipherForPBES2(t, e, r);

      case Vt.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
      case Vt.oids["pbewithSHAAnd40BitRC2-CBC"]:
        return Vt.pbe.getCipherForPKCS12PBE(t, e, r);

      default:
        var n = new Error("Cannot read encrypted PBE data block. Unsupported OID.");
        throw n.oid = t, n.supportedOids = ["pkcs5PBES2", "pbeWithSHAAnd3-KeyTripleDES-CBC", "pbewithSHAAnd40BitRC2-CBC"], n;
    }
  }, Vt.pbe.getCipherForPBES2 = function (t, e, r) {
    var n,
        i = {},
        a = [];
    if (!Kt.validate(e, Mt, i, a)) throw (n = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.")).errors = a, n;
    if ((t = Kt.derToOid(i.kdfOid)) !== Vt.oids.pkcs5PBKDF2) throw (n = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.")).oid = t, n.supportedOids = ["pkcs5PBKDF2"], n;
    if ((t = Kt.derToOid(i.encOid)) !== Vt.oids["aes128-CBC"] && t !== Vt.oids["aes192-CBC"] && t !== Vt.oids["aes256-CBC"] && t !== Vt.oids["des-EDE3-CBC"] && t !== Vt.oids.desCBC) throw (n = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.")).oid = t, n.supportedOids = ["aes128-CBC", "aes192-CBC", "aes256-CBC", "des-EDE3-CBC", "desCBC"], n;
    var o,
        s,
        u = i.kdfSalt,
        c = h.util.createBuffer(i.kdfIterationCount);

    switch (c = c.getInt(c.length() << 3), Vt.oids[t]) {
      case "aes128-CBC":
        o = 16, s = h.aes.createDecryptionCipher;
        break;

      case "aes192-CBC":
        o = 24, s = h.aes.createDecryptionCipher;
        break;

      case "aes256-CBC":
        o = 32, s = h.aes.createDecryptionCipher;
        break;

      case "des-EDE3-CBC":
        o = 24, s = h.des.createDecryptionCipher;
        break;

      case "desCBC":
        o = 8, s = h.des.createDecryptionCipher;
    }

    var f = Gt(i.prfOid),
        l = h.pkcs5.pbkdf2(r, u, c, o, f),
        p = i.encIv,
        d = s(l);
    return d.start(p), d;
  }, Vt.pbe.getCipherForPKCS12PBE = function (t, e, r) {
    var n = {},
        i = [];
    if (!Kt.validate(e, Ht, n, i)) throw (f = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.")).errors = i, f;
    var a,
        o,
        s,
        u = h.util.createBuffer(n.salt),
        c = h.util.createBuffer(n.iterations);

    switch (c = c.getInt(c.length() << 3), t) {
      case Vt.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
        a = 24, o = 8, s = h.des.startDecrypting;
        break;

      case Vt.oids["pbewithSHAAnd40BitRC2-CBC"]:
        a = 5, o = 8, s = function s(t, e) {
          var r = h.rc2.createDecryptionCipher(t, 40);
          return r.start(e, null), r;
        };
        break;

      default:
        var f;
        throw (f = new Error("Cannot read PKCS #12 PBE data block. Unsupported OID.")).oid = t, f;
    }

    var l = Gt(n.prfOid),
        p = Vt.pbe.generatePkcs12Key(r, u, 1, c, a, l);
    return l.start(), s(p, Vt.pbe.generatePkcs12Key(r, u, 2, c, o, l));
  }, Vt.pbe.opensslDeriveBytes = function (t, e, r, n) {
    if (null == n) {
      if (!("md5" in h.md)) throw new Error('"md5" hash algorithm unavailable.');
      n = h.md.md5.create();
    }

    null === e && (e = "");

    for (var i = [zt(n, t + e)], a = 16, o = 1; a < r; ++o, a += 16) {
      i.push(zt(n, i[o - 1] + t + e));
    }

    return i.join("").substr(0, r);
  };
  var Wt, Qt;
  i(function (t) {
    var e = h.asn1,
        r = h.pki,
        n = t.exports = h.pkcs12 = h.pkcs12 || {},
        i = {
      name: "ContentInfo",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "ContentInfo.contentType",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.OID,
        constructed: !1,
        capture: "contentType"
      }, {
        name: "ContentInfo.content",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        constructed: !0,
        captureAsn1: "content"
      }]
    },
        a = {
      name: "PFX",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "PFX.version",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.INTEGER,
        constructed: !1,
        capture: "version"
      }, i, {
        name: "PFX.macData",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SEQUENCE,
        constructed: !0,
        optional: !0,
        captureAsn1: "mac",
        value: [{
          name: "PFX.macData.mac",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.SEQUENCE,
          constructed: !0,
          value: [{
            name: "PFX.macData.mac.digestAlgorithm",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.SEQUENCE,
            constructed: !0,
            value: [{
              name: "PFX.macData.mac.digestAlgorithm.algorithm",
              tagClass: e.Class.UNIVERSAL,
              type: e.Type.OID,
              constructed: !1,
              capture: "macAlgorithm"
            }, {
              name: "PFX.macData.mac.digestAlgorithm.parameters",
              tagClass: e.Class.UNIVERSAL,
              captureAsn1: "macAlgorithmParameters"
            }]
          }, {
            name: "PFX.macData.mac.digest",
            tagClass: e.Class.UNIVERSAL,
            type: e.Type.OCTETSTRING,
            constructed: !1,
            capture: "macDigest"
          }]
        }, {
          name: "PFX.macData.macSalt",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.OCTETSTRING,
          constructed: !1,
          capture: "macSalt"
        }, {
          name: "PFX.macData.iterations",
          tagClass: e.Class.UNIVERSAL,
          type: e.Type.INTEGER,
          constructed: !1,
          optional: !0,
          capture: "macIterations"
        }]
      }]
    },
        o = {
      name: "SafeBag",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "SafeBag.bagId",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.OID,
        constructed: !1,
        capture: "bagId"
      }, {
        name: "SafeBag.bagValue",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        constructed: !0,
        captureAsn1: "bagValue"
      }, {
        name: "SafeBag.bagAttributes",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SET,
        constructed: !0,
        optional: !0,
        capture: "bagAttributes"
      }]
    },
        s = {
      name: "Attribute",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "Attribute.attrId",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.OID,
        constructed: !1,
        capture: "oid"
      }, {
        name: "Attribute.attrValues",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.SET,
        constructed: !0,
        capture: "values"
      }]
    },
        u = {
      name: "CertBag",
      tagClass: e.Class.UNIVERSAL,
      type: e.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "CertBag.certId",
        tagClass: e.Class.UNIVERSAL,
        type: e.Type.OID,
        constructed: !1,
        capture: "certId"
      }, {
        name: "CertBag.certValue",
        tagClass: e.Class.CONTEXT_SPECIFIC,
        constructed: !0,
        value: [{
          name: "CertBag.certValue[0]",
          tagClass: e.Class.UNIVERSAL,
          type: e.Class.OCTETSTRING,
          constructed: !1,
          capture: "cert"
        }]
      }]
    };

    function c(t, e, r, n) {
      for (var i = [], a = 0; a < t.length; a++) {
        for (var o = 0; o < t[a].safeBags.length; o++) {
          var s = t[a].safeBags[o];
          void 0 !== n && s.type !== n || (null !== e ? void 0 !== s.attributes[e] && s.attributes[e].indexOf(r) >= 0 && i.push(s) : i.push(s));
        }
      }

      return i;
    }

    function f(t) {
      if (t.composed || t.constructed) {
        for (var e = h.util.createBuffer(), r = 0; r < t.value.length; ++r) {
          e.putBytes(t.value[r].value);
        }

        t.composed = t.constructed = !1, t.value = e.getBytes();
      }

      return t;
    }

    function l(t, n) {
      var i = {},
          a = [];
      if (!e.validate(t, h.pkcs7.asn1.encryptedDataValidator, i, a)) throw (o = new Error("Cannot read EncryptedContentInfo.")).errors = a, o;
      var o,
          s = e.derToOid(i.contentType);
      if (s !== r.oids.data) throw (o = new Error("PKCS#12 EncryptedContentInfo ContentType is not Data.")).oid = s, o;
      s = e.derToOid(i.encAlgorithm);
      var u = r.pbe.getCipher(s, i.encParameter, n),
          c = f(i.encryptedContentAsn1),
          l = h.util.createBuffer(c.value);
      if (u.update(l), !u.finish()) throw new Error("Failed to decrypt PKCS#12 SafeContents.");
      return u.output.getBytes();
    }

    function p(t, n, i) {
      if (!n && 0 === t.length) return [];
      if ((t = e.fromDer(t, n)).tagClass !== e.Class.UNIVERSAL || t.type !== e.Type.SEQUENCE || !0 !== t.constructed) throw new Error("PKCS#12 SafeContents expected to be a SEQUENCE OF SafeBag.");

      for (var a = [], s = 0; s < t.value.length; s++) {
        var c = t.value[s],
            f = {},
            l = [];
        if (!e.validate(c, o, f, l)) throw (v = new Error("Cannot read SafeBag.")).errors = l, v;
        var h,
            p,
            y = {
          type: e.derToOid(f.bagId),
          attributes: d(f.bagAttributes)
        };
        a.push(y);
        var g = f.bagValue.value[0];

        switch (y.type) {
          case r.oids.pkcs8ShroudedKeyBag:
            if (null === (g = r.decryptPrivateKeyInfo(g, i))) throw new Error("Unable to decrypt PKCS#8 ShroudedKeyBag, wrong password?");

          case r.oids.keyBag:
            try {
              y.key = r.privateKeyFromAsn1(g);
            } catch (t) {
              y.key = null, y.asn1 = g;
            }

            continue;

          case r.oids.certBag:
            h = u, p = function p() {
              if (e.derToOid(f.certId) !== r.oids.x509Certificate) {
                var t = new Error("Unsupported certificate type, only X.509 supported.");
                throw t.oid = e.derToOid(f.certId), t;
              }

              var i = e.fromDer(f.cert, n);

              try {
                y.cert = r.certificateFromAsn1(i, !0);
              } catch (t) {
                y.cert = null, y.asn1 = i;
              }
            };
            break;

          default:
            var v;
            throw (v = new Error("Unsupported PKCS#12 SafeBag type.")).oid = y.type, v;
        }

        if (void 0 !== h && !e.validate(g, h, f, l)) throw (v = new Error("Cannot read PKCS#12 " + h.name)).errors = l, v;
        p();
      }

      return a;
    }

    function d(t) {
      var n = {};
      if (void 0 !== t) for (var i = 0; i < t.length; ++i) {
        var a = {},
            o = [];

        if (!e.validate(t[i], s, a, o)) {
          var u = new Error("Cannot read PKCS#12 BagAttribute.");
          throw u.errors = o, u;
        }

        var c = e.derToOid(a.oid);

        if (void 0 !== r.oids[c]) {
          n[r.oids[c]] = [];

          for (var f = 0; f < a.values.length; ++f) {
            n[r.oids[c]].push(a.values[f].value);
          }
        }
      }
      return n;
    }

    n.pkcs12FromAsn1 = function (t, o, s) {
      "string" == typeof o ? (s = o, o = !0) : void 0 === o && (o = !0);
      var u = {};
      if (!e.validate(t, a, u, [])) throw (d = new Error("Cannot read PKCS#12 PFX. ASN.1 object is not an PKCS#12 PFX.")).errors = d, d;
      var d,
          y = {
        version: u.version.charCodeAt(0),
        safeContents: [],
        getBags: function getBags(t) {
          var e,
              r = {};
          return "localKeyId" in t ? e = t.localKeyId : "localKeyIdHex" in t && (e = h.util.hexToBytes(t.localKeyIdHex)), void 0 === e && !("friendlyName" in t) && "bagType" in t && (r[t.bagType] = c(y.safeContents, null, null, t.bagType)), void 0 !== e && (r.localKeyId = c(y.safeContents, "localKeyId", e, t.bagType)), "friendlyName" in t && (r.friendlyName = c(y.safeContents, "friendlyName", t.friendlyName, t.bagType)), r;
        },
        getBagsByFriendlyName: function getBagsByFriendlyName(t, e) {
          return c(y.safeContents, "friendlyName", t, e);
        },
        getBagsByLocalKeyId: function getBagsByLocalKeyId(t, e) {
          return c(y.safeContents, "localKeyId", t, e);
        }
      };
      if (3 !== u.version.charCodeAt(0)) throw (d = new Error("PKCS#12 PFX of version other than 3 not supported.")).version = u.version.charCodeAt(0), d;
      if (e.derToOid(u.contentType) !== r.oids.data) throw (d = new Error("Only PKCS#12 PFX in password integrity mode supported.")).oid = e.derToOid(u.contentType), d;
      var g = u.content.value[0];
      if (g.tagClass !== e.Class.UNIVERSAL || g.type !== e.Type.OCTETSTRING) throw new Error("PKCS#12 authSafe content data is not an OCTET STRING.");

      if (g = f(g), u.mac) {
        var v = null,
            m = 0,
            E = e.derToOid(u.macAlgorithm);

        switch (E) {
          case r.oids.sha1:
            v = h.md.sha1.create(), m = 20;
            break;

          case r.oids.sha256:
            v = h.md.sha256.create(), m = 32;
            break;

          case r.oids.sha384:
            v = h.md.sha384.create(), m = 48;
            break;

          case r.oids.sha512:
            v = h.md.sha512.create(), m = 64;
            break;

          case r.oids.md5:
            v = h.md.md5.create(), m = 16;
        }

        if (null === v) throw new Error("PKCS#12 uses unsupported MAC algorithm: " + E);
        var C = new h.util.ByteBuffer(u.macSalt),
            S = "macIterations" in u ? parseInt(h.util.bytesToHex(u.macIterations), 16) : 1,
            b = n.generateKey(s, C, 3, S, m, v),
            T = h.hmac.create();
        if (T.start(v, b), T.update(g.value), T.getMac().getBytes() !== u.macDigest) throw new Error("PKCS#12 MAC could not be verified. Invalid password?");
      }

      return function (t, n, a, o) {
        if ((n = e.fromDer(n, a)).tagClass !== e.Class.UNIVERSAL || n.type !== e.Type.SEQUENCE || !0 !== n.constructed) throw new Error("PKCS#12 AuthenticatedSafe expected to be a SEQUENCE OF ContentInfo");

        for (var s = 0; s < n.value.length; s++) {
          var u = n.value[s],
              c = {},
              h = [];
          if (!e.validate(u, i, c, h)) throw (v = new Error("Cannot read ContentInfo.")).errors = h, v;
          var d = {
            encrypted: !1
          },
              y = null,
              g = c.content.value[0];

          switch (e.derToOid(c.contentType)) {
            case r.oids.data:
              if (g.tagClass !== e.Class.UNIVERSAL || g.type !== e.Type.OCTETSTRING) throw new Error("PKCS#12 SafeContents Data is not an OCTET STRING.");
              y = f(g).value;
              break;

            case r.oids.encryptedData:
              y = l(g, o), d.encrypted = !0;
              break;

            default:
              var v;
              throw (v = new Error("Unsupported PKCS#12 contentType.")).contentType = e.derToOid(c.contentType), v;
          }

          d.safeBags = p(y, a, o), t.safeContents.push(d);
        }
      }(y, g.value, o, s), y;
    }, n.toPkcs12Asn1 = function (t, i, a, o) {
      (o = o || {}).saltSize = o.saltSize || 8, o.count = o.count || 2048, o.algorithm = o.algorithm || o.encAlgorithm || "aes128", "useMac" in o || (o.useMac = !0), "localKeyId" in o || (o.localKeyId = null), "generateLocalKeyId" in o || (o.generateLocalKeyId = !0);
      var s,
          u = o.localKeyId;
      if (null !== u) u = h.util.hexToBytes(u);else if (o.generateLocalKeyId) if (i) {
        var c = h.util.isArray(i) ? i[0] : i;
        "string" == typeof c && (c = r.certificateFromPem(c)), (w = h.md.sha1.create()).update(e.toDer(r.certificateToAsn1(c)).getBytes()), u = w.digest().getBytes();
      } else u = h.random.getBytes(20);
      var f = [];
      null !== u && f.push(e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.oids.localKeyId).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.SET, !0, [e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, u)])])), "friendlyName" in o && f.push(e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.oids.friendlyName).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.SET, !0, [e.create(e.Class.UNIVERSAL, e.Type.BMPSTRING, !1, o.friendlyName)])])), f.length > 0 && (s = e.create(e.Class.UNIVERSAL, e.Type.SET, !0, f));
      var l = [],
          p = [];
      null !== i && (p = h.util.isArray(i) ? i : [i]);

      for (var d = [], y = 0; y < p.length; ++y) {
        "string" == typeof (i = p[y]) && (i = r.certificateFromPem(i));
        var g = 0 === y ? s : void 0,
            v = r.certificateToAsn1(i),
            m = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.oids.certBag).getBytes()), e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.oids.x509Certificate).getBytes()), e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, e.toDer(v).getBytes())])])]), g]);
        d.push(m);
      }

      if (d.length > 0) {
        var E = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, d),
            C = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.oids.data).getBytes()), e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, e.toDer(E).getBytes())])]);
        l.push(C);
      }

      var S = null;

      if (null !== t) {
        var b = r.wrapRsaPrivateKey(r.privateKeyToAsn1(t));
        S = null === a ? e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.oids.keyBag).getBytes()), e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [b]), s]) : e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.oids.pkcs8ShroudedKeyBag).getBytes()), e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [r.encryptPrivateKeyInfo(b, a, o)]), s]);
        var T = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [S]),
            A = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.oids.data).getBytes()), e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, e.toDer(T).getBytes())])]);
        l.push(A);
      }

      var I,
          B = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, l);

      if (o.useMac) {
        var w = h.md.sha1.create(),
            N = new h.util.ByteBuffer(h.random.getBytes(o.saltSize)),
            k = o.count,
            _ = (t = n.generateKey(a, N, 3, k, 20), h.hmac.create());

        _.start(w, t), _.update(e.toDer(B).getBytes());

        var R = _.getMac();

        I = e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.oids.sha1).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.NULL, !1, "")]), e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, R.getBytes())]), e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, N.getBytes()), e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, e.integerToDer(k).getBytes())]);
      }

      return e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.INTEGER, !1, e.integerToDer(3).getBytes()), e.create(e.Class.UNIVERSAL, e.Type.SEQUENCE, !0, [e.create(e.Class.UNIVERSAL, e.Type.OID, !1, e.oidToDer(r.oids.data).getBytes()), e.create(e.Class.CONTEXT_SPECIFIC, 0, !0, [e.create(e.Class.UNIVERSAL, e.Type.OCTETSTRING, !1, e.toDer(B).getBytes())])]), I]);
    }, n.generateKey = h.pbe.generatePkcs12Key;
  }), i(function (t) {
    var e = h.asn1,
        r = t.exports = h.pki = h.pki || {};
    r.pemToDer = function (t) {
      var e = h.pem.decode(t)[0];
      if (e.procType && "ENCRYPTED" === e.procType.type) throw new Error("Could not convert PEM to DER; PEM is encrypted.");
      return h.util.createBuffer(e.body);
    }, r.privateKeyFromPem = function (t) {
      var n = h.pem.decode(t)[0];

      if ("PRIVATE KEY" !== n.type && "RSA PRIVATE KEY" !== n.type) {
        var i = new Error('Could not convert private key from PEM; PEM header type is not "PRIVATE KEY" or "RSA PRIVATE KEY".');
        throw i.headerType = n.type, i;
      }

      if (n.procType && "ENCRYPTED" === n.procType.type) throw new Error("Could not convert private key from PEM; PEM is encrypted.");
      var a = e.fromDer(n.body);
      return r.privateKeyFromAsn1(a);
    }, r.privateKeyToPem = function (t, n) {
      var i = {
        type: "RSA PRIVATE KEY",
        body: e.toDer(r.privateKeyToAsn1(t)).getBytes()
      };
      return h.pem.encode(i, {
        maxline: n
      });
    }, r.privateKeyInfoToPem = function (t, r) {
      var n = {
        type: "PRIVATE KEY",
        body: e.toDer(t).getBytes()
      };
      return h.pem.encode(n, {
        maxline: r
      });
    };
  }), i(function (t) {
    var e = t.exports = h.sha512 = h.sha512 || {};
    h.md.sha512 = h.md.algorithms.sha512 = e;
    var r = h.sha384 = h.sha512.sha384 = h.sha512.sha384 || {};
    r.create = function () {
      return e.create("SHA-384");
    }, h.md.sha384 = h.md.algorithms.sha384 = r, h.sha512.sha256 = h.sha512.sha256 || {
      create: function create() {
        return e.create("SHA-512/256");
      }
    }, h.md["sha512/256"] = h.md.algorithms["sha512/256"] = h.sha512.sha256, h.sha512.sha224 = h.sha512.sha224 || {
      create: function create() {
        return e.create("SHA-512/224");
      }
    }, h.md["sha512/224"] = h.md.algorithms["sha512/224"] = h.sha512.sha224, e.create = function (t) {
      if (i || (n = String.fromCharCode(128), n += h.util.fillString(String.fromCharCode(0), 128), a = [[1116352408, 3609767458], [1899447441, 602891725], [3049323471, 3964484399], [3921009573, 2173295548], [961987163, 4081628472], [1508970993, 3053834265], [2453635748, 2937671579], [2870763221, 3664609560], [3624381080, 2734883394], [310598401, 1164996542], [607225278, 1323610764], [1426881987, 3590304994], [1925078388, 4068182383], [2162078206, 991336113], [2614888103, 633803317], [3248222580, 3479774868], [3835390401, 2666613458], [4022224774, 944711139], [264347078, 2341262773], [604807628, 2007800933], [770255983, 1495990901], [1249150122, 1856431235], [1555081692, 3175218132], [1996064986, 2198950837], [2554220882, 3999719339], [2821834349, 766784016], [2952996808, 2566594879], [3210313671, 3203337956], [3336571891, 1034457026], [3584528711, 2466948901], [113926993, 3758326383], [338241895, 168717936], [666307205, 1188179964], [773529912, 1546045734], [1294757372, 1522805485], [1396182291, 2643833823], [1695183700, 2343527390], [1986661051, 1014477480], [2177026350, 1206759142], [2456956037, 344077627], [2730485921, 1290863460], [2820302411, 3158454273], [3259730800, 3505952657], [3345764771, 106217008], [3516065817, 3606008344], [3600352804, 1432725776], [4094571909, 1467031594], [275423344, 851169720], [430227734, 3100823752], [506948616, 1363258195], [659060556, 3750685593], [883997877, 3785050280], [958139571, 3318307427], [1322822218, 3812723403], [1537002063, 2003034995], [1747873779, 3602036899], [1955562222, 1575990012], [2024104815, 1125592928], [2227730452, 2716904306], [2361852424, 442776044], [2428436474, 593698344], [2756734187, 3733110249], [3204031479, 2999351573], [3329325298, 3815920427], [3391569614, 3928383900], [3515267271, 566280711], [3940187606, 3454069534], [4118630271, 4000239992], [116418474, 1914138554], [174292421, 2731055270], [289380356, 3203993006], [460393269, 320620315], [685471733, 587496836], [852142971, 1086792851], [1017036298, 365543100], [1126000580, 2618297676], [1288033470, 3409855158], [1501505948, 4234509866], [1607167915, 987167468], [1816402316, 1246189591]], (o = {})["SHA-512"] = [[1779033703, 4089235720], [3144134277, 2227873595], [1013904242, 4271175723], [2773480762, 1595750129], [1359893119, 2917565137], [2600822924, 725511199], [528734635, 4215389547], [1541459225, 327033209]], o["SHA-384"] = [[3418070365, 3238371032], [1654270250, 914150663], [2438529370, 812702999], [355462360, 4144912697], [1731405415, 4290775857], [2394180231, 1750603025], [3675008525, 1694076839], [1203062813, 3204075428]], o["SHA-512/256"] = [[573645204, 4230739756], [2673172387, 3360449730], [596883563, 1867755857], [2520282905, 1497426621], [2519219938, 2827943907], [3193839141, 1401305490], [721525244, 746961066], [246885852, 2177182882]], o["SHA-512/224"] = [[2352822216, 424955298], [1944164710, 2312950998], [502970286, 855612546], [1738396948, 1479516111], [258812777, 2077511080], [2011393907, 79989058], [1067287976, 1780299464], [286451373, 2446758561]], i = !0), void 0 === t && (t = "SHA-512"), !(t in o)) throw new Error("Invalid SHA-512 algorithm: " + t);

      for (var e = o[t], r = null, u = h.util.createBuffer(), c = new Array(80), f = 0; f < 80; ++f) {
        c[f] = new Array(2);
      }

      var l = 64;

      switch (t) {
        case "SHA-384":
          l = 48;
          break;

        case "SHA-512/256":
          l = 32;
          break;

        case "SHA-512/224":
          l = 28;
      }

      var p = {
        algorithm: t.replace("-", "").toLowerCase(),
        blockLength: 128,
        digestLength: l,
        messageLength: 0,
        fullMessageLength: null,
        messageLengthSize: 16,
        start: function start() {
          p.messageLength = 0, p.fullMessageLength = p.messageLength128 = [];

          for (var t = p.messageLengthSize / 4, n = 0; n < t; ++n) {
            p.fullMessageLength.push(0);
          }

          u = h.util.createBuffer(), r = new Array(e.length);

          for (n = 0; n < e.length; ++n) {
            r[n] = e[n].slice(0);
          }

          return p;
        }
      };
      return p.start(), p.update = function (t, e) {
        "utf8" === e && (t = h.util.encodeUtf8(t));
        var n = t.length;
        p.messageLength += n, n = [n / 4294967296 >>> 0, n >>> 0];

        for (var i = p.fullMessageLength.length - 1; i >= 0; --i) {
          p.fullMessageLength[i] += n[1], n[1] = n[0] + (p.fullMessageLength[i] / 4294967296 >>> 0), p.fullMessageLength[i] = p.fullMessageLength[i] >>> 0, n[0] = n[1] / 4294967296 >>> 0;
        }

        return u.putBytes(t), s(r, c, u), (u.read > 2048 || 0 === u.length()) && u.compact(), p;
      }, p.digest = function () {
        var e = h.util.createBuffer();
        e.putBytes(u.bytes());
        var i,
            a = p.fullMessageLength[p.fullMessageLength.length - 1] + p.messageLengthSize & p.blockLength - 1;
        e.putBytes(n.substr(0, p.blockLength - a));

        for (var o = 8 * p.fullMessageLength[0], f = 0; f < p.fullMessageLength.length - 1; ++f) {
          o += (i = 8 * p.fullMessageLength[f + 1]) / 4294967296 >>> 0, e.putInt32(o >>> 0), o = i >>> 0;
        }

        e.putInt32(o);
        var l = new Array(r.length);

        for (f = 0; f < r.length; ++f) {
          l[f] = r[f].slice(0);
        }

        s(l, c, e);
        var d,
            y = h.util.createBuffer();
        d = "SHA-512" === t ? l.length : "SHA-384" === t ? l.length - 2 : l.length - 4;

        for (f = 0; f < d; ++f) {
          y.putInt32(l[f][0]), f === d - 1 && "SHA-512/224" === t || y.putInt32(l[f][1]);
        }

        return y;
      }, p;
    };
    var n = null,
        i = !1,
        a = null,
        o = null;

    function s(t, e, r) {
      for (var n, i, o, s, u, c, f, l, h, p, d, y, g, v, m, E, C, S, b, T, A, I, B, w, N, k, _, R, P, F, L, U, O, D = r.length(); D >= 128;) {
        for (_ = 0; _ < 16; ++_) {
          e[_][0] = r.getInt32() >>> 0, e[_][1] = r.getInt32() >>> 0;
        }

        for (; _ < 80; ++_) {
          n = (((R = (F = e[_ - 2])[0]) >>> 19 | (P = F[1]) << 13) ^ (P >>> 29 | R << 3) ^ R >>> 6) >>> 0, i = ((R << 13 | P >>> 19) ^ (P << 3 | R >>> 29) ^ (R << 26 | P >>> 6)) >>> 0, o = (((R = (U = e[_ - 15])[0]) >>> 1 | (P = U[1]) << 31) ^ (R >>> 8 | P << 24) ^ R >>> 7) >>> 0, s = ((R << 31 | P >>> 1) ^ (R << 24 | P >>> 8) ^ (R << 25 | P >>> 7)) >>> 0, L = e[_ - 7], O = e[_ - 16], P = i + L[1] + s + O[1], e[_][0] = n + L[0] + o + O[0] + (P / 4294967296 >>> 0) >>> 0, e[_][1] = P >>> 0;
        }

        for (d = t[0][0], y = t[0][1], g = t[1][0], v = t[1][1], m = t[2][0], E = t[2][1], C = t[3][0], S = t[3][1], b = t[4][0], T = t[4][1], A = t[5][0], I = t[5][1], B = t[6][0], w = t[6][1], N = t[7][0], k = t[7][1], _ = 0; _ < 80; ++_) {
          f = ((b >>> 14 | T << 18) ^ (b >>> 18 | T << 14) ^ (T >>> 9 | b << 23)) >>> 0, l = (B ^ b & (A ^ B)) >>> 0, u = ((d >>> 28 | y << 4) ^ (y >>> 2 | d << 30) ^ (y >>> 7 | d << 25)) >>> 0, c = ((d << 4 | y >>> 28) ^ (y << 30 | d >>> 2) ^ (y << 25 | d >>> 7)) >>> 0, h = (d & g | m & (d ^ g)) >>> 0, p = (y & v | E & (y ^ v)) >>> 0, P = k + (((b << 18 | T >>> 14) ^ (b << 14 | T >>> 18) ^ (T << 23 | b >>> 9)) >>> 0) + ((w ^ T & (I ^ w)) >>> 0) + a[_][1] + e[_][1], n = N + f + l + a[_][0] + e[_][0] + (P / 4294967296 >>> 0) >>> 0, i = P >>> 0, o = u + h + ((P = c + p) / 4294967296 >>> 0) >>> 0, s = P >>> 0, N = B, k = w, B = A, w = I, A = b, I = T, b = C + n + ((P = S + i) / 4294967296 >>> 0) >>> 0, T = P >>> 0, C = m, S = E, m = g, E = v, g = d, v = y, d = n + o + ((P = i + s) / 4294967296 >>> 0) >>> 0, y = P >>> 0;
        }

        P = t[0][1] + y, t[0][0] = t[0][0] + d + (P / 4294967296 >>> 0) >>> 0, t[0][1] = P >>> 0, P = t[1][1] + v, t[1][0] = t[1][0] + g + (P / 4294967296 >>> 0) >>> 0, t[1][1] = P >>> 0, P = t[2][1] + E, t[2][0] = t[2][0] + m + (P / 4294967296 >>> 0) >>> 0, t[2][1] = P >>> 0, P = t[3][1] + S, t[3][0] = t[3][0] + C + (P / 4294967296 >>> 0) >>> 0, t[3][1] = P >>> 0, P = t[4][1] + T, t[4][0] = t[4][0] + b + (P / 4294967296 >>> 0) >>> 0, t[4][1] = P >>> 0, P = t[5][1] + I, t[5][0] = t[5][0] + A + (P / 4294967296 >>> 0) >>> 0, t[5][1] = P >>> 0, P = t[6][1] + w, t[6][0] = t[6][0] + B + (P / 4294967296 >>> 0) >>> 0, t[6][1] = P >>> 0, P = t[7][1] + k, t[7][0] = t[7][0] + N + (P / 4294967296 >>> 0) >>> 0, t[7][1] = P >>> 0, D -= 128;
      }
    }
  });

  function Xt(t) {
    t = t || {}, this.name = "", this.cipher = t.cipher, this.blockSize = t.blockSize || 16, this._blocks = this.blockSize / 4, this._inBlock = new Array(this._blocks), this._outBlock = new Array(this._blocks);
  }

  Xt.prototype.start = function () {}, Xt.prototype.encrypt = function (t, e, r) {
    if (t.length() < this.blockSize && !(r && t.length() > 0)) return !0;
    var n;

    for (n = 0; n < this._blocks; ++n) {
      this._inBlock[n] = t.getInt32();
    }

    for (this.cipher.encrypt(this._inBlock, this._outBlock), n = 0; n < this._blocks; ++n) {
      e.putInt32(this._outBlock[n]);
    }
  }, Xt.prototype.decrypt = function (t, e, r) {
    if (t.length() < this.blockSize && !(r && t.length() > 0)) return !0;
    var n;

    for (n = 0; n < this._blocks; ++n) {
      this._inBlock[n] = t.getInt32();
    }

    for (this.cipher.decrypt(this._inBlock, this._outBlock), n = 0; n < this._blocks; ++n) {
      e.putInt32(this._outBlock[n]);
    }
  }, Qt = Xt, Wt = function Wt() {
    return new h.aes.Algorithm("AES", Qt);
  }, h.cipher.registerAlgorithm("AES", Wt);
  var Yt = h,
      Zt = i(function (t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      var e = t.length,
          r = e % 4;
      if (!r) return t;
      var n = e,
          i = 4 - r,
          a = e + i,
          o = Buffer.alloc(a);

      for (o.write(t); i--;) {
        o.write("=", n++);
      }

      return o.toString();
    };
  });
  n(Zt);
  var Jt = i(function (t, e) {
    function r(t, e) {
      return void 0 === e && (e = "utf8"), Buffer.isBuffer(t) ? i(t.toString("base64")) : i(Buffer.from(t, e).toString("base64"));
    }

    function n(t) {
      return t = t.toString(), Zt.default(t).replace(/\-/g, "+").replace(/_/g, "/");
    }

    function i(t) {
      return t.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var a = r;
    a.encode = r, a.decode = function (t, e) {
      return void 0 === e && (e = "utf8"), Buffer.from(n(t), "base64").toString(e);
    }, a.toBase64 = n, a.fromBase64 = i, a.toBuffer = function (t) {
      return Buffer.from(n(t), "base64");
    }, e.default = a;
  });
  n(Jt);
  var $t,
      te = i(function (t) {
    t.exports = Jt.default, t.exports.default = t.exports;
  }),
      ee = {
    encode: function encode(t, e) {
      return t instanceof ArrayBuffer && (t = new Uint8Array(t)), Buffer.isBuffer(t) || (t = Buffer.from(t, e)), te.encode(t);
    },
    decode: te.toBuffer
  },
      re = i(function (t, e) {
    var r = e;
    r.encode = function (t) {
      var e = encodeURIComponent(t || "");
      return e = e.replace(/%([0-9a-fA-F]{2})/g, function (t, e) {
        return e = parseInt(e, 16), String.fromCharCode(e);
      });
    }, r.decode = function (t) {
      var e = (t || "").replace(/[\u0080-\u00ff]/g, function (t) {
        return "%" + (256 | t.charCodeAt(0)).toString(16).substring(1);
      });
      return e = decodeURIComponent(e);
    };
  });

  for (var ne = $t = {
    base64url: ee,
    utf8: re,
    asBuffer: function asBuffer(t, e) {
      return Buffer.isBuffer(t) ? t : "string" == typeof t ? "base64url" === (e = e || "binary") ? $t.base64url.decode(t) : Buffer.from(t, e) : (Yt.util.isArrayBufferView(t) ? t = t instanceof Uint8Array ? t : new Uint8Array(t.buffer, t.byteOffset, t.byteOffset + t.byteLength) : Yt.util.isArrayBuffer(t) && (t = new Uint8Array(t)), Buffer.from(t));
    },
    randomBytes: function randomBytes(t) {
      return Buffer.from(Yt.random.getBytes(t), "binary");
    }
  }, ie = function ie() {
    return t.randomBytes(16);
  }, ae = [], oe = 0; oe < 256; ++oe) {
    ae[oe] = (oe + 256).toString(16).substr(1);
  }

  var se,
      ue,
      ce = function ce(t, e) {
    var r = e || 0,
        n = ae;
    return [n[t[r++]], n[t[r++]], n[t[r++]], n[t[r++]], "-", n[t[r++]], n[t[r++]], "-", n[t[r++]], n[t[r++]], "-", n[t[r++]], n[t[r++]], "-", n[t[r++]], n[t[r++]], n[t[r++]], n[t[r++]], n[t[r++]], n[t[r++]]].join("");
  },
      fe = 0,
      le = 0;

  var he = function he(t, e, r) {
    var n = e && r || 0,
        i = e || [],
        a = (t = t || {}).node || se,
        o = void 0 !== t.clockseq ? t.clockseq : ue;

    if (null == a || null == o) {
      var s = ie();
      null == a && (a = se = [1 | s[0], s[1], s[2], s[3], s[4], s[5]]), null == o && (o = ue = 16383 & (s[6] << 8 | s[7]));
    }

    var u = void 0 !== t.msecs ? t.msecs : new Date().getTime(),
        c = void 0 !== t.nsecs ? t.nsecs : le + 1,
        f = u - fe + (c - le) / 1e4;
    if (f < 0 && void 0 === t.clockseq && (o = o + 1 & 16383), (f < 0 || u > fe) && void 0 === t.nsecs && (c = 0), c >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    fe = u, le = c, ue = o;
    var l = (1e4 * (268435455 & (u += 122192928e5)) + c) % 4294967296;
    i[n++] = l >>> 24 & 255, i[n++] = l >>> 16 & 255, i[n++] = l >>> 8 & 255, i[n++] = 255 & l;
    var h = u / 4294967296 * 1e4 & 268435455;
    i[n++] = h >>> 8 & 255, i[n++] = 255 & h, i[n++] = h >>> 24 & 15 | 16, i[n++] = h >>> 16 & 255, i[n++] = o >>> 8 | 128, i[n++] = 255 & o;

    for (var p = 0; p < 6; ++p) {
      i[n + p] = a[p];
    }

    return e || ce(i);
  };

  var pe = function pe(t, e, r) {
    var n = e && r || 0;
    "string" == typeof t && (e = "binary" === t ? new Array(16) : null, t = null);
    var i = (t = t || {}).random || (t.rng || ie)();
    if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, e) for (var a = 0; a < 16; ++a) {
      e[n + a] = i[a];
    }
    return e || ce(i);
  },
      de = pe;

  de.v1 = he, de.v4 = pe;
  var ye = de,
      ge = i(function (e, r) {
    "undefined" == typeof Promise && o.polyfill(), r.int32ToBuffer = function (t, e) {
      return (e = e || Buffer.alloc(4))[0] = t >>> 24 & 255, e[1] = t >>> 16 & 255, e[2] = t >>> 8 & 255, e[3] = 255 & t, e;
    };
    var n = Math.pow(2, 32);

    r.int64ToBuffer = function (t, e) {
      e = e || Buffer.alloc(8);
      var i = Math.floor(t / n),
          a = t % n;
      return i = r.int32ToBuffer(i), a = r.int32ToBuffer(a), e = Buffer.concat([i, a]);
    };

    var i = {};
    Object.defineProperty(r, "subtleCrypto", {
      get: function get() {
        return "subtleCrypto" in i ? i.subtleCrypto : i.subtleCrypto = function () {
          if ("undefined" != typeof crypto && void 0 !== crypto.subtle) return crypto.subtle;
        }();
      },
      enumerable: !0
    }), Object.defineProperty(r, "nodeCrypto", {
      get: function get() {
        return "nodeCrypto" in i ? i.nodeCrypto : i.nodeCrypto = function () {
          var e;

          try {
            e = t;
          } catch (t) {
            return;
          }

          if (Object.keys(e).length) return e;
        }();
      },
      enumerable: !0
    }), r.setupFallback = function (t, e, n) {
      return t && r.nodeCrypto ? function () {
        var e,
            r = arguments;

        function i(t) {
          return 0 === t.message.indexOf("unsupported algorithm:") ? n.apply(null, r) : Promise.reject(t);
        }

        try {
          e = Promise.resolve(t.apply(null, r));
        } catch (t) {
          e = i(t);
        }

        return e;
      } : e && r.subtleCrypto ? function () {
        var t,
            r = arguments;

        function i(t) {
          return t.code !== DOMException.NOT_SUPPORTED_ERR && "Only ArrayBuffer and ArrayBufferView objects can be passed as CryptoOperationData" !== t.message && t instanceof Error ? Promise.reject(t) : n.apply(null, r);
        }

        try {
          t = (t = e.apply(null, r)).catch(i);
        } catch (e) {
          t = i(e);
        }

        return t;
      } : n;
    };
  }),
      ve = (ge.int32ToBuffer, ge.int64ToBuffer, ge.setupFallback, {
    CHUNK_SIZE: 1024,
    HASHLENGTH: {
      "SHA-1": 160,
      "SHA-256": 256,
      "SHA-384": 384,
      "SHA-512": 512
    },
    ENCLENGTH: {
      "AES-128-CBC": 128,
      "AES-192-CBC": 192,
      "AES-256-CBC": 256,
      "AES-128-KW": 128,
      "AES-192-KW": 192,
      "AES-256-KW": 256
    },
    KEYLENGTH: {
      "A128CBC-HS256": 256,
      "A192CBC-HS384": 384,
      "A256CBC-HS512": 512,
      "A128CBC+HS256": 256,
      "A192CBC+HS384": 384,
      "A256CBC+HS512": 512,
      A128GCM: 128,
      A192GCM: 192,
      A256GCM: 256,
      A128KW: 128,
      A192KW: 192,
      A256KW: 256,
      "ECDH-ES+A128KW": 128,
      "ECDH-ES+A192KW": 192,
      "ECDH-ES+A256KW": 256
    },
    NONCELENGTH: {
      "A128CBC-HS256": 128,
      "A192CBC-HS384": 128,
      "A256CBC-HS512": 128,
      "A128CBC+HS256": 128,
      "A192CBC+HS384": 128,
      "A256CBC+HS512": 128,
      A128GCM: 96,
      A192GCM: 96,
      A256GCM: 96
    }
  });

  function me(t, e) {
    e = e || {}, Buffer.isBuffer(t) ? this.data = t : Yt.util.isArrayBuffer(t) ? (t = new Uint8Array(t), this.data = Buffer.from(t)) : Yt.util.isArrayBufferView(t) && (t = new Uint8Array(t.buffer, t.byteOffset, t.byteLength), this.data = Buffer.from(t)), this.data && (this.write = this.data.length, t = void 0), this.growSize = e.growSize || me.DEFAULT_GROW_SIZE, this.write = this.write || 0, this.read = this.read || 0, t ? this.putBytes(t) : this.data || this.accommodate(0), e.readOffset = "readOffset" in e ? e.readOffset : this.read, this.write = "writeOffset" in e ? e.writeOffset : this.write, this.read = Math.min(e.readOffset, this.write);
  }

  me.DEFAULT_GROW_SIZE = 16, me.prototype.length = function () {
    return this.write - this.read;
  }, me.prototype.available = function () {
    return this.data.length - this.write;
  }, me.prototype.isEmpty = function () {
    return this.length() <= 0;
  }, me.prototype.accommodate = function (t) {
    if (this.data) {
      if (this.available() < t) {
        t = Math.max(t, this.growSize);
        var e = this.data,
            r = Buffer.alloc(e.length + t);
        e.copy(r, 0), this.data = r;
      }
    } else t = Math.max(this.write + t, this.growSize), this.data = Buffer.alloc(t);

    return this.data.fill(0, this.write), this;
  }, me.prototype.clear = function () {
    return this.read = this.write = 0, this.data = Buffer.alloc(0), this;
  }, me.prototype.truncate = function (t) {
    return this.write = this.read + Math.max(0, this.length() - t), this.data.fill(0, this.write), this;
  }, me.prototype.compact = function () {
    return this.read > 0 && (this.write === this.read ? this.read = this.write = 0 : (this.data.copy(this.data, 0, this.read, this.write), this.write = this.write - this.read, this.read = 0), this.data.fill(0, this.write)), this;
  }, me.prototype.copy = function () {
    return new me(this, {
      readOffset: this.read,
      writeOffset: this.write,
      growSize: this.growSize
    });
  }, me.prototype.equals = function (t) {
    if (!me.isBuffer(t)) return !1;
    if (t.length() !== this.length()) return !1;

    for (var e = !0, r = this.read - t.read, n = t.read; t.write > n; n++) {
      e = e && this.data[n + r] === t.data[n];
    }

    return e;
  }, me.prototype.at = function (t) {
    return this.data[this.read + t];
  }, me.prototype.setAt = function (t, e) {
    return this.data[this.read + t] = e, this;
  }, me.prototype.last = function () {
    return this.data[this.write - 1];
  }, me.prototype.bytes = function (t) {
    var e;
    if (void 0 === t ? t = this.length() : t && (t = Math.min(t, this.length())), 0 === t) e = "";else {
      var r = this.read,
          n = r + t,
          i = this.data.slice(r, n);
      e = String.fromCharCode.apply(null, i);
    }
    return e;
  }, me.prototype.buffer = function (t) {
    var e;
    if (void 0 === t ? t = this.length() : t && (t = Math.min(t, this.length())), 0 === t) e = new ArrayBuffer(0);else {
      var r = this.read,
          n = r + t,
          i = this.data.slice(r, n);
      (e = new Uint8Array(n - r)).set(i);
    }
    return e;
  }, me.prototype.native = function (t) {
    var e;
    if (void 0 === t ? t = this.length() : t && (t = Math.min(t, this.length())), 0 === t) e = Buffer.alloc(0);else {
      var r = this.read,
          n = r + t;
      e = this.data.slice(r, n);
    }
    return e;
  }, me.prototype.toHex = function () {
    return this.toString("hex");
  }, me.prototype.toString = function (t) {
    if (0 === this.length()) return "";
    var e = this.data.slice(this.read, this.write);

    switch (t = t || "utf8") {
      case "raw":
        return e.toString("binary");

      case "base64url":
        return ee.encode(e);

      case "utf16":
        return e.toString("ucs2");

      default:
        return e.toString(t);
    }
  }, me.prototype.fillWithByte = function (t, e) {
    return e || (e = this.available()), this.accommodate(e), this.data.fill(t, this.write, this.write + e), this.write += e, this;
  }, me.prototype.getBuffer = function (t) {
    var e = this.buffer(t);
    return this.read += e.byteLength, e;
  }, me.prototype.putBuffer = function (t) {
    return this.putBytes(t);
  }, me.prototype.getBytes = function (t) {
    var e = this.bytes(t);
    return this.read += e.length, e;
  }, me.prototype.putBytes = function (t, e) {
    if ("string" == typeof t) {
      switch (e = e || "binary") {
        case "utf16":
          e = "ucs-2";
          break;

        case "raw":
          e = "binary";
          break;

        case "base64url":
          t = ee.decode(t);
      }

      Buffer.isBuffer(t) || (t = Buffer.from(t, e));
    }

    var r, n;

    if (t instanceof me) {
      var i = t;
      t = i.data.slice(i.read, i.write), i.read = i.write;
    } else t instanceof Yt.util.ByteStringBuffer && (t = t.getBytes());

    if (Buffer.isBuffer(t)) r = t;else if (Array.isArray(t)) r = Buffer.from(t);else if (Yt.util.isArrayBuffer(t)) r = new Uint8Array(t), r = Buffer.from(r);else {
      if (!Yt.util.isArrayBufferView(t)) throw new TypeError("invalid source type");
      r = t instanceof Uint8Array ? t : new Uint8Array(t.buffer, t.byteOffset, t.byteLength), r = Buffer.from(r);
    }
    return this.accommodate(r.length), n = this.data, r.copy(n, this.write), this.write += r.length, this;
  }, me.prototype.getNative = function (t) {
    var e = this.native(t);
    return this.read += e.length, e;
  }, me.prototype.putNative = me.prototype.putBuffer, me.prototype.getByte = function () {
    var t = this.data[this.read];
    return this.read = Math.min(this.read + 1, this.write), t;
  }, me.prototype.putByte = function (t) {
    return this.accommodate(1), this.data[this.write] = 255 & t, this.write++, this;
  }, me.prototype.getInt16 = function () {
    var t = this.data[this.read] << 8 ^ this.data[this.read + 1];
    return this.read = Math.min(this.read + 2, this.write), t;
  }, me.prototype.putInt16 = function (t) {
    return this.accommodate(2), this.data[this.write] = t >>> 8 & 255, this.data[this.write + 1] = 255 & t, this.write += 2, this;
  }, me.prototype.getInt24 = function () {
    var t = this.data[this.read] << 16 ^ this.data[this.read + 1] << 8 ^ this.data[this.read + 2];
    return this.read = Math.min(this.read + 3, this.write), t;
  }, me.prototype.putInt24 = function (t) {
    return this.accommodate(3), this.data[this.write] = t >>> 16 & 255, this.data[this.write + 1] = t >>> 8 & 255, this.data[this.write + 2] = 255 & t, this.write += 3, this;
  }, me.prototype.getInt32 = function () {
    var t = this.data[this.read] << 24 ^ this.data[this.read + 1] << 16 ^ this.data[this.read + 2] << 8 ^ this.data[this.read + 3];
    return this.read = Math.min(this.read + 4, this.write), t;
  }, me.prototype.putInt32 = function (t) {
    return this.accommodate(4), this.data[this.write] = t >>> 24 & 255, this.data[this.write + 1] = t >>> 16 & 255, this.data[this.write + 2] = t >>> 8 & 255, this.data[this.write + 3] = 255 & t, this.write += 4, this;
  }, me.prototype.getInt16Le = function () {
    var t = this.data[this.read + 1] << 8 ^ this.data[this.read];
    return this.read = Math.min(this.read + 2, this.write), t;
  }, me.prototype.putInt16Le = function (t) {
    return this.accommodate(2), this.data[this.write + 1] = t >>> 8 & 255, this.data[this.write] = 255 & t, this.write += 2, this;
  }, me.prototype.getInt24Le = function () {
    var t = this.data[this.read + 2] << 16 ^ this.data[this.read + 1] << 8 ^ this.data[this.read];
    return this.read = Math.min(this.read + 3, this.write), t;
  }, me.prototype.putInt24Le = function (t) {
    return this.accommodate(3), this.data[this.write + 2] = t >>> 16 & 255, this.data[this.write + 1] = t >>> 8 & 255, this.data[this.write] = 255 & t, this.write += 3, this;
  }, me.prototype.getInt32Le = function () {
    var t = this.data[this.read + 3] << 24 ^ this.data[this.read + 2] << 16 ^ this.data[this.read + 1] << 8 ^ this.data[this.read];
    return this.read = Math.min(this.read + 4, this.write), t;
  }, me.prototype.putInt32Le = function (t) {
    return this.accommodate(4), this.data[this.write + 3] = t >>> 24 & 255, this.data[this.write + 2] = t >>> 16 & 255, this.data[this.write + 1] = t >>> 8 & 255, this.data[this.write] = 255 & t, this.write += 4, this;
  }, me.prototype.getInt = function (t) {
    var e = 0;

    do {
      e = e << 8 | this.getByte(), t -= 8;
    } while (t > 0);

    return e;
  }, me.prototype.putInt = function (t, e) {
    this.accommodate(Math.ceil(e / 8));

    do {
      e -= 8, this.putByte(t >> e & 255);
    } while (e > 0);

    return this;
  }, me.prototype.putSignedInt = function (t, e) {
    return t < 0 && (t += 2 << e - 1), this.putInt(t, e);
  }, me.prototype.putString = function (t) {
    return this.putBytes(t, "utf16");
  }, me.isBuffer = function (t) {
    return t instanceof me;
  }, me.asBuffer = function (t) {
    return me.isBuffer(t) ? t : t ? new me(t) : new me();
  };
  var Ee = Yt.util.ByteBuffer = me;

  function Ce(t) {
    var e = t.replace("HS", "SHA").toLowerCase(),
        r = t.replace("HS", "SHA-");

    function n(t, e) {
      return (t = (t || ve.HASHLENGTH[r]) / 8) > e.length ? Promise.reject(new Error("invalid key length")) : Promise.resolve(e);
    }

    return ge.setupFallback(function (t, r, i) {
      return n((i = i || {}).length, t).then(function () {
        var n = ge.nodeCrypto.createHmac(e, t);
        n.update(r);
        var i = n.digest();
        return {
          data: r,
          mac: i
        };
      });
    }, function (t, e, i) {
      var a = {
        name: "HMAC",
        hash: {
          name: r
        }
      };
      return n((i = i || {}).length, t).then(function () {
        return ge.subtleCrypto.importKey("raw", t, a, !0, ["sign"]);
      }).then(function (t) {
        return ge.subtleCrypto.sign(a, t, e);
      }).then(function (t) {
        var r = Buffer.from(t);
        return {
          data: e,
          mac: r
        };
      });
    }, function (t, r, i) {
      return n((i = i || {}).length, t).then(function () {
        var n = Yt.hmac.create();
        return n.start(e, t.toString("binary")), n.update(r), n = n.digest().native(), {
          data: r,
          mac: n
        };
      });
    });
  }

  function Se(t) {
    var e = t.replace("HS", "SHA").toLowerCase(),
        r = t.replace("HS", "SHA-");

    function n(t, e, n) {
      t = (t || ve.HASHLENGTH[r]) / 8;

      for (var i = !0, a = 0; t > a; a++) {
        i = i && e[a] === n[a];
      }

      return i;
    }

    return ge.setupFallback(function (t, r, i, a) {
      a = a || {};
      var o = ge.nodeCrypto.createHmac(e, t);
      o.update(r);
      var s = o.digest();
      if (!n(a.length, i, s)) throw new Error("verification failed");
      return {
        data: r,
        mac: s,
        valid: !0
      };
    }, function (t, e, i, a) {
      var o = {
        name: "HMAC",
        hash: {
          name: r
        }
      };
      return ((a = a || {}).length ? ge.subtleCrypto.importKey("raw", t, o, !0, ["sign"]).then(function (t) {
        return ge.subtleCrypto.sign(o, t, e);
      }).then(function (t) {
        var e = Buffer.from(t);
        return n(a.length, i, e);
      }) : ge.subtleCrypto.importKey("raw", t, o, !0, ["verify"]).then(function (t) {
        return ge.subtleCrypto.verify(o, t, i, e);
      })).then(function (t) {
        return t ? {
          data: e,
          mac: i,
          valid: !0
        } : Promise.reject(new Error("verifaction failed"));
      });
    }, function (t, r, i, a) {
      a = a || {};
      var o = Yt.hmac.create();
      return o.start(e, new Ee(t)), o.update(r), o = o.digest().native(), n(a.length, i, o) ? Promise.resolve({
        data: r,
        mac: i,
        valid: !0
      }) : Promise.reject(new Error("verification failed"));
    });
  }

  var be = {};
  ["HS1", "HS256", "HS384", "HS512"].forEach(function (t) {
    be[t] = {
      sign: Ce(t),
      verify: Se(t)
    };
  });
  var Te = be;

  function Ae(t) {
    var e = t.replace("SHA-", "SHA").toLowerCase(),
        r = {
      name: t
    };
    return ge.setupFallback(function (t) {
      var r = ge.nodeCrypto.createHash(e);
      return r.update(t), r.digest();
    }, function (t) {
      return ge.subtleCrypto.digest(r, t).then(function (t) {
        return t = Buffer.from(t);
      });
    }, function (t) {
      var r = Yt.md[e].create();
      return r.update(t), r = r.digest().native(), Promise.resolve(r);
    });
  }

  var Ie = {};
  ["SHA-1", "SHA-256", "SHA-384", "SHA-512"].forEach(function (t) {
    Ie[t] = {
      digest: Ae(t)
    };
  });
  var Be = Ie;

  function we(t) {
    if (16 !== t.length) throw new Error("invalid iv");
  }

  function Ne(t) {
    return ge.setupFallback(function (e, r, n) {
      try {
        we(n);
      } catch (t) {
        return Promise.reject(t);
      }

      var i = Promise.resolve(r);
      return i = i.then(function (r) {
        var i = "AES-" + t + "-CBC",
            a = ge.nodeCrypto.createCipheriv(i, e, n);
        return Buffer.concat([a.update(r), a.final()]);
      });
    }, function (t, e, r) {
      try {
        we(r);
      } catch (t) {
        return Promise.reject(t);
      }

      var n = Promise.resolve();
      return n = (n = (n = n.then(function () {
        return ge.subtleCrypto.importKey("raw", t, {
          name: "AES-CBC"
        }, !0, ["encrypt"]);
      })).then(function (t) {
        var n = {
          name: "AES-CBC",
          iv: r
        };
        return ge.subtleCrypto.encrypt(n, t, e);
      })).then(function (t) {
        return t = Buffer.from(t);
      });
    }, function (t, e, r) {
      try {
        we(r);
      } catch (t) {
        return Promise.reject(t);
      }

      var n = Promise.resolve();
      return n = n.then(function () {
        var n = Yt.cipher.createCipher("AES-CBC", new Ee(t));
        return n.start({
          iv: new Ee(r)
        }), n.update(new Ee(e)), n.finish() ? n.output.native() : Promise.reject(new Error("encryption failed"));
      });
    });
  }

  function ke(t) {
    return ge.setupFallback(function (e, r, n) {
      try {
        we(n);
      } catch (t) {
        return Promise.reject(t);
      }

      var i = Promise.resolve();
      return i = i.then(function () {
        var i = "AES-" + t + "-CBC",
            a = ge.nodeCrypto.createDecipheriv(i, e, n);
        return Buffer.concat([a.update(r), a.final()]);
      });
    }, function (t, e, r) {
      try {
        we(r);
      } catch (t) {
        return Promise.reject(t);
      }

      var n = Promise.resolve();
      return n = (n = (n = n.then(function () {
        return ge.subtleCrypto.importKey("raw", t, {
          name: "AES-CBC"
        }, !0, ["decrypt"]);
      })).then(function (t) {
        var n = {
          name: "AES-CBC",
          iv: r
        };
        return ge.subtleCrypto.decrypt(n, t, e);
      })).then(function (t) {
        return t = Buffer.from(t);
      });
    }, function (t, e, r) {
      try {
        we(r);
      } catch (t) {
        return Promise.reject(t);
      }

      var n = Promise.resolve();
      return n = n.then(function () {
        var n = Yt.cipher.createDecipher("AES-CBC", new Ee(t));
        return n.start({
          iv: new Ee(r)
        }), n.update(new Ee(e)), n.finish() ? n.output.native() : Promise.reject(new Error("encryption failed"));
      });
    });
  }

  function _e(t, e) {
    if (e << 1 != t.length << 3) throw new Error("invalid encryption key size");
  }

  function Re(t) {
    var e = Ne(t);
    return function (r, n, i) {
      try {
        _e(r, t);
      } catch (t) {
        return Promise.reject(t);
      }

      var a = r.slice(t / 8),
          o = r.slice(0, t / 8),
          s = i.iv || Buffer.alloc(0),
          u = i.aad || i.adata || Buffer.alloc(0),
          c = e(a, n, s);
      return c = c.then(function (e) {
        var r = Buffer.concat([u, s, e, ge.int64ToBuffer(8 * u.length)]);
        return Te["HS" + 2 * t].sign(o, r, {
          length: t
        }).then(function (r) {
          var n = r.mac.slice(0, t / 8);
          return {
            data: e,
            tag: n
          };
        });
      });
    };
  }

  function Pe(t) {
    var e = ke(t);
    return function (r, n, i) {
      try {
        _e(r, t);
      } catch (t) {
        return Promise.reject(t);
      }

      var a = r.slice(t / 8),
          o = r.slice(0, t / 8),
          s = i.iv || Buffer.alloc(0),
          u = i.aad || i.adata || Buffer.alloc(0),
          c = i.tag || i.mac || Buffer.alloc(0),
          f = Promise.resolve();
      return f = (f = f.then(function () {
        var e = Buffer.concat([u, s, n, ge.int64ToBuffer(8 * u.length)]);
        return Te["HS" + 2 * t].verify(o, e, c, {
          length: t
        }).then(function () {
          return n;
        }, function () {
          throw new Error("mac check failed");
        });
      })).then(function () {
        return e(a, n, s);
      });
    };
  }

  var Fe = Buffer.from("Encryption", "utf8"),
      Le = Buffer.from("Integrity", "utf8"),
      Ue = Buffer.from(".", "utf8");

  function Oe(t, e, r, n) {
    var i = 8 * t.length,
        a = i / 2,
        o = Promise.resolve();
    return o = (o = o.then(function () {
      return Buffer.concat([ge.int32ToBuffer(1), t, ge.int32ToBuffer(a), Buffer.from(e, "utf8"), r, n, Fe]);
    })).then(function (t) {
      return Be["SHA-" + i].digest(t).then(function (t) {
        return t.slice(0, a / 8);
      });
    }), o = Promise.resolve(o);
  }

  function De(t, e, r, n) {
    var i = 8 * t.length,
        a = i,
        o = Promise.resolve();
    return o = (o = o.then(function () {
      return Buffer.concat([ge.int32ToBuffer(1), t, ge.int32ToBuffer(a), Buffer.from(e, "utf8"), r, n, Le]);
    })).then(function (t) {
      return Be["SHA-" + i].digest(t).then(function (t) {
        return t.slice(0, a / 8);
      });
    }), o = Promise.resolve(o);
  }

  function Ke(t, e) {
    var r = Ne(t);
    return function (n, i, a) {
      var o,
          s,
          u = a.epu || ge.int32ToBuffer(0),
          c = a.epv || ge.int32ToBuffer(0),
          f = a.iv || Buffer.alloc(0),
          l = a.aad || a.adata || Buffer.alloc(0),
          h = a.kdata || Buffer.alloc(0),
          p = [Oe(n, e, u, c), De(n, e, u, c)],
          d = Promise.all(p).then(function (t) {
        o = t[0], s = t[1];
      });
      return d = (d = (d = d.then(function () {
        return r(o, i, f);
      })).then(function (e) {
        var r = Buffer.concat([l, Ue, Buffer.from(h), Ue, Buffer.from(ne.base64url.encode(f), "utf8"), Ue, Buffer.from(ne.base64url.encode(e), "utf8")]);
        return Promise.all([Promise.resolve(e), Te["HS" + 2 * t].sign(s, r, {
          length: t
        })]);
      })).then(function (t) {
        return {
          data: t[0],
          tag: t[1].mac
        };
      });
    };
  }

  function Ve(t, e) {
    var r = ke(t);
    return function (n, i, a) {
      var o,
          s,
          u = a.epu || ge.int32ToBuffer(0),
          c = a.epv || ge.int32ToBuffer(0),
          f = a.iv || Buffer.alloc(0),
          l = a.aad || a.adata || Buffer.alloc(0),
          h = a.kdata || Buffer.alloc(0),
          p = a.tag || a.mac || Buffer.alloc(0),
          d = [Oe(n, e, u, c), De(n, e, u, c)],
          y = Promise.all(d).then(function (t) {
        o = t[0], s = t[1];
      });
      return y = (y = y.then(function () {
        var e = Buffer.concat([l, Ue, Buffer.from(h), Ue, Buffer.from(ne.base64url.encode(f), "utf8"), Ue, Buffer.from(ne.base64url.encode(i), "utf8")]);

        try {
          return Te["HS" + 2 * t].verify(s, e, p, {
            loose: !1
          });
        } catch (t) {
          throw new Error("mac check failed");
        }
      })).then(function () {
        return r(o, i, f);
      });
    };
  }

  var xe = {};
  ["A128CBC-HS256", "A192CBC-HS384", "A256CBC-HS512"].forEach(function (t) {
    var e = parseInt(/A(\d+)CBC-HS(\d+)?/g.exec(t)[1]);
    xe[t] = {
      encrypt: Re(e),
      decrypt: Pe(e)
    };
  }), ["A128CBC+HS256", "A192CBC+HS384", "A256CBC+HS512"].forEach(function (t) {
    var e = parseInt(/A(\d+)CBC\+HS(\d+)?/g.exec(t)[1]);
    xe[t] = {
      encrypt: Ke(e, t),
      decrypt: Ve(e, t)
    };
  });
  var je = xe,
      Me = ze,
      He = null;

  try {
    He = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11])), {}).exports;
  } catch (t) {}

  function ze(t, e, r) {
    this.low = 0 | t, this.high = 0 | e, this.unsigned = !!r;
  }

  function Ge(t) {
    return !0 === (t && t.__isLong__);
  }

  ze.prototype.__isLong__, Object.defineProperty(ze.prototype, "__isLong__", {
    value: !0
  }), ze.isLong = Ge;
  var qe = {},
      We = {};

  function Qe(t, e) {
    var r, n, i;
    return e ? (i = 0 <= (t >>>= 0) && t < 256) && (n = We[t]) ? n : (r = Ye(t, (0 | t) < 0 ? -1 : 0, !0), i && (We[t] = r), r) : (i = -128 <= (t |= 0) && t < 128) && (n = qe[t]) ? n : (r = Ye(t, t < 0 ? -1 : 0, !1), i && (qe[t] = r), r);
  }

  function Xe(t, e) {
    if (isNaN(t)) return e ? ar : ir;

    if (e) {
      if (t < 0) return ar;
      if (t >= er) return fr;
    } else {
      if (t <= -rr) return lr;
      if (t + 1 >= rr) return cr;
    }

    return t < 0 ? Xe(-t, e).neg() : Ye(t % tr | 0, t / tr | 0, e);
  }

  function Ye(t, e, r) {
    return new ze(t, e, r);
  }

  ze.fromInt = Qe, ze.fromNumber = Xe, ze.fromBits = Ye;
  var Ze = Math.pow;

  function Je(t, e, r) {
    if (0 === t.length) throw Error("empty string");
    if ("NaN" === t || "Infinity" === t || "+Infinity" === t || "-Infinity" === t) return ir;
    if ("number" == typeof e ? (r = e, e = !1) : e = !!e, (r = r || 10) < 2 || 36 < r) throw RangeError("radix");
    var n;
    if ((n = t.indexOf("-")) > 0) throw Error("interior hyphen");
    if (0 === n) return Je(t.substring(1), e, r).neg();

    for (var i = Xe(Ze(r, 8)), a = ir, o = 0; o < t.length; o += 8) {
      var s = Math.min(8, t.length - o),
          u = parseInt(t.substring(o, o + s), r);

      if (s < 8) {
        var c = Xe(Ze(r, s));
        a = a.mul(c).add(Xe(u));
      } else a = (a = a.mul(i)).add(Xe(u));
    }

    return a.unsigned = e, a;
  }

  function $e(t, e) {
    return "number" == typeof t ? Xe(t, e) : "string" == typeof t ? Je(t, e) : Ye(t.low, t.high, "boolean" == typeof e ? e : t.unsigned);
  }

  ze.fromString = Je, ze.fromValue = $e;
  var tr = 4294967296,
      er = tr * tr,
      rr = er / 2,
      nr = Qe(1 << 24),
      ir = Qe(0);
  ze.ZERO = ir;
  var ar = Qe(0, !0);
  ze.UZERO = ar;
  var or = Qe(1);
  ze.ONE = or;
  var sr = Qe(1, !0);
  ze.UONE = sr;
  var ur = Qe(-1);
  ze.NEG_ONE = ur;
  var cr = Ye(-1, 2147483647, !1);
  ze.MAX_VALUE = cr;
  var fr = Ye(-1, -1, !0);
  ze.MAX_UNSIGNED_VALUE = fr;
  var lr = Ye(0, -2147483648, !1);
  ze.MIN_VALUE = lr;
  var hr = ze.prototype;
  hr.toInt = function () {
    return this.unsigned ? this.low >>> 0 : this.low;
  }, hr.toNumber = function () {
    return this.unsigned ? (this.high >>> 0) * tr + (this.low >>> 0) : this.high * tr + (this.low >>> 0);
  }, hr.toString = function (t) {
    if ((t = t || 10) < 2 || 36 < t) throw RangeError("radix");
    if (this.isZero()) return "0";

    if (this.isNegative()) {
      if (this.eq(lr)) {
        var e = Xe(t),
            r = this.div(e),
            n = r.mul(e).sub(this);
        return r.toString(t) + n.toInt().toString(t);
      }

      return "-" + this.neg().toString(t);
    }

    for (var i = Xe(Ze(t, 6), this.unsigned), a = this, o = "";;) {
      var s = a.div(i),
          u = (a.sub(s.mul(i)).toInt() >>> 0).toString(t);
      if ((a = s).isZero()) return u + o;

      for (; u.length < 6;) {
        u = "0" + u;
      }

      o = "" + u + o;
    }
  }, hr.getHighBits = function () {
    return this.high;
  }, hr.getHighBitsUnsigned = function () {
    return this.high >>> 0;
  }, hr.getLowBits = function () {
    return this.low;
  }, hr.getLowBitsUnsigned = function () {
    return this.low >>> 0;
  }, hr.getNumBitsAbs = function () {
    if (this.isNegative()) return this.eq(lr) ? 64 : this.neg().getNumBitsAbs();

    for (var t = 0 != this.high ? this.high : this.low, e = 31; e > 0 && 0 == (t & 1 << e); e--) {
      ;
    }

    return 0 != this.high ? e + 33 : e + 1;
  }, hr.isZero = function () {
    return 0 === this.high && 0 === this.low;
  }, hr.eqz = hr.isZero, hr.isNegative = function () {
    return !this.unsigned && this.high < 0;
  }, hr.isPositive = function () {
    return this.unsigned || this.high >= 0;
  }, hr.isOdd = function () {
    return 1 == (1 & this.low);
  }, hr.isEven = function () {
    return 0 == (1 & this.low);
  }, hr.equals = function (t) {
    return Ge(t) || (t = $e(t)), (this.unsigned === t.unsigned || this.high >>> 31 != 1 || t.high >>> 31 != 1) && this.high === t.high && this.low === t.low;
  }, hr.eq = hr.equals, hr.notEquals = function (t) {
    return !this.eq(t);
  }, hr.neq = hr.notEquals, hr.ne = hr.notEquals, hr.lessThan = function (t) {
    return this.comp(t) < 0;
  }, hr.lt = hr.lessThan, hr.lessThanOrEqual = function (t) {
    return this.comp(t) <= 0;
  }, hr.lte = hr.lessThanOrEqual, hr.le = hr.lessThanOrEqual, hr.greaterThan = function (t) {
    return this.comp(t) > 0;
  }, hr.gt = hr.greaterThan, hr.greaterThanOrEqual = function (t) {
    return this.comp(t) >= 0;
  }, hr.gte = hr.greaterThanOrEqual, hr.ge = hr.greaterThanOrEqual, hr.compare = function (t) {
    if (Ge(t) || (t = $e(t)), this.eq(t)) return 0;
    var e = this.isNegative(),
        r = t.isNegative();
    return e && !r ? -1 : !e && r ? 1 : this.unsigned ? t.high >>> 0 > this.high >>> 0 || t.high === this.high && t.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(t).isNegative() ? -1 : 1;
  }, hr.comp = hr.compare, hr.negate = function () {
    return !this.unsigned && this.eq(lr) ? lr : this.not().add(or);
  }, hr.neg = hr.negate, hr.add = function (t) {
    Ge(t) || (t = $e(t));
    var e = this.high >>> 16,
        r = 65535 & this.high,
        n = this.low >>> 16,
        i = 65535 & this.low,
        a = t.high >>> 16,
        o = 65535 & t.high,
        s = t.low >>> 16,
        u = 0,
        c = 0,
        f = 0,
        l = 0;
    return f += (l += i + (65535 & t.low)) >>> 16, c += (f += n + s) >>> 16, u += (c += r + o) >>> 16, u += e + a, Ye((f &= 65535) << 16 | (l &= 65535), (u &= 65535) << 16 | (c &= 65535), this.unsigned);
  }, hr.subtract = function (t) {
    return Ge(t) || (t = $e(t)), this.add(t.neg());
  }, hr.sub = hr.subtract, hr.multiply = function (t) {
    if (this.isZero()) return ir;
    if (Ge(t) || (t = $e(t)), He) return Ye(He.mul(this.low, this.high, t.low, t.high), He.get_high(), this.unsigned);
    if (t.isZero()) return ir;
    if (this.eq(lr)) return t.isOdd() ? lr : ir;
    if (t.eq(lr)) return this.isOdd() ? lr : ir;
    if (this.isNegative()) return t.isNegative() ? this.neg().mul(t.neg()) : this.neg().mul(t).neg();
    if (t.isNegative()) return this.mul(t.neg()).neg();
    if (this.lt(nr) && t.lt(nr)) return Xe(this.toNumber() * t.toNumber(), this.unsigned);
    var e = this.high >>> 16,
        r = 65535 & this.high,
        n = this.low >>> 16,
        i = 65535 & this.low,
        a = t.high >>> 16,
        o = 65535 & t.high,
        s = t.low >>> 16,
        u = 65535 & t.low,
        c = 0,
        f = 0,
        l = 0,
        h = 0;
    return l += (h += i * u) >>> 16, f += (l += n * u) >>> 16, l &= 65535, f += (l += i * s) >>> 16, c += (f += r * u) >>> 16, f &= 65535, c += (f += n * s) >>> 16, f &= 65535, c += (f += i * o) >>> 16, c += e * u + r * s + n * o + i * a, Ye((l &= 65535) << 16 | (h &= 65535), (c &= 65535) << 16 | (f &= 65535), this.unsigned);
  }, hr.mul = hr.multiply, hr.divide = function (t) {
    if (Ge(t) || (t = $e(t)), t.isZero()) throw Error("division by zero");
    var e, r, n;
    if (He) return this.unsigned || -2147483648 !== this.high || -1 !== t.low || -1 !== t.high ? Ye((this.unsigned ? He.div_u : He.div_s)(this.low, this.high, t.low, t.high), He.get_high(), this.unsigned) : this;
    if (this.isZero()) return this.unsigned ? ar : ir;

    if (this.unsigned) {
      if (t.unsigned || (t = t.toUnsigned()), t.gt(this)) return ar;
      if (t.gt(this.shru(1))) return sr;
      n = ar;
    } else {
      if (this.eq(lr)) return t.eq(or) || t.eq(ur) ? lr : t.eq(lr) ? or : (e = this.shr(1).div(t).shl(1)).eq(ir) ? t.isNegative() ? or : ur : (r = this.sub(t.mul(e)), n = e.add(r.div(t)));
      if (t.eq(lr)) return this.unsigned ? ar : ir;
      if (this.isNegative()) return t.isNegative() ? this.neg().div(t.neg()) : this.neg().div(t).neg();
      if (t.isNegative()) return this.div(t.neg()).neg();
      n = ir;
    }

    for (r = this; r.gte(t);) {
      e = Math.max(1, Math.floor(r.toNumber() / t.toNumber()));

      for (var i = Math.ceil(Math.log(e) / Math.LN2), a = i <= 48 ? 1 : Ze(2, i - 48), o = Xe(e), s = o.mul(t); s.isNegative() || s.gt(r);) {
        s = (o = Xe(e -= a, this.unsigned)).mul(t);
      }

      o.isZero() && (o = or), n = n.add(o), r = r.sub(s);
    }

    return n;
  }, hr.div = hr.divide, hr.modulo = function (t) {
    return Ge(t) || (t = $e(t)), He ? Ye((this.unsigned ? He.rem_u : He.rem_s)(this.low, this.high, t.low, t.high), He.get_high(), this.unsigned) : this.sub(this.div(t).mul(t));
  }, hr.mod = hr.modulo, hr.rem = hr.modulo, hr.not = function () {
    return Ye(~this.low, ~this.high, this.unsigned);
  }, hr.and = function (t) {
    return Ge(t) || (t = $e(t)), Ye(this.low & t.low, this.high & t.high, this.unsigned);
  }, hr.or = function (t) {
    return Ge(t) || (t = $e(t)), Ye(this.low | t.low, this.high | t.high, this.unsigned);
  }, hr.xor = function (t) {
    return Ge(t) || (t = $e(t)), Ye(this.low ^ t.low, this.high ^ t.high, this.unsigned);
  }, hr.shiftLeft = function (t) {
    return Ge(t) && (t = t.toInt()), 0 == (t &= 63) ? this : t < 32 ? Ye(this.low << t, this.high << t | this.low >>> 32 - t, this.unsigned) : Ye(0, this.low << t - 32, this.unsigned);
  }, hr.shl = hr.shiftLeft, hr.shiftRight = function (t) {
    return Ge(t) && (t = t.toInt()), 0 == (t &= 63) ? this : t < 32 ? Ye(this.low >>> t | this.high << 32 - t, this.high >> t, this.unsigned) : Ye(this.high >> t - 32, this.high >= 0 ? 0 : -1, this.unsigned);
  }, hr.shr = hr.shiftRight, hr.shiftRightUnsigned = function (t) {
    if (Ge(t) && (t = t.toInt()), 0 === (t &= 63)) return this;
    var e = this.high;
    return t < 32 ? Ye(this.low >>> t | e << 32 - t, e >>> t, this.unsigned) : Ye(32 === t ? e : e >>> t - 32, 0, this.unsigned);
  }, hr.shru = hr.shiftRightUnsigned, hr.shr_u = hr.shiftRightUnsigned, hr.toSigned = function () {
    return this.unsigned ? Ye(this.low, this.high, !1) : this;
  }, hr.toUnsigned = function () {
    return this.unsigned ? this : Ye(this.low, this.high, !0);
  }, hr.toBytes = function (t) {
    return t ? this.toBytesLE() : this.toBytesBE();
  }, hr.toBytesLE = function () {
    var t = this.high,
        e = this.low;
    return [255 & e, e >>> 8 & 255, e >>> 16 & 255, e >>> 24, 255 & t, t >>> 8 & 255, t >>> 16 & 255, t >>> 24];
  }, hr.toBytesBE = function () {
    var t = this.high,
        e = this.low;
    return [t >>> 24, t >>> 16 & 255, t >>> 8 & 255, 255 & t, e >>> 24, e >>> 16 & 255, e >>> 8 & 255, 255 & e];
  }, ze.fromBytes = function (t, e, r) {
    return r ? ze.fromBytesLE(t, e) : ze.fromBytesBE(t, e);
  }, ze.fromBytesLE = function (t, e) {
    return new ze(t[0] | t[1] << 8 | t[2] << 16 | t[3] << 24, t[4] | t[5] << 8 | t[6] << 16 | t[7] << 24, e);
  }, ze.fromBytesBE = function (t, e) {
    return new ze(t[4] << 24 | t[5] << 16 | t[6] << 8 | t[7], t[0] << 24 | t[1] << 16 | t[2] << 8 | t[3], e);
  };
  var pr = i(function (t) {
    var e = t.exports = {
      intToBigEndian: function intToBigEndian(t, r, n) {
        if ("number" == typeof t) switch (arguments.length) {
          case 1:
            r = Buffer.alloc(4), e.intToBigEndian(t, r, 0);
            break;

          case 3:
            r[n] = 255 & t >>> 24, r[++n] = 255 & t >>> 16, r[++n] = 255 & t >>> 8, r[++n] = 255 & t;
            break;

          default:
            throw new TypeError("Expected 1 or 3 arguments.");
        } else switch (arguments.length) {
          case 1:
            r = Buffer.alloc(4 * t.length), e.intToBigEndian(t, r, 0);
            break;

          case 3:
            for (var i = 0; i < t.length; ++i) {
              e.intToBigEndian(t[i], r, n), n += 4;
            }

            break;

          default:
            throw new TypeError("Expected 1 or 3 arguments.");
        }
        return r;
      },
      longToBigEndian: function longToBigEndian(t, r, n) {
        if (Array.isArray(t)) switch (arguments.length) {
          case 1:
            r = Buffer.alloc(8 * t.length), e.longToBigEndian(t, r, 0);
            break;

          case 3:
            for (var i = 0; i < t.length; ++i) {
              e.longToBigEndian(t[i], r, n), n += 8;
            }

            break;

          default:
            throw new TypeError("Expected 1 or 3 arguments.");
        } else switch (arguments.length) {
          case 1:
            r = Buffer.alloc(8), e.longToBigEndian(t, r, 0);
            break;

          case 3:
            var a = t.low,
                o = t.high;
            e.intToBigEndian(o, r, n), e.intToBigEndian(a, r, n + 4);
            break;

          default:
            throw new TypeError("Expected 1 or 3 arguments.");
        }
        return r;
      },
      bigEndianToInt: function bigEndianToInt(t, r, n) {
        switch (arguments.length) {
          case 2:
            var i = t[r] << 24;
            return i |= (255 & t[++r]) << 16, i |= (255 & t[++r]) << 8, i |= 255 & t[++r];

          case 3:
            for (var a = 0; a < n.length; ++a) {
              n[a] = e.bigEndianToInt(t, r), r += 4;
            }

            break;

          default:
            throw new TypeError("Expected 2 or 3 arguments.");
        }
      },
      bigEndianToLong: function bigEndianToLong(t, r, n) {
        switch (arguments.length) {
          case 2:
            var i = e.bigEndianToInt(t, r),
                a = e.bigEndianToInt(t, r + 4),
                o = new Me(a, i);
            return o;

          case 3:
            for (var s = 0; s < n.length; ++s) {
              n[s] = e.bigEndianToLong(t, r), r += 8;
            }

            break;

          default:
            throw new TypeError("Expected 2 or 3 arguments.");
        }
      }
    };
  }),
      dr = (pr.intToBigEndian, pr.longToBigEndian, pr.bigEndianToInt, pr.bigEndianToLong, i(function (t) {
    var e = s.fill,
        r = 3774873600,
        n = new Me(r >> 8);
    var i = t.exports = {
      E1: r,
      E1B: 225,
      E1L: n,
      LOOKUP: function () {
        for (var t = [], e = 0; e < 256; ++e) {
          for (var n = 0, i = 7; i >= 0; --i) {
            0 != (e & 1 << i) && (n ^= r >>> 7 - i);
          }

          t.push(n);
        }

        return t;
      }(),
      arrayCopy: function arrayCopy(t, e, r, n, i) {
        if (e < 0 || n < 0 || i < 0) throw new TypeError("Invalid input.");

        if (r instanceof Uint8Array) {
          if (n >= r.length || n + i > r.length) throw new TypeError("Invalid input.");
          (0 !== e || i < t.length) && (t = t instanceof Uint8Array ? t.subarray(e, e + i) : t.slice(e, e + i)), r.set(t, n);
        } else for (var a = 0; a < i; ++a) {
          r[n + a] = t[e + a];
        }
      },
      arrayEqual: function arrayEqual(t, e) {
        t = t || [], e = e || [];

        for (var r = Math.min(t.length, e.length), n = t.length === e.length, i = 0; i < r; i++) {
          n = n && void 0 !== t[i] && void 0 !== e[i] && t[i] === e[i];
        }

        return n;
      },
      asBytes: function asBytes(t, e) {
        switch (arguments.length) {
          case 1:
            return e = Buffer.alloc(16), pr.intToBigEndian(t, e, 0), e;

          case 2:
            pr.intToBigEndian(t, e, 0);
            break;

          default:
            throw new TypeError("Expected 1 or 2 arguments.");
        }
      },
      asInts: function asInts(t, r) {
        switch (arguments.length) {
          case 1:
            return e(r = [], 0, 0, 4), pr.bigEndianToInt(t, 0, r), r;

          case 2:
            pr.bigEndianToInt(t, 0, r);
            break;

          default:
            throw new TypeError("Expected 1 or 2 arguments.");
        }
      },
      oneAsInts: function oneAsInts() {
        for (var t = [], e = 0; e < 4; ++e) {
          t.push(1 << 31);
        }

        return t;
      },
      shiftRight: function shiftRight(t, e) {
        var r, n;

        switch (arguments.length) {
          case 1:
            return r = t[0], t[0] = r >>> 1, n = r << 31, r = t[1], t[1] = r >>> 1 | n, n = r << 31, r = t[2], t[2] = r >>> 1 | n, n = r << 31, r = t[3], t[3] = r >>> 1 | n, r << 31 & 4294967295;

          case 2:
            return r = t[0], e[0] = r >>> 1, n = r << 31, r = t[1], e[1] = r >>> 1 | n, n = r << 31, r = t[2], e[2] = r >>> 1 | n, n = r << 31, r = t[3], e[3] = r >>> 1 | n, r << 31 & 4294967295;

          default:
            throw new TypeError("Expected 1 or 2 arguments.");
        }
      },
      shiftRightN: function shiftRightN(t, e, r) {
        var n, i, a;

        switch (arguments.length) {
          case 2:
            return i = t[0], n = 32 - e, t[0] = i >>> e, a = i << n, i = t[1], t[1] = i >>> e | a, a = i << n, i = t[2], t[2] = i >>> e | a, a = i << n, i = t[3], t[3] = i >>> e | a, i << n;

          case 3:
            return i = t[0], n = 32 - e, r[0] = i >>> e, a = i << n, i = t[1], r[1] = i >>> e | a, a = i << n, i = t[2], r[2] = i >>> e | a, a = i << n, i = t[3], r[3] = i >>> e | a, i << n;

          default:
            throw new TypeError("Expected 2 or 3 arguments.");
        }
      },
      xor: function xor(t, e, r) {
        switch (arguments.length) {
          case 2:
            t[0] ^= e[0], t[1] ^= e[1], t[2] ^= e[2], t[3] ^= e[3];
            break;

          case 3:
            r[0] = t[0] ^ e[0], r[1] = t[1] ^ e[1], r[2] = t[2] ^ e[2], r[3] = t[3] ^ e[3];
            break;

          default:
            throw new TypeError("Expected 2 or 3 arguments.");
        }
      },
      multiply: function multiply(t, e) {
        for (var r = t.slice(), n = [], a = 0; a < 4; ++a) {
          for (var o = e[a], s = 31; s >= 0; --s) {
            0 != (o & 1 << s) && i.xor(n, r), 0 !== i.shiftRight(r) && (r[0] ^= i.E1);
          }
        }

        i.arrayCopy(n, 0, t, 0, 4);
      },
      multiplyP: function multiplyP(t, e) {
        switch (arguments.length) {
          case 1:
            0 !== i.shiftRight(t) && (t[0] ^= i.E1);
            break;

          case 2:
            0 !== i.shiftRight(t, e) && (e[0] ^= i.E1);
            break;

          default:
            throw new TypeError("Expected 1 or 2 arguments.");
        }
      },
      multiplyP8: function multiplyP8(t, e) {
        var r;

        switch (arguments.length) {
          case 1:
            r = i.shiftRightN(t, 8), t[0] ^= i.LOOKUP[r >>> 24];
            break;

          case 2:
            r = i.shiftRightN(t, 8, e), e[0] ^= i.LOOKUP[r >>> 24];
            break;

          default:
            throw new TypeError("Expected 1 or 2 arguments.");
        }
      }
    };
  }));
  dr.E1, dr.E1B, dr.E1L, dr.LOOKUP, dr.arrayCopy, dr.arrayEqual, dr.asBytes, dr.asInts, dr.oneAsInts, dr.shiftRight, dr.shiftRightN, dr.xor, dr.multiply, dr.multiplyP, dr.multiplyP8;

  function yr() {
    this.H = [], this.M = null;
  }

  yr.prototype.init = function (t) {
    var e, r, n;
    if (null == this.M) for (this.M = [], e = 0; e < 32; ++e) {
      for (this.M[e] = [], r = 0; r < 16; ++r) {
        for (this.M[e][r] = [], n = 0; n < 4; ++n) {
          this.M[e][r][n] = 0;
        }
      }
    } else if (dr.arrayEqual(this.H, t)) return;

    for (this.H = t.slice(), dr.asInts(t, this.M[1][8]), r = 4; r >= 1; r >>= 1) {
      dr.multiplyP(this.M[1][r + r], this.M[1][r]);
    }

    for (dr.multiplyP(this.M[1][1], this.M[0][8]), r = 4; r >= 1; r >>= 1) {
      dr.multiplyP(this.M[0][r + r], this.M[0][r]);
    }

    for (e = 0;;) {
      for (r = 2; r < 16; r += r) {
        for (n = 1; n < r; ++n) {
          dr.xor(this.M[e][r], this.M[e][n], this.M[e][r + n]);
        }
      }

      if (32 == ++e) return;
      if (e > 1) for (r = 8; r > 0; r >>= 1) {
        dr.multiplyP8(this.M[e - 2][r], this.M[e][r]);
      }
    }
  }, yr.prototype.multiplyH = function (t) {
    for (var e = [], r = 15; r >= 0; --r) {
      var n = this.M[r + r][15 & t[r]];
      e[0] ^= n[0], e[1] ^= n[1], e[2] ^= n[2], e[3] ^= n[3], n = this.M[r + r + 1][(240 & t[r]) >>> 4], e[0] ^= n[0], e[1] ^= n[1], e[2] ^= n[2], e[3] ^= n[3];
    }

    pr.intToBigEndian(e, t, 0);
  };
  var gr = {
    "8k": yr
  };
  var vr = {
    encrypt: function encrypt(t, e, r, n, i) {
      var a = new Array(4),
          o = new Array(4);
      pr.bigEndianToInt(e, r, a), t.encrypt(a, o), pr.intToBigEndian(o, n, i);
    }
  };

  function mr(t) {
    t = t || {}, this.name = "GCM", this.cipher = t.cipher, this.blockSize = this.blockSize || 16;
  }

  var Er = function Er(t) {
    var e = new Yt.aes.Algorithm("AES-GCM", mr);
    return e.initialize({
      key: new Ee(t.key)
    }), e.mode.start(t), e.mode;
  },
      Cr = function Cr(t) {
    var e = new Yt.aes.Algorithm("AES-GCM", mr);
    return e.initialize({
      key: new Ee(t.key)
    }), e.mode._decrypt = !0, e.mode.start(t), e.mode;
  };

  function Sr(t, e) {
    function r(r, n) {
      if (t !== r.length << 3) throw new Error("invalid key size");
      if (!n && !e) throw new Error("invalid iv");
      if (n && 12 !== n.length) throw new Error("invalid iv");
    }

    function n(t) {
      if (e) {
        var r = ne.base64url.encode(t.iv),
            n = ne.base64url.encode(t.tag);
        t = {
          data: t.data,
          header: {
            iv: r,
            tag: n
          }
        };
      }

      return t;
    }

    return ge.setupFallback(function (t, e, i) {
      var a = i.iv,
          o = i.aad || i.adata || Buffer.alloc(0);

      try {
        r(t, a);
      } catch (t) {
        return Promise.reject(t);
      }

      a = a || ne.randomBytes(12);
      var s,
          u = "aes-" + 8 * t.length + "-gcm";

      try {
        s = ge.nodeCrypto.createCipheriv(u, t, a);
      } catch (t) {
        throw new Error("unsupported algorithm: " + u);
      }

      if ("function" != typeof s.setAAD) throw new Error("unsupported algorithm: " + u);
      return o.length && s.setAAD(o), n({
        data: Buffer.concat([s.update(e), s.final()]),
        iv: a,
        tag: s.getAuthTag()
      });
    }, function (t, e, i) {
      var a = i.iv,
          o = i.aad || i.adata || Buffer.alloc(0);

      try {
        r(t, a);
      } catch (t) {
        return Promise.reject(t);
      }

      a = a || ne.randomBytes(12);
      var s = {
        name: "AES-GCM"
      };
      return ge.subtleCrypto.importKey("raw", t, s, !0, ["encrypt"]).then(function (t) {
        return s.iv = a, s.tagLength = 128, o.length && (s.additionalData = o), ge.subtleCrypto.encrypt(s, t, e);
      }).then(function (t) {
        var e = t.byteLength - 16,
            r = t.slice(e);
        r = Buffer.from(r);
        var i = t.slice(0, e);
        return n({
          data: i = Buffer.from(i),
          iv: a,
          tag: r
        });
      });
    }, function (t, e, i) {
      var a,
          o,
          s = i.iv,
          u = i.aad || i.adata || Buffer.alloc(0);

      try {
        r(t, s);
      } catch (t) {
        return Promise.reject(t);
      }

      return s = s || ne.randomBytes(12), a = Er({
        key: t,
        iv: s,
        additionalData: u
      }), o = Buffer.alloc(e.length), new Promise(function (t, r) {
        var i = ve.CHUNK_SIZE,
            u = 0,
            c = 0;
        !function f() {
          var l = Math.min(i, e.length - c);
          if (u += a.update(e, c, l, o, u), c += l, e.length > c) setTimeout(f, 0);else if ((u += a.finish(o, u)) === e.length) {
            var h = a.tag;
            t(n({
              data: o,
              iv: s,
              tag: h
            }));
          } else r(new Error("encryption failed"));
        }();
      });
    });
  }

  function br(t) {
    function e(e, r, n) {
      if (t !== e.length << 3) throw new Error("invalid key size");
      if (12 !== r.length) throw new Error("invalid iv");
      if (16 !== n.length) throw new Error("invalid tag length");
    }

    return ge.setupFallback(function (t, r, n) {
      var i = n.aad || n.adata || Buffer.alloc(0),
          a = n.iv || Buffer.alloc(0),
          o = n.tag || n.mac || Buffer.alloc(0);

      try {
        e(t, a, o);
      } catch (t) {
        return Promise.reject(t);
      }

      var s,
          u = "aes-" + 8 * t.length + "-gcm";

      try {
        s = ge.nodeCrypto.createDecipheriv(u, t, a);
      } catch (t) {
        throw new Error("unsupported algorithm: " + u);
      }

      if ("function" != typeof s.setAAD) throw new Error("unsupported algorithm: " + u);
      s.setAuthTag(o), i.length && s.setAAD(i);

      try {
        return Buffer.concat([s.update(r), s.final()]);
      } catch (t) {
        throw new Error("decryption failed");
      }
    }, function (t, r, n) {
      var i = n.aad || n.adata || Buffer.alloc(0),
          a = n.iv || Buffer.alloc(0),
          o = n.tag || n.mac || Buffer.alloc(0);

      try {
        e(t, a, o);
      } catch (t) {
        return Promise.reject(t);
      }

      var s = {
        name: "AES-GCM"
      };
      return ge.subtleCrypto.importKey("raw", t, s, !0, ["decrypt"]).then(function (t) {
        return s.iv = a, s.tagLength = 128, i.length && (s.additionalData = i), r = Buffer.concat([r, o], r.length + o.length), ge.subtleCrypto.decrypt(s, t, r);
      }).then(function (t) {
        return t = Buffer.from(t);
      });
    }, function (t, r, n) {
      var i,
          a,
          o = n.aad || n.adata || Buffer.alloc(0),
          s = n.iv || Buffer.alloc(0),
          u = n.tag || n.mac || Buffer.alloc(0);

      try {
        e(t, s, u);
      } catch (t) {
        return Promise.reject(t);
      }

      return i = Cr({
        key: t,
        iv: s,
        additionalData: o,
        tag: u
      }), a = Buffer.alloc(r.length), new Promise(function (t, e) {
        var n = ve.CHUNK_SIZE,
            o = 0,
            s = 0;
        !function u() {
          var c = Math.min(n, r.length - s);
          if (o += i.update(r, s, c, a, o), s += c, r.length > s) setTimeout(u, 0);else {
            try {
              o += i.finish(a, o);
            } catch (t) {
              return void e(new Error("decryption failed"));
            }

            o === r.length ? t(a) : e(new Error("decryption failed"));
          }
        }();
      });
    });
  }

  mr.prototype.start = function (t) {
    if (this.tag = null, !("iv" in (t = t || {}))) throw new Error("Gcm needs ParametersWithIV or AEADParameters");
    if (this.nonce = t.iv, null == this.nonce || this.nonce.length < 1) throw new Error("IV must be at least 1 byte");
    this.tagLength = 16, "tag" in t && (this.tag = Buffer.from(t.tag));
    var e = this._decrypt ? this.blockSize + this.tagLength : this.blockSize;
    this.bufBlock = Buffer.alloc(e);
    var r = t.multiplier;
    if (null == r && (r = new gr["8k"]()), this.multiplier = r, this.H = this.zeroBlock(), vr.encrypt(this.cipher, this.H, 0, this.H, 0), this.multiplier.init(this.H), this.exp = null, this.J0 = this.zeroBlock(), 12 === this.nonce.length) this.nonce.copy(this.J0, 0, 0, this.nonce.length), this.J0[this.blockSize - 1] = 1;else {
      this.gHASH(this.J0, this.nonce, this.nonce.length);
      var n = this.zeroBlock();
      pr.longToBigEndian(new Me(this.nonce.length).multiply(8), n, 8), this.gHASHBlock(this.J0, n);
    }
    this.S = this.zeroBlock(), this.SAt = this.zeroBlock(), this.SAtPre = this.zeroBlock(), this.atBlock = this.zeroBlock(), this.atBlockPos = 0, this.atLength = Me.ZERO, this.atLengthPre = Me.ZERO, this.counter = Buffer.from(this.J0), this.bufOff = 0, this.totalLength = Me.ZERO, "additionalData" in t && this.processAADBytes(t.additionalData, 0, t.additionalData.length);
  }, mr.prototype.update = function (t, e, r, n, i) {
    for (var a = 0; r > 0;) {
      var o = Math.min(r, this.bufBlock.length - this.bufOff);
      t.copy(this.bufBlock, this.bufOff, e, e + o), r -= o, e += o, this.bufOff += o, this.bufOff === this.bufBlock.length && (this.outputBlock(n, i + a), a += this.blockSize);
    }

    return a;
  }, mr.prototype.finish = function (t, e) {
    var r = 0;
    this._decrypt && (r += this.update(this.tag, 0, this.tag.length, t, e)), this.totalLength.isZero() && this.initCipher();
    var n = this.bufOff;

    if (this._decrypt) {
      if (n < this.tagLength) throw new Error("data too short");
      n -= this.tagLength;
    }

    n > 0 && (this.gCTRPartial(this.bufBlock, 0, n, t, e + r), r += n), this.atLength = this.atLength.add(this.atBlockPos);
    var i = this.zeroBlock();
    pr.longToBigEndian(this.atLength.multiply(8), i, 0), pr.longToBigEndian(this.totalLength.multiply(8), i, 8), this.gHASHBlock(this.S, i);
    var a = Buffer.alloc(this.blockSize);

    if (vr.encrypt(this.cipher, this.J0, 0, a, 0), this.xor(a, this.S), this._decrypt) {
      if (!dr.arrayEqual(this.tag, a)) throw new Error("mac check in Gcm failed");
    } else this.tag = Buffer.alloc(this.tagLength), a.copy(this.tag, 0, 0, this.tagLength);

    return r;
  }, mr.prototype.initCipher = function () {
    this.atLength.greaterThan(Me.ZERO) && (this.SAt.copy(this.SAtPre, 0, 0, this.blockSize), this.atLengthPre = this.atLength.add(Me.ZERO)), this.atBlockPos > 0 && (this.gHASHPartial(this.SAtPre, this.atBlock, 0, this.atBlockPos), this.atLengthPre = this.atLengthPre.add(this.atBlockPos)), this.atLengthPre.greaterThan(Me.ZERO) && this.SAtPre.copy(this.S, 0, 0, this.blockSize);
  }, mr.prototype.outputBlock = function (t, e) {
    this.totalLength.isZero() && this.initCipher(), this.gCTRBlock(this.bufBlock, t, e), this._decrypt ? (this.bufBlock.copy(this.bufBlock, 0, this.blockSize, this.blockSize + this.tagLength), this.bufOff = this.tagLength) : this.bufOff = 0;
  }, mr.prototype.processAADBytes = function (t, e, r) {
    for (var n = 0; n < r; ++n) {
      this.atBlock[this.atBlockPos] = t[e + n], ++this.atBlockPos === this.blockSize && (this.gHASHBlock(this.SAt, this.atBlock), this.atBlockPos = 0, this.atLength = this.atLength.add(this.blockSize));
    }
  }, mr.prototype.getNextCounterBlock = function () {
    for (var t = 15; t >= 12; --t) {
      var e = this.counter[t] + 1 & 255;
      if (this.counter[t] = e, 0 !== e) break;
    }

    var r = Buffer.alloc(this.blockSize);
    return vr.encrypt(this.cipher, this.counter, 0, r, 0), r;
  }, mr.prototype.gCTRBlock = function (t, e, r) {
    var n = this.getNextCounterBlock();
    this.xor(n, t), n.copy(e, r, 0, this.blockSize), this.gHASHBlock(this.S, this._decrypt ? t : n), this.totalLength = this.totalLength.add(this.blockSize);
  }, mr.prototype.gCTRPartial = function (t, e, r, n, i) {
    var a = this.getNextCounterBlock();
    this.xor(a, t, e, r), a.copy(n, i, 0, r), this.gHASHPartial(this.S, this._decrypt ? t : a, 0, r), this.totalLength = this.totalLength.add(r);
  }, mr.prototype.gHASHBlock = function (t, e) {
    this.xor(t, e), this.multiplier.multiplyH(t);
  }, mr.prototype.gHASHPartial = function (t, e, r, n) {
    this.xor(t, e, r, n), this.multiplier.multiplyH(t);
  }, mr.prototype.xor = function (t, e, r, n) {
    switch (arguments.length) {
      case 2:
        for (var i = 15; i >= 0; --i) {
          t[i] ^= e[i];
        }

        break;

      case 4:
        for (; n-- > 0;) {
          t[n] ^= e[r + n];
        }

        break;

      default:
        throw new TypeError("Expected 2 or 4 arguments.");
    }

    return t;
  }, mr.prototype.zeroBlock = function () {
    return Buffer.alloc(16);
  };
  var Tr = {};
  ["A128GCM", "A192GCM", "A256GCM", "A128GCMKW", "A192GCMKW", "A256GCMKW"].forEach(function (t) {
    var e = /A(\d+)GCM(KW)?/g.exec(t),
        r = parseInt(e[1]),
        n = "KW" === e[2];
    Tr[t] = {
      encrypt: Sr(r, n),
      decrypt: br(r)
    };
  });
  var Ar = Tr,
      Ir = Buffer.from("a6a6a6a6a6a6a6a6", "hex");

  function Br(t, e) {
    for (var r = Math.max(t.length, e.length), n = Buffer.alloc(r), i = 0; r > i; i++) {
      n[i] = (t[i] || 0) ^ (e[i] || 0);
    }

    return n;
  }

  function wr(t, e) {
    for (var r = [], n = 0; t.length > n; n += e) {
      r.push(t.slice(n, n + e));
    }

    return r;
  }

  function Nr(t) {
    var e = Math.floor(t / 4294967296),
        r = t % 4294967296,
        n = Buffer.alloc(8);
    return n[0] = 255 & e >>> 24, n[1] = 255 & e >>> 16, n[2] = 255 & e >>> 8, n[3] = 255 & e >>> 0, n[4] = 255 & r >>> 24, n[5] = 255 & r >>> 16, n[6] = 255 & r >>> 8, n[7] = 255 & r >>> 0, n;
  }

  function kr(t) {
    function e(e, r) {
      if (t !== e.length << 3) throw new Error("invalid key size");
      if (0 < r.length && 0 != r.length % 8) throw new Error("invalid data length");
    }

    return ge.setupFallback(function (r, n) {
      try {
        e(r, n);
      } catch (t) {
        return Promise.reject(t);
      }

      var i,
          a,
          o,
          s = wr(n, 8),
          u = Buffer.alloc(16);
      i = Ir;

      for (var c = 0; 6 > c; c++) {
        for (var f = 0; s.length > f; f++) {
          o = s.length * c + f + 1, a = Buffer.concat([i, s[f]]), i = Br((a = ge.nodeCrypto.createCipheriv("AES" + t, r, u).update(a)).slice(0, 8), Nr(o)), s[f] = a.slice(8, 16);
        }
      }

      s = [i].concat(s);
      var l = Buffer.concat(s);
      return Promise.resolve({
        data: l
      });
    }, function (t, r) {
      try {
        e(t, r);
      } catch (t) {
        return Promise.reject(t);
      }

      var n = {
        name: "AES-KW"
      },
          i = [ge.subtleCrypto.importKey("raw", r, {
        name: "HMAC",
        hash: "SHA-256"
      }, !0, ["sign"]), ge.subtleCrypto.importKey("raw", t, n, !0, ["wrapKey"])];
      return i = (i = (i = Promise.all(i)).then(function (t) {
        return ge.subtleCrypto.wrapKey("raw", t[0], t[1], n);
      })).then(function (t) {
        return {
          data: t = Buffer.from(t)
        };
      });
    }, function (t, r) {
      try {
        e(t, r);
      } catch (t) {
        return Promise.reject(t);
      }

      var n,
          i,
          a,
          o = Yt.cipher.createCipher("AES", new Ee(t)),
          s = wr(r, 8);
      n = Ir;

      for (var u = 0; 6 > u; u++) {
        for (var c = 0; s.length > c; c++) {
          a = s.length * u + c + 1, i = Buffer.concat([n, s[c]]), o.start(), o.update(new Ee(i)), o.finish(), n = Br((i = o.output.native()).slice(0, 8), Nr(a)), s[c] = i.slice(8, 16);
        }
      }

      s = [n].concat(s);
      var f = Buffer.concat(s);
      return Promise.resolve({
        data: f
      });
    });
  }

  function _r(t) {
    function e(e, r) {
      if (t !== e.length << 3) throw new Error("invalid key size");
      if (0 < r.length - 8 && 0 != r.length % 8) throw new Error("invalid data length");
    }

    return ge.setupFallback(function (r, n) {
      try {
        e(r, n);
      } catch (t) {
        return Promise.reject(t);
      }

      var i,
          a,
          o = wr(n, 8),
          s = Buffer.alloc(16);
      i = o[0], o = o.slice(1);

      for (var u = 5; 0 <= u; --u) {
        for (var c = o.length - 1; 0 <= c; --c) {
          a = Br(i, Nr(o.length * u + c + 1)), a = Buffer.concat([a, o[c], s]), i = (a = ge.nodeCrypto.createDecipheriv("AES" + t, r, s).update(a)).slice(0, 8), o[c] = a.slice(8, 16);
        }
      }

      if (i.toString() !== Ir.toString()) return Promise.reject(new Error("decryption failed"));
      var f = Buffer.concat(o);
      return Promise.resolve(f);
    }, function (t, r) {
      try {
        e(t, r);
      } catch (t) {
        return Promise.reject(t);
      }

      var n = {
        name: "AES-KW"
      },
          i = ge.subtleCrypto.importKey("raw", t, n, !0, ["unwrapKey"]);
      return i = (i = (i = i.then(function (t) {
        return ge.subtleCrypto.unwrapKey("raw", r, t, n, {
          name: "HMAC",
          hash: "SHA-256"
        }, !0, ["sign"]);
      })).then(function (t) {
        return ge.subtleCrypto.exportKey("raw", t);
      })).then(function (t) {
        return t = Buffer.from(t);
      });
    }, function (t, r) {
      try {
        e(t, r);
      } catch (t) {
        return Promise.reject(t);
      }

      var n,
          i,
          a = Yt.cipher.createDecipher("AES", new Ee(t)),
          o = wr(r, 8);
      n = o[0], o = o.slice(1);

      for (var s = 5; 0 <= s; --s) {
        for (var u = o.length - 1; 0 <= u; --u) {
          i = Br(n, Nr(o.length * s + u + 1)), i = Buffer.concat([i, o[u]]), a.start(), a.update(new Ee(i)), a.finish(), n = (i = a.output.native()).slice(0, 8), o[u] = i.slice(8, 16);
        }
      }

      if (n.toString() !== Ir.toString()) return Promise.reject(new Error("decryption failed"));
      var c = Buffer.concat(o);
      return Promise.resolve(c);
    });
  }

  var Rr = {};
  ["A128KW", "A192KW", "A256KW"].forEach(function (t) {
    var e = parseInt(/A(\d+)KW/g.exec(t)[1]);
    Rr[t] = {
      encrypt: kr(e),
      decrypt: _r(e)
    };
  });
  var Pr = Rr;

  function Fr(t) {
    t = t.replace("CONCAT-", "");
    return function (e, r) {
      var n = (r = r || {}).length,
          i = ve.HASHLENGTH[t];
      if (!n) return Promise.reject(new Error("invalid key length"));
      if (!r.otherInfo) return Promise.reject(new Error("invalid otherInfo"));
      var a = r.otherInfo,
          o = Be[t].digest,
          s = Math.ceil(n / i),
          u = 0,
          c = [];
      return function t() {
        if (s === u++) return Buffer.concat(c).slice(0, n);
        var r = Buffer.alloc(4 + e.length + a.length);
        return r.writeUInt32BE(u, 0), e.copy(r, 4), a.copy(r, 4 + e.length), o(r).then(function (e) {
          return c.push(e), t();
        });
      }();
    };
  }

  var Lr = {};
  ["CONCAT-SHA-1", "CONCAT-SHA-256", "CONCAT-SHA-384", "CONCAT-SHA-512"].forEach(function (t) {
    Lr[t] = {
      derive: Fr(t)
    };
  });
  var Ur = Lr;
  /*!
  	 * algorithms/dir.js - Direct key mode
  	 *
  	 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
  	 */

  var Or = {
    dir: {
      encrypt: function encrypt(t) {
        return Promise.resolve({
          data: t,
          once: !0,
          direct: !0
        });
      },
      decrypt: function decrypt(t) {
        return Promise.resolve(t);
      }
    }
  },
      Dr = Yt.jsbn.BigInteger;

  function Kr() {
    return new Dr(null);
  }

  function Vr(t) {
    this.r2 = Kr(), this.q3 = Kr(), Dr.ONE.dlShiftTo(2 * t.t, this.r2), this.mu = this.r2.divide(t), this.m = t;
  }

  function xr(t, e) {
    this.x = e, this.p = t;
  }

  function jr(t, e, r, n) {
    this.curve = t, this.x = e, this.y = r, this.z = n || Dr.ONE, this.zinv = null;
  }

  function Mr(t, e, r) {
    this.p = t, this.a = this.fromBigInteger(e), this.b = this.fromBigInteger(r), this.infinity = new jr(this, null, null), this.reducer = new Vr(this.p);
  }

  Vr.prototype.convert = function (t) {
    if (t.s < 0 || t.t > 2 * this.m.t) return t.mod(this.m);
    if (t.compareTo(this.m) < 0) return t;
    var e = Kr();
    return t.copyTo(e), this.reduce(e), e;
  }, Vr.prototype.revert = function (t) {
    return t;
  }, Vr.prototype.reduce = function (t) {
    for (t.drShiftTo(this.m.t - 1, this.r2), t.t > this.m.t + 1 && (t.t = this.m.t + 1, t.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t.compareTo(this.r2) < 0;) {
      t.dAddOffset(1, this.m.t + 1);
    }

    for (t.subTo(this.r2, t); t.compareTo(this.m) >= 0;) {
      t.subTo(this.m, t);
    }
  }, Vr.prototype.mulTo = function (t, e, r) {
    t.multiplyTo(e, r), this.reduce(r);
  }, Vr.prototype.sqrTo = function (t, e) {
    t.squareTo(e), this.reduce(e);
  }, xr.prototype.equals = function (t) {
    return t === this || this.p.equals(t.p) && this.x.equals(t.x);
  }, xr.prototype.toBigInteger = function () {
    return this.x;
  }, xr.prototype.negate = function () {
    return new xr(this.p, this.x.negate().mod(this.p));
  }, xr.prototype.add = function (t) {
    return new xr(this.p, this.x.add(t.toBigInteger()).mod(this.p));
  }, xr.prototype.subtract = function (t) {
    return new xr(this.p, this.x.subtract(t.toBigInteger()).mod(this.p));
  }, xr.prototype.multiply = function (t) {
    return new xr(this.p, this.x.multiply(t.toBigInteger()).mod(this.p));
  }, xr.prototype.square = function () {
    return new xr(this.p, this.x.pow(2).mod(this.p));
  }, xr.prototype.divide = function (t) {
    return new xr(this.p, this.x.multiply(t.toBigInteger().modInverse(this.p)).mod(this.p));
  }, jr.prototype.getX = function () {
    this.zinv || (this.zinv = this.z.modInverse(this.curve.p));
    var t = this.x.toBigInteger().multiply(this.zinv);
    return this.curve.reduce(t), this.curve.fromBigInteger(t);
  }, jr.prototype.getY = function () {
    this.zinv || (this.zinv = this.z.modInverse(this.curve.p));
    var t = this.y.toBigInteger().multiply(this.zinv);
    return this.curve.reduce(t), this.curve.fromBigInteger(t);
  }, jr.prototype.equals = function (t) {
    return t === this || (this.isInfinity() ? t.isInfinity() : t.isInfinity() ? this.isInfinity() : !!t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.p).equals(Dr.ZERO) && t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.p).equals(Dr.ZERO));
  }, jr.prototype.isInfinity = function () {
    return null == this.x && null == this.y || this.z.equals(Dr.ZERO) && !this.y.toBigInteger().equals(Dr.ZERO);
  }, jr.prototype.negate = function () {
    return new jr(this.curve, this.x, this.y.negate(), this.z);
  }, jr.prototype.add = function (t) {
    if (this.isInfinity()) return t;
    if (t.isInfinity()) return this;
    var e = t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.p),
        r = t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.p);
    if (Dr.ZERO.equals(r)) return Dr.ZERO.equals(e) ? this.twice() : this.curve.getInfinity();
    var n = new Dr("3"),
        i = this.x.toBigInteger(),
        a = this.y.toBigInteger(),
        o = r.pow(2),
        s = o.multiply(r),
        u = i.multiply(o),
        c = e.pow(2).multiply(this.z),
        f = c.subtract(u.shiftLeft(1)).multiply(t.z).subtract(s).multiply(r).mod(this.curve.p),
        l = u.multiply(n).multiply(e).subtract(a.multiply(s)).subtract(c.multiply(e)).multiply(t.z).add(e.multiply(s)).mod(this.curve.p),
        h = s.multiply(this.z).multiply(t.z).mod(this.curve.p);
    return new jr(this.curve, this.curve.fromBigInteger(f), this.curve.fromBigInteger(l), h);
  }, jr.prototype.twice = function () {
    if (this.isInfinity()) return this;
    if (0 === this.y.toBigInteger().signum()) return this.curve.getInfinity();
    var t = new Dr("3"),
        e = this.x.toBigInteger(),
        r = this.y.toBigInteger(),
        n = r.multiply(this.z),
        i = n.multiply(r).mod(this.curve.p),
        a = this.curve.a.toBigInteger(),
        o = e.pow(2).multiply(t);
    Dr.ZERO.equals(a) || (o = o.add(this.z.pow(2).multiply(a)));
    var s = (o = o.mod(this.curve.p)).pow(2).subtract(e.shiftLeft(3).multiply(i)).shiftLeft(1).multiply(n).mod(this.curve.p),
        u = o.multiply(t).multiply(e).subtract(i.shiftLeft(1)).shiftLeft(2).multiply(i).subtract(o.pow(2).multiply(o)).mod(this.curve.p),
        c = n.pow(2).multiply(n).shiftLeft(3).mod(this.curve.p);
    return new jr(this.curve, this.curve.fromBigInteger(s), this.curve.fromBigInteger(u), c);
  }, jr.prototype.multiply = function (t) {
    if (this.isInfinity()) return this;
    if (0 === t.signum()) return this.curve.getInfinity();
    var e,
        r = t,
        n = r.multiply(new Dr("3")),
        i = this.negate(),
        a = this;

    for (e = n.bitLength() - 2; e > 0; --e) {
      a = a.twice();
      var o = n.testBit(e);
      o !== r.testBit(e) && (a = a.add(o ? this : i));
    }

    return a;
  }, jr.prototype.multiplyTwo = function (t, e, r) {
    var n;
    n = t.bitLength() > r.bitLength() ? t.bitLength() - 1 : r.bitLength() - 1;

    for (var i = this.curve.getInfinity(), a = this.add(e); n >= 0;) {
      i = i.twice(), t.testBit(n) ? i = r.testBit(n) ? i.add(a) : i.add(this) : r.testBit(n) && (i = i.add(e)), --n;
    }

    return i;
  }, Mr.prototype.getP = function () {
    return this.p;
  }, Mr.prototype.getA = function () {
    return this.a;
  }, Mr.prototype.getB = function () {
    return this.b;
  }, Mr.prototype.equals = function (t) {
    return t === this || this.p.equals(t.p) && this.a.equals(t.a) && this.b.equals(t.b);
  }, Mr.prototype.contains = function (t) {
    var e = t.getX().toBigInteger(),
        r = t.getY().toBigInteger(),
        n = this.a.toBigInteger(),
        i = this.b.toBigInteger(),
        a = this.p,
        o = r.pow(2).mod(a),
        s = e.pow(3).add(n.multiply(e)).add(i).mod(a);
    return o.equals(s);
  }, Mr.prototype.getInfinity = function () {
    return this.infinity;
  }, Mr.prototype.fromBigInteger = function (t) {
    return new xr(this.p, t);
  }, Mr.prototype.reduce = function (t) {
    this.reducer.reduce(t);
  }, Mr.prototype.decodePointHex = function (t) {
    switch (parseInt(t.substring(0, 2), 16)) {
      case 0:
        return this.infinity;

      case 2:
      case 3:
        return null;

      case 4:
      case 6:
      case 7:
        var e = (t.length - 2) / 2,
            r = t.substr(2, e),
            n = t.substr(e + 2, e);
        return new jr(this, this.fromBigInteger(new Dr(r, 16)), this.fromBigInteger(new Dr(n, 16)));

      default:
        return null;
    }
  }, Mr.prototype.encodePointHex = function (t) {
    if (t.isInfinity()) return "00";
    var e = t.getX().toBigInteger().toString(16),
        r = t.getY().toBigInteger().toString(16),
        n = this.getP().toString(16).length;

    for (n % 2 != 0 && n++; e.length < n;) {
      e = "0" + e;
    }

    for (; r.length < n;) {
      r = "0" + r;
    }

    return "04" + e + r;
  };
  var Hr = {
    ECFieldElementFp: xr,
    ECPointFp: jr,
    ECCurveFp: Mr
  },
      zr = i(function (t) {
    var e = Yt.jsbn.BigInteger;

    function r(t, e, r, n) {
      this.curve = t, this.g = e, this.n = r, this.h = n;
    }

    function n(t) {
      return new e(t, 16);
    }

    r.prototype.getCurve = function () {
      return this.curve;
    }, r.prototype.getG = function () {
      return this.g;
    }, r.prototype.getN = function () {
      return this.n;
    }, r.prototype.getH = function () {
      return this.h;
    };
    var i,
        a,
        o,
        s,
        u,
        c,
        f,
        l = t.exports = {
      secp256r1: (i = n("FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF"), a = n("FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC"), o = n("5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B"), s = n("FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551"), u = e.ONE, c = new Hr.ECCurveFp(i, a, o), f = c.decodePointHex("046B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C2964FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5"), new r(c, f, s, u)),
      secp384r1: function () {
        var t = n("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF"),
            i = n("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC"),
            a = n("B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF"),
            o = n("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973"),
            s = e.ONE,
            u = new Hr.ECCurveFp(t, i, a),
            c = u.decodePointHex("04AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB73617DE4A96262C6F5D9E98BF9292DC29F8F41DBD289A147CE9DA3113B5F0B8C00A60B1CE1D7E819D7A431D7C90EA0E5F");
        return new r(u, c, o, s);
      }(),
      secp521r1: function () {
        var t = n("01FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF"),
            i = n("01FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC"),
            a = n("0051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00"),
            o = n("01FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409"),
            s = e.ONE,
            u = new Hr.ECCurveFp(t, i, a),
            c = u.decodePointHex("0400C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66011839296A789A3BC0045C8A5FB42C7D1BD998F54449579B446817AFBD17273E662C97EE72995EF42640C550B9013FAD0761353C7086A272C24088BE94769FD16650");
        return new r(u, c, o, s);
      }()
    };
    l["P-256"] = l.secp256r1, l["P-384"] = l.secp384r1, l["P-521"] = l.secp521r1;
  }),
      Gr = Yt.jsbn.BigInteger;

  function qr(t) {
    return new Gr(t, 16);
  }

  function Wr(t, e) {
    e || (e = Math.ceil(t.bitLength() / 8)), e *= 2;
    var r = t.toString(16);

    for (r = r.substring(Math.max(r.length - e, 0)); e > r.length;) {
      r = "0" + r;
    }

    return Buffer.from(r, "hex");
  }

  function Qr(t) {
    return "string" == typeof t && (t = Buffer.from(t, "binary")), qr(t.toString("hex"));
  }

  function Xr(t) {
    return Math.ceil(t.getN().bitLength() / 8);
  }

  function Yr(t) {
    var e = zr[t];
    if (!e) throw new TypeError("unsupported named curve: " + t);
    return e;
  }

  function Zr(t, e) {
    var r = t.getN().bitLength(),
        n = 8 * e.length,
        i = Qr(e);
    return r < n && (i = i.shiftRight(n - r)), i;
  }

  function Jr(t, e, r) {
    var n = Yr(t),
        i = n.getCurve(),
        a = new Hr.ECPointFp(i, i.fromBigInteger(e), i.fromBigInteger(r));
    this.curve = t, this.params = n, this.point = a;
    var o = Xr(n);
    this.x = Wr(e, o), this.y = Wr(r, o);
  }

  function $r(t, e) {
    var r = Yr(t);
    this.curve = t, this.params = r;
    var n = Xr(r);
    this.d = Wr(e, n);
  }

  Jr.prototype.isValid = function () {
    return this.params.curve.contains(this.point);
  }, Jr.prototype.verify = function (t, e) {
    var r = this.params.getN(),
        n = this.params.getG(),
        i = Qr(e.r),
        a = Qr(e.s);
    if (i.compareTo(Gr.ONE) < 0 || i.compareTo(r) >= 0) return !1;
    if (a.compareTo(Gr.ONE) < 0 || i.compareTo(r) >= 0) return !1;
    var o = Zr(this.params, t),
        s = a.modInverse(r),
        u = o.multiply(s).mod(r),
        c = i.multiply(s).mod(r),
        f = n.multiplyTwo(u, this.point, c).getX().toBigInteger();
    return (f = f.mod(r)).equals(i);
  }, $r.prototype.toPublicKey = function () {
    var t = Qr(this.d),
        e = this.params.getG().multiply(t);
    return new Jr(this.curve, e.getX().toBigInteger(), e.getY().toBigInteger());
  }, $r.prototype.sign = function (t) {
    var e,
        r,
        n,
        i,
        a = Xr(this.params),
        o = this.params.getN(),
        s = this.params.getG(),
        u = Zr(this.params, t),
        c = Qr(this.d);

    do {
      do {
        do {
          n = Qr(Yt.random.getBytes(a));
        } while (n.equals(Gr.ZERO) || n.compareTo(o) >= 0);

        e = s.multiply(n).getX().toBigInteger().mod(o);
      } while (e.equals(Gr.ZERO));

      i = c.multiply(e), i = u.add(i), r = n.modInverse(o).multiply(i).mod(o);
    } while (r.equals(Gr.ONE));

    var f = Xr(this.params);
    return {
      r: e = Wr(e, f),
      s: r = Wr(r, f)
    };
  }, $r.prototype.isValid = function () {
    var t = Qr(this.d),
        e = this.params.getN().subtract(Gr.ONE);
    return t.compareTo(Gr.ONE) >= 0 && t.compareTo(e) < 0;
  }, $r.prototype.computeSecret = function (t) {
    var e = Qr(this.d),
        r = t.point.multiply(e).getX().toBigInteger();
    return r = Wr(r, Xr(this.params));
  };
  var tn = {
    generateKeyPair: function generateKeyPair(t) {
      var e = Yr(t),
          r = e.getN(),
          n = Yt.random.getBytes(Xr(e));
      n = Qr(n);
      var i = r.subtract(Gr.ONE),
          a = new $r(t, n.mod(i).add(Gr.ONE)),
          o = a.toPublicKey();
      return {
        private: a,
        public: o
      };
    },
    asPublicKey: function asPublicKey(t, e, r) {
      return "string" == typeof e ? e = qr(e) : Buffer.isBuffer(e) && (e = Qr(e)), "string" == typeof r ? r = qr(r) : Buffer.isBuffer(r) && (r = Qr(r)), new Jr(t, e, r);
    },
    asPrivateKey: function asPrivateKey(t, e) {
      return "string" == typeof e ? e = qr(e) : Buffer.isBuffer(e) && (e = Qr(e)), new $r(t, e);
    }
  },
      en = s.clone,
      rn = {
    "P-256": 256,
    "P-384": 384,
    "P-521": 521
  };

  function nn(t, e) {
    var r = en(t);
    return (e ? ["x", "y"] : ["d"]).forEach(function (t) {
      r[t] = ne.asBuffer(r[t], "base64url");
    }), r;
  }

  var an = Buffer.from([4]);
  var on = "Could not extract parameters from DER signature";

  function sn(t, e, r) {
    for (var n = 0; e + n < r && 0 === t[e + n];) {
      ++n;
    }

    return t[e + n] >= 128 && --n, n;
  }

  var un = {
    convertToForge: function convertToForge(t, e) {
      var r = e ? ["x", "y"] : ["d"];
      return r = r.map(function (e) {
        return new Yt.jsbn.BigInteger(t[e].toString("hex"), 16);
      }), r = [t.crv].concat(r), (e ? tn.asPublicKey : tn.asPrivateKey).apply(tn, r);
    },
    convertToJWK: function convertToJWK(t, e) {
      var r = en(t);
      return (e ? ["x", "y"] : ["x", "y", "d"]).forEach(function (t) {
        r[t] = ne.base64url.encode(r[t]);
      }), delete r.key_ops, delete r.use, delete r.alg, e && delete r.d, r;
    },
    convertToObj: nn,
    convertToBuffer: function convertToBuffer(t, e) {
      return t = nn(t, e), e ? Buffer.concat([an, t.x, t.y]) : t.d;
    },
    curveSize: function curveSize(t) {
      return rn[t || ""] || NaN;
    },
    derToConcat: function derToConcat(t, e) {
      var r = 0;
      if (48 !== t[r++]) throw new Error(on);
      var n = t[r++];
      if (129 === n && (n = t[r++]), n > t.length - r) throw new Error(on);
      if (2 !== t[r++]) throw new Error(on);
      var i = t[r++];
      if (i > t.length - r - 2) throw new Error(on);
      if (i > e + 1) throw new Error(on);
      var a = r;
      if (r += i, 2 !== t[r++]) throw new Error(on);
      var o = t[r++];
      if (o !== t.length - r) throw new Error(on);
      if (o > e + 1) throw new Error(on);
      var s = r;
      if ((r += o) !== t.length) throw new Error(on);
      var u = e - i,
          c = e - o,
          f = Buffer.alloc(u + i + c + o);

      for (r = 0; r < u; ++r) {
        f[r] = 0;
      }

      var l = Math.max(-u, 0);
      t.copy(f, r, a + l, a + i);

      for (var h = r = e; r < h + c; ++r) {
        f[r] = 0;
      }

      var p = Math.max(-c, 0);
      return t.copy(f, r, s + p, s + o), f;
    },
    concatToDer: function concatToDer(t, e) {
      var r = sn(t, 0, e),
          n = sn(t, e, t.length),
          i = e - r,
          a = e - n,
          o = i + a + 4,
          s = o < 128,
          u = Buffer.alloc((s ? 2 : 3) + o),
          c = 0;
      return u[c++] = 48, s ? u[c++] = o : (u[c++] = 129, u[c++] = 255 & o), u[c++] = 2, u[c++] = i, r < 0 ? (u[c++] = 0, c += t.copy(u, c, 0, e)) : c += t.copy(u, c, r, e), u[c++] = 2, u[c++] = a, n < 0 ? (u[c++] = 0, t.copy(u, c, e)) : t.copy(u, c, e + n), u;
    },
    convertToPEM: function convertToPEM(t, e) {
      var r,
          n,
          i,
          a = t.crv;
      return a = function (t) {
        switch (t) {
          case "P-256":
            return "1.2.840.10045.3.1.7";

          case "P-384":
            return "1.3.132.0.34";

          case "P-521":
            return "1.3.132.0.35";

          default:
            return null;
        }
      }(a), a = Yt.asn1.oidToDer(a), e ? (r = "EC PRIVATE KEY", n = Buffer.concat([Buffer.from([0, 4]), t.x, t.y]).toString("binary"), t = t.d.toString("binary"), i = Yt.asn1.create(Yt.asn1.Class.UNIVERSAL, Yt.asn1.Type.SEQUENCE, !0, [Yt.asn1.create(Yt.asn1.Class.UNIVERSAL, Yt.asn1.Type.INTEGER, !1, ""), Yt.asn1.create(Yt.asn1.Class.UNIVERSAL, Yt.asn1.Type.OCTETSTRING, !1, t), Yt.asn1.create(Yt.asn1.Class.CONTEXT_SPECIFIC, 0, !0, [Yt.asn1.create(Yt.asn1.Class.UNIVERSAL, Yt.asn1.Type.OID, !1, a.bytes())]), Yt.asn1.create(Yt.asn1.Class.CONTEXT_SPECIFIC, 1, !0, [Yt.asn1.create(Yt.asn1.Class.UNIVERSAL, Yt.asn1.Type.BITSTRING, !1, n)])])) : (r = "PUBLIC KEY", t = Buffer.concat([Buffer.from([0, 4]), t.x, t.y]).toString("binary"), i = Yt.asn1.create(Yt.asn1.Class.UNIVERSAL, Yt.asn1.Type.SEQUENCE, !0, [Yt.asn1.create(Yt.asn1.Class.UNIVERSAL, Yt.asn1.Type.SEQUENCE, !0, [Yt.asn1.create(Yt.asn1.Class.UNIVERSAL, Yt.asn1.Type.OID, !1, Yt.asn1.oidToDer("1.2.840.10045.2.1").bytes()), Yt.asn1.create(Yt.asn1.Class.UNIVERSAL, Yt.asn1.Type.OID, !1, a.bytes())]), Yt.asn1.create(Yt.asn1.Class.UNIVERSAL, Yt.asn1.Type.BITSTRING, !1, t)])), i = Yt.asn1.toDer(i).bytes(), Yt.pem.encode({
        type: r,
        body: i
      });
    },
    EC_OID: "1.2.840.10045.2.1"
  };

  function cn(t) {
    var e = t.replace("HKDF-", ""),
        r = t.replace("HKDF-SHA-", "HS");
    return function (t, n) {
      var i = ve.HASHLENGTH[e] / 8;
      "string" == typeof r && (r = Te[r].sign);
      var a = (n = n || {}).salt;
      a && 0 !== a.length || (a = Buffer.alloc(i));
      var o = n.info || Buffer.alloc(0),
          s = n.length || i,
          u = Math.ceil(s / i),
          c = [],
          f = 0;
      return r(a, t, {
        length: 8 * a.length
      }).then(function (t) {
        return function t(e, n) {
          return u === f++ ? Buffer.concat(c).slice(0, s) : (n || (n = Buffer.alloc(0)), n = Buffer.concat([n, o, Buffer.from([f])]), n = (n = r(e, n)).then(function (r) {
            return n = r.mac, c.push(n), t(e, n);
          }));
        }(t.mac);
      });
    };
  }

  var fn = {};
  ["HKDF-SHA-1", "HKDF-SHA-256", "HKDF-SHA-384", "HKDF-SHA-512"].forEach(function (t) {
    fn[t] = {
      derive: cn(t)
    };
  });
  var ln = fn,
      hn = i(function (t) {
    var e = s.clone,
        r = s.omit,
        n = s.pick;

    function i(t) {
      switch (t) {
        case "P-256":
          return "SHA-256";

        case "P-384":
          return "SHA-384";

        case "P-521":
          return "SHA-512";

        default:
          throw new Error("unsupported curve: " + t);
      }
    }

    var a = t.exports = {};

    function o(t, e, r) {
      function n(t) {
        return Buffer.concat([ge.int32ToBuffer(t.length), t]);
      }

      var i = r.algorithm || "",
          o = ve.KEYLENGTH[i],
          s = ne.asBuffer(r.apu || "", "base64url"),
          u = ne.asBuffer(r.apv || "", "base64url"),
          c = {
        public: e,
        length: o / 8,
        hash: "SHA-256",
        otherInfo: Buffer.concat([n(Buffer.from(i, "utf8")), n(s), n(u), ge.int32ToBuffer(o)])
      };
      return a["ECDH-CONCAT"].derive(t, c);
    }

    ["ECDH", "ECDH-HKDF", "ECDH-CONCAT"].forEach(function (t) {
      var o,
          s,
          u = /^ECDH(?:-(\w+))?$/g.exec(t || "")[1],
          c = a[t] = a[t] || {};

      switch (u || "") {
        case "CONCAT":
          c.derive = function (t, e) {
            var o;
            e = e || {};

            try {
              if (!(o = e.hash || i(t.crv))) throw new Error("invalid hash: " + o);
              o.toUpperCase();
            } catch (t) {
              return Promise.reject(t);
            }

            var s = ["public"],
                u = a.ECDH.derive(t, n(e, s));
            return u = u.then(function (t) {
              return Ur["CONCAT-" + o].derive(t, r(e, s));
            });
          };

          break;

        case "HKDF":
          c.derive = function (t, e) {
            var o;
            e = e || {};

            try {
              if (!(o = e.hash || i(t.crv))) throw new Error("invalid hash: " + o);
              o.toUpperCase();
            } catch (t) {
              return Promise.reject(t);
            }

            var s = ["public"],
                u = a.ECDH.derive(t, n(e, s));
            return u = u.then(function (t) {
              return ln["HKDF-" + o].derive(t, r(e, s));
            });
          };

          break;

        case "":
          c.derive = (o = {
            name: "ECDH"
          }, s = function s(t, e) {
            var r = t && un.convertToForge(t, !0);
            if (!r || !r.isValid()) return Promise.reject(new Error("invalid EC public key"));

            switch (e) {
              case "jwk":
                r = un.convertToJWK(t, !0);
                break;

              case "buffer":
                r = un.convertToBuffer(t, !0);
            }

            return Promise.resolve(r);
          }, ge.setupFallback(function (t, e) {
            if ("function" != typeof ge.nodeCrypto.createECDH) throw new Error("unsupported algorithm: ECDH");
            var r,
                n = (e = e || {}).length || 0;

            switch (t.crv) {
              case "P-256":
                r = "prime256v1";
                break;

              case "P-384":
                r = "secp384r1";
                break;

              case "P-521":
                r = "secp521r1";
                break;

              default:
                return Promise.reject(new Error("invalid curve: " + r));
            }

            var i = un.convertToBuffer(t, !1),
                a = s(e.public, "buffer");
            return a = a.then(function (t) {
              var e = ge.nodeCrypto.createECDH(r);
              e.setPrivateKey(i);
              var a = e.computeSecret(t);

              if (n) {
                if (a.length < n) return Promise.reject(new Error("key length too large: " + n));
                a = a.slice(0, n);
              }

              return a;
            });
          }, function (t, r) {
            t = t || {};
            var n = (r = r || {}).length || 0,
                i = l(e(o), {
              namedCurve: t.crv
            });
            n || (n = t.d.length);
            var a = un.convertToJWK(t, !1);
            a = ge.subtleCrypto.importKey("jwk", a, i, !1, ["deriveBits"]);
            var u = s(r.public, "jwk");
            u = u.then(function (t) {
              return ge.subtleCrypto.importKey("jwk", t, i, !1, []);
            });
            var c = Promise.all([a, u]);
            return c = (c = c.then(function (t) {
              var r = t[0],
                  i = t[1],
                  a = l(e(o), {
                public: i
              });
              return ge.subtleCrypto.deriveBits(a, r, 8 * n);
            })).then(function (t) {
              return t = Buffer.from(t);
            });
          }, function (t, e) {
            var r = (e = e || {}).length || 0,
                n = un.convertToForge(t, !1),
                i = s(e.public, "forge");
            return i = i.then(function (t) {
              var e = n.computeSecret(t);

              if (r) {
                if (e.length < r) return Promise.reject(new Error("key length too large: " + r));
                e = e.slice(0, r);
              }

              return e;
            });
          }));
          break;

        default:
          c.derive = null;
      }
    }), ["ECDH-ES", "ECDH-ES+A128KW", "ECDH-ES+A192KW", "ECDH-ES+A256KW"].forEach(function (t) {
      var e,
          r,
          n = /^ECDH-ES(?:\+(.+))?/g.exec(t || "")[1],
          i = a[t] = a[t] || {};
      n ? (n = Pr[n]) ? (i.encrypt = (r = n.encrypt, function (t, e, n) {
        if (!(n = n || {}).epk || !n.epk.d) return Promise.reject(new Error("missing ephemeral private key"));
        var i = un.convertToObj(n.epk, !1);
        if (!t || !t.x || !t.y) return Promise.reject(new Error("missing static public key"));
        var a = o(i, un.convertToObj(t, !0), {
          algorithm: n.alg,
          apu: n.apu,
          apv: n.apv
        });
        return a = a.then(function (t) {
          return r(t, e);
        });
      }), i.decrypt = (e = n.decrypt, function (t, r, n) {
        if (!(n = n || {}).epk || !n.epk.x || !n.epk.y) return Promise.reject(new Error("missing ephemeral public key"));
        var i = un.convertToObj(n.epk, !0);
        if (!t || !t.d) return Promise.reject(new Error("missing static private key"));
        var a = o(un.convertToObj(t, !1), i, {
          algorithm: n.alg,
          apu: n.apu,
          apv: n.apv
        });
        return a = a.then(function (t) {
          return e(t, r);
        });
      })) : i.ecrypt = i.decrypt = null : (i.encrypt = function (t, e, r) {
        if (!(r = r || {}).epk || !r.epk.d) return Promise.reject(new Error("missing ephemeral private key"));
        var n = un.convertToObj(r.epk, !1);
        if (!t || !t.x || !t.y) return Promise.reject(new Error("missing static public key"));
        var i = o(n, un.convertToObj(t, !0), {
          algorithm: r.enc,
          apu: r.apu,
          apv: r.apv
        });
        return i = i.then(function (t) {
          return {
            data: t,
            once: !0,
            direct: !0
          };
        });
      }, i.decrypt = function (t, e, r) {
        if (!(r = r || {}).epk || !r.epk.x || !r.epk.y) return Promise.reject(new Error("missing ephemeral public key"));
        var n = un.convertToObj(r.epk, !0);
        if (!t || !t.d) return Promise.reject(new Error("missing static private key"));
        var i = o(un.convertToObj(t, !1), n, {
          algorithm: r.enc,
          apu: r.apu,
          apv: r.apv
        });
        return i = i.then(function (t) {
          return t;
        });
      });
    });
  });

  function pn(t) {
    switch (t) {
      case "SHA-256":
        return "P-256";

      case "SHA-384":
        return "P-384";

      case "SHA-512":
        return "P-521";

      default:
        throw new Error("unsupported hash: " + t);
    }
  }

  function dn(t) {
    var e,
        r = pn(t),
        n = t.toLowerCase().replace("-", "");
    return ge.nodeCrypto && ge.nodeCrypto.getHashes().indexOf(n) > -1 && (e = function e(t, _e2) {
      if (r !== t.crv) return Promise.reject(new Error("invalid curve"));
      var i, a;

      switch (i = (i = Promise.resolve(ge.nodeCrypto.createSign(n))).then(function (t) {
        return t.update(_e2), t;
      }), n.slice(-3)) {
        case "384":
          a = 48;
          break;

        case "512":
          a = 66;
          break;

        default:
          a = 32;
      }

      return i = (i = i.then(function (e) {
        return un.derToConcat(e.sign(un.convertToPEM(t, !0)), a);
      })).then(function (t) {
        return {
          data: _e2,
          mac: t
        };
      });
    }), ge.setupFallback(e, function (e, n) {
      if (r !== e.crv) return Promise.reject(new Error("invalid curve"));
      var i = un.convertToJWK(e, !1),
          a = {
        name: "ECDSA",
        namedCurve: i.crv,
        hash: {
          name: t
        }
      };
      return ge.subtleCrypto.importKey("jwk", i, a, !0, ["sign"]).then(function (t) {
        return ge.subtleCrypto.sign(a, t, n);
      }).then(function (t) {
        return t = Buffer.from(t), {
          data: n,
          mac: t
        };
      });
    }, function (e, n) {
      if (r !== e.crv) return Promise.reject(new Error("invalid curve"));
      var i = un.convertToForge(e, !1);
      return Be[t].digest(n).then(function (t) {
        return t = i.sign(t), t = Buffer.concat([t.r, t.s]), {
          data: n,
          mac: t
        };
      });
    });
  }

  function yn(t) {
    var e,
        r = pn(t),
        n = t.toLowerCase().replace("-", "");
    return ge.nodeCrypto && ge.nodeCrypto.getHashes().indexOf(n) > -1 && (e = function e(t, _e3, i) {
      if (r !== t.crv) return Promise.reject(new Error("invalid curve"));
      var a;

      switch (n.slice(-3)) {
        case "384":
          a = 48;
          break;

        case "512":
          a = 66;
          break;

        default:
          a = 32;
      }

      return Promise.resolve(ge.nodeCrypto.createVerify(n)).then(function (r) {
        return r.update(_e3), r.end(), r.verify(un.convertToPEM(t, !1), un.concatToDer(i, a));
      }).then(function (t) {
        if (!t) throw new Error("verification failed");
        return {
          data: _e3,
          mac: i,
          valid: !0
        };
      });
    }), ge.setupFallback(e, function (e, n, i) {
      if (r !== e.crv) return Promise.reject(new Error("invalid curve"));
      var a = un.convertToJWK(e, !0),
          o = {
        name: "ECDSA",
        namedCurve: a.crv,
        hash: {
          name: t
        }
      };
      return ge.subtleCrypto.importKey("jwk", a, o, !0, ["verify"]).then(function (t) {
        return ge.subtleCrypto.verify(o, t, i, n);
      }).then(function (t) {
        return t ? {
          data: n,
          mac: i,
          valid: !0
        } : Promise.reject(new Error("verification failed"));
      });
    }, function (e, n, i) {
      if (r !== e.crv) return Promise.reject(new Error("invalid curve"));
      var a = un.convertToForge(e, !0);
      return Be[t].digest(n).then(function (t) {
        var e = i.length / 2,
            r = {
          r: i.slice(0, e),
          s: i.slice(e)
        };
        return a.verify(t, r) ? {
          data: n,
          mac: i,
          valid: !0
        } : Promise.reject(new Error("verification failed"));
      });
    });
  }

  var gn = {};
  ["ES256", "ES384", "ES512"].forEach(function (t) {
    var e = t.replace(/ES(\d+)/g, function (t, e) {
      return "SHA-" + e;
    });
    gn[t] = {
      sign: dn(e),
      verify: yn(e)
    };
  });
  var vn = gn,
      mn = Buffer.from([0]);

  function En(t, e, r) {
    var n = "PBES2-" + t + "+" + e,
        i = [Buffer.from(n, "utf8"), mn, r];
    return Buffer.concat(i);
  }

  function Cn(t) {
    function e(t) {
      var e = (t = t || {}).length || 0,
          r = ne.asBuffer(t.salt || Buffer.alloc(0), "base64u4l"),
          n = t.iterations || 0;
      if (0 >= e) throw new Error("invalid key length");
      if (0 >= n) throw new Error("invalid iteration count");
      return t.length = e, t.salt = r, t.iterations = n, t;
    }

    return ge.setupFallback(function (r, n) {
      if (6 > ge.nodeCrypto.pbkdf2.length) throw new Error("unsupported algorithm: PBKDF2-" + t);

      try {
        n = e(n);
      } catch (t) {
        return Promise.reject(t);
      }

      var i = n.length,
          a = n.salt,
          o = n.iterations,
          s = t.replace("-", "");
      return new Promise(function (t, e) {
        ge.nodeCrypto.pbkdf2(r, a, o, i, s, function (r, n) {
          r ? e(r) : t(n);
        });
      });
    }, function (r, n) {
      try {
        n = e(n);
      } catch (t) {
        return Promise.reject(t);
      }

      var i = n.length,
          a = n.salt,
          o = n.iterations,
          s = Promise.resolve(r);
      return s = (s = (s = s.then(function (t) {
        return ge.subtleCrypto.importKey("raw", t, "PBKDF2", !1, ["deriveBits"]);
      })).then(function (e) {
        var r = {
          name: "PBKDF2",
          salt: new Uint8Array(a),
          iterations: o,
          hash: t
        };
        return ge.subtleCrypto.deriveBits(r, e, 8 * i);
      })).then(function (t) {
        return ne.asBuffer(t);
      });
    }, function (r, n) {
      try {
        n = e(n);
      } catch (t) {
        return Promise.reject(t);
      }

      var i = n.length,
          a = n.salt,
          o = n.iterations;
      return new Promise(function (e, n) {
        var s = Yt.md[t.replace("-", "").toLowerCase()].create();
        Yt.pkcs5.pbkdf2(r.toString("binary"), a.toString("binary"), o, i, s, function (t, r) {
          t ? n(t) : (r = Buffer.from(r, "binary"), e(r));
        });
      });
    });
  }

  function Sn(t, e) {
    var r = "PBKDF2-" + t.replace("HS", "SHA-"),
        n = ve.KEYLENGTH[e] / 8;
    return function (i, a, o) {
      o = o || {};
      var s = ne.asBuffer(o.p2s || Buffer.alloc(0), "base64url"),
          u = o.p2c || 8192;
      if (0 >= u) throw new Error("invalid iteration count");
      if (0 === s.length) s = ne.randomBytes(16);else if (8 > s.length) throw new Error("salt too small");
      var c = {
        p2s: ne.base64url.encode(s),
        p2c: u
      };
      s = En(t, e, s), o = l(o, {
        salt: s,
        iterations: u,
        length: n
      });
      var f = Promise.resolve(i);
      return f = (f = (f = f.then(function (t) {
        return Tn[r].derive(t, o);
      })).then(function (t) {
        return Pr[e].encrypt(t, a);
      })).then(function (t) {
        return t.header = l(t.header || {}, c), t;
      });
    };
  }

  function bn(t, e) {
    var r = "PBKDF2-" + t.replace("HS", "SHA-"),
        n = ve.KEYLENGTH[e] / 8;
    return function (i, a, o) {
      o = o || {};
      var s = ne.asBuffer(o.p2s || Buffer.alloc(0), "base64url"),
          u = o.p2c || 0;
      if (0 >= u) return Promise.reject(new Error("invalid iteration count"));
      if (8 > s.length) return Promise.reject(new Error("salt too small"));
      s = En(t, e, s), o = l(o, {
        salt: s,
        iterations: u,
        length: n
      });
      var c = Promise.resolve(i);
      return c = (c = c.then(function (t) {
        return Tn[r].derive(t, o);
      })).then(function (t) {
        return Pr[e].decrypt(t, a);
      });
    };
  }

  var Tn = {};
  ["PBKDF2-SHA-256", "PBKDF2-SHA-384", "PBKDF2-SHA-512"].forEach(function (t) {
    var e = t.replace("PBKDF2-", "");
    Tn[t] = {
      derive: Cn(e)
    };
  }), ["PBES2-HS256+A128KW", "PBES2-HS384+A192KW", "PBES2-HS512+A256KW"].forEach(function (t) {
    var e = /PBES2-(HS\d+)\+(A\d+KW)/g.exec(t),
        r = e[1],
        n = e[2];
    Tn[t] = {
      encrypt: Sn(r, n),
      decrypt: bn(r, n)
    };
  });
  var An = Tn,
      In = s.clone;

  function Bn(t, e) {
    var r = e ? ["n", "e"] : ["n", "e", "d", "p", "q", "dp", "dq", "qi"];
    return r = r.map(function (e) {
      return new Yt.jsbn.BigInteger(t[e].toString("hex"), 16);
    }), (e ? Yt.pki.rsa.setPublicKey : Yt.pki.rsa.setPrivateKey).apply(Yt.pki.rsa, r);
  }

  var wn = {
    convertToForge: Bn,
    convertToJWK: function convertToJWK(t, e) {
      var r = In(t);
      return (e ? ["n", "e"] : ["n", "e", "d", "p", "q", "dp", "dq", "qi"]).forEach(function (t) {
        r[t] = ne.base64url.encode(r[t]);
      }), delete r.key_ops, delete r.use, delete r.alg, e && (delete r.d, delete r.p, delete r.q, delete r.dp, delete r.dq, delete r.qi), r;
    },
    convertToPem: function convertToPem(t, e) {
      var r,
          n = e ? "__cachedPublicPem" : "__cachedPrivatePem";
      return t[n] ? t[n] : (r = e ? Yt.pki.publicKeyToPem(Bn(t, e)) : Yt.pki.privateKeyToPem(Bn(t, e)), Object.defineProperty(t, n, {
        value: r
      }), r);
    }
  },
      Nn = {
    "RSA-OAEP": "RSA_PKCS1_OAEP_PADDING",
    RSA1_5: "RSA_PKCS1_PADDING"
  };

  function kn(t) {
    return ge.nodeCrypto && ge.nodeCrypto.constants && -1 !== Object.keys(Nn).indexOf(t);
  }

  function _n(t) {
    var e = {
      name: t
    };
    "RSA-OAEP-256" === t ? (e.name = "RSA-OAEP", e.hash = {
      name: "SHA-256"
    }) : "RSA-OAEP" === t ? e.hash = {
      name: "SHA-1"
    } : e.name = "RSAES-PKCS1-v1_5";
    var r, n;
    return r = "RSAES-PKCS1-v1_5" !== e.name ? function (t, r) {
      return t = wn.convertToJWK(t, !0), ge.subtleCrypto.importKey("jwk", t, e, !0, ["encrypt"]).then(function (t) {
        return ge.subtleCrypto.encrypt(e, t, r);
      }).then(function (t) {
        return {
          data: Buffer.from(t)
        };
      });
    } : null, kn(t) && (n = function n(e, r) {
      return e = wn.convertToPem(e, !0), {
        data: ge.nodeCrypto.publicEncrypt({
          key: e,
          padding: ge.nodeCrypto.constants[Nn[t]]
        }, r)
      };
    }), ge.setupFallback(n, r, function (t, r) {
      r = new Ee(r).bytes();
      var n = wn.convertToForge(t, !0),
          i = {};
      "RSA-OAEP" === e.name && (i.md = e.hash.name.toLowerCase().replace(/-/g, ""), i.md = Yt.md[i.md].create());
      var a = n.encrypt(r, e.name.toUpperCase(), i);
      return a = new Ee(a).native(), Promise.resolve({
        data: a
      });
    });
  }

  function Rn(t) {
    var e = {
      name: t
    };
    "RSA-OAEP-256" === t ? (e.name = "RSA-OAEP", e.hash = {
      name: "SHA-256"
    }) : "RSA-OAEP" === t ? e.hash = {
      name: "SHA-1"
    } : e.name = "RSAES-PKCS1-v1_5";
    var r, n;
    return r = "RSAES-PKCS1-v1_5" !== e.name ? function (t, r) {
      return t = wn.convertToJWK(t, !1), ge.subtleCrypto.importKey("jwk", t, e, !0, ["decrypt"]).then(function (t) {
        return ge.subtleCrypto.decrypt(e, t, r);
      }).then(function (t) {
        return Buffer.from(t);
      });
    } : null, kn(t) ? n = function n(e, r) {
      return e = wn.convertToPem(e, !1), ge.nodeCrypto.privateDecrypt({
        key: e,
        padding: ge.nodeCrypto.constants[Nn[t]]
      }, r);
    } : ge.nodeCrypto && "RSA-OAEP" === t && (n = function n(t, e) {
      return t = wn.convertToPem(t, !1), ge.nodeCrypto.privateDecrypt(t, e);
    }), ge.setupFallback(n, r, function (t, r) {
      r = new Ee(r).bytes();
      var n = wn.convertToForge(t, !1),
          i = {};
      "RSA-OAEP" === e.name && (i.md = e.hash.name.toLowerCase().replace(/-/g, ""), i.md = Yt.md[i.md].create());
      var a = n.decrypt(r, e.name.toUpperCase(), i);
      return a = new Ee(a).native(), Promise.resolve(a);
    });
  }

  var Pn = {};
  ["RSA-OAEP", "RSA-OAEP-256", "RSA1_5"].forEach(function (t) {
    Pn[t] = {
      encrypt: _n(t),
      decrypt: Rn(t)
    };
  });
  var Fn = Pn;

  function Ln() {
    return ge.nodeCrypto && ge.nodeCrypto.constants && ge.nodeCrypto.constants.RSA_PSS_SALTLEN_DIGEST;
  }

  function Un(t) {
    var e,
        r = t.replace("RS", "SHA").toLowerCase(),
        n = t.replace("RS", "SHA-"),
        i = {
      name: "RSASSA-PKCS1-V1_5",
      hash: {
        name: n
      }
    },
        a = "RSA-" + n.replace("-", "");
    return ge.nodeCrypto && ge.nodeCrypto.getHashes().indexOf(a) > -1 && (e = function e(t, _e4) {
      var r = ge.nodeCrypto.createSign(a);
      return r.update(_e4), {
        data: _e4,
        mac: r.sign(wn.convertToPem(t, !1))
      };
    }), ge.setupFallback(e, function (t, e) {
      return t = wn.convertToJWK(t, !1), ge.subtleCrypto.importKey("jwk", t, i, !0, ["sign"]).then(function (t) {
        return ge.subtleCrypto.sign(i, t, e);
      }).then(function (t) {
        var r = Buffer.from(t);
        return {
          data: e,
          mac: r
        };
      });
    }, function (t, e) {
      var n = Yt.md[r].create();
      n.start(), n.update(e);
      var i = wn.convertToForge(t, !1).sign(n, "RSASSA-PKCS1-V1_5");
      return i = Buffer.from(i, "binary"), Promise.resolve({
        data: e,
        mac: i
      });
    });
  }

  function On(t) {
    var e,
        r = t.replace("RS", "SHA").toLowerCase(),
        n = {
      name: "RSASSA-PKCS1-V1_5",
      hash: {
        name: t.replace("RS", "SHA-")
      }
    };
    return ge.nodeCrypto && ge.nodeCrypto.getHashes().indexOf(r) > -1 && (e = function e(t, _e5, n) {
      var i = ge.nodeCrypto.createVerify(r);
      return i.update(_e5), i.end(), i.verify(wn.convertToPem(t, !0), n) ? {
        data: _e5,
        mac: n,
        valid: !0
      } : Promise.reject(new Error("verification failed"));
    }), ge.setupFallback(e, function (t, e, r) {
      return t = wn.convertToJWK(t, !0), ge.subtleCrypto.importKey("jwk", t, n, !0, ["verify"]).then(function (t) {
        return ge.subtleCrypto.verify(n, t, r, e);
      }).then(function (t) {
        return t ? {
          data: e,
          mac: r,
          valid: !0
        } : Promise.reject(new Error("verification failed"));
      });
    }, function (t, e, n) {
      var i = Yt.md[r].create();
      i.start(), i.update(e), i = i.digest().bytes();
      var a = wn.convertToForge(t, !0),
          o = n.toString("binary");
      return a.verify(i, o, "RSASSA-PKCS1-V1_5") ? Promise.resolve({
        data: e,
        mac: n,
        valid: !0
      }) : Promise.reject(new Error("verification failed"));
    });
  }

  function Dn(t) {
    var e,
        r = t.replace("PS", "SHA").toLowerCase(),
        n = t.replace("PS", "SHA-"),
        i = {
      name: "RSA-PSS",
      hash: {
        name: n
      },
      saltLength: ve.HASHLENGTH[n] / 8
    },
        a = "RSA-" + n.replace("-", "");
    return Ln() && (e = function e(t, _e6) {
      var r = ge.nodeCrypto.createSign(a);
      return r.update(_e6), {
        data: _e6,
        mac: r.sign({
          key: wn.convertToPem(t, !1),
          padding: ge.nodeCrypto.constants.RSA_PKCS1_PSS_PADDING,
          saltLength: ge.nodeCrypto.constants.RSA_PSS_SALTLEN_DIGEST
        })
      };
    }), ge.setupFallback(e, function (t, e) {
      return t = wn.convertToJWK(t, !1), ge.subtleCrypto.importKey("jwk", t, i, !0, ["sign"]).then(function (t) {
        return ge.subtleCrypto.sign(i, t, e);
      }).then(function (t) {
        var r = Buffer.from(t);
        return {
          data: e,
          mac: r
        };
      });
    }, function (t, e) {
      var i = Yt.md[r].create();
      i.start(), i.update(e);
      var a = Yt.pss.create({
        md: Yt.md[r].create(),
        mgf: Yt.mgf.mgf1.create(Yt.md[r].create()),
        saltLength: ve.HASHLENGTH[n] / 8
      }),
          o = wn.convertToForge(t, !1).sign(i, a);
      return o = Buffer.from(o, "binary"), Promise.resolve({
        data: e,
        mac: o
      });
    });
  }

  function Kn(t) {
    var e,
        r = t.replace("PS", "SHA").toLowerCase(),
        n = t.replace("PS", "SHA-"),
        i = {
      name: "RSA-PSS",
      hash: {
        name: n
      },
      saltLength: ve.HASHLENGTH[n] / 8
    };
    return Ln() && (e = function e(t, _e7, n) {
      var i = ge.nodeCrypto.createVerify(r);
      return i.update(_e7), i.end(), i.verify({
        key: wn.convertToPem(t, !0),
        padding: ge.nodeCrypto.constants.RSA_PKCS1_PSS_PADDING,
        saltLength: ge.nodeCrypto.constants.RSA_PSS_SALTLEN_DIGEST
      }, n) ? {
        data: _e7,
        mac: n,
        valid: !0
      } : Promise.reject(new Error("verification failed"));
    }), ge.setupFallback(e, function (t, e, r) {
      return t = wn.convertToJWK(t, !0), ge.subtleCrypto.importKey("jwk", t, i, !0, ["verify"]).then(function (t) {
        return ge.subtleCrypto.verify(i, t, r, e);
      }).then(function (t) {
        return t ? {
          data: e,
          mac: r,
          valid: !0
        } : Promise.reject(new Error("verification failed"));
      });
    }, function (t, e, i) {
      var a = Yt.md[r].create();
      a.start(), a.update(e), a = a.digest().bytes();
      var o = Yt.pss.create({
        md: Yt.md[r].create(),
        mgf: Yt.mgf.mgf1.create(Yt.md[r].create()),
        saltLength: ve.HASHLENGTH[n] / 8
      }),
          s = wn.convertToForge(t, !0),
          u = i.toString("binary");
      return s.verify(a, u, o) ? Promise.resolve({
        data: e,
        mac: i,
        valid: !0
      }) : Promise.reject(new Error("verification failed"));
    });
  }

  var Vn = {};
  ["PS256", "PS384", "PS512"].forEach(function (t) {
    Vn[t] = {
      sign: Dn(t),
      verify: Kn(t)
    };
  }), ["RS256", "RS384", "RS512"].forEach(function (t) {
    Vn[t] = {
      sign: Un(t),
      verify: On(t)
    };
  });
  var xn = {},
      jn = {},
      Mn = {},
      Hn = {},
      zn = {},
      Gn = {};
  [je, Ar, Pr, Ur, Or, hn, vn, ln, Te, An, Fn, Vn, Be].forEach(function (t) {
    Object.keys(t).forEach(function (e) {
      var r = t[e];
      "function" == typeof r.encrypt && (zn[e] = r.encrypt), "function" == typeof r.decrypt && (Gn[e] = r.decrypt), "function" == typeof r.sign && (Mn[e] = r.sign), "function" == typeof r.verify && (Hn[e] = r.verify), "function" == typeof r.digest && (xn[e] = r.digest), "function" == typeof r.derive && (jn[e] = r.derive);
    });
  });

  var qn = {
    digest: function digest(t, e, r) {
      var n = xn[t];
      return n ? n(e, r) : Promise.reject(new Error("unsupported algorithm: " + t));
    },
    derive: function derive(t, e, r) {
      var n = jn[t];
      return n ? n(e, r) : Promise.reject(new Error("unsupported algorithm: " + t));
    },
    sign: function sign(t, e, r, n) {
      var i = Mn[t];
      return i ? i(e, r, n || {}) : Promise.reject(new Error("unsupported algorithm: " + t));
    },
    verify: function verify(t, e, r, n, i) {
      var a = Hn[t];
      return a ? a(e, r, n, i || {}) : Promise.reject(new Error("unsupported algorithm: " + t));
    },
    encrypt: function encrypt(t, e, r, n) {
      var i = zn[t];
      return i ? i(e, r, n || {}) : Promise.reject(new Error("unsupported algorithm: " + t));
    },
    decrypt: function decrypt(t, e, r, n) {
      var i = Gn[t];
      return i ? i(e, r, n || {}) : Promise.reject(new Error("unsupported algorithm: " + t));
    }
  },
      Wn = {
    MODE_SIGN: "sign",
    MODE_VERIFY: "verify",
    MODE_ENCRYPT: "encrypt",
    MODE_DECRYPT: "decrypt",
    MODE_WRAP: "wrap",
    MODE_UNWRAP: "unwrap"
  },
      Qn = s.clone,
      Xn = {
    name: "PrivateKeyInfo",
    tagClass: Yt.asn1.Class.UNIVERSAL,
    type: Yt.asn1.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "PrivateKeyInfo.version",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.INTEGER,
      constructed: !1,
      capture: "keyVersion"
    }, {
      name: "PrivateKeyInfo.privateKeyAlgorithm",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "AlgorithmIdentifier.algorithm",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.OID,
        constructed: !1,
        capture: "keyOid"
      }, {
        name: "AlgorithmIdentifier.parameters",
        captureAsn1: "keyParams"
      }]
    }, {
      name: "PrivateKeyInfo",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.OCTETSTRING,
      constructed: !1,
      capture: "keyValue"
    }]
  },
      Yn = {
    name: "SubjectPublicKeyInfo",
    tagClass: Yt.asn1.Class.UNIVERSAL,
    type: Yt.asn1.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "AlgorithmIdentifier.algorithm",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.OID,
        constructed: !1,
        capture: "keyOid"
      }, {
        name: "AlgorithmIdentifier.parameters",
        captureAsn1: "keyParams"
      }]
    }, {
      name: "SubjectPublicKeyInfo.subjectPublicKey",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.BITSTRING,
      constructed: !1,
      capture: "keyValue"
    }]
  },
      Zn = {
    name: "Certificate",
    tagClass: Yt.asn1.Class.UNIVERSAL,
    type: Yt.asn1.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "Certificate.TBSCertificate",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "certificate",
      value: [{
        name: "Certificate.TBSCertificate.version",
        tagClass: Yt.asn1.Class.CONTEXT_SPECIFIC,
        type: 0,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.version.integer",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          type: Yt.asn1.Type.INTEGER,
          constructed: !1,
          capture: "certVersion"
        }]
      }, {
        name: "Certificate.TBSCertificate.serialNumber",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "certSerialNumber"
      }, {
        name: "Certificate.TBSCertificate.signature",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "Certificate.TBSCertificate.signature.algorithm",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          type: Yt.asn1.Type.OID,
          constructed: !1,
          capture: "certSignatureOid"
        }, {
          name: "Certificate.TBSCertificate.signature.parameters",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          optional: !0,
          captureAsn1: "certSignatureParams"
        }]
      }, {
        name: "Certificate.TBSCertificate.issuer",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.SEQUENCE,
        constructed: !0,
        captureAsn1: "certIssuer"
      }, {
        name: "Certificate.TBSCertificate.validity",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "Certificate.TBSCertificate.validity.notBefore (utc)",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          type: Yt.asn1.Type.UTCTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity1UTCTime"
        }, {
          name: "Certificate.TBSCertificate.validity.notBefore (generalized)",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          type: Yt.asn1.Type.GENERALIZEDTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity2GeneralizedTime"
        }, {
          name: "Certificate.TBSCertificate.validity.notAfter (utc)",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          type: Yt.asn1.Type.UTCTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity3UTCTime"
        }, {
          name: "Certificate.TBSCertificate.validity.notAfter (generalized)",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          type: Yt.asn1.Type.GENERALIZEDTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity4GeneralizedTime"
        }]
      }, {
        name: "Certificate.TBSCertificate.subject",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.SEQUENCE,
        constructed: !0,
        captureAsn1: "certSubject"
      }, Yn, {
        name: "Certificate.TBSCertificate.issuerUniqueID",
        tagClass: Yt.asn1.Class.CONTEXT_SPECIFIC,
        type: 1,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.issuerUniqueID.id",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          type: Yt.asn1.Type.BITSTRING,
          constructed: !1,
          capture: "certIssuerUniqueId"
        }]
      }, {
        name: "Certificate.TBSCertificate.subjectUniqueID",
        tagClass: Yt.asn1.Class.CONTEXT_SPECIFIC,
        type: 2,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.subjectUniqueID.id",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          type: Yt.asn1.Type.BITSTRING,
          constructed: !1,
          capture: "certSubjectUniqueId"
        }]
      }, {
        name: "Certificate.TBSCertificate.extensions",
        tagClass: Yt.asn1.Class.CONTEXT_SPECIFIC,
        type: 3,
        constructed: !0,
        captureAsn1: "certExtensions",
        optional: !0
      }]
    }, {
      name: "Certificate.signatureAlgorithm",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "Certificate.signatureAlgorithm.algorithm",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.OID,
        constructed: !1,
        capture: "certSignatureOid"
      }, {
        name: "Certificate.TBSCertificate.signature.parameters",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        optional: !0,
        captureAsn1: "certSignatureParams"
      }]
    }, {
      name: "Certificate.signatureValue",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.BITSTRING,
      constructed: !1,
      capture: "certSignature"
    }]
  },
      Jn = {
    THUMBPRINT_KEY: "internal\0thumbprint",
    THUMBPRINT_HASH: "SHA-256"
  },
      $n = {
    validators: {
      privateKey: Xn,
      publicKey: Yn,
      certificate: Zn
    },
    thumbprint: function thumbprint(t, e, r) {
      if ("function" != typeof t.thumbprint) return Promise.reject(new Error("thumbprint not supported"));
      r = (r || Jn.THUMBPRINT_HASH).toUpperCase();
      var n = t.thumbprint(e),
          i = Object.keys(n).sort().map(function (t) {
        var e = n[t];
        return Buffer.isBuffer(e) && (e = ne.base64url.encode(e)), JSON.stringify(t) + ":" + JSON.stringify(e);
      });
      i = "{" + i.join(",") + "}";

      try {
        return qn.digest(r, Buffer.from(i, "utf8"));
      } catch (t) {
        return Promise.reject(t);
      }
    },
    unpackProps: function unpackProps(t, e) {
      var r;
      e.forEach(function (e) {
        if (e.name in t) {
          r = r || {};
          var n = t[e.name];

          switch (e.type) {
            case "binary":
              Buffer.isBuffer(n) ? t[e.name] = ne.base64url.encode(n) : n = ne.base64url.decode(n);
              break;

            case "string":
            case "number":
            case "boolean":
              break;

            case "array":
              n = [].concat(n);
              break;

            case "object":
              n = Qn(n);
          }

          r[e.name] = n;
        }
      });
      var n = r || {};
      return Object.keys(t).forEach(function (e) {
        e in n || delete t[e];
      }), r;
    },
    COMMON_PROPS: [{
      name: "kty",
      type: "string"
    }, {
      name: "kid",
      type: "string"
    }, {
      name: "use",
      type: "string"
    }, {
      name: "alg",
      type: "string"
    }, {
      name: "x5c",
      type: "array"
    }, {
      name: "x5t",
      type: "binary"
    }, {
      name: "x5u",
      type: "string"
    }, {
      name: "key_ops",
      type: "array"
    }],
    INTERNALS: Jn
  },
      ti = s.assign,
      ei = s.clone,
      ri = s.flatten,
      ni = s.intersection,
      ii = s.omit,
      ai = s.pick,
      oi = s.uniq,
      si = function si(t, e, r, n) {
    if (!t) throw new Error("kty cannot be null");
    if (!e) throw new Error("keystore cannot be null");
    if (!r) throw new Error("props cannot be null");
    if ("string" == typeof r && (r = JSON.parse(r)), !n) throw new Error("cfg cannot be null");
    var i,
        a,
        o = [],
        s = {},
        u = {};
    r = ei(r), i = ti({}, r[$n.INTERNALS.THUMBPRINT_KEY] || {}), delete r[$n.INTERNALS.THUMBPRINT_KEY], Object.keys(i).forEach(function (t) {
      var e = i[t];
      a || (a = e, Buffer.isBuffer(a) && (a = ne.base64url.encode(a))), Buffer.isBuffer(e) || (e = ne.base64url.decode(e), i[t] = e);
    }), r.kty = t, r.kid = r.kid || a || ye();
    var c,
        f = Object.keys($n.COMMON_PROPS).map(function (t) {
      return $n.COMMON_PROPS[t].name;
    });
    u.base = ai(r, f), o = o.concat(Object.keys(u.base)), u.public = ei(r), s.public = n.publicKey(u.public), s.public && (o = o.concat(Object.keys(u.public))), u.private = ei(r), s.private = n.privateKey(u.private), s.private && (o = o.concat(Object.keys(u.private))), u.extra = ii(r, o), c = s.public && "length" in s.public ? s.public.length : s.private && "length" in s.private ? s.private.length : NaN, Object.defineProperty(this, "keystore", {
      value: e,
      enumerable: !0
    }), Object.defineProperty(this, "length", {
      value: c,
      enumerable: !0
    }), Object.defineProperty(this, "kty", {
      value: t,
      enumerable: !0
    }), Object.defineProperty(this, "kid", {
      value: u.base.kid,
      enumerable: !0
    }), Object.defineProperty(this, "use", {
      value: u.base.use || "",
      enumerable: !0
    }), Object.defineProperty(this, "alg", {
      value: u.base.alg || "",
      enumerable: !0
    }), Object.defineProperty(this, "thumbprint", {
      value: function value(t) {
        if (t = (t || $n.INTERNALS.THUMBPRINT_HASH).toUpperCase(), i[t]) return Promise.resolve(i[t]);
        var e = $n.thumbprint(n, u, t);
        return e = e.then(function (e) {
          return e && (i[t] = e), e;
        });
      }
    }), Object.defineProperty(this, "algorithms", {
      value: function value(e) {
        var r = [];
        this.use && "sig" !== this.use || (e && Wn.MODE_SIGN !== e || r.push(Wn.MODE_SIGN), e && Wn.MODE_VERIFY !== e || r.push(Wn.MODE_VERIFY)), this.use && "enc" !== this.use || (e && Wn.MODE_ENCRYPT !== e || r.push(Wn.MODE_ENCRYPT), e && Wn.MODE_DECRYPT !== e || r.push(Wn.MODE_DECRYPT), e && Wn.MODE_WRAP !== e || r.push(Wn.MODE_WRAP), e && Wn.MODE_UNWRAP !== e || r.push(Wn.MODE_UNWRAP));
        var i,
            a = this,
            o = r.map(function (t) {
          return n.algorithms.call(a, s, t);
        });
        (o = ri(o), o = oi(o), this.alg) && (i = "oct" === t ? [this.alg, "dir"] : [this.alg], o = ni(o, i));
        return o;
      }
    }), Object.defineProperty(this, "supports", {
      value: function value(t, e) {
        return -1 !== this.algorithms(e).indexOf(t);
      }
    }), Object.defineProperty(this, "has", {
      value: function value(t, e) {
        var r = !1;
        return r = (r = (r = (r = r || !!(u.base && t in u.base)) || !!(s.public && t in s.public)) || !!(u.extra && t in u.extra)) || !!(e && s.private && t in s.private);
      }
    }), Object.defineProperty(this, "get", {
      value: function value(t, e) {
        var r;
        return u.base && t in u.base ? r = u.base : s.public && t in s.public ? r = s.public : u.extra && t in u.extra ? r = u.extra : e && s.private && t in s.private && (r = s.private), r && r[t] || null;
      }
    }), Object.defineProperty(this, "toJSON", {
      value: function value(t, e) {
        Array.isArray(t) && (e = t, t = !1);
        var r = {};
        return r = l(r, u.base, u.public, "boolean" == typeof t && t ? u.private : {}, u.extra), r = ii(r, e || []);
      }
    }), Object.defineProperty(this, "toPEM", {
      value: function value(t) {
        if (null === t && (t = !1), !n.convertToPEM) throw new Error("Unsupported key type for PEM encoding");
        var e = t ? s.private : s.public;
        if (!e) throw new Error("Invalid key");
        return n.convertToPEM.call(this, e, t);
      }
    }), Object.defineProperty(this, "toObject", {
      value: function value(t, e) {
        Array.isArray(t) && (e = t, t = !1);
        var r = {};
        return r = l(r, u.base, s.public, "boolean" == typeof t && t ? s.private : {}, u.extra), r = ii(r, (e || []).concat("length"));
      }
    }), Object.defineProperty(this, "sign", {
      value: function value(t, e, r) {
        if (-1 === this.algorithms("sign").indexOf(t)) return Promise.reject(new Error("unsupported algorithm"));
        var i = n.signKey.call(this, t, s);
        return i ? (r = r ? ei(r) : {}, n.signProps && (r = l(r, n.signProps.call(this, t, r))), qn.sign(t, i, e, r)) : Promise.reject(new Error("improper key"));
      }
    }), Object.defineProperty(this, "verify", {
      value: function value(t, e, r, i) {
        if (-1 === this.algorithms("verify").indexOf(t)) return Promise.reject(new Error("unsupported algorithm"));
        var a = n.verifyKey.call(this, t, s);
        return a ? (i = i ? ei(i) : {}, n.verifyProps && (i = l(i, n.verifyProps.call(this, t, i))), qn.verify(t, a, e, r, i)) : Promise.reject(new Error("improper key"));
      }
    }), Object.defineProperty(this, "encrypt", {
      value: function value(t, e, r) {
        if (-1 === this.algorithms("encrypt").indexOf(t)) return Promise.reject(new Error("unsupported algorithm"));
        var i = n.encryptKey.call(this, t, s);
        return i ? (r = r ? ei(r) : {}, n.encryptProps && (r = l(r, n.encryptProps.call(this, t, r))), qn.encrypt(t, i, e, r)) : Promise.reject(new Error("improper key"));
      }
    }), Object.defineProperty(this, "decrypt", {
      value: function value(t, e, r) {
        if (-1 === this.algorithms("decrypt").indexOf(t)) return Promise.reject(new Error("unsupported algorithm"));
        var i = n.decryptKey.call(this, t, s);
        return i ? (r = r ? ei(r) : {}, n.decryptProps && (r = l(r, n.decryptProps.call(this, t, r))), qn.decrypt(t, i, e, r)) : Promise.reject(new Error("improper key"));
      }
    }), Object.defineProperty(this, "wrap", {
      value: function value(t, e, r) {
        if (-1 === this.algorithms("wrap").indexOf(t)) return Promise.reject(new Error("unsupported algorithm"));
        var i = n.wrapKey.call(this, t, s);
        return i ? (r = r ? ei(r) : {}, n.wrapProps && (r = l(r, n.wrapProps.call(this, t, r))), qn.encrypt(t, i, e, r)) : Promise.reject(new Error("improper key"));
      }
    }), Object.defineProperty(this, "unwrap", {
      value: function value(t, e, r) {
        if (-1 === this.algorithms("unwrap").indexOf(t)) return Promise.reject(new Error("unsupported algorithm"));
        var i = n.unwrapKey.call(this, t, s);
        return i ? (r = r ? ei(r) : {}, n.unwrapProps && (r = l(r, n.unwrapProps.call(this, t, r))), qn.decrypt(t, i, e, r)) : Promise.reject(new Error("improper key"));
      }
    });
  },
      ui = s.clone,
      ci = {
    BaseKey: si,
    helpers: $n
  },
      fi = function fi() {
    var t = {};
    Object.defineProperty(this, "register", {
      value: function value(e) {
        if (!e || "string" != typeof e.kty || !e.kty) throw new Error("invalid Key factory");
        var r = e.kty;
        return t[r] = e, this;
      }
    }), Object.defineProperty(this, "unregister", {
      value: function value(e) {
        if (!e || "string" != typeof e.kty || !e.kty) throw new Error("invalid Key factory");
        var r = e.kty;
        return e === t[r] && delete t[r], this;
      }
    }), Object.defineProperty(this, "get", {
      value: function value(e) {
        return t[e || ""] || void 0;
      }
    }), Object.defineProperty(this, "all", {
      value: function value() {
        return Object.keys(t).map(function (e) {
          return t[e];
        });
      }
    });
  },
      li = new fi();

  function hi(t, e) {
    var r,
        n = {},
        i = [],
        a = e.form,
        o = e.body,
        s = null;

    switch (e = Yt.asn1.fromDer(o), a) {
      case "private":
        t.all().some(function (t) {
          if (r) return !1;
          if (!t.validators) return !1;
          var a = t.validators.oid,
              o = t.validators.privateKey;
          return !!o && (n = {}, i = [], (r = Yt.asn1.validate(e, o, n, i)) && (n.keyOid = Yt.asn1.oidToDer(a), n.parsed = !0), r);
        }), n.type = "private";
        break;

      case "pkcs8":
        r = Yt.asn1.validate(e, ci.helpers.validators.privateKey, n, i), n.type = "private";
        break;

      case "public":
      case "spki":
        r = Yt.asn1.validate(e, ci.helpers.validators.publicKey, n, i), n.type = "public";
        break;

      case "pkix":
      case "x509":
        if (r = Yt.asn1.validate(e, ci.helpers.validators.certificate, n, i)) {
          n = function (t) {
            return ["certIssuer", "certSubject"].forEach(function (e) {
              var r = Yt.pki.RDNAttributesAsArray(t[e]),
                  n = t[e] = {};
              r.forEach(function (t) {
                n[t.name || t.type] = t.value;
              });
            }), t;
          }(n);

          var u = Yt.md.sha1.create();
          u.update(o), s = ne.base64url.encode(Buffer.from(u.digest().toHex(), "hex"));
        }

        n.type = "public";
    }

    return r ? (n.keyOid && (n.keyOid = Yt.asn1.derToOid(n.keyOid)), r = null, li.all().forEach(function (t) {
      r || t && "function" == typeof t.import && (r = t.import(n));
    }), r && n.certSubject && n.certSubject.commonName && (r.kid = n.certSubject.commonName), r && s && (r.x5t = s), r) : null;
  }

  var pi = function pi(t, e) {
    var r = {};
    Object.defineProperty(this, "generate", {
      value: function value(e, r, n) {
        var i = t.get(e);
        if (!i) return Promise.reject(new Error("unsupported key type"));
        (n = ui(n || {})).kty = e;
        var a = this;
        return i.generate(r).then(function (t) {
          return t = l(n, t, {
            kty: e
          }), a.add(t);
        });
      }
    }), Object.defineProperty(this, "add", {
      value: function value(e, n, i) {
        var a;
        if (i = i || {}, Buffer.isBuffer(e) || "string" == typeof e) {
          if ("json" === (n = (n || "json").toLowerCase())) e = JSON.parse(e.toString("utf8"));else try {
            if (a = "pem" === n ? function (t) {
              var e = {};
              if (!Yt.pem.decode(t).some(function (t) {
                switch (t.type) {
                  case "CERTIFICATE":
                    e.form = "pkix";
                    break;

                  case "PUBLIC KEY":
                    e.form = "spki";
                    break;

                  case "PRIVATE KEY":
                    e.form = "pkcs8";
                    break;

                  case "EC PRIVATE KEY":
                  case "RSA PRIVATE KEY":
                    e.form = "private";
                    break;

                  default:
                    return !1;
                }

                return e.body = t.body, !0;
              })) throw new Error("supported PEM type not found");
              return e;
            }(e) : {
              body: e.toString("binary"),
              form: n
            }, !(e = hi(t, a))) throw new Error("no importer for key");
            Object.keys(i).forEach(function (t) {
              e[t] = i[t];
            });
          } catch (t) {
            return Promise.reject(t);
          }
        } else e = pi.isKey(e) ? e.toJSON(!0) : ui(e);
        var o = t.get(e.kty);
        if (!o) return Promise.reject(new Error("unsupported key type"));
        var s = this;
        return o.prepare(e).then(function (t) {
          return new ci.BaseKey(e.kty, s, e, t);
        }).then(function (t) {
          var e = t.kid || "";
          return (r[e] = r[e] || []).push(t), t;
        });
      }
    }), Object.defineProperty(this, "remove", {
      value: function value(t) {
        if (t) {
          var e = r[t.kid];

          if (e) {
            var n = e.indexOf(t);
            -1 !== n && (e.splice(n, 1), e.length || delete r[t.kid]);
          }
        }
      }
    }), Object.defineProperty(this, "all", {
      value: function value(t, n) {
        void 0 !== (t = t || {}).kid && null !== t.kid && "string" != typeof t.kid && (t.kid = String(t.kid));

        var i = [],
            a = function a(e) {
          return (!t.kty || !e.kty || t.kty === e.kty) && (!t.use || !e.use || t.use === e.use) && (!t.alg || ("dir" === t.alg || !e.alg || t.alg === e.alg) && e.supports(t.alg));
        };

        return Object.keys(r).forEach(function (e) {
          if (!t.kid || t.kid === e) {
            var n = r[e].filter(a);
            n.length && (i = i.concat(n));
          }
        }), !n && e && (i = i.concat(e.all(t))), i;
      }
    }), Object.defineProperty(this, "get", {
      value: function value(t, r, n) {
        "boolean" == typeof t ? (n = t, r = t = null) : "object" == typeof t && (n = r, r = t, t = null), r = r || {}, t && (r.kid = t), void 0 !== r.kid && null !== r.kid && "string" != typeof r.kid && (r.kid = String(r.kid));
        var i = this.all(r, !0);
        return i.length || !e || n || (i = e.get(r, n)), i[0] || null;
      }
    }), Object.defineProperty(this, "temp", {
      value: function value() {
        return new pi(t, this);
      }
    }), Object.defineProperty(this, "toJSON", {
      value: function value(t) {
        var e = [];
        return Object.keys(r).forEach(function (n) {
          var i = r[n].map(function (e) {
            return e.toJSON(t);
          });
          e = e.concat(i);
        }), {
          keys: e
        };
      }
    });
  };

  pi.isKeyStore = function (t) {
    return !!t && "object" == typeof t && "function" == typeof t.get && "function" == typeof t.all && "function" == typeof t.generate && "function" == typeof t.add && "function" == typeof t.remove;
  }, pi.createKeyStore = function () {
    return new pi(li);
  }, pi.asKeyStore = function (t) {
    if (pi.isKeyStore(t)) return Promise.resolve(t);
    var e,
        r = pi.createKeyStore();
    if ("string" == typeof t && (t = JSON.parse(t)), Array.isArray(t)) e = t;else {
      if (!("keys" in t)) return Promise.reject(new Error("invalid keystore"));
      e = t.keys;
    }
    e = e.map(function (t) {
      return r.add(t);
    });
    var n = Promise.all(e);
    return n = n.then(function () {
      return r;
    });
  }, pi.isKey = function (t) {
    return !!t && "object" == typeof t && !!pi.isKeyStore(t.keystore) && "string" == typeof t.kty && "number" == typeof t.length && "function" == typeof t.algorithms && "function" == typeof t.supports && "function" == typeof t.encrypt && "function" == typeof t.decrypt && "function" == typeof t.wrap && "function" == typeof t.unwrap && "function" == typeof t.sign && "function" == typeof t.verify;
  }, pi.createKey = function (t, e, r) {
    return pi.createKeyStore().generate(t, e, r);
  }, pi.asKey = function (t, e, r) {
    return pi.isKey(t) ? Promise.resolve(t) : t = pi.createKeyStore().add(t, e, r);
  };
  var di = {
    KeyRegistry: fi,
    KeyStore: pi,
    registry: li
  },
      yi = {
    BaseKey: si,
    helpers: $n
  },
      gi = ["HS256", "HS384", "HS512"],
      vi = ["A128GCM", "A192GCM", "A256GCM", "A128CBC-HS256", "A192CBC-HS384", "A256CBC-HS512", "A128CBC+HS256", "A192CBC+HS384", "A256CBC+HS512"],
      mi = ["A128KW", "A192KW", "A256KW", "A128GCMKW", "A192GCMKW", "A256GCMKW", "PBES2-HS256+A128KW", "PBES2-HS384+A192KW", "PBES2-HS512+A256KW", "dir"];

  function Ei(t, e) {
    return "iv" in e && (e.iv = Buffer.isBuffer(e.iv) ? e.iv : ne.base64url.decode(e.iv || "")), "adata" in e && (e.adata = Buffer.isBuffer(e.adata) ? e.adata : Buffer.from(e.adata || "", "utf8")), "mac" in e && (e.mac = Buffer.isBuffer(e.mac) ? e.mac : ne.base64url.decode(e.mac || "")), "tag" in e && (e.tag = Buffer.isBuffer(e.tag) ? e.tag : ne.base64url.decode(e.tag || "")), e;
  }

  function Ci(t, e) {
    return "iv" in e && (e.iv = Buffer.isBuffer(e.iv) ? e.iv : ne.base64url.decode(e.iv || "")), "adata" in e && (e.adata = Buffer.isBuffer(e.adata) ? e.adata : Buffer.from(e.adata || "", "utf8")), e;
  }

  var Si = {
    publicKey: function publicKey(t) {
      var e = yi.helpers.COMMON_PROPS.concat([]);
      return yi.helpers.unpackProps(t, e);
    },
    privateKey: function privateKey(t) {
      var e,
          r = yi.helpers.COMMON_PROPS.concat([{
        name: "k",
        type: "binary"
      }]);
      return (e = yi.helpers.unpackProps(t, r)) && e.k ? e.length = 8 * e.k.length : e = void 0, e;
    },
    thumbprint: function thumbprint(t) {
      return t.private && (t = t.private), {
        k: t.k || "",
        kty: "oct"
      };
    },
    algorithms: function algorithms(t, e) {
      var r = t.private && 8 * t.private.k.length,
          n = [256, 384, 512];
      if (!r) return [];

      switch (e) {
        case "encrypt":
        case "decrypt":
          return vi.filter(function (t) {
            return t === "A" + r / 2 + "CBC-HS" + r || t === "A" + r / 2 + "CBC+HS" + r || t === "A" + r + "GCM";
          });

        case "sign":
        case "verify":
          return gi.filter(function (t) {
            var e = !1;
            return n.forEach(function (n) {
              n > r || (e |= t === "HS" + n);
            }), e;
          });

        case "wrap":
        case "unwrap":
          return mi.filter(function (t) {
            return t === "A" + r + "KW" || t === "A" + r + "GCMKW" || 0 === t.indexOf("PBES2-") || "dir" === t;
          });
      }

      return [];
    },
    encryptKey: function encryptKey(t, e) {
      return e.private && e.private.k;
    },
    encryptProps: Ci,
    decryptKey: function decryptKey(t, e) {
      return e.private && e.private.k;
    },
    decryptProps: Ei,
    wrapKey: function wrapKey(t, e) {
      return e.private && e.private.k;
    },
    wrapProps: Ci,
    unwrapKey: function unwrapKey(t, e) {
      return e.private && e.private.k;
    },
    unwrapProps: Ei,
    signKey: function signKey(t, e) {
      return e.private && e.private.k;
    },
    verifyKey: function verifyKey(t, e) {
      return e.private && e.private.k;
    }
  },
      bi = {
    kty: "oct",
    prepare: function prepare(t) {
      var e = Si,
          r = Promise.resolve(t);
      return r = (r = r.then(function (t) {
        return yi.helpers.thumbprint(e, t);
      })).then(function (r) {
        var n = {};
        return n[yi.helpers.INTERNALS.THUMBPRINT_HASH] = r, t[yi.helpers.INTERNALS.THUMBPRINT_KEY] = n, e;
      });
    },
    generate: function generate(t) {
      var e = ne.randomBytes(t / 8);
      return Promise.resolve({
        k: e
      });
    }
  };
  Object.freeze({
    config: Si,
    factory: bi
  });
  di.registry.register(bi);
  var Ti = ge.nodeCrypto,
      Ai = {
    BaseKey: si,
    helpers: $n
  },
      Ii = ["RS256", "RS384", "RS512", "PS256", "PS384", "PS512"],
      Bi = ["RSA-OAEP", "RSA-OAEP-256", "RSA1_5"],
      wi = {
    publicKey: function publicKey(t) {
      var e,
          r = Ai.helpers.COMMON_PROPS.concat([{
        name: "n",
        type: "binary"
      }, {
        name: "e",
        type: "binary"
      }]);
      return (e = Ai.helpers.unpackProps(t, r)) && e.n && e.e ? e.length = 8 * e.n.length : (delete e.e, delete e.n), e;
    },
    privateKey: function privateKey(t) {
      var e,
          r = Ai.helpers.COMMON_PROPS.concat([{
        name: "n",
        type: "binary"
      }, {
        name: "e",
        type: "binary"
      }, {
        name: "d",
        type: "binary"
      }, {
        name: "p",
        type: "binary"
      }, {
        name: "q",
        type: "binary"
      }, {
        name: "dp",
        type: "binary"
      }, {
        name: "dq",
        type: "binary"
      }, {
        name: "qi",
        type: "binary"
      }]);
      return (e = Ai.helpers.unpackProps(t, r)) && e.d && e.n && e.e && e.p && e.q && e.dp && e.dq && e.qi ? e.length = 8 * e.d.length : e = void 0, e;
    },
    thumbprint: function thumbprint(t) {
      return t.public && (t = t.public), {
        e: t.e,
        kty: "RSA",
        n: t.n
      };
    },
    algorithms: function algorithms(t, e) {
      switch (e) {
        case "encrypt":
        case "decrypt":
          return [];

        case "wrap":
          return t.public && Bi.slice() || [];

        case "unwrap":
          return t.private && Bi.slice() || [];

        case "sign":
          return t.private && Ii.slice() || [];

        case "verify":
          return t.public && Ii.slice() || [];
      }

      return [];
    },
    wrapKey: function wrapKey(t, e) {
      return e.public;
    },
    unwrapKey: function unwrapKey(t, e) {
      return e.private;
    },
    signKey: function signKey(t, e) {
      return e.private;
    },
    verifyKey: function verifyKey(t, e) {
      return e.public;
    },
    convertToPEM: function convertToPEM(t, e) {
      var r = wn.convertToForge(t, !e);
      return e ? Yt.pki.privateKeyToPem(r) : Yt.pki.publicKeyToPem(r);
    }
  };
  var Ni = {
    oid: "1.2.840.113549.1.1.1",
    privateKey: {
      name: "RSAPrivateKey",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "RSAPrivateKey.version",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "version"
      }, {
        name: "RSAPrivateKey.modulus",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "n"
      }, {
        name: "RSAPrivateKey.publicExponent",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "e"
      }, {
        name: "RSAPrivateKey.privateExponent",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "d"
      }, {
        name: "RSAPrivateKey.prime1",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "p"
      }, {
        name: "RSAPrivateKey.prime2",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "q"
      }, {
        name: "RSAPrivateKey.exponent1",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "dp"
      }, {
        name: "RSAPrivateKey.exponent2",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "dq"
      }, {
        name: "RSAPrivateKey.coefficient",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "qi"
      }]
    },
    publicKey: {
      name: "RSAPublicKey",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "RSAPublicKey.modulus",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "n"
      }, {
        name: "RSAPublicKey.exponent",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1,
        capture: "e"
      }]
    }
  },
      ki = {
    kty: "RSA",
    validators: Ni,
    prepare: function prepare(t) {
      var e = wi,
          r = Promise.resolve(t);
      return r = (r = r.then(function (t) {
        return Ai.helpers.thumbprint(e, t);
      })).then(function (r) {
        var n = {};
        return n[Ai.helpers.INTERNALS.THUMBPRINT_HASH] = r, t[Ai.helpers.INTERNALS.THUMBPRINT_KEY] = n, e;
      });
    },
    generate: function generate(t) {
      var e;
      if (Ti) e = new Promise(function (e, r) {
        Yt.pki.rsa.generateKeyPair({
          bits: t,
          e: 65537
        }, function (t, n) {
          if (t) return r(t);
          e(n.privateKey);
        });
      });else {
        var r = Yt.pki.rsa.generateKeyPair({
          bits: t,
          e: 65537
        });
        e = Promise.resolve(r.privateKey);
      }
      return e.then(function (t) {
        var e = {};
        return ["e", "n", "d", "p", "q", {
          incoming: "dP",
          outgoing: "dp"
        }, {
          incoming: "dQ",
          outgoing: "dq"
        }, {
          incoming: "qInv",
          outgoing: "qi"
        }].forEach(function (r) {
          var n, i, a;
          "string" == typeof r ? n = i = r : (n = r.incoming, i = r.outgoing), n in t && (e[i] = ((a = (a = t[n]).toString(16)).length % 2 && (a = "0" + a), Buffer.from(a, "hex")));
        }), e;
      });
    },
    import: function _import(t) {
      if (Ni.oid !== t.keyOid) return null;

      if (!t.parsed) {
        "string" == typeof t.keyValue ? t.keyValue = Yt.asn1.fromDer(t.keyValue) : Array.isArray(t.keyValue) && (t.keyValue = t.keyValue[0]);
        var e = "private" === t.type ? Ni.privateKey : Ni.publicKey,
            r = {};
        if (!Yt.asn1.validate(t.keyValue, e, r, [])) return null;
        t = r;
      }

      var n = {
        kty: "RSA"
      };
      return ["n", "e", "d", "p", "q", "dp", "dq", "qi"].forEach(function (e) {
        if (e in t) {
          var r = Buffer.from(t[e], "binary");
          0 === r[0] && (r = r.slice(1)), n[e] = r;
        }
      }), n;
    }
  };
  Object.freeze({
    config: wi,
    factory: ki
  });
  !function (t) {
    t.register(ki);
  }(di.registry);
  var _i = {
    BaseKey: si,
    helpers: $n
  },
      Ri = ["ES256", "ES384", "ES512"],
      Pi = ["ECDH-ES", "ECDH-ES+A128KW", "ECDH-ES+A192KW", "ECDH-ES+A256KW"],
      Fi = un.EC_OID;

  function Li(t) {
    switch (t) {
      case "1.2.840.10045.3.1.7":
        return "P-256";

      case "1.3.132.0.34":
        return "P-384";

      case "1.3.132.0.35":
        return "P-521";

      default:
        return null;
    }
  }

  var Ui = {
    publicKey: function publicKey(t) {
      var e = _i.helpers.COMMON_PROPS.concat([{
        name: "crv",
        type: "string"
      }, {
        name: "x",
        type: "binary"
      }, {
        name: "y",
        type: "binary"
      }]),
          r = _i.helpers.unpackProps(t, e);

      return r && r.crv && r.x && r.y ? r.length = un.curveSize(r.crv) : (delete r.crv, delete r.x, delete r.y), r;
    },
    privateKey: function privateKey(t) {
      var e = _i.helpers.COMMON_PROPS.concat([{
        name: "crv",
        type: "string"
      }, {
        name: "x",
        type: "binary"
      }, {
        name: "y",
        type: "binary"
      }, {
        name: "d",
        type: "binary"
      }]),
          r = _i.helpers.unpackProps(t, e);

      return r && r.crv && r.x && r.y && r.d ? r.length = un.curveSize(r.crv) : r = void 0, r;
    },
    thumbprint: function thumbprint(t) {
      return t.public && (t = t.public), {
        crv: t.crv,
        kty: "EC",
        x: t.x,
        y: t.y
      };
    },
    algorithms: function algorithms(t, e) {
      var r = t.public && t.public.length || t.private && t.private.length || 0;

      switch (521 === r && (r = 512), e) {
        case "encrypt":
        case "decrypt":
          return [];

        case "wrap":
          return t.public && Pi || [];

        case "unwrap":
          return t.private && Pi || [];

        case "sign":
          return t.private ? Ri.filter(function (t) {
            return t === "ES" + r;
          }) : [];

        case "verify":
          return t.public ? Ri.filter(function (t) {
            return t === "ES" + r;
          }) : [];
      }
    },
    encryptKey: function encryptKey(t, e) {
      return e.public;
    },
    decryptKey: function decryptKey(t, e) {
      return e.private;
    },
    wrapKey: function wrapKey(t, e) {
      return e.public;
    },
    unwrapKey: function unwrapKey(t, e) {
      return e.private;
    },
    signKey: function signKey(t, e) {
      return e.private;
    },
    verifyKey: function verifyKey(t, e) {
      return e.public;
    }
  };
  Ui.convertToPEM = un.convertToPEM;
  var Oi = {
    oid: Fi,
    privateKey: {
      name: "ECPrivateKey",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "ECPrivateKey.version",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1
      }, {
        name: "ECPrivateKey.private",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.OCTETSTRING,
        constructed: !1,
        capture: "d"
      }, {
        tagClass: Yt.asn1.Class.CONTEXT_SPECIFIC,
        name: "ECPrivateKey.parameters",
        constructed: !0,
        value: [{
          name: "ECPrivateKey.namedCurve",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          type: Yt.asn1.Type.OID,
          constructed: !1,
          capture: "crv"
        }]
      }, {
        name: "ECPrivateKey.publicKey",
        tagClass: Yt.asn1.Class.CONTEXT_SPECIFIC,
        constructed: !0,
        value: [{
          name: "ECPrivateKey.point",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          type: Yt.asn1.Type.BITSTRING,
          constructed: !1,
          capture: "point"
        }]
      }]
    },
    embeddedPrivateKey: {
      name: "ECPrivateKey",
      tagClass: Yt.asn1.Class.UNIVERSAL,
      type: Yt.asn1.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "ECPrivateKey.version",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.INTEGER,
        constructed: !1
      }, {
        name: "ECPrivateKey.private",
        tagClass: Yt.asn1.Class.UNIVERSAL,
        type: Yt.asn1.Type.OCTETSTRING,
        constructed: !1,
        capture: "d"
      }, {
        name: "ECPrivateKey.publicKey",
        tagClass: Yt.asn1.Class.CONTEXT_SPECIFIC,
        constructed: !0,
        value: [{
          name: "ECPrivateKey.point",
          tagClass: Yt.asn1.Class.UNIVERSAL,
          type: Yt.asn1.Type.BITSTRING,
          constructed: !1,
          capture: "point"
        }]
      }]
    }
  },
      Di = {
    kty: "EC",
    validators: Oi,
    prepare: function prepare(t) {
      var e = Ui,
          r = Promise.resolve(t);
      return r = (r = r.then(function (t) {
        return _i.helpers.thumbprint(e, t);
      })).then(function (r) {
        var n = {};
        return n[_i.helpers.INTERNALS.THUMBPRINT_HASH] = r, t[_i.helpers.INTERNALS.THUMBPRINT_KEY] = n, e;
      });
    },
    generate: function generate(t) {
      var e = tn.generateKeyPair(t),
          r = {
        crv: t,
        x: e.public.x,
        y: e.public.y,
        d: e.private.d
      };
      return Promise.resolve(r);
    },
    import: function _import(t) {
      if (Oi.oid !== t.keyOid) return null;
      var e;
      if (t.keyParams && Yt.asn1.Type.OID === t.keyParams.type ? e = Li(e = Yt.asn1.derToOid(t.keyParams.value)) : t.crv && (e = Li(e = Yt.asn1.derToOid(t.crv))), !e) return null;

      if (!t.parsed) {
        var r = {};

        if ("private" === t.type) {
          if ("string" == typeof t.keyValue ? t.keyValue = Yt.asn1.fromDer(t.keyValue) : Array.isArray(t.keyValue) && (t.keyValue = t.keyValue[0]), !Yt.asn1.validate(t.keyValue, Oi.embeddedPrivateKey, r, [])) return null;
        } else r.point = t.keyValue;

        t = r;
      }

      var n = {
        kty: "EC",
        crv: e
      };

      if (t.d && (n.d = Buffer.from(t.d, "binary")), t.point) {
        var i = Buffer.from(t.point, "binary");
        if (4 !== i.readUInt16BE(0)) return null;
        var a = (i = i.slice(2)).length / 2;
        n.x = i.slice(0, a), n.y = i.slice(a);
      }

      return n;
    }
  };
  Object.freeze({
    config: Ui,
    factory: Di
  });
  !function (t) {
    t.register(Di);
  }(di.registry);

  var Ki = i(function (t, e) {
    Object.keys(di.KeyStore).forEach(function (t) {
      e[t] = di.KeyStore[t];
    }), Object.keys(Wn).forEach(function (t) {
      e[t] = Wn[t];
    });
  }),
      Vi = {
    compact: !1,
    protect: "*"
  },
      xi = function xi(t, e) {
    return Array.prototype.slice.call(t, e || 0);
  },
      ji = s.clone,
      Mi = s.uniq,
      Hi = function Hi(t, e) {
    var r = !1,
        n = t.format || "general",
        i = Buffer.alloc(0);
    Object.defineProperty(this, "compact", {
      get: function get() {
        return "compact" === n;
      },
      enumerable: !0
    }), Object.defineProperty(this, "format", {
      get: function get() {
        return n;
      },
      enumerable: !0
    }), Object.defineProperty(this, "update", {
      value: function value(t, e) {
        if (r) throw new Error("already final");
        return null != t && (t = ne.asBuffer(t, e), i = i.length ? Buffer.concat([i, t], i.length + t.length) : t), this;
      }
    }), Object.defineProperty(this, "final", {
      value: function value(t, a) {
        if (r) return Promise.reject(new Error("already final"));
        var o;

        switch (this.update(t, a), r = !0, o = (o = (o = Promise.all(e)).then(function (t) {
          return i = ne.base64url.encode(i), t = t.map(function (t) {
            var e = {},
                r = 0,
                n = ji(t.header),
                a = Object.keys(n).length;
            t.protected.forEach(function (t) {
              t in n && (e[t] = n[t], r++, delete n[t], a--);
            }), r > 0 ? (e = JSON.stringify(e), e = ne.base64url.encode(e)) : e = "";
            var o = Buffer.from(e + "." + i, "ascii");
            return t = (t = t.key.sign(t.header.alg, o, t.header)).then(function (t) {
              var i = {};
              return 0 < r && (i.protected = e), 0 < a && (i.header = n), i.signature = ne.base64url.encode(t.mac), i;
            });
          }), t = [Promise.resolve(i)].concat(t), Promise.all(t);
        })).then(function (t) {
          return {
            payload: t[0],
            signatures: t.slice(1)
          };
        }), n) {
          case "compact":
            o = o.then(function (t) {
              var e = [t.signatures[0].protected, t.payload, t.signatures[0].signature];
              return e = e.join(".");
            });
            break;

          case "flattened":
            o = o.then(function (t) {
              var e = {};
              e.payload = t.payload;
              var r = t.signatures[0];
              return r.protected && (e.protected = r.protected), r.header && (e.header = r.header), e.signature = r.signature, e;
            });
        }

        return o;
      }
    });
  };
  /*!
  	 * jws/helpers.js - JWS Internal Helper Functions
  	 *
  	 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
  	 */


  var zi = {
    signer: Hi,
    createSign: function createSign(t, e) {
      var r = t,
          n = 1,
          i = e;
      if (0 === arguments.length) throw new Error("at least one signatory must be provided");
      1 === arguments.length ? (i = t, n = 0, r = {}) : Ki.isKey(t) || t && "kty" in t || t && "key" in t && (Ki.isKey(t.key) || "kty" in t.key) ? (i = t, n = 0, r = {}) : r = ji(t), Array.isArray(i) || (i = xi(arguments, n));
      var a = (r = l(ji(Vi), r)).fields || {},
          o = r.format;
      if (o || (o = r.compact ? "compact" : "general"), ("compact" === o || "flattened" === o) && 1 < i.length) throw new Error("too many signatories for compact or flattened JSON serialization");
      var s = "*" === r.protect;
      r.compact && (s = !0), i = i.map(function (t, e) {
        return (t && "kty" in t ? Ki.asKey(t).then(function (t) {
          return {
            key: t
          };
        }) : t ? Ki.asKey(t.key).then(function (e) {
          return {
            header: t.header,
            reference: t.reference,
            protect: t.protect,
            key: e
          };
        }) : Promise.reject(new Error("missing key for signatory " + e))).then(function (t) {
          var e = t.key,
              r = t.header || {};
          r = l(l({}, a), r), t.header = r, r.alg || (r.alg = e.algorithms(Ki.MODE_SIGN)[0] || "");
          var n,
              i = t.reference;
          if (delete t.reference, void 0 === i ? i = (i = ["kid", "jku", "x5c", "x5t", "x5u"].some(function (t) {
            return t in r;
          })) ? null : "kid" : "boolean" == typeof i && (i = i ? "kid" : null), i) if (n = e.toJSON(), "jwk" === i) {
            if ("oct" === e.kty) return Promise.reject(new Error("cannot embed key"));
            r.jwk = n;
          } else i in n && (r[i] = n[i]);
          var o = t.protect;
          if (s || "*" === o) o = Object.keys(r);else if ("string" === o) o = [o];else if (Array.isArray(o)) o = o.concat();else {
            if (o) return Promise.reject(new Error("protect must be a list of fields"));
            o = [];
          }
          return o = Mi(o), t.protected = o, t = Object.freeze(t);
        });
      });
      var u = {
        format: o
      };
      return new Hi(u, i);
    }
  };
  /*!
  	 * util/algconfig.js - Functions for managing algorithm set options
  	 *
  	 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
  	 */

  function Gi(t) {
    return t.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
  }

  var qi = function qi(t) {
    t ? "string" == typeof t && (t = t.split(" ")) : t = [];
    var e,
        r = [],
        n = [],
        i = [],
        a = [],
        o = /^(!)?([^*]*)(\*?)([^*]*)$/;
    t.forEach(function (t) {
      if (t) {
        o.lastIndex = 0;
        var s = o.exec(t);
        s && (e = "(" + function (t, e, r) {
          var n = [];
          return n.push("^"), t && (t = Gi(t), n.push(t)), e && n.push(t || r ? ".*" : ".+"), r && (r = Gi(r), n.push(r)), n.push("$"), n.join("");
        }(s[2], s[3], s[4]) + ")", s[1] ? (a.push(e), n.push(s[0])) : (i.push(e), r.push(s[0])));
      }
    }), i = i.length ? new RegExp(i.join("|")) : null, a = a.length ? new RegExp(a.join("|")) : null, r.length || (r = ["*"]), Object.defineProperty(this, "spec", {
      value: r.join(" ") + " " + n.join(" "),
      enumerable: !0
    }), Object.defineProperty(this, "match", {
      value: function value(t) {
        var e = Boolean(t);
        return e && i && (i.lastIndex = 0, e = i.test(t)), e && a && (a.lastIndex = 0, e = !a.test(t)), e;
      }
    });
  },
      Wi = s.clone,
      Qi = {
    algorithms: "*",
    allowEmbeddedKey: !1
  },
      Xi = function Xi(t, e) {
    var r, n;
    n = Ki.isKey(t) ? (r = t).keystore : Ki.isKeyStore(t) ? t : Ki.createKeyStore(), e = l(Qi, e), Object.defineProperty(this, "defaultKey", {
      value: r || void 0,
      enumerable: !0
    }), Object.defineProperty(this, "keystore", {
      value: n,
      enumerable: !0
    }), Object.defineProperty(this, "verify", {
      value: function value(t, i) {
        var a = (i = l({}, e, i || {})).handlers || {},
            o = Object.keys(a),
            s = new qi(i.algorithms);
        if ("string" == typeof t) t = {
          payload: (t = t.split("."))[1],
          signatures: [{
            protected: t[0],
            signature: t[2]
          }]
        };else if (!t || "object" != typeof t) throw new Error("invalid input");
        t.signature && (t.signatures = [{
          protected: t.protected || void 0,
          header: t.header || void 0,
          signature: t.signature
        }]);
        var u = t.signatures || [{}];
        u = u.map(function (t) {
          var e = Wi(t.header || {}),
              r = t.protected ? JSON.parse(ee.decode(t.protected, "utf8")) : {};
          e = l(e, r);
          var n = ee.decode(t.signature);
          if (!s.match(e.alg)) return Promise.reject(new Error("Algorithm not allowed: " + e.alg));
          var i = r.crit;

          if (i) {
            if (!Array.isArray(i)) return Promise.reject(new Error("Invalid 'crit' header"));

            for (var a = 0; i.length > a; a++) {
              if (-1 === o.indexOf(i[a])) return Promise.reject(new Error("Critical extension is not supported: " + i[a]));
            }
          }

          return r = Object.keys(r), Promise.resolve({
            protected: r,
            aad: t.protected || "",
            header: e,
            signature: n
          });
        });
        var c = Promise.all(u);
        return c = c.then(function (e) {
          return new Promise(function (s, u) {
            var c = function c() {
              var f = e.shift();

              if (f) {
                f = l({}, f, {
                  payload: t.payload
                });
                var h = Promise.resolve(f);
                (h = (h = (h = (h = (h = (h = h.then(function (t) {
                  var e;
                  return i.allowEmbeddedKey && t.header.jwk ? e = Ki.asKey(t.header.jwk) : i.allowEmbeddedKey && t.header.x5c ? (e = t.header.x5c[0], e = Buffer.from(e, "base64"), e = Ki.asKey(e, "pkix")) : e = Promise.resolve(r || n.get({
                    use: "sig",
                    alg: t.header.alg,
                    kid: t.header.kid
                  })), e.then(function (e) {
                    return e ? (t.key = e, t) : Promise.reject(new Error("key does not match"));
                  });
                })).then(function (t) {
                  var e = [];
                  return o.forEach(function (r) {
                    var n;
                    "function" == typeof (r = a[r]) ? n = r(t) : "object" == typeof r && "function" == typeof r.prepare && (n = r.prepare(t)), n && e.push(Promise.resolve(n));
                  }), Promise.all(e).then(function () {
                    return t;
                  });
                })).then(function (t) {
                  var e = t.aad || "",
                      r = t.payload || "",
                      n = Buffer.alloc(1 + e.length + r.length),
                      i = 0;
                  return n.write(e, i, "ascii"), i += e.length, n.write(".", i, "ascii"), i++, Buffer.isBuffer(r) ? r.copy(n, i) : n.write(r, i, "binary"), t.content = n, t;
                })).then(function (t) {
                  return t.key.verify(t.header.alg, t.content, t.signature);
                })).then(function (t) {
                  var e = f.payload;
                  return e = ee.decode(e), {
                    protected: f.protected,
                    header: f.header,
                    payload: e,
                    signature: t.mac,
                    key: f.key
                  };
                })).then(function (t) {
                  var e = [];
                  return o.forEach(function (r) {
                    var n;
                    "object" == typeof (r = a[r]) && "function" == typeof r.complete && (n = r.complete(t)), n && e.push(Promise.resolve(n));
                  }), Promise.all(e).then(function () {
                    return t;
                  });
                })).then(s, c);
              } else u(new Error("no key found"));
            };

            c();
          });
        });
      }
    });
  };

  var Yi = {
    createSign: zi.createSign,
    createVerify: {
      verifier: Xi,
      createVerify: function createVerify(t, e) {
        return new Xi(t, e);
      }
    }.createVerify
  },
      Zi = {
    zip: !1,
    format: "general",
    contentAlg: "A128CBC-HS256",
    protect: "*"
  },
      Ji = function Ji(t) {
    var e = Ki.createKeyStore(),
        r = ve.KEYLENGTH[t];
    if (r) return e.generate("oct", r);
    throw new Error("unsupported encryption algorithm");
  },
      $i = function $i(t, e) {
    return Array.prototype.slice.call(t, e || 0);
  },
      ta = s.assign,
      ea = s.clone;

  function ra(t, r, n) {
    var i = !1,
        a = t.format || "general",
        o = !!t.protectAll,
        s = Buffer.alloc(0);
    Object.defineProperty(this, "zip", {
      get: function get() {
        return r.zip || "";
      },
      enumerable: !0
    }), Object.defineProperty(this, "compact", {
      get: function get() {
        return "compact" === a;
      },
      enumerable: !0
    }), Object.defineProperty(this, "format", {
      get: function get() {
        return a;
      },
      enumerable: !0
    }), Object.defineProperty(this, "protected", {
      get: function get() {
        return ea(t.protect);
      },
      enumerable: !0
    }), Object.defineProperty(this, "header", {
      get: function get() {
        return ea(r);
      },
      enumerable: !0
    }), Object.defineProperty(this, "update", {
      value: function value(t, e) {
        if (i) throw new Error("already final");
        return null != t && (t = ne.asBuffer(t, e), s = s.length ? Buffer.concat([s, t], s.length + t.length) : t), this;
      }
    }), Object.defineProperty(this, "final", {
      value: function value(u, c) {
        if (i) return Promise.reject(new Error("already final"));
        this.update(u, c), i = !0;
        var f,
            l = Promise.resolve({}),
            h = r.enc;
        l = (l = l.then(function (e) {
          return t.cek && (f = Ki.asKey(t.cek)), e;
        })).then(function (e) {
          var i = Promise.all(n);
          return i = (i = i.then(function (e) {
            var n = 1 === e.length;
            return e = e.map(function (e) {
              return function (e, n) {
                var i = {};
                i = ta(i, r), i = ta(i, e.header);
                var a,
                    o,
                    s = e.key,
                    u = i.alg;
                return 0 === (i.alg || "").indexOf("ECDH-ES") ? (a = s.keystore.temp(), o = e.epk ? Promise.resolve(e.epk).then(function (t) {
                  e.header.epk = t.toJSON(!1, ["kid"]), i.epk = t.toObject(!0, ["kid"]);
                }) : a.generate("EC", s.get("crv")).then(function (t) {
                  e.header.epk = t.toJSON(!1, ["kid"]), i.epk = t.toObject(!0, ["kid"]);
                })) : o = Promise.resolve(), o = (o = o.then(function () {
                  var e, a;
                  return "dir" === u && n ? a = (f = Promise.resolve(s)).then(function (t) {
                    return h || (i.enc = r.enc = h = t.algorithms(Ki.MODE_ENCRYPT)[0]), {
                      once: !0,
                      direct: !0
                    };
                  }) : (f || (h || (i.enc = r.enc = h = t.contentAlg), f = Ji(h)), a = (a = f.then(function (t) {
                    return e = t.get("k", !0), s;
                  })).then(function (t) {
                    return t.wrap(u, e, i);
                  })), a;
                })).then(function (t) {
                  if (t.once && !n) return Promise.reject(new Error("cannot use 'alg':'" + u + "' with multiple recipients"));
                  var r,
                      i = {};
                  return t.data && (r = t.data, r = ne.base64url.encode(r)), t.direct && r ? f = Ki.asKey({
                    kty: "oct",
                    k: r
                  }) : r && (i.encrypted_key = r), e.header && Object.keys(e.header).length && (i.header = ea(e.header || {})), t.header && (i.header = ta(i.header || {}, t.header)), i;
                });
              }(e, n);
            }), Promise.all(e);
          })).then(function (t) {
            return e.recipients = t.filter(function (t) {
              return !!t;
            }), e;
          });
        });
        var p = {};

        switch (l = (l = (l = l.then(function (e) {
          var n, i, s, u;
          return s = ea(r), o && 1 === e.recipients.length || "compact" === a ? (n = {}, n = ta({}, s, e.recipients[0].header), i = Object.keys(n).length, s = void 0, u = 0, delete e.recipients[0].header, 0 === Object.keys(e.recipients[0]).length && e.recipients.splice(0, 1)) : (n = {}, i = 0, u = Object.keys(s).length, t.protect.forEach(function (t) {
            t in s && (n[t] = s[t], i++, delete s[t], u--);
          }), e.recipients = (e.recipients || []).map(function (t) {
            var e = (t = t || {}).header;
            return e && (Object.keys(e).forEach(function (t) {
              t in n && delete e[t];
            }), Object.keys(e).length || delete t.header), t;
          })), e.recipients && 0 !== e.recipients.length || delete e.recipients, s && u > 0 && (p = ta(p, s), e.unprotected = s), n && i > 0 && (p = ta(p, n), n = JSON.stringify(n), e.protected = ne.base64url.encode(n, "utf8")), e;
        })).then(function (t) {
          var r = s;
          return p.zip ? "DEF" === p.zip ? new Promise(function (n, i) {
            e.deflateRaw(Buffer.from(r, "binary"), function (e, r) {
              e ? i(e) : (t.plaintext = r, n(t));
            });
          }) : Promise.reject(new Error("unsupported 'zip' mode")) : (t.plaintext = r, t);
        })).then(function (e) {
          p.adata = e.protected, "aad" in t && null != t.aad && (p.adata += "." + t.aad, p.adata = Buffer.from(p.adata, "utf8"));
          var r = t.iv || ne.randomBytes(ve.NONCELENGTH[h] / 8);
          "string" == typeof r && (r = ne.base64url.decode(r)), p.iv = r, "recipients" in e && 1 === e.recipients.length && (p.kdata = e.recipients[0].encrypted_key), "epu" in t && null != t.epu && (p.epu = t.epu), "epv" in t && null != t.epv && (p.epv = t.epv);
          var n = e.plaintext;
          return delete e.plaintext, f.then(function (i) {
            var a = i.encrypt(h, n, p);
            return a = a.then(function (n) {
              return e.iv = ne.base64url.encode(r, "binary"), "aad" in t && null != t.aad && (e.aad = t.aad), e.ciphertext = ne.base64url.encode(n.data, "binary"), e.tag = ne.base64url.encode(n.tag, "binary"), e;
            });
          });
        }), a) {
          case "compact":
            l = l.then(function (t) {
              var e = new Array(5);
              return e[0] = t.protected, t.recipients && t.recipients[0] && (e[1] = t.recipients[0].encrypted_key), e[2] = t.iv, e[3] = t.ciphertext, e[4] = t.tag, e = e.join(".");
            });
            break;

          case "flattened":
            l = l.then(function (t) {
              var e = {},
                  r = t.recipients && t.recipients[0];
              return t.protected && (e.protected = t.protected), t.unprotected && (e.unprotected = t.unprotected), ["header", "encrypted_key"].forEach(function (t) {
                r && t in r && r[t] && ("object" != typeof r[t] || Object.keys(r[t]).length) && (e[t] = r[t]);
              }), t.aad && (e.aad = t.aad), e.iv = t.iv, e.ciphertext = t.ciphertext, e.tag = t.tag, e;
            });
            break;

          case "general":
            l = l.then(function (t) {
              var e = t.recipients || [];
              return (e = (e = e.map(function (t) {
                if (Object.keys(t).length) return t;
              })).filter(function (t) {
                return !!t;
              })).length ? t.recipients = e : delete t.recipients, t;
            });
        }

        return l;
      }
    });
  }

  var na = {
    algorithms: "*"
  };

  function ia(t, r) {
    var n, i;
    if (Ki.isKey(t)) i = (n = t).keystore;else {
      if (!Ki.isKeyStore(t)) throw new TypeError("Keystore must be provided");
      i = t;
    }
    r = l(na, r), Object.defineProperty(this, "decrypt", {
      value: function value(t, a) {
        var o = (a = l({}, r, a || {})).handlers || {},
            s = Object.keys(o),
            u = new qi(a.algorithms);
        if ("string" == typeof t) t = {
          protected: (t = t.split("."))[0],
          recipients: [{
            encrypted_key: t[1]
          }],
          iv: t[2],
          ciphertext: t[3],
          tag: t[4]
        };else if (!t || "object" != typeof t) throw new Error("invalid input");
        "encrypted_key" in t && (t.recipients = [{
          encrypted_key: t.encrypted_key
        }]);
        var c,
            f,
            h,
            p,
            d,
            y = t.recipients || [{}];
        return Promise.resolve(y).then(function (e) {
          if (t.protected) {
            f = ee.decode(t.protected).toString("utf8");
            var r = (f = JSON.parse(f)).crit;

            if (r) {
              if (!Array.isArray(r)) return Promise.reject(new Error("Invalid 'crit' header"));

              for (var n = 0; r.length > n; n++) {
                if (-1 === s.indexOf(r[n])) return Promise.reject(new Error("Critical extension is not supported: " + r[n]));
              }
            }

            c = f, f = Object.keys(f);
          } else c = {}, f = [];

          return c = l(t.unprotected || {}, c), e = e.map(function (t) {
            var e = Promise.resolve(),
                r = t.header || {};
            return r = l(r, c), t.header = r, t.protected = f, u.match(r.alg) || (e = e.then(function () {
              return Promise.reject(new Error("Algorithm not allowed: " + r.alg));
            })), u.match(r.enc) || (e = e.then(function () {
              return Promise.reject(new Error("Algorithm not allowed: " + r.enc));
            })), r.epk && (e = (e = e.then(function () {
              return Ki.asKey(r.epk);
            })).then(function (t) {
              r.epk = t.toObject(!1);
            })), e.then(function () {
              return t;
            });
          }), Promise.all(e);
        }).then(function (t) {
          var e = {};
          return new Promise(function (r, a) {
            var o = function o() {
              var s = t.shift();

              if (s) {
                var u = Promise.resolve(s);
                (u = (u = u.then(function (t) {
                  var e = d = t.encrypted_key || "";
                  return e = ee.decode(e), (h = n || i.get({
                    use: "enc",
                    alg: t.header.alg,
                    kid: t.header.kid
                  })) ? h.unwrap(t.header.alg, e, t.header) : Promise.reject();
                })).then(function (t) {
                  p = {
                    kty: "oct",
                    k: ee.encode(t)
                  }, p = Ki.asKey(p), e.key = h, e.header = s.header, e.protected = s.protected, r(e);
                })).catch(o);
              } else a(new Error("no key found"));
            };

            o();
          });
        }).then(function (e) {
          return e.iv = t.iv, e.tag = t.tag, e.ciphertext = t.ciphertext, e;
        }).then(function (t) {
          var e = [];
          return s.forEach(function (r) {
            var n;
            "function" == typeof (r = o[r]) ? n = r(t) : "object" == typeof r && "function" == typeof r.prepare && (n = r.prepare(t)), n && e.push(Promise.resolve(n));
          }), Promise.all(e).then(function () {
            return t;
          });
        }).then(function (t) {
          return Buffer.isBuffer(t.ciphertext) || (t.ciphertext = ee.decode(t.ciphertext)), t;
        }).then(function (e) {
          var r = t.protected;
          "aad" in t && null != t.aad && (r += "." + t.aad);
          var n = {
            iv: e.iv,
            adata: r,
            tag: e.tag,
            kdata: d,
            epu: e.epu,
            epv: e.epv
          },
              i = e.ciphertext;
          return delete e.iv, delete e.tag, delete e.ciphertext, p.then(function (t) {
            return t.decrypt(e.header.enc, i, n).then(function (t) {
              return e.payload = e.plaintext = t, e;
            });
          });
        }).then(function (t) {
          return "DEF" === t.header.zip ? new Promise(function (r, n) {
            e.inflateRaw(Buffer.from(t.plaintext), function (e, i) {
              e ? n(e) : (t.payload = t.plaintext = i, r(t));
            });
          }) : t;
        }).then(function (t) {
          var e = [];
          return s.forEach(function (r) {
            var n;
            "object" == typeof (r = o[r]) && "function" == typeof r.complete && (n = r.complete(t)), n && e.push(Promise.resolve(n));
          }), Promise.all(e).then(function () {
            return t;
          });
        });
      }
    });
  }

  var aa = {
    createEncrypt: {
      encrypter: ra,
      createEncrypt: function createEncrypt(t, e) {
        var r = t,
            n = 1,
            i = e;
        if (0 === arguments.length) throw new Error("at least one recipient must be provided");
        1 === arguments.length ? (i = t, n = 0, r = {}) : Ki.isKey(t) || t && "kty" in t || t && "key" in t && (Ki.isKey(t.key) || "kty" in t.key) ? (i = t, n = 0, r = {}) : r = ea(t), Array.isArray(i) || (i = $i(arguments, n)), r = ta(ea(Zi), r);
        var a = ea(r.fields || {});

        switch (r.zip && (a.zip = "boolean" == typeof r.zip ? !!r.zip && "DEF" : r.zip), r.format = (r.compact ? "compact" : r.format) || "general", r.format) {
          case "compact":
            if ("aad" in t) throw new Error("additional authenticated data cannot be used for compact serialization");

          case "flattened":
            if (i.length > 1) throw new Error("too many recipients for compact serialization");
        }

        var o = !1;
        if ("compact" === r.format || "*" === r.protect) o = !0, r.protect = Object.keys(a).concat("enc");else if ("string" == typeof r.protect) r.protect = [r.protect];else if (Array.isArray(r.protect)) r.protect = r.protect.concat();else {
          if (r.protect) throw new Error("protect must be a list of fields");
          r.protect = [];
        }
        if (o && 1 < i.length) throw new Error("too many recipients to protect all header parameters");
        i = i.map(function (t, e) {
          var r;
          return r = t && "kty" in t ? (r = Ki.asKey(t)).then(function (t) {
            return {
              key: t
            };
          }) : t ? (r = Ki.asKey(t.key)).then(function (e) {
            return {
              header: t.header,
              reference: t.reference,
              key: e
            };
          }) : Promise.reject(new Error("missing key for recipient " + e)), t.epk && (r = r.then(function (e) {
            return Ki.asKey(t.epk).then(function (t) {
              return e.epk = t, e;
            });
          })), r = r.then(function (t) {
            var r = t.key,
                n = t.header || {};
            t.header = n;
            var i = {};
            if (i = ta(i, a), (i = ta(i, t.header)).alg || (i.alg = r.algorithms(Ki.MODE_WRAP)[0], n.alg = i.alg), !i.alg) return Promise.reject(new Error("key not valid for encrypting to recipient " + e));
            n.alg = i.alg;
            var o,
                s = t.reference;
            if (delete t.reference, void 0 === s ? s = (s = ["kid", "jku", "x5c", "x5t", "x5u"].some(function (t) {
              return t in n;
            })) ? null : "kid" : "boolean" == typeof s && (s = s ? "kid" : null), s) if (o = r.toJSON(), "jwk" === s) {
              if ("oct" === r.kty) return Promise.reject(new Error("cannot embed key"));
              n.jwk = o;
            } else s in o && (n[s] = o[s]);
            return t = Object.freeze(t);
          });
        });
        var s = {
          aad: "aad" in r ? ne.base64url.encode(r.aad || "") : null,
          contentAlg: r.contentAlg,
          format: r.format,
          protect: r.protect,
          cek: r.cek,
          iv: r.iv,
          protectAll: o
        },
            u = new ra(s, a, i);
        return u;
      }
    }.createEncrypt,
    createDecrypt: {
      decrypter: ia,
      createDecrypt: function createDecrypt(t, e) {
        return new ia(t, e);
      }
    }.createDecrypt
  },
      oa = {
    JWE: aa,
    JWS: Yi,
    util: ne
  };

  var sa = function sa(t) {
    var e,
        r,
        n,
        i = t.split(".");
    if (3 === i.length) e = "JWS", r = function r(e, _r2) {
      return oa.JWS.createVerify(e).verify(t, _r2);
    };else {
      if (5 !== i.length) throw new TypeError("invalid jose serialization");
      e = "JWE", r = function r(e, _r3) {
        return oa.JWE.createDecrypt(e).decrypt(t, _r3);
      };
    }
    return n = oa.util.base64url.decode(i[0], "utf8"), n = JSON.parse(n), {
      type: e,
      format: "compact",
      input: t,
      header: n,
      perform: r
    };
  },
      ua = {
    JWE: aa,
    JWS: Yi,
    util: ne
  };

  var ca = function ca(t) {
    var e, r, n;
    if ("signatures" in t || "signature" in t) e = "JWS", r = function r(e, _r4) {
      return ua.JWS.createVerify(e).verify(t, _r4);
    }, n = (n = t.signatures || [{
      protected: t.protected,
      header: t.header,
      signature: t.signature
    }]).map(function (t) {
      var e,
          r = {};
      return t.header && (r = l(r, t.header)), t.protected && (e = t.protected, e = ua.util.base64url.decode(e, "utf8"), e = JSON.parse(e), r = l(r, e)), r;
    });else if ("ciphertext" in t) {
      e = "JWE", r = function r(e, _r5) {
        return ua.JWE.createDecrypt(e).decrypt(t, _r5);
      };
      var i = {};
      t.protected && (i.protected = t.protected, i.protected = ua.util.base64url.decode(i.protected, "utf8"), i.protected = JSON.parse(i.protected)), t.unprotected && (i.unprotected = t.unprotected), n = (n = t.recipients || [{}]).map(function (t) {
        var e = {};
        return t.header && (e = l(e, t.header)), i.unprotected && (e = l(e, i.unprotected)), i.protected && (e = l(e, i.protected)), e;
      });
    }
    return {
      type: e,
      format: "json",
      input: t,
      all: n,
      perform: r
    };
  },
      fa = i(function (t) {
    var e = t.exports = function (t) {
      if (Buffer.isBuffer(t)) return sa(t.toString("ascii"));
      if ("string" == typeof t) return sa(t);
      if (t) return ca(t);
      throw new TypeError("invalid input");
    };

    e.compact = sa, e.json = ca;
  });

  "undefined" == typeof Promise && o.polyfill();
  var la = {
    JWA: qn,
    JWE: aa,
    JWK: Ki,
    JWS: Yi,
    util: ne,
    parse: fa,
    canYouSee: Yi.createVerify
  }.JWE;
  var ha = {
    COMPACT: "compact"
  },
      pa = "INVALID_CARD_DATA",
      da = "INVALID_ENCRYPTION_KEY",
      ya = "[object Object]";

  var ga = /*#__PURE__*/function (_Error) {
    _inherits(ga, _Error);

    var _super = _createSuper(ga);

    function ga(t, e) {
      var _this;

      _classCallCheck(this, ga);

      var r;
      _this = _super.call(this, e), _this.name = _this.constructor.name, _this.error = t, _this.message = e, r = _assertThisInitialized(_this), "function" == typeof Error.captureStackTrace ? Error.captureStackTrace(r, r.constructor) : r.stack = new Error(r.message).stack;
      return _this;
    }

    return ga;
  }( /*#__PURE__*/_wrapNativeSuper(Error));

  module.exports = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var t, e;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              t = _ref.card, e = _ref.encryptionKey;

              if (!(!t || {}.toString.call(t) !== ya)) {
                _context.next = 3;
                break;
              }

              throw new ga("", pa);

            case 3:
              if (!(!e || {}.toString.call(e) !== ya)) {
                _context.next = 5;
                break;
              }

              throw new ga("", da);

            case 5:
              _context.next = 7;
              return la.createEncrypt({
                format: ha.COMPACT
              }, e).update(JSON.stringify(t)).final();

            case 7:
              return _context.abrupt("return", _context.sent);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
});